import {
  VOID7hggqo3abtya as VOID,
  toString1pkumu07cwy4m as toString,
  toString30pk9tzaqopn as toString_0,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  listOf1jh22dvmctj1r as listOf,
  Unit_instanceat14thlj150z as Unit_instance,
  ArrayList3it5z8td81qkl as ArrayList,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  toList3jhuyej2anx2q as toList,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
  getProgressionLastElement2w30kdy2w5nkt as getProgressionLastElement,
  Paire9pteg33gng7 as Pair,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  numberToDouble210hrknaofnhf as numberToDouble,
  coerceIn1xblvmyr0tby6 as coerceIn,
  coerceAtLeastklytehohcpeq as coerceAtLeast,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Enum3alwj03lh1n41 as Enum,
  Default_getInstancegttbt9h1yt0q as Default_getInstance,
  random1sf5nh8jpeq5r as random,
  random234odtwlu7lq2 as random_0,
  println2shhhgwwt4c61 as println,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  coerceAtMost322komnqp70ag as coerceAtMost,
  to2cs3ny02qtbcb as to,
  mapOf1xd03cq9cnmy8 as mapOf,
  Exceptiondt2hlxn7j7vw as Exception,
  Long2qws0ah9gnpki as Long,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  getKClass1s3j9wy1cofik as getKClass,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  KClass1cc9rfeybg8hs as KClass,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast_0,
  printStackTrace18lnx7a39cni as printStackTrace,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  emptyList1g2z5xcrvp2zy as emptyList,
  toLongw1zpgk99d84b as toLong,
  abs1kdzbjes1idip as abs,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  split2bvyvnrlcifjv as split,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  take9j4462mea726 as take,
  listOfvhqybd2zx248 as listOf_0,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  indexOf1xbs558u7wr52 as indexOf,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  startsWith26w8qjqapeeq6 as startsWith,
  removePrefix279df90bhrqqg as removePrefix,
  toSet2orjxp16sotqu as toSet,
  KtList3hktaavzmj137 as KtList,
  firstOrNull1982767dljvdy as firstOrNull,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  coerceAtMostfyc3emgaderp as coerceAtMost_0,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  KtMap140uvy3s5zad8 as KtMap,
  isNumberiramasdbon0i as isNumber,
  get_EmptyContinuationn1rwa6yr6j5w as get_EmptyContinuation,
  startCoroutineUninterceptedOrReturnGeneratorVersion1r5yf56916wr4 as startCoroutineUninterceptedOrReturnGeneratorVersion,
} from './kotlin-kotlin-stdlib.mjs';
import {
  DateTime2gld4ho36azq9 as DateTime,
  DateTime__hashCode_impl_yf0bc92s64omsn0fynv as DateTime__hashCode_impl_yf0bc9,
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance_0,
  get_secondsjblpw5qd4dzj as get_seconds,
  DateTime__minus_impl_10njw812puhhvc4b9kf as DateTime__minus_impl_10njw8,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  Bitmap321klycakvwgb5w as Bitmap32,
  Companion_getInstance2ou2xyvohty1g as Companion_getInstance_1,
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  Companion_getInstancezw1wxvwtmh0g as Companion_getInstance_2,
  get_DefaultStringTextRendererdyzggul2pyry as get_DefaultStringTextRenderer,
  get_DefaultTtfFontAsBitmap1hzwi8e4truhb as get_DefaultTtfFontAsBitmap,
  RGBA__toString_impl_4lw6dp2tumn1mea41fm as RGBA__toString_impl_4lw6dp,
  RGBA__hashCode_impl_h59qf629uhw1oxrapg6 as RGBA__hashCode_impl_h59qf6,
  RGBA34obx2i62wcl3 as RGBA,
  slice2pfxfvku0ybgy as slice,
  _RGBA___get_value__impl__hhco8vehpblbe3f2y8 as _RGBA___get_value__impl__hhco8v,
  RGBA__withAd_impl_cralao1ojb8pkalp2nb as RGBA__withAd_impl_cralao,
  ShapeBuilderk05da5wk16e9 as ShapeBuilder,
  EmptyShape_instance1905h5dvjxi3r as EmptyShape_instance,
  readTtfFont159as20nksus9 as readTtfFont,
  get_DefaultTtfFontddovg6zy24ck as get_DefaultTtfFont,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  SolidRect131p7hyzlx7j8 as SolidRect,
  addTo25e29vq105prw as addTo,
  positionu6441b7hkb4l as position,
  addUpdater1la23qj9g2d42 as addUpdater,
  Image1b2d7ghyim7p5 as Image,
  scalea9fc0mbrr7ub as scale,
  Companion_instance1qzytx5vkv693 as Companion_instance,
  Text3kimhvgfxflj3 as Text,
  get_mouse1jstwhfaumelj as get_mouse,
  Container7486fjmip554 as Container,
  ClipContainernpx31s3mxtjx as ClipContainer,
  SceneContainer99ijjqni12hp as SceneContainer,
  Companion_getInstance2b4rje0hs8ulh as Companion_getInstance_3,
  xy1gb51vhy014mx as xy,
  Scenezu810y12qpqp as Scene,
  GraphicsRenderer_SYSTEM_getInstance3mmjgo01yqcce as GraphicsRenderer_SYSTEM_getInstance,
  Graphics2q0lx93a2j4b2 as Graphics,
  MouseEvents19mapgq8ez76g as MouseEvents,
  Korge3fi4cwjkh8up9 as Korge,
  delay8my8khmz70k5 as delay,
  SContainerfim2zr5seafm as SContainer,
  get_AlphaTransition23l7sd982osvm as get_AlphaTransition,
  withEasingtnol1eyyo9sf as withEasing,
  views116j359zi8nvf as views,
  findFirstAscendante8nli1jx4t64 as findFirstAscendant,
  FixedSizeContainersre0rworj71w as FixedSizeContainer,
  Stage1ggtrzujnnkl0 as Stage,
} from './korge-root-korge.mjs';
import {
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstanceeqp3ibr2vvu9 as Companion_getInstance_4,
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstance1j5nd3fbu9uao as Companion_getInstance_5,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  _Ratio___init__impl__9mwvn2xyj9fjgana63 as _Ratio___init__impl__9mwvn2,
  roundDecimalPlaces1x32iuyd1l8m5 as roundDecimalPlaces,
  Companion_getInstance3gvjtadf9ot2d as Companion_getInstance_6,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  Companion_getInstance1lsta35m6yx2z as Companion_getInstance_7,
  Resources1ysf2j4wd5yk7 as Resources,
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  launchImmediatelylnv8lnistpdy as launchImmediately,
} from './korlibs-io-root-korlibs-io.mjs';
import {
  delay1f60wyf8ua1gc as delay_0,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  launch1c91vkjzdi9sd as launch,
  Dispatchers_getInstance2xomc0oxzllw9 as Dispatchers_getInstance,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
} from './kotlinx-coroutines-core.mjs';
import { Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance } from './korlibs-logger-root-korlibs-logger.mjs';
import {
  readSoundcwkqnndcldwa as readSound,
  PlaybackParametersw3tmyruspy4s as PlaybackParameters,
} from './korlibs-audio-root-korlibs-audio.mjs';
import { format1w6w3fsj4lh0e as format } from './korlibs-string-root-korlibs-string.mjs';
import { Companion_getInstance345a0ojzj45ct as Companion_getInstance_8 } from './korlibs-serialization-root-korlibs-serialization.mjs';
import { get_EASE_IN_OUT_QUAD21w3u6e1aoexb as get_EASE_IN_OUT_QUAD } from './korlibs-math-root-korlibs-math.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Achievement {
  constructor(id, title, description, condition, reward, unlocked, unlockedAt, progress, notificationShown) {
    unlocked = unlocked === VOID ? false : unlocked;
    unlockedAt = unlockedAt === VOID ? null : unlockedAt;
    progress = progress === VOID ? 0 : progress;
    notificationShown = notificationShown === VOID ? false : notificationShown;
    this.vbu_1 = id;
    this.wbu_1 = title;
    this.xbu_1 = description;
    this.ybu_1 = condition;
    this.zbu_1 = reward;
    this.abv_1 = unlocked;
    this.bbv_1 = unlockedAt;
    this.cbv_1 = progress;
    this.dbv_1 = notificationShown;
  }
  toString() {
    var tmp = toString(this.ybu_1);
    var tmp_0 = this.zbu_1.toString();
    var tmp_1 = this.abv_1;
    var tmp_2 = this.bbv_1;
    return 'Achievement(id=' + this.vbu_1 + ', title=' + this.wbu_1 + ', description=' + this.xbu_1 + ', condition=' + tmp + ', reward=' + tmp_0 + ', unlocked=' + tmp_1 + ', unlockedAt=' + toString_0(tmp_2 == null ? null : new DateTime(tmp_2)) + ', progress=' + this.cbv_1 + ', notificationShown=' + this.dbv_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.vbu_1);
    result = imul(result, 31) + getStringHashCode(this.wbu_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.xbu_1) | 0;
    result = imul(result, 31) + hashCode(this.ybu_1) | 0;
    result = imul(result, 31) + this.zbu_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.abv_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.bbv_1;
    if ((tmp_1 == null ? null : new DateTime(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = DateTime__hashCode_impl_yf0bc9(this.bbv_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + this.cbv_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.dbv_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Achievement))
      return false;
    var tmp0_other_with_cast = other instanceof Achievement ? other : THROW_CCE();
    if (!(this.vbu_1 === tmp0_other_with_cast.vbu_1))
      return false;
    if (!(this.wbu_1 === tmp0_other_with_cast.wbu_1))
      return false;
    if (!(this.xbu_1 === tmp0_other_with_cast.xbu_1))
      return false;
    if (!equals(this.ybu_1, tmp0_other_with_cast.ybu_1))
      return false;
    if (!this.zbu_1.equals(tmp0_other_with_cast.zbu_1))
      return false;
    if (!(this.abv_1 === tmp0_other_with_cast.abv_1))
      return false;
    var tmp = this.bbv_1;
    var tmp_0 = tmp == null ? null : new DateTime(tmp);
    var tmp_1 = tmp0_other_with_cast.bbv_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new DateTime(tmp_1)))
      return false;
    if (!(this.cbv_1 === tmp0_other_with_cast.cbv_1))
      return false;
    if (!(this.dbv_1 === tmp0_other_with_cast.dbv_1))
      return false;
    return true;
  }
}
class AchievementReward {
  constructor(scoreBonus, description) {
    scoreBonus = scoreBonus === VOID ? 0.0 : scoreBonus;
    description = description === VOID ? '' : description;
    this.ebv_1 = scoreBonus;
    this.fbv_1 = description;
  }
  toString() {
    return 'AchievementReward(scoreBonus=' + this.ebv_1 + ', description=' + this.fbv_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.ebv_1);
    result = imul(result, 31) + getStringHashCode(this.fbv_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AchievementReward))
      return false;
    var tmp0_other_with_cast = other instanceof AchievementReward ? other : THROW_CCE();
    if (!equals(this.ebv_1, tmp0_other_with_cast.ebv_1))
      return false;
    if (!(this.fbv_1 === tmp0_other_with_cast.fbv_1))
      return false;
    return true;
  }
}
class AchievementCondition {}
class Population extends AchievementCondition {
  constructor(target) {
    super();
    this.gbv_1 = target;
  }
  toString() {
    return 'Population(target=' + this.gbv_1 + ')';
  }
  hashCode() {
    return this.gbv_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Population))
      return false;
    var tmp0_other_with_cast = other instanceof Population ? other : THROW_CCE();
    if (!(this.gbv_1 === tmp0_other_with_cast.gbv_1))
      return false;
    return true;
  }
}
class Collisions extends AchievementCondition {
  constructor(target) {
    super();
    this.hbv_1 = target;
  }
  toString() {
    return 'Collisions(target=' + this.hbv_1 + ')';
  }
  hashCode() {
    return this.hbv_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Collisions))
      return false;
    var tmp0_other_with_cast = other instanceof Collisions ? other : THROW_CCE();
    if (!(this.hbv_1 === tmp0_other_with_cast.hbv_1))
      return false;
    return true;
  }
}
class Score extends AchievementCondition {
  constructor(target) {
    super();
    this.ibv_1 = target;
  }
  toString() {
    return 'Score(target=' + this.ibv_1 + ')';
  }
  hashCode() {
    return getNumberHashCode(this.ibv_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Score))
      return false;
    var tmp0_other_with_cast = other instanceof Score ? other : THROW_CCE();
    if (!equals(this.ibv_1, tmp0_other_with_cast.ibv_1))
      return false;
    return true;
  }
}
class TimeAlive extends AchievementCondition {
  constructor(seconds) {
    super();
    this.jbv_1 = seconds;
  }
  toString() {
    return 'TimeAlive(seconds=' + this.jbv_1 + ')';
  }
  hashCode() {
    return getNumberHashCode(this.jbv_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TimeAlive))
      return false;
    var tmp0_other_with_cast = other instanceof TimeAlive ? other : THROW_CCE();
    if (!equals(this.jbv_1, tmp0_other_with_cast.jbv_1))
      return false;
    return true;
  }
}
class ReproductionStreak extends AchievementCondition {}
class AchievementManager {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.kbv_1 = ArrayList.j1();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.lbv_1 = ArrayList.j1();
    initializeAchievements(this);
  }
  obv() {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.kbv_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'AchievementManager.resetAchievements.<anonymous>' call
      element.abv_1 = false;
      element.bbv_1 = null;
      element.cbv_1 = 0;
      element.dbv_1 = false;
    }
  }
  pbv(population, collisions, score, timeAlive) {
    var totalReward = 0.0;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.kbv_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'AchievementManager.checkAchievements.<anonymous>' call
      if (!element.abv_1) {
        var condition = element.ybu_1;
        var tmp;
        if (condition instanceof Population) {
          element.cbv_1 = population;
          tmp = population >= condition.gbv_1;
        } else {
          if (condition instanceof Collisions) {
            element.cbv_1 = collisions;
            tmp = collisions >= condition.hbv_1;
          } else {
            if (condition instanceof Score) {
              element.cbv_1 = numberToInt(score);
              tmp = score >= condition.ibv_1;
            } else {
              if (condition instanceof TimeAlive) {
                element.cbv_1 = numberToInt(timeAlive);
                tmp = timeAlive >= condition.jbv_1;
              } else {
                if (condition instanceof ReproductionStreak) {
                  tmp = false;
                } else {
                  noWhenBranchMatchedException();
                }
              }
            }
          }
        }
        var shouldUnlock = tmp;
        if (shouldUnlock) {
          totalReward = totalReward + unlockAchievement(this, element);
        }
      }
    }
    return totalReward;
  }
  qbv(listener) {
    this.lbv_1.h(listener);
  }
  rbv() {
    return toList(this.kbv_1);
  }
  sbv() {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.count' call
      var this_0 = this.kbv_1;
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.h1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = 0;
        break $l$block;
      }
      var count = 0;
      var tmp0_iterator = this_0.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'AchievementManager.getUnlockedCount.<anonymous>' call
        if (element.abv_1) {
          count = count + 1 | 0;
          checkCountOverflow(count);
        }
      }
      tmp$ret$0 = count;
    }
    return tmp$ret$0;
  }
  tbv() {
    return this.kbv_1.f1();
  }
  ubv() {
  }
}
class AchievementNotification {
  constructor(container, achievement, yOffset, onRemoved) {
    yOffset = yOffset === VOID ? 0.0 : yOffset;
    onRemoved = onRemoved === VOID ? null : onRemoved;
    this.vbv_1 = container;
    this.wbv_1 = achievement;
    this.xbv_1 = yOffset;
    this.ybv_1 = onRemoved;
    this.zbv_1 = 380.0;
    this.abw_1 = 120.0;
    this.bbw_1 = 0.0;
    this.cbw_1 = 4.0;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.dbw_1 = ArrayList.j1();
    this.jbw_1 = true;
    this.kbw_1 = false;
    createNotification(this);
  }
  r6() {
    this.kbw_1 = true;
    this.jbw_1 = false;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.dbw_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'AchievementNotification.remove.<anonymous>' call
      element.kak();
    }
    this.dbw_1.k3();
    var tmp0_safe_receiver = this.ybv_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
  }
}
class AchievementPanel {
  constructor(container, achievementManager, onClose) {
    this.lbw_1 = container;
    this.mbw_1 = achievementManager;
    this.nbw_1 = onClose;
    this.obw_1 = 600.0;
    this.pbw_1 = 500.0;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.qbw_1 = ArrayList.j1();
    createPanel(this);
  }
}
class CollisionEvent {
  constructor(dustCloud, timer, newSquareX, newSquareY, newSquareVelocity) {
    this.sbw_1 = dustCloud;
    this.tbw_1 = timer;
    this.ubw_1 = newSquareX;
    this.vbw_1 = newSquareY;
    this.wbw_1 = newSquareVelocity;
  }
  toString() {
    return 'CollisionEvent(dustCloud=' + this.sbw_1.toString() + ', timer=' + this.tbw_1 + ', newSquareX=' + this.ubw_1 + ', newSquareY=' + this.vbw_1 + ', newSquareVelocity=' + this.wbw_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.sbw_1);
    result = imul(result, 31) + getNumberHashCode(this.tbw_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ubw_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.vbw_1) | 0;
    result = imul(result, 31) + this.wbw_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CollisionEvent))
      return false;
    var tmp0_other_with_cast = other instanceof CollisionEvent ? other : THROW_CCE();
    if (!equals(this.sbw_1, tmp0_other_with_cast.sbw_1))
      return false;
    if (!equals(this.tbw_1, tmp0_other_with_cast.tbw_1))
      return false;
    if (!equals(this.ubw_1, tmp0_other_with_cast.ubw_1))
      return false;
    if (!equals(this.vbw_1, tmp0_other_with_cast.vbw_1))
      return false;
    if (!this.wbw_1.equals(tmp0_other_with_cast.wbw_1))
      return false;
    return true;
  }
}
class Companion {
  constructor() {
    this.xbw_1 = 8;
    this.ybw_1 = 12;
    this.zbw_1 = 10;
    this.abx_1 = 10;
    this.bbx_1 = 5;
    this.cbx_1 = 5;
    this.dbx_1 = 5;
    this.ebx_1 = 3;
    this.fbx_1 = 5;
    this.gbx_1 = 5;
    this.hbx_1 = 5;
    this.ibx_1 = 1;
    this.jbx_1 = 5;
    this.kbx_1 = 10;
    this.lbx_1 = 5;
    this.mbx_1 = 1;
    this.nbx_1 = 3;
    this.obx_1 = 1;
    this.pbx_1 = 1;
    this.qbx_1 = 1;
    this.rbx_1 = 1;
    this.sbx_1 = 5;
    this.tbx_1 = 1;
    this.ubx_1 = 1;
    this.vbx_1 = 1;
    this.wbx_1 = 1;
    this.xbx_1 = 5;
    this.ybx_1 = 5;
    this.zbx_1 = 1;
    this.aby_1 = 5;
    this.bby_1 = 5;
    this.cby_1 = 1;
    this.dby_1 = 5;
    this.eby_1 = 5;
    this.fby_1 = 1;
  }
}
class GameConfig {
  constructor() {
    this.gby_1 = 0;
    this.hby_1 = 5.0;
    this.iby_1 = 15.0;
    this.jby_1 = 20;
    this.kby_1 = 150.0;
    this.lby_1 = 80.0;
    this.mby_1 = 1.0;
    this.nby_1 = 1.0;
    this.oby_1 = 1.0;
    this.pby_1 = 0.5;
    this.qby_1 = 60.0;
    this.rby_1 = 20.0;
    this.sby_1 = 0.8;
    this.tby_1 = false;
    this.uby_1 = 10.0;
    this.vby_1 = 1.0;
    this.wby_1 = 1.0;
    this.xby_1 = false;
    this.yby_1 = 1.0;
    this.zby_1 = false;
    this.abz_1 = false;
    this.bbz_1 = false;
    this.cbz_1 = false;
    this.dbz_1 = false;
    this.ebz_1 = 1.0;
    this.fbz_1 = false;
    this.gbz_1 = false;
    this.hbz_1 = 2;
    this.ibz_1 = 0;
    this.jbz_1 = 1.0;
    this.kbz_1 = 20.0;
    this.lbz_1 = 5;
    this.mbz_1 = 5;
    this.nbz_1 = 8;
    this.obz_1 = 8;
    this.pbz_1 = 15;
    this.qbz_1 = 12;
    this.rbz_1 = 20;
    this.sbz_1 = 30;
    this.tbz_1 = 50;
    this.ubz_1 = 60;
    this.vbz_1 = 80;
    this.wbz_1 = 100;
    this.xbz_1 = 120;
    this.ybz_1 = 200;
    this.zbz_1 = 400;
    this.ac0_1 = 600;
    this.bc0_1 = 600;
    this.cc0_1 = 2000;
    this.dc0_1 = 3000;
    this.ec0_1 = 2500;
    this.fc0_1 = 3500;
    this.gc0_1 = 2000;
    this.hc0_1 = 5000;
    this.ic0_1 = 6000;
    this.jc0_1 = 15000;
    this.kc0_1 = 50000;
    this.lc0_1 = 20;
    this.mc0_1 = 100;
    this.nc0_1 = 1000;
    this.oc0_1 = 25;
    this.pc0_1 = 150;
    this.qc0_1 = 2000;
    this.rc0_1 = 30;
    this.sc0_1 = 180;
    this.tc0_1 = 2500;
    this.uc0_1 = 0;
    this.vc0_1 = 0;
    this.wc0_1 = 0;
    this.xc0_1 = 0;
    this.yc0_1 = 0;
    this.zc0_1 = 0;
    this.ac1_1 = 0;
    this.bc1_1 = 0;
    this.cc1_1 = 0;
    this.dc1_1 = 0;
    this.ec1_1 = 0;
    this.fc1_1 = 0;
    this.gc1_1 = 0;
    this.hc1_1 = 0;
    this.ic1_1 = 0;
    this.jc1_1 = 0;
    this.kc1_1 = 0;
    this.lc1_1 = 0;
    this.mc1_1 = 0;
    this.nc1_1 = 0;
    this.oc1_1 = 0;
    this.pc1_1 = 0;
    this.qc1_1 = 0;
    this.rc1_1 = 0;
    this.sc1_1 = 0;
    this.tc1_1 = 0;
    this.uc1_1 = 0;
    this.vc1_1 = 0;
    this.wc1_1 = 0;
    this.xc1_1 = 0;
    this.yc1_1 = 0;
    this.zc1_1 = 0;
    this.ac2_1 = 0;
    this.bc2_1 = 0;
    this.cc2_1 = 0;
    this.dc2_1 = 0;
  }
  ec2() {
    if (this.gby_1 === 0) {
      this.gby_1 = 1;
      return true;
    }
    return false;
  }
  fc2() {
    return this.uc0_1 < 8;
  }
  gc2() {
    return this.vc0_1 < 12;
  }
  hc2() {
    return this.wc0_1 < 10;
  }
  ic2() {
    return this.xc0_1 < 10;
  }
  jc2() {
    return this.yc0_1 < 5;
  }
  kc2() {
    return this.zc0_1 < 5;
  }
  lc2() {
    return this.ac1_1 < 5;
  }
  mc2() {
    return this.bc1_1 < 3;
  }
  nc2() {
    return this.cc1_1 < 5;
  }
  oc2() {
    return this.dc1_1 < 5;
  }
  pc2() {
    return this.ec1_1 < 5;
  }
  qc2() {
    return this.fc1_1 < 1;
  }
  rc2() {
    return this.gc1_1 < 5;
  }
  sc2() {
    return this.hc1_1 < 10;
  }
  tc2() {
    return this.ic1_1 < 5;
  }
  uc2() {
    return this.jc1_1 < 1;
  }
  vc2() {
    return this.kc1_1 < 3;
  }
  wc2() {
    return this.lc1_1 < 1;
  }
  xc2() {
    return this.mc1_1 < 1;
  }
  yc2() {
    return this.nc1_1 < 1;
  }
  zc2() {
    return this.oc1_1 < 1;
  }
  ac3() {
    return this.pc1_1 < 5;
  }
  bc3() {
    return this.qc1_1 < 1;
  }
  cc3() {
    return this.rc1_1 < 1;
  }
  dc3() {
    return this.tc1_1 < 1;
  }
  ec3() {
    return this.uc1_1 < 1;
  }
  fc3() {
    return this.vc1_1 < 5;
  }
  gc3() {
    return this.wc1_1 < 5;
  }
  hc3() {
    return this.xc1_1 < 1;
  }
  ic3() {
    return this.yc1_1 < 5;
  }
  jc3() {
    return this.zc1_1 < 5;
  }
  kc3() {
    return this.ac2_1 < 1;
  }
  lc3() {
    return this.bc2_1 < 5;
  }
  mc3() {
    return this.cc2_1 < 5;
  }
  nc3() {
    return this.dc2_1 < 1;
  }
  oc3() {
    return this.sc1_1 === 0;
  }
  p2u() {
    this.gby_1 = 0;
    this.hby_1 = 5.0;
    this.iby_1 = 15.0;
    this.jby_1 = 10;
    this.kby_1 = 100.0;
    this.lby_1 = 50.0;
    this.mby_1 = 1.0;
    this.nby_1 = 1.0;
    this.oby_1 = 1.0;
    this.pby_1 = 0.5;
    this.qby_1 = 60.0;
    this.rby_1 = 20.0;
    this.sby_1 = 0.8;
    this.tby_1 = false;
    this.uby_1 = 10.0;
    this.vby_1 = 1.0;
    this.wby_1 = 1.0;
    this.xby_1 = false;
    this.yby_1 = 1.0;
    this.zby_1 = false;
    this.abz_1 = false;
    this.bbz_1 = false;
    this.dbz_1 = false;
    this.ebz_1 = 1.0;
    this.fbz_1 = false;
    this.gbz_1 = false;
    this.hbz_1 = 2;
    this.ibz_1 = 0;
    this.jbz_1 = 1.0;
    this.kbz_1 = 10.0;
    this.lbz_1 = 5;
    this.mbz_1 = 5;
    this.nbz_1 = 8;
    this.obz_1 = 8;
    this.pbz_1 = 15;
    this.qbz_1 = 12;
    this.rbz_1 = 20;
    this.sbz_1 = 30;
    this.tbz_1 = 50;
    this.ubz_1 = 60;
    this.vbz_1 = 80;
    this.wbz_1 = 100;
    this.xbz_1 = 120;
    this.ybz_1 = 200;
    this.zbz_1 = 400;
    this.ac0_1 = 600;
    this.bc0_1 = 600;
    this.cc0_1 = 2000;
    this.dc0_1 = 3000;
    this.ec0_1 = 2500;
    this.fc0_1 = 3500;
    this.gc0_1 = 2000;
    this.hc0_1 = 5000;
    this.ic0_1 = 6000;
    this.lc0_1 = 20;
    this.mc0_1 = 100;
    this.nc0_1 = 1000;
    this.oc0_1 = 25;
    this.pc0_1 = 150;
    this.qc0_1 = 2000;
    this.rc0_1 = 30;
    this.sc0_1 = 180;
    this.tc0_1 = 2500;
    this.jc0_1 = 15000;
    this.kc0_1 = 50000;
    this.uc0_1 = 0;
    this.vc0_1 = 0;
    this.wc0_1 = 0;
    this.xc0_1 = 0;
    this.yc0_1 = 0;
    this.zc0_1 = 0;
    this.ac1_1 = 0;
    this.bc1_1 = 0;
    this.cc1_1 = 0;
    this.dc1_1 = 0;
    this.ec1_1 = 0;
    this.fc1_1 = 0;
    this.gc1_1 = 0;
    this.hc1_1 = 0;
    this.ic1_1 = 0;
    this.jc1_1 = 0;
    this.kc1_1 = 0;
    this.lc1_1 = 0;
    this.mc1_1 = 0;
    this.nc1_1 = 0;
    this.oc1_1 = 0;
    this.pc1_1 = 0;
    this.qc1_1 = 0;
    this.rc1_1 = 0;
    this.tc1_1 = 0;
    this.uc1_1 = 0;
    this.vc1_1 = 0;
    this.wc1_1 = 0;
    this.xc1_1 = 0;
    this.yc1_1 = 0;
    this.zc1_1 = 0;
    this.ac2_1 = 0;
    this.bc2_1 = 0;
    this.cc2_1 = 0;
    this.dc2_1 = 0;
  }
  pc3() {
    this.hby_1 = 5.0 - this.uc0_1 * 0.5;
    var tmp = this;
    // Inline function 'kotlin.math.pow' call
    var x = this.uc0_1;
    var tmp$ret$0 = Math.pow(1.5, x);
    tmp.lbz_1 = numberToInt(5 * tmp$ret$0);
    this.iby_1 = 15.0 - this.vc0_1 * 1.0;
    var tmp_0 = this;
    // Inline function 'kotlin.math.pow' call
    var x_0 = this.vc0_1;
    var tmp$ret$1 = Math.pow(1.5, x_0);
    tmp_0.mbz_1 = numberToInt(5 * tmp$ret$1);
    this.jby_1 = 10 + imul(this.wc0_1, 10) | 0;
    var tmp_1 = this;
    // Inline function 'kotlin.math.pow' call
    var x_1 = this.wc0_1;
    var tmp$ret$2 = Math.pow(1.5, x_1);
    tmp_1.nbz_1 = numberToInt(8 * tmp$ret$2);
    this.lby_1 = 80.0 + this.xc0_1 * 10.0;
    this.kby_1 = 150.0 + this.xc0_1 * 10.0;
    var tmp_2 = this;
    // Inline function 'kotlin.math.pow' call
    var x_2 = this.xc0_1;
    var tmp$ret$3 = Math.pow(1.5, x_2);
    tmp_2.obz_1 = numberToInt(8 * tmp$ret$3);
    this.mby_1 = 1.0 + this.yc0_1 * 0.5;
    var tmp_3 = this;
    // Inline function 'kotlin.math.pow' call
    var x_3 = this.yc0_1;
    var tmp$ret$4 = Math.pow(1.8, x_3);
    tmp_3.pbz_1 = numberToInt(15 * tmp$ret$4);
    this.nby_1 = 1.0 + this.zc0_1 * 0.1;
    var tmp_4 = this;
    // Inline function 'kotlin.math.pow' call
    var x_4 = this.zc0_1;
    var tmp$ret$5 = Math.pow(1.6, x_4);
    tmp_4.qbz_1 = numberToInt(12 * tmp$ret$5);
    this.oby_1 = 1.0 + this.ac1_1 * 0.2;
    var tmp_5 = this;
    // Inline function 'kotlin.math.pow' call
    var x_5 = this.ac1_1;
    var tmp$ret$6 = Math.pow(1.7, x_5);
    tmp_5.rbz_1 = numberToInt(20 * tmp$ret$6);
    this.pby_1 = 0.5 - this.bc1_1 * 0.05;
    var tmp_6 = this;
    // Inline function 'kotlin.math.pow' call
    var x_6 = this.bc1_1;
    var tmp$ret$7 = Math.pow(1.8, x_6);
    tmp_6.sbz_1 = numberToInt(30 * tmp$ret$7);
    this.qby_1 = 60.0 + this.cc1_1 * 20.0;
    var tmp_7 = this;
    // Inline function 'kotlin.math.pow' call
    var x_7 = this.cc1_1;
    var tmp$ret$8 = Math.pow(2.0, x_7);
    tmp_7.tbz_1 = numberToInt(50 * tmp$ret$8);
    this.rby_1 = 20.0 + this.dc1_1 * 5.0;
    var tmp_8 = this;
    // Inline function 'kotlin.math.pow' call
    var x_8 = this.dc1_1;
    var tmp$ret$9 = Math.pow(2.0, x_8);
    tmp_8.ubz_1 = numberToInt(60 * tmp$ret$9);
    this.sby_1 = 0.8 + this.ec1_1 * 0.05;
    var tmp_9 = this;
    // Inline function 'kotlin.math.pow' call
    var x_9 = this.ec1_1;
    var tmp$ret$10 = Math.pow(2.2, x_9);
    tmp_9.vbz_1 = numberToInt(80 * tmp$ret$10);
    this.tby_1 = this.fc1_1 > 0;
    this.wbz_1 = this.fc1_1 > 0 ? 2147483647 : 100;
    this.uby_1 = 10.0 - this.gc1_1 * 0.5;
    var tmp_10 = this;
    // Inline function 'kotlin.math.pow' call
    var x_10 = this.gc1_1;
    var tmp$ret$11 = Math.pow(1.8, x_10);
    tmp_10.xbz_1 = numberToInt(120 * tmp$ret$11);
    this.vby_1 = 1.0 + this.hc1_1 * 0.5;
    var tmp_11 = this;
    // Inline function 'kotlin.math.pow' call
    var x_11 = this.hc1_1;
    var tmp$ret$12 = Math.pow(1.5, x_11);
    tmp_11.ybz_1 = numberToInt(200 * tmp$ret$12);
    this.wby_1 = 1.0 + this.ic1_1 * 0.25;
    var tmp_12 = this;
    // Inline function 'kotlin.math.pow' call
    var x_12 = this.ic1_1;
    var tmp$ret$13 = Math.pow(2.0, x_12);
    tmp_12.zbz_1 = numberToInt(400 * tmp$ret$13);
    this.xby_1 = this.jc1_1 > 0;
    this.ac0_1 = this.jc1_1 > 0 ? 2147483647 : 600;
    this.yby_1 = 1.0 - this.kc1_1 * 0.1;
    var tmp_13 = this;
    // Inline function 'kotlin.math.pow' call
    var x_13 = this.kc1_1;
    var tmp$ret$14 = Math.pow(2.5, x_13);
    tmp_13.bc0_1 = numberToInt(600 * tmp$ret$14);
    this.zby_1 = this.lc1_1 > 0;
    if (this.zby_1) {
      this.lby_1 = this.lby_1 + 200.0;
      this.kby_1 = this.kby_1 + 200.0;
    }
    this.cc0_1 = this.lc1_1 > 0 ? 2147483647 : 2000;
    this.abz_1 = this.mc1_1 > 0;
    this.dc0_1 = this.mc1_1 > 0 ? 2147483647 : 3000;
    this.bbz_1 = this.nc1_1 > 0;
    if (this.bbz_1) {
      this.jby_1 = this.jby_1 + 40 | 0;
    }
    this.ec0_1 = this.nc1_1 > 0 ? 2147483647 : 2500;
    this.dbz_1 = this.oc1_1 > 0;
    if (this.dbz_1) {
      this.oby_1 = this.oby_1 * 3.0;
    }
    this.fc0_1 = this.oc1_1 > 0 ? 2147483647 : 3500;
    this.ebz_1 = 1.0 + this.pc1_1 * 2.0;
    var tmp_14 = this;
    // Inline function 'kotlin.math.pow' call
    var x_14 = this.pc1_1;
    var tmp$ret$15 = Math.pow(3.0, x_14);
    tmp_14.gc0_1 = numberToInt(2000 * tmp$ret$15);
    this.fbz_1 = this.qc1_1 > 0;
    if (this.fbz_1) {
      this.wby_1 = this.wby_1 * 2.0;
    }
    this.hc0_1 = this.qc1_1 > 0 ? 2147483647 : 5000;
    this.gbz_1 = this.rc1_1 > 0;
    this.ic0_1 = this.rc1_1 > 0 ? 2147483647 : 6000;
    if (this.tc1_1 > 0) {
      this.rby_1 = this.rby_1 * 2.0;
      this.oby_1 = this.oby_1 * 2.0;
      this.wby_1 = this.wby_1 * 1.5;
    }
    this.jc0_1 = this.tc1_1 > 0 ? 2147483647 : 15000;
    if (this.uc1_1 > 0) {
      this.vby_1 = this.vby_1 * 10.0;
      this.jby_1 = this.jby_1 + 50 | 0;
      this.wby_1 = this.wby_1 * 2.0;
    }
    this.kc0_1 = this.uc1_1 > 0 ? 2147483647 : 50000;
    this.hbz_1 = ((2 + imul(this.vc1_1, 2) | 0) + imul(this.wc1_1, 2) | 0) + imul(this.xc1_1, 5) | 0;
    var tmp_15 = this;
    // Inline function 'kotlin.math.pow' call
    var x_15 = this.vc1_1;
    var tmp$ret$16 = Math.pow(2.5, x_15);
    tmp_15.lc0_1 = numberToInt(20 * tmp$ret$16);
    var tmp_16 = this;
    // Inline function 'kotlin.math.pow' call
    var x_16 = this.wc1_1;
    var tmp$ret$17 = Math.pow(2.5, x_16);
    tmp_16.mc0_1 = numberToInt(100 * tmp$ret$17);
    var tmp_17 = this;
    // Inline function 'kotlin.math.pow' call
    var x_17 = this.xc1_1;
    var tmp$ret$18 = Math.pow(3.0, x_17);
    tmp_17.nc0_1 = numberToInt(1000 * tmp$ret$18);
    this.jbz_1 = 1.0 * (1 << this.yc1_1) * (1 << this.zc1_1) * (1 << this.ac2_1);
    var tmp_18 = this;
    // Inline function 'kotlin.math.pow' call
    var x_18 = this.yc1_1;
    var tmp$ret$19 = Math.pow(2.0, x_18);
    tmp_18.oc0_1 = numberToInt(25 * tmp$ret$19);
    var tmp_19 = this;
    // Inline function 'kotlin.math.pow' call
    var x_19 = this.zc1_1;
    var tmp$ret$20 = Math.pow(2.5, x_19);
    tmp_19.pc0_1 = numberToInt(150 * tmp$ret$20);
    var tmp_20 = this;
    // Inline function 'kotlin.math.pow' call
    var x_20 = this.ac2_1;
    var tmp$ret$21 = Math.pow(3.0, x_20);
    tmp_20.qc0_1 = numberToInt(2000 * tmp$ret$21);
    var speedMultiplier = 1.0;
    if (this.bc2_1 > 0)
      speedMultiplier = speedMultiplier * 0.75;
    if (this.cc2_1 > 0)
      speedMultiplier = speedMultiplier * 0.75;
    if (this.dc2_1 > 0)
      speedMultiplier = speedMultiplier * 0.5;
    this.kbz_1 = 20.0 * speedMultiplier;
    var tmp_21 = this;
    // Inline function 'kotlin.math.pow' call
    var x_21 = this.bc2_1;
    var tmp$ret$22 = Math.pow(2.0, x_21);
    tmp_21.rc0_1 = numberToInt(30 * tmp$ret$22);
    var tmp_22 = this;
    // Inline function 'kotlin.math.pow' call
    var x_22 = this.cc2_1;
    var tmp$ret$23 = Math.pow(2.5, x_22);
    tmp_22.sc0_1 = numberToInt(180 * tmp$ret$23);
    var tmp_23 = this;
    // Inline function 'kotlin.math.pow' call
    var x_23 = this.dc2_1;
    var tmp$ret$24 = Math.pow(3.0, x_23);
    tmp_23.tc0_1 = numberToInt(2500 * tmp$ret$24);
  }
}
class Gender extends Enum {}
class HairStyle extends Enum {}
class OutfitStyle extends Enum {}
class Appearance {
  constructor(hairStyle, hairColor, outfitStyle, skinColor) {
    this.qc3_1 = hairStyle;
    this.rc3_1 = hairColor;
    this.sc3_1 = outfitStyle;
    this.tc3_1 = skinColor;
  }
  toString() {
    return 'Appearance(hairStyle=' + this.qc3_1.toString() + ', hairColor=' + RGBA__toString_impl_4lw6dp(this.rc3_1) + ', outfitStyle=' + this.sc3_1.toString() + ', skinColor=' + RGBA__toString_impl_4lw6dp(this.tc3_1) + ')';
  }
  hashCode() {
    var result = this.qc3_1.hashCode();
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.rc3_1) | 0;
    result = imul(result, 31) + this.sc3_1.hashCode() | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.tc3_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Appearance))
      return false;
    var tmp0_other_with_cast = other instanceof Appearance ? other : THROW_CCE();
    if (!this.qc3_1.equals(tmp0_other_with_cast.qc3_1))
      return false;
    if (!(this.rc3_1 === tmp0_other_with_cast.rc3_1))
      return false;
    if (!this.sc3_1.equals(tmp0_other_with_cast.sc3_1))
      return false;
    if (!(this.tc3_1 === tmp0_other_with_cast.tc3_1))
      return false;
    return true;
  }
}
class GameSquare {
  constructor(container, startX, startY, baseColor, initialVelocity, size, adultAge, gender, fixedHairStyle, fixedOutfitStyle, collisionCooldownDuration, soundManager, config) {
    fixedHairStyle = fixedHairStyle === VOID ? null : fixedHairStyle;
    fixedOutfitStyle = fixedOutfitStyle === VOID ? null : fixedOutfitStyle;
    collisionCooldownDuration = collisionCooldownDuration === VOID ? 5.0 : collisionCooldownDuration;
    soundManager = soundManager === VOID ? null : soundManager;
    config = config === VOID ? null : config;
    this.uc3_1 = container;
    this.vc3_1 = baseColor;
    this.wc3_1 = size;
    this.xc3_1 = adultAge;
    this.yc3_1 = gender;
    this.zc3_1 = collisionCooldownDuration;
    this.ac4_1 = soundManager;
    this.bc4_1 = config;
    this.ec4_1 = initialVelocity;
    this.fc4_1 = initialVelocity;
    this.gc4_1 = 0.0;
    this.hc4_1 = false;
    this.ic4_1 = 0.0;
    this.jc4_1 = 0.0;
    this.kc4_1 = false;
    this.lc4_1 = 0.0;
    this.mc4_1 = 0.5;
    this.nc4_1 = 60.0;
    this.oc4_1 = NameGenerator_getInstance().kc5(this.yc3_1);
    this.pc4_1 = 0.0;
    this.qc4_1 = 0;
    var tmp = this;
    var tmp_0;
    if (!(fixedHairStyle == null) && !(fixedOutfitStyle == null)) {
      tmp_0 = generateFixedAppearance(this, fixedHairStyle, fixedOutfitStyle);
    } else {
      tmp_0 = generateRandomAppearance(this);
    }
    tmp.sc4_1 = tmp_0;
    var tmp_1 = this;
    // Inline function 'korlibs.korge.view.container' call
    var this_0 = this.uc3_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = Container.za4(false);
    // Inline function 'kotlin.apply' call
    var this_2 = addTo(this_1, this_0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'GameSquare.<anonymous>' call
    position(this_2, startX, startY);
    tmp_1.cc4_1 = this_2;
    var tmp_2 = this;
    // Inline function 'korlibs.korge.view.solidRect' call
    var this_3 = this.cc4_1;
    var width = this.wc3_1;
    var height = this.wc3_1;
    var color = Colors_getInstance().l40_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_4 = SolidRect.cbl(Size2D.f2i(width, height), color);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
    tmp_2.dc4_1 = addTo(this_4, this_3);
    updateSprite(this);
    // Inline function 'korlibs.korge.input.onClick' call
    var this_5 = this.cc4_1;
    var handler = GameSquare$lambda(this);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop = click$factory_2();
    var tmp1_safe_receiver = this_5 == null ? null : this_5.gai();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp1_safe_receiver.f1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var tmp0_safe_receiver = tmp1_safe_receiver.e1(_unary__edvuaz);
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
        if (tmp1_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_3 = prop.get(tmp1_safe_receiver_0);
          tmp_3.q20(GameSquare$lambda_0(handler));
        }
      }
    }
  }
  lc5() {
    return this.gc4_1 >= this.xc3_1;
  }
  mc5() {
    var tmp0_safe_receiver = this.bc4_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sby_1;
    var maxFertileAge = (tmp1_elvis_lhs == null ? 0.8 : tmp1_elvis_lhs) * this.nc4_1;
    return this.gc4_1 <= maxFertileAge;
  }
  tc4() {
    return !this.hc4_1 && this.lc5() && this.jc4_1 <= 0 && !this.kc4_1 && this.mc5();
  }
  nc5() {
    return this.kc4_1 && this.lc4_1 >= this.mc4_1;
  }
  m2i() {
    return this.cc4_1.b6j() + this.wc3_1 / 2;
  }
  n2i() {
    return this.cc4_1.c6j() + this.wc3_1 / 2;
  }
  oc5(deltaTime) {
    if (this.kc4_1) {
      updateDeathState(this, deltaTime);
    } else if (this.hc4_1) {
      updateFrozenState(this, deltaTime);
    } else {
      updateActiveState(this, deltaTime);
      updateAnimation(this, deltaTime);
    }
  }
  pc5(deltaTime) {
    if (!this.hc4_1) {
      var _receiver__tnumb7 = this.cc4_1;
      _receiver__tnumb7.tai(_receiver__tnumb7.b6j() + this.ec4_1.a2a_1 * deltaTime);
      var _receiver__tnumb7_0 = this.cc4_1;
      _receiver__tnumb7_0.uai(_receiver__tnumb7_0.c6j() + this.ec4_1.b2a_1 * deltaTime);
    }
  }
  qc5(containerX, containerY, containerWidth, containerHeight) {
    if (this.cc4_1.b6j() <= containerX || this.cc4_1.b6j() + this.wc3_1 >= containerX + containerWidth) {
      this.ec4_1 = Vector2D.k2c(-this.ec4_1.a2a_1, this.ec4_1.b2a_1);
      this.fc4_1 = this.ec4_1;
      this.cc4_1.tai(coerceIn(this.cc4_1.b6j(), containerX, containerX + containerWidth - this.wc3_1));
    }
    if (this.cc4_1.c6j() <= containerY || this.cc4_1.c6j() + this.wc3_1 >= containerY + containerHeight) {
      this.ec4_1 = Vector2D.k2c(this.ec4_1.a2a_1, -this.ec4_1.b2a_1);
      this.fc4_1 = this.ec4_1;
      this.cc4_1.uai(coerceIn(this.cc4_1.c6j(), containerY, containerY + containerHeight - this.wc3_1));
    }
  }
  rc5() {
    this.hc4_1 = true;
    this.ic4_1 = 2.0;
    this.fc4_1 = this.ec4_1;
    this.ec4_1 = Vector2D.k2c(0.0, 0.0);
    this.cc4_1.i8q(false);
  }
  r6() {
    this.cc4_1.kak();
  }
  sc5() {
    this.kc4_1 = true;
    this.lc4_1 = 0.0;
    this.ec4_1 = Vector2D.k2c(0.0, 0.0);
    updateSprite(this);
  }
  tc5(newLifespan) {
    this.nc4_1 = newLifespan;
  }
}
class GravestoneSpriteCache {
  constructor() {
    GravestoneSpriteCache_instance = this;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.uc5_1 = LinkedHashMap.oc();
  }
  vc5(size) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.uc5_1;
    var value = this_0.f3(size);
    var tmp;
    if (value == null) {
      // Inline function 'GravestoneSpriteCache.getOrCreateGravestone.<anonymous>' call
      var answer = createGravestoneBitmap(GravestoneSpriteCache_getInstance(), size);
      this_0.h3(size, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  }
}
class HumanSpriteCache {
  constructor() {
    HumanSpriteCache_instance = this;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.uc4_1 = LinkedHashMap.oc();
  }
  vc4(size, appearance, baseColor, frame) {
    var key = '' + appearance.hashCode() + '_' + _RGBA___get_value__impl__hhco8v(baseColor) + '_' + frame;
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.uc4_1;
    var value = this_0.f3(key);
    var tmp;
    if (value == null) {
      // Inline function 'HumanSpriteCache.getOrCreateSprite.<anonymous>' call
      var answer = createHumanBitmap(HumanSpriteCache_getInstance(), size, appearance, baseColor, frame);
      this_0.h3(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  }
}
class Localization {
  constructor() {
    Localization_instance = this;
    this.mbv_1 = 'en';
    this.nbv_1 = mapOf([to('px_per_sec', mapOf([to('en', 'px/sec'), to('de', 'px/Sek'), to('ru', '\u043F\u043A\u0441/\u0441\u0435\u043A'), to('cs', 'px/s'), to('fr', 'px/s')])), to('enabled', mapOf([to('en', 'Enabled'), to('de', 'Aktiviert'), to('ru', '\u0412\u043A\u043B\u044E\u0447\u0435\u043D\u043E'), to('cs', 'Povoleno'), to('fr', 'Activ\xE9')])), to('disabled', mapOf([to('en', 'Disabled'), to('de', 'Deaktiviert'), to('ru', '\u041E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u043E'), to('cs', 'Zak\xE1z\xE1no'), to('fr', 'D\xE9sactiv\xE9')])), to('game_title', mapOf([to('en', 'People Maker'), to('de', 'Menschen Macher'), to('ru', '\u0421\u043E\u0437\u0434\u0430\u0442\u0435\u043B\u044C \u041B\u044E\u0434\u0435\u0439'), to('cs', 'Tv\u016Frce Lid\xED'), to('fr', 'Cr\xE9ateur de Personnes')])), to('population', mapOf([to('en', 'Population:'), to('de', 'Bev\xF6lkerung:'), to('ru', '\u041D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u0435:'), to('cs', 'Populace:'), to('fr', 'Population:')])), to('score', mapOf([to('en', 'Score:'), to('de', 'Punkte:'), to('ru', '\u041E\u0447\u043A\u0438:'), to('cs', 'Sk\xF3re:'), to('fr', 'Score:')])), to('time', mapOf([to('en', 'Time:'), to('de', 'Zeit:'), to('ru', '\u0412\u0440\u0435\u043C\u044F:'), to('cs', '\u010Cas:'), to('fr', 'Temps:')])), to('births', mapOf([to('en', 'Births:'), to('de', 'Geburten:'), to('ru', '\u0420\u043E\u0436\u0434\u0435\u043D\u0438\u0439:'), to('cs', 'Narozen\xED:'), to('fr', 'Naissances:')])), to('deaths', mapOf([to('en', 'Deaths:'), to('de', 'Todesf\xE4lle:'), to('ru', '\u0421\u043C\u0435\u0440\u0442\u0435\u0439:'), to('cs', '\xDAmrt\xED:'), to('fr', 'D\xE9c\xE8s:')])), to('collisions', mapOf([to('en', 'Collisions:'), to('de', 'Kollisionen:'), to('ru', '\u0421\u0442\u043E\u043B\u043A\u043D\u043E\u0432\u0435\u043D\u0438\u0439:'), to('cs', 'Kolize:'), to('fr', 'Collisions:')])), to('gender_ratio', mapOf([to('en', 'Gender Ratio:'), to('de', 'Geschlechterverh\xE4ltnis:'), to('ru', '\u0421\u043E\u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0435 \u043F\u043E\u043B\u043E\u0432:'), to('cs', 'Pom\u011Br pohlav\xED:'), to('fr', 'Ratio de genre:')])), to('finish_round', mapOf([to('en', 'Finish round'), to('de', 'Runde beenden'), to('ru', '\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0440\u0430\u0443\u043D\u0434'), to('cs', 'Dokon\u010Dit kolo'), to('fr', 'Terminer le tour')])), to('upgrades', mapOf([to('en', 'Upgrades'), to('de', 'Upgrades'), to('ru', '\u0423\u043B\u0443\u0447\u0448\u0435\u043D\u0438\u044F'), to('cs', 'Vylep\u0161en\xED'), to('fr', 'Am\xE9liorations')])), to('settings', mapOf([to('en', 'Settings'), to('de', 'Einstellungen'), to('ru', '\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438'), to('cs', 'Nastaven\xED'), to('fr', 'Param\xE8tres')])), to('achievements', mapOf([to('en', 'Achievements'), to('de', 'Erfolge'), to('ru', '\u0414\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F'), to('cs', '\xDAsp\u011Bchy'), to('fr', 'Succ\xE8s')])), to('reset', mapOf([to('en', 'Reset'), to('de', 'Zur\xFCcksetzen'), to('ru', '\u0421\u0431\u0440\u043E\u0441'), to('cs', 'Reset'), to('fr', 'R\xE9initialiser')])), to('close', mapOf([to('en', 'Close'), to('de', 'Schlie\xDFen'), to('ru', '\u0417\u0430\u043A\u0440\u044B\u0442\u044C'), to('cs', 'Zav\u0159\xEDt'), to('fr', 'Fermer')])), to('settings_title', mapOf([to('en', 'Settings'), to('de', 'Einstellungen'), to('ru', '\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438'), to('cs', 'Nastaven\xED'), to('fr', 'Param\xE8tres')])), to('language', mapOf([to('en', 'Language:'), to('de', 'Sprache:'), to('ru', '\u042F\u0437\u044B\u043A:'), to('cs', 'Jazyk:'), to('fr', 'Langue:')])), to('sfx_volume', mapOf([to('en', 'SFX Volume:'), to('de', 'SFX-Lautst\xE4rke:'), to('ru', '\u0413\u0440\u043E\u043C\u043A\u043E\u0441\u0442\u044C \u0437\u0432\u0443\u043A\u043E\u0432:'), to('cs', 'Hlasitost SFX:'), to('fr', 'Volume SFX:')])), to('total_time', mapOf([to('en', 'Total Time Played:'), to('de', 'Gesamte Spielzeit:'), to('ru', '\u041E\u0431\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u0438\u0433\u0440\u044B:'), to('cs', 'Celkov\xFD \u010Das hry:'), to('fr', 'Temps total jou\xE9:')])), to('achievements_title', mapOf([to('en', 'Achievements'), to('de', 'Erfolge'), to('ru', '\u0414\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F'), to('cs', '\xDAsp\u011Bchy'), to('fr', 'Succ\xE8s')])), to('unlocked', mapOf([to('en', 'Unlocked!'), to('de', 'Freigeschaltet!'), to('ru', '\u0420\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043E!'), to('cs', 'Odem\u010Deno!'), to('fr', 'D\xE9bloqu\xE9!')])), to('upgrade_tree', mapOf([to('en', 'Upgrade Tree'), to('de', 'Upgrade-Baum'), to('ru', '\u0414\u0435\u0440\u0435\u0432\u043E \u0443\u043B\u0443\u0447\u0448\u0435\u043D\u0438\u0439'), to('cs', 'Strom vylep\u0161en\xED'), to('fr', "Arbre d'am\xE9liorations")])), to('drag_mouse', mapOf([to('en', 'Drag with mouse to move around'), to('de', 'Mit der Maus ziehen, um sich zu bewegen'), to('ru', '\u041F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u0439\u0442\u0435 \u043C\u044B\u0448\u044C\u044E \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0438\u044F'), to('cs', 'P\u0159eta\u017Een\xEDm my\u0161\xED se pohybujte'), to('fr', 'Glissez avec la souris pour vous d\xE9placer')])), to('scroll_zoom', mapOf([to('en', 'Scroll to zoom'), to('de', 'Scrollen zum Zoomen'), to('ru', '\u041F\u0440\u043E\u043A\u0440\u0443\u0442\u043A\u0430 \u0434\u043B\u044F \u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F'), to('cs', 'Rolujte pro p\u0159ibl\xED\u017Een\xED'), to('fr', 'D\xE9filer pour zoomer')])), to('save_position', mapOf([to('en', 'Save Position'), to('de', 'Position speichern'), to('ru', '\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u043F\u043E\u0437\u0438\u0446\u0438\u044E'), to('cs', 'Ulo\u017Eit pozici'), to('fr', 'Sauvegarder la position')])), to('return_to_game', mapOf([to('en', 'Return to Game'), to('de', 'Zur\xFCck zum Spiel'), to('ru', '\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u0432 \u0438\u0433\u0440\u0443'), to('cs', 'Vr\xE1tit se do hry'), to('fr', 'Retour au jeu')])), to('cost', mapOf([to('en', 'Cost:'), to('de', 'Kosten:'), to('ru', '\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C:'), to('cs', 'Cena:'), to('fr', 'Co\xFBt:')])), to('requires', mapOf([to('en', 'Requires:'), to('de', 'Ben\xF6tigt:'), to('ru', '\u0422\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F:'), to('cs', 'Vy\u017Eaduje:'), to('fr', 'N\xE9cessite:')])), to('game_over', mapOf([to('en', 'Game Over'), to('de', 'Spiel vorbei'), to('ru', '\u0418\u0433\u0440\u0430 \u043E\u043A\u043E\u043D\u0447\u0435\u043D\u0430'), to('cs', 'Konec hry'), to('fr', 'Fin du jeu')])), to('no_people_left', mapOf([to('en', 'No people left!'), to('de', 'Keine Menschen mehr \xFCbrig!'), to('ru', '\u041D\u0435 \u043E\u0441\u0442\u0430\u043B\u043E\u0441\u044C \u043B\u044E\u0434\u0435\u0439!'), to('cs', '\u017D\xE1dn\xED lid\xE9 nez\u016Fstali!'), to('fr', 'Plus personne!')])), to('open_upgrades', mapOf([to('en', 'Open Upgrades'), to('de', 'Upgrades \xF6ffnen'), to('ru', '\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0443\u043B\u0443\u0447\u0448\u0435\u043D\u0438\u044F'), to('cs', 'Otev\u0159\xEDt vylep\u0161en\xED'), to('fr', 'Ouvrir am\xE9liorations')])), to('victory', mapOf([to('en', 'Victory!'), to('de', 'Sieg!'), to('ru', '\u041F\u043E\u0431\u0435\u0434\u0430!'), to('cs', 'V\xEDt\u011Bzstv\xED!'), to('fr', 'Victoire!')])), to('congratulations', mapOf([to('en', 'Congratulations!'), to('de', 'Gl\xFCckwunsch!'), to('ru', '\u041F\u043E\u0437\u0434\u0440\u0430\u0432\u043B\u044F\u0435\u043C!'), to('cs', 'Gratulujeme!'), to('fr', 'F\xE9licitations!')])), to('victory_message', mapOf([to('en', "You've reached 1000 people!"), to('de', 'Du hast 1000 Menschen erreicht!'), to('ru', '\u0412\u044B \u0434\u043E\u0441\u0442\u0438\u0433\u043B\u0438 1000 \u0447\u0435\u043B\u043E\u0432\u0435\u043A!'), to('cs', 'Dos\xE1hli jste 1000 lid\xED!'), to('fr', 'Vous avez atteint 1000 personnes!')])), to('thank_you', mapOf([to('en', 'Thank you for playing!'), to('de', 'Danke f\xFCrs Spielen!'), to('ru', '\u0421\u043F\u0430\u0441\u0438\u0431\u043E \u0437\u0430 \u0438\u0433\u0440\u0443!'), to('cs', 'D\u011Bkujeme za hran\xED!'), to('fr', "Merci d'avoir jou\xE9!")])), to('created_by', mapOf([to('en', 'Created by Arsenii Lisunov'), to('de', 'Erstellt von Arsenii Lisunov'), to('ru', '\u0421\u043E\u0437\u0434\u0430\u043D\u043E \u0410\u0440\u0441\u0435\u043D\u0438\u0435\u043C \u041B\u0438\u0441\u0443\u043D\u043E\u0432\u044B\u043C'), to('cs', 'Vytvo\u0159il Arsenii Lisunov'), to('fr', 'Cr\xE9\xE9 par Arsenii Lisunov')])), to('session_time', mapOf([to('en', 'Session Time:'), to('de', 'Sitzungszeit:'), to('ru', '\u0412\u0440\u0435\u043C\u044F \u0441\u0435\u0441\u0441\u0438\u0438:'), to('cs', '\u010Cas relace:'), to('fr', 'Temps de session:')])), to('total_time_played', mapOf([to('en', 'Total Time Played:'), to('de', 'Gesamte Spielzeit:'), to('ru', '\u041E\u0431\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u0438\u0433\u0440\u044B:'), to('cs', 'Celkov\xFD \u010Das hry:'), to('fr', 'Temps total jou\xE9:')])), to('continue_playing', mapOf([to('en', 'Continue Playing'), to('de', 'Weiterspielen'), to('ru', '\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0438\u0433\u0440\u0443'), to('cs', 'Pokra\u010Dovat ve h\u0159e'), to('fr', 'Continuer \xE0 jouer')])), to('upgrade_start', mapOf([to('en', 'Genesis'), to('de', 'Genesis'), to('ru', '\u0413\u0435\u043D\u0435\u0437\u0438\u0441'), to('cs', 'Genesis'), to('fr', 'Gen\xE8se')])), to('upgrade_collision_cooldown', mapOf([to('en', 'Quick Recovery'), to('de', 'Schnelle Erholung'), to('ru', '\u0411\u044B\u0441\u0442\u0440\u043E\u0435 \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435'), to('cs', 'Rychl\xE9 zotaven\xED'), to('fr', 'R\xE9cup\xE9ration rapide')])), to('upgrade_adult_age', mapOf([to('en', 'Early Maturity'), to('de', 'Fr\xFChe Reife'), to('ru', '\u0420\u0430\u043D\u043D\u0435\u0435 \u0432\u0437\u0440\u043E\u0441\u043B\u0435\u043D\u0438\u0435'), to('cs', 'Brzk\xE1 dosp\u011Blost'), to('fr', 'Maturit\xE9 pr\xE9coce')])), to('upgrade_max_speed', mapOf([to('en', 'Swift Movement'), to('de', 'Schnelle Bewegung'), to('ru', '\u0411\u044B\u0441\u0442\u0440\u043E\u0435 \u0434\u0432\u0438\u0436\u0435\u043D\u0438\u0435'), to('cs', 'Rychl\xFD pohyb'), to('fr', 'Mouvement rapide')])), to('upgrade_max_population', mapOf([to('en', 'Population Growth'), to('de', 'Bev\xF6lkerungswachstum'), to('ru', '\u0420\u043E\u0441\u0442 \u043D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u044F'), to('cs', 'R\u016Fst populace'), to('fr', 'Croissance d\xE9mographique')])), to('upgrade_birth_bonus', mapOf([to('en', 'Twin Boom'), to('de', 'Zwillingsboom'), to('ru', '\u0411\u043B\u0438\u0437\u043D\u0435\u0446\u043E\u0432\u044B\u0439 \u0431\u0443\u043C'), to('cs', 'Dvoj\u010Data'), to('fr', 'Boom de jumeaux')])), to('upgrade_movement_efficiency', mapOf([to('en', 'Graceful Motion'), to('de', 'Anmutige Bewegung'), to('ru', '\u0413\u0440\u0430\u0446\u0438\u043E\u0437\u043D\u043E\u0435 \u0434\u0432\u0438\u0436\u0435\u043D\u0438\u0435'), to('cs', 'Elegantn\xED pohyb'), to('fr', 'Mouvement gracieux')])), to('upgrade_fertility_rate', mapOf([to('en', 'Fertility Boost'), to('de', 'Fruchtbarkeitsschub'), to('ru', '\u041F\u043E\u0432\u044B\u0448\u0435\u043D\u0438\u0435 \u0444\u0435\u0440\u0442\u0438\u043B\u044C\u043D\u043E\u0441\u0442\u0438'), to('cs', 'Zv\xFD\u0161en\xED plodnosti'), to('fr', 'Boost de fertilit\xE9')])), to('upgrade_lifespan', mapOf([to('en', 'Longevity'), to('de', 'Langlebigkeit'), to('ru', '\u0414\u043E\u043B\u0433\u043E\u043B\u0435\u0442\u0438\u0435'), to('cs', 'Dlouhov\u011Bkost'), to('fr', 'Long\xE9vit\xE9')])), to('upgrade_gender_balance', mapOf([to('en', 'Gender Balance'), to('de', 'Geschlechtergleichgewicht'), to('ru', '\u0413\u0435\u043D\u0434\u0435\u0440\u043D\u044B\u0439 \u0431\u0430\u043B\u0430\u043D\u0441'), to('cs', 'Rovnov\xE1ha pohlav\xED'), to('fr', '\xC9quilibre des genres')])), to('upgrade_collision_range', mapOf([to('en', 'Social Proximity'), to('de', 'Soziale N\xE4he'), to('ru', '\u0421\u043E\u0446\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u0431\u043B\u0438\u0437\u043E\u0441\u0442\u044C'), to('cs', 'Soci\xE1ln\xED bl\xEDzkost'), to('fr', 'Proximit\xE9 sociale')])), to('upgrade_fertility_age', mapOf([to('en', 'Extended Fertility'), to('de', 'Erweiterte Fruchtbarkeit'), to('ru', '\u041F\u0440\u043E\u0434\u043B\u0435\u043D\u043D\u0430\u044F \u0444\u0435\u0440\u0442\u0438\u043B\u044C\u043D\u043E\u0441\u0442\u044C'), to('cs', 'Prodlou\u017Een\xE1 plodnost'), to('fr', 'Fertilit\xE9 prolong\xE9e')])), to('upgrade_auto_spawn', mapOf([to('en', 'Life Generator'), to('de', 'Lebensgenerator'), to('ru', '\u0413\u0435\u043D\u0435\u0440\u0430\u0442\u043E\u0440 \u0436\u0438\u0437\u043D\u0438'), to('cs', 'Gener\xE1tor \u017Eivota'), to('fr', 'G\xE9n\xE9rateur de vie')])), to('upgrade_auto_spawn_rate', mapOf([to('en', 'Rapid Genesis'), to('de', 'Schnelle Genesis'), to('ru', '\u0411\u044B\u0441\u0442\u0440\u044B\u0439 \u0433\u0435\u043D\u0435\u0437\u0438\u0441'), to('cs', 'Rychl\xE1 geneze'), to('fr', 'Gen\xE8se rapide')])), to('upgrade_score_multiplier', mapOf([to('en', 'Score Boost'), to('de', 'Punktebonus'), to('ru', '\u0411\u043E\u043D\u0443\u0441 \u043E\u0447\u043A\u043E\u0432'), to('cs', 'Bonus sk\xF3re'), to('fr', 'Bonus de score')])), to('upgrade_time_acceleration', mapOf([to('en', 'Time Warp'), to('de', 'Zeitverzerrung'), to('ru', '\u0418\u0441\u043A\u0430\u0436\u0435\u043D\u0438\u0435 \u0432\u0440\u0435\u043C\u0435\u043D\u0438'), to('cs', 'Zrychlen\xED \u010Dasu'), to('fr', 'Distorsion temporelle')])), to('upgrade_mass_reproduction', mapOf([to('en', 'Mass Reproduction'), to('de', 'Massenreproduktion'), to('ru', '\u041C\u0430\u0441\u0441\u043E\u0432\u043E\u0435 \u0440\u0430\u0437\u043C\u043D\u043E\u0436\u0435\u043D\u0438\u0435'), to('cs', 'Hromadn\xE1 reprodukce'), to('fr', 'Reproduction de masse')])), to('upgrade_evolution_bonus', mapOf([to('en', 'Evolution Leap'), to('de', 'Evolutionssprung'), to('ru', '\u042D\u0432\u043E\u043B\u044E\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u0441\u043A\u0430\u0447\u043E\u043A'), to('cs', 'Evolu\u010Dn\xED skok'), to('fr', 'Bond \xE9volutif')])), to('upgrade_ultra_speed', mapOf([to('en', 'Ultra Speed'), to('de', 'Ultrageschwindigkeit'), to('ru', '\u0423\u043B\u044C\u0442\u0440\u0430\u0441\u043A\u043E\u0440\u043E\u0441\u0442\u044C'), to('cs', 'Ultrarychlost'), to('fr', 'Vitesse ultra')])), to('upgrade_instant_maturity', mapOf([to('en', 'Instant Maturity'), to('de', 'Sofortige Reife'), to('ru', '\u041C\u0433\u043D\u043E\u0432\u0435\u043D\u043D\u043E\u0435 \u0432\u0437\u0440\u043E\u0441\u043B\u0435\u043D\u0438\u0435'), to('cs', 'Okam\u017Eit\xE1 dosp\u011Blost'), to('fr', 'Maturit\xE9 instantan\xE9e')])), to('upgrade_mega_population', mapOf([to('en', 'Mega Population'), to('de', 'Megabev\xF6lkerung'), to('ru', '\u041C\u0435\u0433\u0430 \u043D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u0435'), to('cs', 'Mega populace'), to('fr', 'M\xE9ga population')])), to('upgrade_infinite_population', mapOf([to('en', 'Infinite Population'), to('de', 'Unendliche Bev\xF6lkerung'), to('ru', '\u0411\u0435\u0441\u043A\u043E\u043D\u0435\u0447\u043D\u043E\u0435 \u043D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u0435'), to('cs', 'Nekone\u010Dn\xE1 populace'), to('fr', 'Population infinie')])), to('upgrade_fertility_explosion', mapOf([to('en', 'Fertility Explosion'), to('de', 'Fruchtbarkeitsexplosion'), to('ru', '\u0412\u0437\u0440\u044B\u0432 \u0444\u0435\u0440\u0442\u0438\u043B\u044C\u043D\u043E\u0441\u0442\u0438'), to('cs', 'Explozi plodnosti'), to('fr', 'Explosion de fertilit\xE9')])), to('upgrade_score_ascension', mapOf([to('en', 'Score Ascension'), to('de', 'Punkteaufstieg'), to('ru', '\u0412\u043E\u0437\u043D\u0435\u0441\u0435\u043D\u0438\u0435 \u043E\u0447\u043A\u043E\u0432'), to('cs', 'Vzestup sk\xF3re'), to('fr', 'Ascension du score')])), to('upgrade_time_dilation', mapOf([to('en', 'Time Dilation'), to('de', 'Zeitdehnung'), to('ru', '\u0417\u0430\u043C\u0435\u0434\u043B\u0435\u043D\u0438\u0435 \u0432\u0440\u0435\u043C\u0435\u043D\u0438'), to('cs', '\u010Casov\xE1 dilatace'), to('fr', 'Dilatation temporelle')])), to('upgrade_reproduction_frenzy', mapOf([to('en', 'Reproduction Frenzy'), to('de', 'Reproduktionsrausch'), to('ru', '\u0411\u0435\u0437\u0443\u043C\u0438\u0435 \u0440\u0430\u0437\u043C\u043D\u043E\u0436\u0435\u043D\u0438\u044F'), to('cs', 'Reproduk\u010Dn\xED \u0161\xEDlenstv\xED'), to('fr', 'Fr\xE9n\xE9sie de reproduction')])), to('upgrade_cosmic_convergence', mapOf([to('en', 'Cosmic Convergence'), to('de', 'Kosmische Konvergenz'), to('ru', '\u041A\u043E\u0441\u043C\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043A\u043E\u043D\u0432\u0435\u0440\u0433\u0435\u043D\u0446\u0438\u044F'), to('cs', 'Kosmick\xE1 konvergence'), to('fr', 'Convergence cosmique')])), to('upgrade_transcendence', mapOf([to('en', 'Transcendence'), to('de', 'Transzendenz'), to('ru', '\u0422\u0440\u0430\u043D\u0441\u0446\u0435\u043D\u0434\u0435\u043D\u0446\u0438\u044F'), to('cs', 'Transcendence'), to('fr', 'Transcendance')])), to('upgrade_starting_population', mapOf([to('en', 'Extra Souls'), to('de', 'Extraseelen'), to('ru', '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0434\u0443\u0448\u0438'), to('cs', 'Extra du\u0161e'), to('fr', '\xC2mes suppl\xE9mentaires')])), to('upgrade_starting_population_boost', mapOf([to('en', 'Soul Surge'), to('de', 'Seelenflut'), to('ru', '\u0412\u0441\u043F\u043B\u0435\u0441\u043A \u0434\u0443\u0448'), to('cs', 'P\u0159\xEDliv du\u0161\xED'), to('fr', "Vague d'\xE2mes")])), to('upgrade_starting_population_mega', mapOf([to('en', 'Soul Storm'), to('de', 'Seelensturm'), to('ru', '\u0411\u0443\u0440\u044F \u0434\u0443\u0448'), to('cs', 'Bou\u0159e du\u0161\xED'), to('fr', "Temp\xEAte d'\xE2mes")])), to('upgrade_click_power', mapOf([to('en', 'Divine Touch'), to('de', 'G\xF6ttliche Ber\xFChrung'), to('ru', '\u0411\u043E\u0436\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0435 \u043F\u0440\u0438\u043A\u043E\u0441\u043D\u043E\u0432\u0435\u043D\u0438\u0435'), to('cs', 'Bo\u017Esk\xFD dotyk'), to('fr', 'Toucher divin')])), to('upgrade_click_power_boost', mapOf([to('en', "Creator's Hand"), to('de', 'Sch\xF6pferhand'), to('ru', '\u0420\u0443\u043A\u0430 \u0441\u043E\u0437\u0434\u0430\u0442\u0435\u043B\u044F'), to('cs', 'Ruka tv\u016Frce'), to('fr', 'Main du cr\xE9ateur')])), to('upgrade_click_power_mega', mapOf([to('en', 'Omnipotent Click'), to('de', 'Allm\xE4chtiger Klick'), to('ru', '\u0412\u0441\u0435\u043C\u043E\u0433\u0443\u0449\u0438\u0439 \u043A\u043B\u0438\u043A'), to('cs', 'V\u0161emohouc\xED kliknut\xED'), to('fr', 'Clic omnipotent')])), to('upgrade_star_speed', mapOf([to('en', 'Stellar Velocity'), to('de', 'Stellare Geschwindigkeit'), to('ru', '\u0417\u0432\u0435\u0437\u0434\u043D\u0430\u044F \u0441\u043A\u043E\u0440\u043E\u0441\u0442\u044C'), to('cs', 'Hv\u011Bzdn\xE1 rychlost'), to('fr', 'Vitesse stellaire')])), to('upgrade_star_speed_boost', mapOf([to('en', 'Cosmic Speed'), to('de', 'Kosmische Geschwindigkeit'), to('ru', '\u041A\u043E\u0441\u043C\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0441\u043A\u043E\u0440\u043E\u0441\u0442\u044C'), to('cs', 'Kosmick\xE1 rychlost'), to('fr', 'Vitesse cosmique')])), to('upgrade_star_speed_mega', mapOf([to('en', 'Light Speed'), to('de', 'Lichtgeschwindigkeit'), to('ru', '\u0421\u043A\u043E\u0440\u043E\u0441\u0442\u044C \u0441\u0432\u0435\u0442\u0430'), to('cs', 'Rychlost sv\u011Btla'), to('fr', 'Vitesse lumi\xE8re')])), to('upgrade_start_desc', mapOf([to('en', 'Start your evolutionary journey'), to('de', 'Beginne deine evolution\xE4re Reise'), to('ru', '\u041D\u0430\u0447\u043D\u0438\u0442\u0435 \u044D\u0432\u043E\u043B\u044E\u0446\u0438\u043E\u043D\u043D\u043E\u0435 \u043F\u0443\u0442\u0435\u0448\u0435\u0441\u0442\u0432\u0438\u0435'), to('cs', 'Zahajte svou evolu\u010Dn\xED cestu'), to('fr', 'Commencez votre voyage \xE9volutif')])), to('upgrade_collision_cooldown_desc', mapOf([to('en', 'Reduce collision cooldown time'), to('de', 'Reduziere Kollisions-Abklingzeit'), to('ru', '\u0421\u043E\u043A\u0440\u0430\u0449\u0435\u043D\u0438\u0435 \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u043F\u043E\u0441\u043B\u0435 \u0441\u0442\u043E\u043B\u043A\u043D\u043E\u0432\u0435\u043D\u0438\u044F'), to('cs', 'Sn\xED\u017E\xED \u010Das odnovu po kolizi'), to('fr', 'R\xE9duire le temps de r\xE9cup\xE9ration de collision')])), to('upgrade_adult_age_desc', mapOf([to('en', 'Humans grow up faster'), to('de', 'Menschen wachsen schneller'), to('ru', '\u041B\u044E\u0434\u0438 \u0432\u0437\u0440\u043E\u0441\u043B\u0435\u044E\u0442 \u0431\u044B\u0441\u0442\u0440\u0435\u0435'), to('cs', 'Lid\xE9 dor\u016Fstaj\xED rychleji'), to('fr', 'Les humains grandissent plus vite')])), to('upgrade_max_speed_desc', mapOf([to('en', 'Humans move faster'), to('de', 'Menschen bewegen sich schneller'), to('ru', '\u041B\u044E\u0434\u0438 \u0434\u0432\u0438\u0433\u0430\u044E\u0442\u0441\u044F \u0431\u044B\u0441\u0442\u0440\u0435\u0435'), to('cs', 'Lid\xE9 se pohybuj\xED rychleji'), to('fr', 'Les humains se d\xE9placent plus vite')])), to('upgrade_max_population_desc', mapOf([to('en', 'Increase population capacity'), to('de', 'Erh\xF6he Bev\xF6lkerungskapazit\xE4t'), to('ru', '\u0423\u0432\u0435\u043B\u0438\u0447\u0435\u043D\u0438\u0435 \u0432\u043C\u0435\u0441\u0442\u0438\u043C\u043E\u0441\u0442\u0438 \u043D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u044F'), to('cs', 'Zv\xFD\u0161it kapacitu populace'), to('fr', 'Augmenter la capacit\xE9 de population')])), to('upgrade_birth_bonus_desc', mapOf([to('en', 'Gain more score per birth'), to('de', 'Erhalte mehr Punkte pro Geburt'), to('ru', '\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 \u043E\u0447\u043A\u043E\u0432 \u0437\u0430 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u0435'), to('cs', 'Z\xEDskejte v\xEDce bod\u016F za narozen\xED'), to('fr', 'Gagner plus de points par naissance')])), to('upgrade_movement_efficiency_desc', mapOf([to('en', 'More consistent movement speed'), to('de', 'Konstantere Bewegungsgeschwindigkeit'), to('ru', '\u0411\u043E\u043B\u0435\u0435 \u043F\u043E\u0441\u0442\u043E\u044F\u043D\u043D\u0430\u044F \u0441\u043A\u043E\u0440\u043E\u0441\u0442\u044C \u0434\u0432\u0438\u0436\u0435\u043D\u0438\u044F'), to('cs', 'Konstantn\u011Bj\u0161\xED rychlost pohybu'), to('fr', 'Vitesse de d\xE9placement plus constante')])), to('upgrade_fertility_rate_desc', mapOf([to('en', 'Increased reproduction success'), to('de', 'Erh\xF6hte Fortpflanzungschance'), to('ru', '\u0423\u0432\u0435\u043B\u0438\u0447\u0435\u043D\u043D\u044B\u0439 \u0443\u0441\u043F\u0435\u0445 \u0440\u0430\u0437\u043C\u043D\u043E\u0436\u0435\u043D\u0438\u044F'), to('cs', 'Zv\xFD\u0161en\xE1 \xFAsp\u011B\u0161nost rozmno\u017Eov\xE1n\xED'), to('fr', 'Succ\xE8s de reproduction accru')])), to('upgrade_lifespan_desc', mapOf([to('en', 'Humans live longer'), to('de', 'Menschen leben l\xE4nger'), to('ru', '\u041B\u044E\u0434\u0438 \u0436\u0438\u0432\u0443\u0442 \u0434\u043E\u043B\u044C\u0448\u0435'), to('cs', 'Lid\xE9 \u017Eij\xED d\xE9le'), to('fr', 'Les humains vivent plus longtemps')])), to('upgrade_gender_balance_desc', mapOf([to('en', 'Adjust male/female ratio'), to('de', 'Passe M\xE4nnlich/Weiblich-Verh\xE4ltnis an'), to('ru', '\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u0441\u043E\u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u044F \u043C\u0443\u0436\u0447\u0438\u043D/\u0436\u0435\u043D\u0449\u0438\u043D'), to('cs', 'Upravit pom\u011Br mu\u017E\u016F/\u017Een'), to('fr', 'Ajuster le ratio homme/femme')])), to('upgrade_collision_range_desc', mapOf([to('en', 'Larger interaction radius'), to('de', 'Gr\xF6\xDFerer Interaktionsradius'), to('ru', '\u0411\u043E\u043B\u044C\u0448\u0438\u0439 \u0440\u0430\u0434\u0438\u0443\u0441 \u0432\u0437\u0430\u0438\u043C\u043E\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F'), to('cs', 'V\u011Bt\u0161\xED polom\u011Br interakce'), to('fr', "Rayon d'interaction plus grand")])), to('upgrade_fertility_age_desc', mapOf([to('en', 'Reproduce until older age'), to('de', 'Reproduziere bis ins h\xF6here Alter'), to('ru', '\u0420\u0430\u0437\u043C\u043D\u043E\u0436\u0435\u043D\u0438\u0435 \u0434\u043E \u0431\u043E\u043B\u0435\u0435 \u0441\u0442\u0430\u0440\u0448\u0435\u0433\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430'), to('cs', 'Rozmno\u017Eov\xE1n\xED do vy\u0161\u0161\xEDho v\u011Bku'), to('fr', "Se reproduire jusqu'\xE0 un \xE2ge avanc\xE9")])), to('upgrade_auto_spawn_desc', mapOf([to('en', 'Automatically spawn new humans'), to('de', 'Automatisch neue Menschen erschaffen'), to('ru', '\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043F\u043E\u044F\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u043E\u0432\u044B\u0445 \u043B\u044E\u0434\u0435\u0439'), to('cs', 'Automaticky vytv\xE1\u0159et nov\xE9 lidi'), to('fr', 'G\xE9n\xE9rer automatiquement de nouveaux humains')])), to('upgrade_auto_spawn_rate_desc', mapOf([to('en', 'Spawn humans faster'), to('de', 'Menschen schneller erschaffen'), to('ru', '\u0411\u044B\u0441\u0442\u0440\u0435\u0435 \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C \u043B\u044E\u0434\u0435\u0439'), to('cs', 'Rychlej\u0161\xED vytv\xE1\u0159en\xED lid\xED'), to('fr', 'G\xE9n\xE9rer des humains plus rapidement')])), to('upgrade_score_multiplier_desc', mapOf([to('en', 'Multiply all score gains'), to('de', 'Multipliziere alle Punktgewinne'), to('ru', '\u0423\u043C\u043D\u043E\u0436\u0435\u043D\u0438\u0435 \u0432\u0441\u0435\u0445 \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u043C\u044B\u0445 \u043E\u0447\u043A\u043E\u0432'), to('cs', 'N\xE1sobit v\u0161echny zisky bod\u016F'), to('fr', 'Multiplier tous les gains de points')])), to('upgrade_time_acceleration_desc', mapOf([to('en', 'Speed up game time'), to('de', 'Beschleunige Spielzeit'), to('ru', '\u0423\u0441\u043A\u043E\u0440\u0435\u043D\u0438\u0435 \u0438\u0433\u0440\u043E\u0432\u043E\u0433\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438'), to('cs', 'Zrychlit hern\xED \u010Das'), to('fr', 'Acc\xE9l\xE9rer le temps de jeu')])), to('upgrade_mass_reproduction_desc', mapOf([to('en', 'Multiple births per collision'), to('de', 'Mehrere Geburten pro Kollision'), to('ru', '\u041D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u0439 \u0437\u0430 \u0441\u0442\u043E\u043B\u043A\u043D\u043E\u0432\u0435\u043D\u0438\u0435'), to('cs', 'V\xEDce narozen\xED na kolizi'), to('fr', 'Naissances multiples par collision')])), to('upgrade_evolution_bonus_desc', mapOf([to('en', 'Boost all stats'), to('de', 'Verbessere alle Werte'), to('ru', '\u0423\u0441\u0438\u043B\u0435\u043D\u0438\u0435 \u0432\u0441\u0435\u0445 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A'), to('cs', 'Pos\xEDlen\xED v\u0161ech statistik'), to('fr', 'Am\xE9liorer toutes les statistiques')])), to('upgrade_ultra_speed_desc', mapOf([to('en', 'Extreme movement speed'), to('de', 'Extreme Bewegungsgeschwindigkeit'), to('ru', '\u042D\u043A\u0441\u0442\u0440\u0435\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u043A\u043E\u0440\u043E\u0441\u0442\u044C \u0434\u0432\u0438\u0436\u0435\u043D\u0438\u044F'), to('cs', 'Extr\xE9mn\xED rychlost pohybu'), to('fr', 'Vitesse de d\xE9placement extr\xEAme')])), to('upgrade_instant_maturity_desc', mapOf([to('en', 'Instant adult status'), to('de', 'Sofortiger Erwachsenenstatus'), to('ru', '\u041C\u0433\u043D\u043E\u0432\u0435\u043D\u043D\u044B\u0439 \u0432\u0437\u0440\u043E\u0441\u043B\u044B\u0439 \u0441\u0442\u0430\u0442\u0443\u0441'), to('cs', 'Okam\u017Eit\xFD status dosp\u011Bl\xE9ho'), to('fr', 'Statut adulte instantan\xE9')])), to('upgrade_mega_population_desc', mapOf([to('en', 'Massive population increase'), to('de', 'Massive Bev\xF6lkerungszunahme'), to('ru', '\u041C\u0430\u0441\u0441\u043E\u0432\u043E\u0435 \u0443\u0432\u0435\u043B\u0438\u0447\u0435\u043D\u0438\u0435 \u043D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u044F'), to('cs', 'Masivn\xED n\xE1r\u016Fst populace'), to('fr', 'Augmentation massive de la population')])), to('upgrade_infinite_population_desc', mapOf([to('en', 'Increase population limit to 500'), to('de', 'Erh\xF6he Bev\xF6lkerungslimit auf 500'), to('ru', '\u0423\u0432\u0435\u043B\u0438\u0447\u0438\u0442\u044C \u043B\u0438\u043C\u0438\u0442 \u043D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u044F \u0434\u043E 500'), to('cs', 'Zv\xFD\u0161it limit populace na 500'), to('fr', 'Augmenter la limite de population \xE0 500')])), to('upgrade_fertility_explosion_desc', mapOf([to('en', 'Guaranteed reproduction'), to('de', 'Garantierte Fortpflanzung'), to('ru', '\u0413\u0430\u0440\u0430\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u0440\u0430\u0437\u043C\u043D\u043E\u0436\u0435\u043D\u0438\u0435'), to('cs', 'Zaru\u010Den\xE9 rozmno\u017Eov\xE1n\xED'), to('fr', 'Reproduction garantie')])), to('upgrade_score_ascension_desc', mapOf([to('en', 'Massive score multiplier'), to('de', 'Massiver Punktemultiplikator'), to('ru', '\u041C\u0430\u0441\u0441\u043E\u0432\u044B\u0439 \u043C\u043D\u043E\u0436\u0438\u0442\u0435\u043B\u044C \u043E\u0447\u043A\u043E\u0432'), to('cs', 'Masivn\xED n\xE1sobitel bod\u016F'), to('fr', 'Multiplicateur de points massif')])), to('upgrade_time_dilation_desc', mapOf([to('en', 'Ultra fast gameplay'), to('de', 'Ultra schnelles Gameplay'), to('ru', '\u0423\u043B\u044C\u0442\u0440\u0430\u0431\u044B\u0441\u0442\u0440\u044B\u0439 \u0433\u0435\u0439\u043C\u043F\u043B\u0435\u0439'), to('cs', 'Ultra rychl\xE1 hra'), to('fr', 'Gameplay ultra rapide')])), to('upgrade_reproduction_frenzy_desc', mapOf([to('en', 'Insane birth rates'), to('de', 'Wahnsinnige Geburtenrate'), to('ru', '\u0411\u0435\u0437\u0443\u043C\u043D\u0430\u044F \u0440\u043E\u0436\u0434\u0430\u0435\u043C\u043E\u0441\u0442\u044C'), to('cs', '\u0160\xEDlen\xE1 porodnost'), to('fr', 'Taux de natalit\xE9 insens\xE9')])), to('upgrade_cosmic_convergence_desc', mapOf([to('en', 'Ultimate power boost'), to('de', 'Ultimative Kraftsteigerung'), to('ru', '\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u0443\u0441\u0438\u043B\u0435\u043D\u0438\u0435 \u043C\u043E\u0449\u0438'), to('cs', 'Maxim\xE1ln\xED pos\xEDlen\xED s\xEDly'), to('fr', 'Boost de puissance ultime')])), to('upgrade_transcendence_desc', mapOf([to('en', 'Transcend all limits'), to('de', '\xDCberschreite alle Grenzen'), to('ru', '\u041F\u0440\u0435\u043E\u0434\u043E\u043B\u0435\u043D\u0438\u0435 \u0432\u0441\u0435\u0445 \u043F\u0440\u0435\u0434\u0435\u043B\u043E\u0432'), to('cs', 'P\u0159ekro\u010Dit v\u0161echny limity'), to('fr', 'Transcender toutes les limites')])), to('upgrade_starting_population_desc', mapOf([to('en', 'Start with more people'), to('de', 'Starte mit mehr Menschen'), to('ru', '\u041D\u0430\u0447\u0430\u0442\u044C \u0441 \u0431\u043E\u043B\u044C\u0448\u0438\u043C \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E\u043C \u043B\u044E\u0434\u0435\u0439'), to('cs', 'Za\u010D\xEDt s v\xEDce lidmi'), to('fr', 'Commencer avec plus de personnes')])), to('upgrade_starting_population_boost_desc', mapOf([to('en', 'Even more starting people'), to('de', 'Noch mehr Startmenschen'), to('ru', '\u0415\u0449\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 \u043B\u044E\u0434\u0435\u0439 \u043D\u0430 \u0441\u0442\u0430\u0440\u0442\u0435'), to('cs', 'Je\u0161t\u011B v\xEDce lid\xED na za\u010D\xE1tku'), to('fr', 'Encore plus de personnes au d\xE9part')])), to('upgrade_starting_population_mega_desc', mapOf([to('en', 'Massive starting population'), to('de', 'Massive Startbev\xF6lkerung'), to('ru', '\u041C\u0430\u0441\u0441\u043E\u0432\u043E\u0435 \u043D\u0430\u0447\u0430\u043B\u044C\u043D\u043E\u0435 \u043D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u0435'), to('cs', 'Masivn\xED po\u010D\xE1te\u010Dn\xED populace'), to('fr', 'Population de d\xE9part massive')])), to('upgrade_click_power_desc', mapOf([to('en', 'Double star score value'), to('de', 'Verdoppelt Stern-Punktewert'), to('ru', '\u0423\u0434\u0432\u043E\u0438\u0442\u044C \u0446\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0437\u0432\u0435\u0437\u0434\u044B'), to('cs', 'Zdvojn\xE1sobit hodnotu hv\u011Bzdy'), to('fr', "Double la valeur d'\xE9toile")])), to('upgrade_click_power_boost_desc', mapOf([to('en', 'Further double star score'), to('de', 'Verdoppelt Sternpunkte weiter'), to('ru', '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u0443\u0434\u0432\u043E\u0435\u043D\u0438\u0435 \u043E\u0447\u043A\u043E\u0432 \u0437\u0432\u0435\u0437\u0434\u044B'), to('cs', 'Dal\u0161\xED zdvojn\xE1soben\xED sk\xF3re hv\u011Bzdy'), to('fr', "Double encore le score d'\xE9toile")])), to('upgrade_click_power_mega_desc', mapOf([to('en', 'Massive star score bonus'), to('de', 'Massiver Sternpunkte-Bonus'), to('ru', '\u041E\u0433\u0440\u043E\u043C\u043D\u044B\u0439 \u0431\u043E\u043D\u0443\u0441 \u043E\u0447\u043A\u043E\u0432 \u0437\u0432\u0435\u0437\u0434\u044B'), to('cs', 'Obrovsk\xFD bonus sk\xF3re hv\u011Bzdy'), to('fr', "Bonus de score d'\xE9toile massif")])), to('upgrade_star_speed_desc', mapOf([to('en', 'Stars respawn 25% faster'), to('de', 'Sterne erscheinen 25% schneller'), to('ru', '\u0417\u0432\u0451\u0437\u0434\u044B \u043F\u043E\u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u043D\u0430 25% \u0431\u044B\u0441\u0442\u0440\u0435\u0435'), to('cs', 'Hv\u011Bzdy se obnovuj\xED o 25% rychleji'), to('fr', 'Les \xE9toiles r\xE9apparaissent 25% plus vite')])), to('upgrade_star_speed_boost_desc', mapOf([to('en', 'Stars respawn even faster'), to('de', 'Sterne erscheinen noch schneller'), to('ru', '\u0417\u0432\u0451\u0437\u0434\u044B \u043F\u043E\u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u0435\u0449\u0451 \u0431\u044B\u0441\u0442\u0440\u0435\u0435'), to('cs', 'Hv\u011Bzdy se obnovuj\xED je\u0161t\u011B rychleji'), to('fr', 'Les \xE9toiles r\xE9apparaissent encore plus vite')])), to('upgrade_star_speed_mega_desc', mapOf([to('en', 'Stars respawn 50% faster'), to('de', 'Sterne erscheinen 50% schneller'), to('ru', '\u0417\u0432\u0451\u0437\u0434\u044B \u043F\u043E\u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u043D\u0430 50% \u0431\u044B\u0441\u0442\u0440\u0435\u0435'), to('cs', 'Hv\u011Bzdy se obnovuj\xED o 50% rychleji'), to('fr', 'Les \xE9toiles r\xE9apparaissent 50% plus vite')])), to('new_game', mapOf([to('en', 'New Game'), to('de', 'Neues Spiel'), to('ru', '\u041D\u043E\u0432\u0430\u044F \u0438\u0433\u0440\u0430'), to('cs', 'Nov\xE1 hra'), to('fr', 'Nouvelle partie')])), to('quit', mapOf([to('en', 'Quit'), to('de', 'Beenden'), to('ru', '\u0412\u044B\u0445\u043E\u0434'), to('cs', 'Ukon\u010Dit'), to('fr', 'Quitter')])), to('main_menu', mapOf([to('en', 'Main Menu'), to('de', 'Hauptmen\xFC'), to('ru', '\u0413\u043B\u0430\u0432\u043D\u043E\u0435 \u043C\u0435\u043D\u044E'), to('cs', 'Hlavn\xED menu'), to('fr', 'Menu principal')])), to('return_to_main_menu', mapOf([to('en', 'Return to Main Menu'), to('de', 'Zur\xFCck zum Hauptmen\xFC'), to('ru', '\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u0432 \u0433\u043B\u0430\u0432\u043D\u043E\u0435 \u043C\u0435\u043D\u044E'), to('cs', 'N\xE1vrat do hlavn\xEDho menu'), to('fr', 'Retour au menu principal')])), to('male', mapOf([to('en', 'Male:'), to('de', 'M\xE4nnlich:'), to('ru', '\u041C\u0443\u0436\u0447\u0438\u043D\u044B:'), to('cs', 'Mu\u017Ei:'), to('fr', 'Hommes:')])), to('female', mapOf([to('en', 'Female:'), to('de', 'Weiblich:'), to('ru', '\u0416\u0435\u043D\u0449\u0438\u043D\u044B:'), to('cs', '\u017Deny:'), to('fr', 'Femmes:')])), to('current_run', mapOf([to('en', 'Current Run:'), to('de', 'Aktueller Durchlauf:'), to('ru', '\u0422\u0435\u043A\u0443\u0449\u0438\u0439 \u0437\u0430\u0431\u0435\u0433:'), to('cs', 'Aktu\xE1ln\xED b\u011Bh:'), to('fr', 'Session actuelle:')])), to('total_playtime', mapOf([to('en', 'Total Playtime:'), to('de', 'Gesamtspielzeit:'), to('ru', '\u041E\u0431\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u0438\u0433\u0440\u044B:'), to('cs', 'Celkov\xFD \u010Das hry:'), to('fr', 'Temps de jeu total:')])), to('game_over_message', mapOf([to('en', 'All your people have died.\nTime to upgrade and try again!'), to('de', 'Alle deine Leute sind gestorben.\nZeit f\xFCr Verbesserungen und einen neuen Versuch!'), to('ru', '\u0412\u0441\u0435 \u0432\u0430\u0448\u0438 \u043B\u044E\u0434\u0438 \u043F\u043E\u0433\u0438\u0431\u043B\u0438.\n\u0412\u0440\u0435\u043C\u044F \u0443\u043B\u0443\u0447\u0448\u0430\u0442\u044C\u0441\u044F \u0438 \u043F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0441\u043D\u043E\u0432\u0430!'), to('cs', 'V\u0161ichni va\u0161i lid\xE9 zem\u0159eli.\n\u010Cas vylep\u0161it a zkusit to znovu!'), to('fr', "Tous vos habitants sont morts.\nTemps d'am\xE9liorer et de r\xE9essayer!")])), to('continue_infinitely', mapOf([to('en', 'Continue Infinitely'), to('de', 'Unendlich weiterspielen'), to('ru', '\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0431\u0435\u0441\u043A\u043E\u043D\u0435\u0447\u043D\u043E'), to('cs', 'Pokra\u010Dovat donekone\u010Dna'), to('fr', "Continuer \xE0 l'infini")])), to('mouse_instructions', mapOf([to('en', 'Use mouse wheel to zoom, drag to pan'), to('de', 'Mausrad zum Zoomen, Ziehen zum Verschieben'), to('ru', '\u041A\u043E\u043B\u0435\u0441\u043E \u043C\u044B\u0448\u0438 \u0434\u043B\u044F \u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0430, \u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u0435 \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0438\u044F'), to('cs', 'Kole\u010Dko my\u0161i pro zoom, ta\u017Een\xED pro posun'), to('fr', 'Molette de la souris pour zoomer, glisser pour d\xE9placer')])), to('no_achievements', mapOf([to('en', 'No achievements unlocked yet!'), to('de', 'Noch keine Erfolge freigeschaltet!'), to('ru', '\u0414\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u0435\u0449\u0435 \u043D\u0435 \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u044B!'), to('cs', 'Zat\xEDm nebyly odem\u010Deny \u017E\xE1dn\xE9 \xFAsp\u011Bchy!'), to('fr', 'Aucun succ\xE8s d\xE9bloqu\xE9 pour le moment!')])), to('locked', mapOf([to('en', 'Locked'), to('de', 'Gesperrt'), to('ru', '\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043E'), to('cs', 'Zam\u010Deno'), to('fr', 'Verrouill\xE9')])), to('purchased', mapOf([to('en', 'Purchased'), to('de', 'Gekauft'), to('ru', '\u041A\u0443\u043F\u043B\u0435\u043D\u043E'), to('cs', 'Koupeno'), to('fr', 'Achet\xE9')])), to('tier', mapOf([to('en', 'Tier'), to('de', 'Stufe'), to('ru', '\u0423\u0440\u043E\u0432\u0435\u043D\u044C'), to('cs', '\xDArove\u0148'), to('fr', 'Niveau')])), to('sound', mapOf([to('en', 'Sound:'), to('de', 'Ton:'), to('ru', '\u0417\u0432\u0443\u043A:'), to('cs', 'Zvuk:'), to('fr', 'Son:')])), to('on', mapOf([to('en', 'ON'), to('de', 'AN'), to('ru', '\u0412\u041A\u041B'), to('cs', 'ZAP'), to('fr', 'ON')])), to('off', mapOf([to('en', 'OFF'), to('de', 'AUS'), to('ru', '\u0412\u042B\u041A\u041B'), to('cs', 'VYP'), to('fr', 'OFF')])), to('volume', mapOf([to('en', 'Volume:'), to('de', 'Lautst\xE4rke:'), to('ru', '\u0413\u0440\u043E\u043C\u043A\u043E\u0441\u0442\u044C:'), to('cs', 'Hlasitost:'), to('fr', 'Volume:')])), to('fullscreen', mapOf([to('en', 'Fullscreen'), to('de', 'Vollbild'), to('ru', '\u041F\u043E\u043B\u043D\u044B\u0439 \u044D\u043A\u0440\u0430\u043D'), to('cs', 'Cel\xE1 obrazovka'), to('fr', 'Plein \xE9cran')])), to('yes', mapOf([to('en', 'Yes'), to('de', 'Ja'), to('ru', '\u0414\u0430'), to('cs', 'Ano'), to('fr', 'Oui')])), to('no', mapOf([to('en', 'No'), to('de', 'Nein'), to('ru', '\u041D\u0435\u0442'), to('cs', 'Ne'), to('fr', 'Non')])), to('reset_confirm', mapOf([to('en', 'Reset everything?'), to('de', 'Alles zur\xFCcksetzen?'), to('ru', '\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0432\u0441\u0451?'), to('cs', 'Resetovat v\u0161e?'), to('fr', 'Tout r\xE9initialiser?')])), to('fps', mapOf([to('en', 'FPS:'), to('de', 'FPS:'), to('ru', 'FPS:'), to('cs', 'FPS:'), to('fr', 'FPS:')])), to('stress_test', mapOf([to('en', 'Stress Test:'), to('de', 'Stresstest:'), to('ru', '\u0421\u0442\u0440\u0435\u0441\u0441-\u0442\u0435\u0441\u0442:'), to('cs', 'Z\xE1t\u011B\u017Eov\xFD test:'), to('fr', 'Test de stress:')])), to('achievement_unlocked', mapOf([to('en', 'Achievement Unlocked!'), to('de', 'Erfolg freigeschaltet!'), to('ru', '\u0414\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u0435 \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043E!'), to('cs', '\xDAsp\u011Bch odem\u010Den!'), to('fr', 'Succ\xE8s d\xE9bloqu\xE9!')])), to('reward', mapOf([to('en', 'Reward:'), to('de', 'Belohnung:'), to('ru', '\u041D\u0430\u0433\u0440\u0430\u0434\u0430:'), to('cs', 'Odm\u011Bna:'), to('fr', 'R\xE9compense:')])), to('unlocked_count', mapOf([to('en', 'Unlocked'), to('de', 'Freigeschaltet'), to('ru', '\u0420\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043E'), to('cs', 'Odem\u010Deno'), to('fr', 'D\xE9bloqu\xE9')])), to('level', mapOf([to('en', 'Level:'), to('de', 'Stufe:'), to('ru', '\u0423\u0440\u043E\u0432\u0435\u043D\u044C:'), to('cs', '\xDArove\u0148:'), to('fr', 'Niveau:')])), to('max_level', mapOf([to('en', 'MAX LEVEL'), to('de', 'MAX STUFE'), to('ru', '\u041C\u0410\u041A\u0421 \u0423\u0420\u041E\u0412\u0415\u041D\u042C'), to('cs', 'MAX \xDAROVE\u0147'), to('fr', 'NIVEAU MAX')])), to('pan_mouse', mapOf([to('en', 'Pan: Left Mouse Drag'), to('de', 'Verschieben: Linke Maustaste ziehen'), to('ru', '\u041F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0438\u0435: \u041F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u0435 \u041B\u041A\u041C'), to('cs', 'Posun: Ta\u017Een\xED lev\xFDm tla\u010D\xEDtkem'), to('fr', 'D\xE9placer: Glisser souris gauche')])), to('zoom_mouse', mapOf([to('en', 'Zoom: Mouse Wheel'), to('de', 'Zoom: Mausrad'), to('ru', '\u041C\u0430\u0441\u0448\u0442\u0430\u0431: \u041A\u043E\u043B\u0435\u0441\u043E \u043C\u044B\u0448\u0438'), to('cs', 'Zoom: Kole\u010Dko my\u0161i'), to('fr', 'Zoom: Molette souris')])), to('save_positions', mapOf([to('en', 'Save Positions'), to('de', 'Positionen speichern'), to('ru', '\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u043F\u043E\u0437\u0438\u0446\u0438\u0438'), to('cs', 'Ulo\u017Eit pozice'), to('fr', 'Sauvegarder positions')])), to('ach_pop_5_title', mapOf([to('en', 'Baby Boom'), to('de', 'Baby-Boom'), to('ru', '\u0414\u0435\u0442\u0441\u043A\u0438\u0439 \u0431\u0443\u043C'), to('cs', 'D\u011Btsk\xFD boom'), to('fr', 'Boom des b\xE9b\xE9s')])), to('ach_pop_5_desc', mapOf([to('en', 'Reach a population of 5'), to('de', 'Erreiche eine Bev\xF6lkerung von 5'), to('ru', '\u0414\u043E\u0441\u0442\u0438\u0433\u043D\u0438\u0442\u0435 \u043D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u044F 5'), to('cs', 'Dos\xE1hn\u011Bte populace 5'), to('fr', 'Atteignez une population de 5')])), to('ach_pop_5_reward', mapOf([to('en', '+100 Score'), to('de', '+100 Punkte'), to('ru', '+100 \u041E\u0447\u043A\u043E\u0432'), to('cs', '+100 Bod\u016F'), to('fr', '+100 Score')])), to('ach_pop_10_title', mapOf([to('en', 'Small Village'), to('de', 'Kleines Dorf'), to('ru', '\u041C\u0430\u043B\u0435\u043D\u044C\u043A\u0430\u044F \u0434\u0435\u0440\u0435\u0432\u043D\u044F'), to('cs', 'Mal\xE1 vesnice'), to('fr', 'Petit village')])), to('ach_pop_10_desc', mapOf([to('en', 'Reach a population of 10'), to('de', 'Erreiche eine Bev\xF6lkerung von 10'), to('ru', '\u0414\u043E\u0441\u0442\u0438\u0433\u043D\u0438\u0442\u0435 \u043D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u044F 10'), to('cs', 'Dos\xE1hn\u011Bte populace 10'), to('fr', 'Atteignez une population de 10')])), to('ach_pop_10_reward', mapOf([to('en', '+250 Score'), to('de', '+250 Punkte'), to('ru', '+250 \u041E\u0447\u043A\u043E\u0432'), to('cs', '+250 Bod\u016F'), to('fr', '+250 Score')])), to('ach_pop_25_title', mapOf([to('en', 'Growing Town'), to('de', 'Wachsende Stadt'), to('ru', '\u0420\u0430\u0441\u0442\u0443\u0449\u0438\u0439 \u0433\u043E\u0440\u043E\u0434'), to('cs', 'Rostouc\xED m\u011Bsto'), to('fr', 'Ville en croissance')])), to('ach_pop_25_desc', mapOf([to('en', 'Reach a population of 25'), to('de', 'Erreiche eine Bev\xF6lkerung von 25'), to('ru', '\u0414\u043E\u0441\u0442\u0438\u0433\u043D\u0438\u0442\u0435 \u043D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u044F 25'), to('cs', 'Dos\xE1hn\u011Bte populace 25'), to('fr', 'Atteignez une population de 25')])), to('ach_pop_25_reward', mapOf([to('en', '+500 Score'), to('de', '+500 Punkte'), to('ru', '+500 \u041E\u0447\u043A\u043E\u0432'), to('cs', '+500 Bod\u016F'), to('fr', '+500 Score')])), to('ach_pop_50_title', mapOf([to('en', 'Metropolis'), to('de', 'Metropole'), to('ru', '\u041C\u0435\u0433\u0430\u043F\u043E\u043B\u0438\u0441'), to('cs', 'Metropole'), to('fr', 'M\xE9tropole')])), to('ach_pop_50_desc', mapOf([to('en', 'Reach a population of 50'), to('de', 'Erreiche eine Bev\xF6lkerung von 50'), to('ru', '\u0414\u043E\u0441\u0442\u0438\u0433\u043D\u0438\u0442\u0435 \u043D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u044F 50'), to('cs', 'Dos\xE1hn\u011Bte populace 50'), to('fr', 'Atteignez une population de 50')])), to('ach_pop_50_reward', mapOf([to('en', '+1,000 Score'), to('de', '+1.000 Punkte'), to('ru', '+1 000 \u041E\u0447\u043A\u043E\u0432'), to('cs', '+1 000 Bod\u016F'), to('fr', '+1 000 Score')])), to('ach_pop_100_title', mapOf([to('en', 'Overpopulation!'), to('de', '\xDCberbev\xF6lkerung!'), to('ru', '\u041F\u0435\u0440\u0435\u043D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u0435!'), to('cs', 'P\u0159elidn\u011Bn\xED!'), to('fr', 'Surpopulation!')])), to('ach_pop_100_desc', mapOf([to('en', 'Reach a population of 100'), to('de', 'Erreiche eine Bev\xF6lkerung von 100'), to('ru', '\u0414\u043E\u0441\u0442\u0438\u0433\u043D\u0438\u0442\u0435 \u043D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u044F 100'), to('cs', 'Dos\xE1hn\u011Bte populace 100'), to('fr', 'Atteignez une population de 100')])), to('ach_pop_100_reward', mapOf([to('en', '+2,500 Score'), to('de', '+2.500 Punkte'), to('ru', '+2 500 \u041E\u0447\u043A\u043E\u0432'), to('cs', '+2 500 Bod\u016F'), to('fr', '+2 500 Score')])), to('ach_col_10_title', mapOf([to('en', 'First Encounters'), to('de', 'Erste Begegnungen'), to('ru', '\u041F\u0435\u0440\u0432\u044B\u0435 \u0432\u0441\u0442\u0440\u0435\u0447\u0438'), to('cs', 'Prvn\xED setk\xE1n\xED'), to('fr', 'Premi\xE8res rencontres')])), to('ach_col_10_desc', mapOf([to('en', 'Witness 10 collisions'), to('de', 'Erlebe 10 Kollisionen'), to('ru', '\u0421\u0432\u0438\u0434\u0435\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0443\u0439\u0442\u0435 10 \u0441\u0442\u043E\u043B\u043A\u043D\u043E\u0432\u0435\u043D\u0438\u0439'), to('cs', 'Bu\u010Fte sv\u011Bdky 10 koliz\xED'), to('fr', 'Assistez \xE0 10 collisions')])), to('ach_col_10_reward', mapOf([to('en', '+50 Score'), to('de', '+50 Punkte'), to('ru', '+50 \u041E\u0447\u043A\u043E\u0432'), to('cs', '+50 Bod\u016F'), to('fr', '+50 Score')])), to('ach_col_50_title', mapOf([to('en', 'Social Butterfly'), to('de', 'Sozialer Schmetterling'), to('ru', '\u041E\u0431\u0449\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u0431\u0430\u0431\u043E\u0447\u043A\u0430'), to('cs', 'Spole\u010Densk\xFD mot\xFDl'), to('fr', 'Papillon social')])), to('ach_col_50_desc', mapOf([to('en', 'Witness 50 collisions'), to('de', 'Erlebe 50 Kollisionen'), to('ru', '\u0421\u0432\u0438\u0434\u0435\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0443\u0439\u0442\u0435 50 \u0441\u0442\u043E\u043B\u043A\u043D\u043E\u0432\u0435\u043D\u0438\u0439'), to('cs', 'Bu\u010Fte sv\u011Bdky 50 koliz\xED'), to('fr', 'Assistez \xE0 50 collisions')])), to('ach_col_50_reward', mapOf([to('en', '+200 Score'), to('de', '+200 Punkte'), to('ru', '+200 \u041E\u0447\u043A\u043E\u0432'), to('cs', '+200 Bod\u016F'), to('fr', '+200 Score')])), to('ach_col_100_title', mapOf([to('en', 'Party Animal'), to('de', 'Partytier'), to('ru', '\u0422\u0443\u0441\u043E\u0432\u0449\u0438\u043A'), to('cs', 'Pa\u0159men'), to('fr', 'F\xEAtard')])), to('ach_col_100_desc', mapOf([to('en', 'Witness 100 collisions'), to('de', 'Erlebe 100 Kollisionen'), to('ru', '\u0421\u0432\u0438\u0434\u0435\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0443\u0439\u0442\u0435 100 \u0441\u0442\u043E\u043B\u043A\u043D\u043E\u0432\u0435\u043D\u0438\u0439'), to('cs', 'Bu\u010Fte sv\u011Bdky 100 koliz\xED'), to('fr', 'Assistez \xE0 100 collisions')])), to('ach_col_100_reward', mapOf([to('en', '+500 Score'), to('de', '+500 Punkte'), to('ru', '+500 \u041E\u0447\u043A\u043E\u0432'), to('cs', '+500 Bod\u016F'), to('fr', '+500 Score')])), to('ach_col_500_title', mapOf([to('en', 'Chaos Theory'), to('de', 'Chaostheorie'), to('ru', '\u0422\u0435\u043E\u0440\u0438\u044F \u0445\u0430\u043E\u0441\u0430'), to('cs', 'Teorie chaosu'), to('fr', 'Th\xE9orie du chaos')])), to('ach_col_500_desc', mapOf([to('en', 'Witness 500 collisions'), to('de', 'Erlebe 500 Kollisionen'), to('ru', '\u0421\u0432\u0438\u0434\u0435\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0443\u0439\u0442\u0435 500 \u0441\u0442\u043E\u043B\u043A\u043D\u043E\u0432\u0435\u043D\u0438\u0439'), to('cs', 'Bu\u010Fte sv\u011Bdky 500 koliz\xED'), to('fr', 'Assistez \xE0 500 collisions')])), to('ach_col_500_reward', mapOf([to('en', '+2,000 Score'), to('de', '+2.000 Punkte'), to('ru', '+2 000 \u041E\u0447\u043A\u043E\u0432'), to('cs', '+2 000 Bod\u016F'), to('fr', '+2 000 Score')])), to('ach_score_5000_title', mapOf([to('en', 'Rising Star'), to('de', 'Aufgehender Stern'), to('ru', '\u0412\u043E\u0441\u0445\u043E\u0434\u044F\u0449\u0430\u044F \u0437\u0432\u0435\u0437\u0434\u0430'), to('cs', 'Stoupaj\xEDc\xED hv\u011Bzda'), to('fr', '\xC9toile montante')])), to('ach_score_5000_desc', mapOf([to('en', 'Accumulate 5,000 score'), to('de', 'Sammle 5.000 Punkte'), to('ru', '\u041D\u0430\u043A\u043E\u043F\u0438\u0442\u0435 5 000 \u043E\u0447\u043A\u043E\u0432'), to('cs', 'Nashrom\xE1\u017Ed\u011Bte 5 000 bod\u016F'), to('fr', 'Accumulez 5 000 points')])), to('ach_score_5000_reward', mapOf([to('en', '+500 Score'), to('de', '+500 Punkte'), to('ru', '+500 \u041E\u0447\u043A\u043E\u0432'), to('cs', '+500 Bod\u016F'), to('fr', '+500 Score')])), to('ach_score_10000_title', mapOf([to('en', 'Point Master'), to('de', 'Punkte-Meister'), to('ru', '\u041C\u0430\u0441\u0442\u0435\u0440 \u043E\u0447\u043A\u043E\u0432'), to('cs', 'Mistr bod\u016F'), to('fr', 'Ma\xEEtre des points')])), to('ach_score_10000_desc', mapOf([to('en', 'Accumulate 10,000 score'), to('de', 'Sammle 10.000 Punkte'), to('ru', '\u041D\u0430\u043A\u043E\u043F\u0438\u0442\u0435 10 000 \u043E\u0447\u043A\u043E\u0432'), to('cs', 'Nashrom\xE1\u017Ed\u011Bte 10 000 bod\u016F'), to('fr', 'Accumulez 10 000 points')])), to('ach_score_10000_reward', mapOf([to('en', '+1,000 Score'), to('de', '+1.000 Punkte'), to('ru', '+1 000 \u041E\u0447\u043A\u043E\u0432'), to('cs', '+1 000 Bod\u016F'), to('fr', '+1 000 Score')])), to('ach_score_25000_title', mapOf([to('en', 'Legendary'), to('de', 'Legend\xE4r'), to('ru', '\u041B\u0435\u0433\u0435\u043D\u0434\u0430\u0440\u043D\u044B\u0439'), to('cs', 'Legend\xE1rn\xED'), to('fr', 'L\xE9gendaire')])), to('ach_score_25000_desc', mapOf([to('en', 'Accumulate 25,000 score'), to('de', 'Sammle 25.000 Punkte'), to('ru', '\u041D\u0430\u043A\u043E\u043F\u0438\u0442\u0435 25 000 \u043E\u0447\u043A\u043E\u0432'), to('cs', 'Nashrom\xE1\u017Ed\u011Bte 25 000 bod\u016F'), to('fr', 'Accumulez 25 000 points')])), to('ach_score_25000_reward', mapOf([to('en', '+2,500 Score'), to('de', '+2.500 Punkte'), to('ru', '+2 500 \u041E\u0447\u043A\u043E\u0432'), to('cs', '+2 500 Bod\u016F'), to('fr', '+2 500 Score')])), to('ach_time_120_title', mapOf([to('en', 'Two Minutes'), to('de', 'Zwei Minuten'), to('ru', '\u0414\u0432\u0435 \u043C\u0438\u043D\u0443\u0442\u044B'), to('cs', 'Dv\u011B minuty'), to('fr', 'Deux minutes')])), to('ach_time_120_desc', mapOf([to('en', 'Survive for 2 minutes'), to('de', '\xDCberlebe 2 Minuten'), to('ru', '\u0412\u044B\u0436\u0438\u0442\u044C 2 \u043C\u0438\u043D\u0443\u0442\u044B'), to('cs', 'P\u0159e\u017Eijte 2 minuty'), to('fr', 'Survivez 2 minutes')])), to('ach_time_120_reward', mapOf([to('en', '+100 Score'), to('de', '+100 Punkte'), to('ru', '+100 \u041E\u0447\u043A\u043E\u0432'), to('cs', '+100 Bod\u016F'), to('fr', '+100 Score')])), to('ach_time_300_title', mapOf([to('en', 'Patience'), to('de', 'Geduld'), to('ru', '\u0422\u0435\u0440\u043F\u0435\u043D\u0438\u0435'), to('cs', 'Trp\u011Blivost'), to('fr', 'Patience')])), to('ach_time_300_desc', mapOf([to('en', 'Survive for 5 minutes'), to('de', '\xDCberlebe 5 Minuten'), to('ru', '\u0412\u044B\u0436\u0438\u0442\u044C 5 \u043C\u0438\u043D\u0443\u0442'), to('cs', 'P\u0159e\u017Eijte 5 minut'), to('fr', 'Survivez 5 minutes')])), to('ach_time_300_reward', mapOf([to('en', '+500 Score'), to('de', '+500 Punkte'), to('ru', '+500 \u041E\u0447\u043A\u043E\u0432'), to('cs', '+500 Bod\u016F'), to('fr', '+500 Score')])), to('ach_time_600_title', mapOf([to('en', 'Dedicated'), to('de', 'Engagiert'), to('ru', '\u041F\u043E\u0441\u0432\u044F\u0449\u0451\u043D\u043D\u044B\u0439'), to('cs', 'Oddan\xFD'), to('fr', 'D\xE9vou\xE9')])), to('ach_time_600_desc', mapOf([to('en', 'Survive for 10 minutes'), to('de', '\xDCberlebe 10 Minuten'), to('ru', '\u0412\u044B\u0436\u0438\u0442\u044C 10 \u043C\u0438\u043D\u0443\u0442'), to('cs', 'P\u0159e\u017Eijte 10 minut'), to('fr', 'Survivez 10 minutes')])), to('ach_time_600_reward', mapOf([to('en', '+1,500 Score'), to('de', '+1.500 Punkte'), to('ru', '+1 500 \u041E\u0447\u043A\u043E\u0432'), to('cs', '+1 500 Bod\u016F'), to('fr', '+1 500 Score')])), to('gender_60_male', mapOf([to('en', '60% male'), to('de', '60% m\xE4nnlich'), to('ru', '60% \u043C\u0443\u0436\u0447\u0438\u043D'), to('cs', '60% mu\u017E\u016F'), to('fr', '60% hommes')])), to('gender_40_male', mapOf([to('en', '40% male'), to('de', '40% m\xE4nnlich'), to('ru', '40% \u043C\u0443\u0436\u0447\u0438\u043D'), to('cs', '40% mu\u017E\u016F'), to('fr', '40% hommes')])), to('gender_50_male', mapOf([to('en', '50% male'), to('de', '50% m\xE4nnlich'), to('ru', '50% \u043C\u0443\u0436\u0447\u0438\u043D'), to('cs', '50% mu\u017E\u016F'), to('fr', '50% hommes')]))]);
  }
  wc5() {
    var tmp;
    try {
      var systemLang = Companion_getInstance_7().vu().e39_1;
      switch (systemLang) {
        case 'de':
        case 'ru':
        case 'cs':
        case 'fr':
          tmp = systemLang;
          break;
        default:
          tmp = 'en';
          break;
      }
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Exception) {
        var e = $p;
        tmp_0 = 'en';
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  xc5(code) {
    switch (code) {
      case 'en':
        return 'English';
      case 'de':
        return 'Deutsch';
      case 'ru':
        return '\u0420\u0443\u0441\u0441\u043A\u0438\u0439';
      case 'cs':
        return '\u010Ce\u0161tina';
      case 'fr':
        return 'Fran\xE7ais';
      default:
        return 'English';
    }
  }
  hi(key) {
    var tmp0_safe_receiver = this.nbv_1.f3(key);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f3(this.mbv_1);
    return tmp1_elvis_lhs == null ? key : tmp1_elvis_lhs;
  }
}
class MainMenuScene$sceneMain$lambda$slambda {
  constructor($gravestoneContainer) {
    this.yc5_1 = $gravestoneContainer;
  }
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class MainMenuScene$sceneMain$lambda$slambda_0 {
  constructor(this$0) {
    this.zc5_1 = this$0;
  }
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class MainMenuScene$sceneMain$lambda$slambda_1 {
  constructor(this$0) {
    this.ac6_1 = this$0;
  }
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class MainMenuScene extends Scene {
  constructor() {
    super();
    this.lc6_1 = null;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new GameConfig();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'MainMenuScene.mainMenuConfig.<anonymous>' call
    this_0.qby_1 = 600.0;
    tmp.mc6_1 = this_0;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.nc6_1 = ArrayList.j1();
    this.oc6_1 = null;
    this.pc6_1 = null;
    this.qc6_1 = null;
    this.rc6_1 = null;
    this.sc6_1 = null;
    this.tc6_1 = new SoundManager();
  }
  qa7(_this__u8e3s4, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneMain__5xvlzl.bind(VOID, _this__u8e3s4, this), $completion);
  }
}
class NameGenerator {
  constructor() {
    NameGenerator_instance = this;
    this.ic5_1 = listOf(['Liam', 'Noah', 'Oliver', 'James', 'Elijah', 'William', 'Henry', 'Lucas', 'Benjamin', 'Theodore', 'Jack', 'Levi', 'Alexander', 'Jackson', 'Mateo', 'Daniel', 'Michael', 'Mason', 'Sebastian', 'Ethan', 'Logan', 'Owen', 'Samuel', 'Jacob', 'Asher', 'Aiden', 'John', 'Joseph', 'Wyatt', 'David', 'Leo', 'Luke', 'Julian', 'Hudson', 'Grayson', 'Matthew', 'Ezra', 'Gabriel', 'Carter', 'Isaac', 'Jayden', 'Luca', 'Anthony', 'Dylan', 'Lincoln', 'Thomas', 'Maverick', 'Elias', 'Josiah', 'Charles', 'Caleb', 'Christopher', 'Ezekiel', 'Miles', 'Jaxon', 'Isaiah', 'Andrew', 'Joshua', 'Nathan', 'Nolan', 'Adrian', 'Cameron', 'Santiago', 'Eli', 'Aaron', 'Ryan', 'Angel', 'Cooper', 'Waylon', 'Easton', 'Kai', 'Christian', 'Landon', 'Colton', 'Roman', 'Axel', 'Brooks', 'Jonathan', 'Robert', 'Jameson', 'Ian', 'Everett', 'Greyson', 'Wesley', 'Jeremiah', 'Hunter', 'Leonardo', 'Jordan', 'Jose', 'Bennett', 'Silas', 'Nicholas', 'Parker', 'Beau', 'Weston', 'Austin', 'Connor', 'Carson', 'Dominic', 'Xavier', 'Jaxson', 'Jace', 'Emmett', 'Adam', 'Declan', 'Rowan', 'Micah', 'Kayden', 'Gael', 'River']);
    this.jc5_1 = listOf(['Olivia', 'Emma', 'Charlotte', 'Amelia', 'Sophia', 'Isabella', 'Ava', 'Mia', 'Evelyn', 'Luna', 'Harper', 'Camila', 'Sofia', 'Scarlett', 'Eleanor', 'Elizabeth', 'Ella', 'Madison', 'Avery', 'Mila', 'Aria', 'Emily', 'Abigail', 'Layla', 'Chloe', 'Ellie', 'Violet', 'Hazel', 'Nora', 'Lily', 'Aurora', 'Nova', 'Eliana', 'Grace', 'Zoey', 'Riley', 'Stella', 'Natalie', 'Leah', 'Willow', 'Addison', 'Lucy', 'Paisley', 'Naomi', 'Hannah', 'Claire', 'Zoe', 'Penelope', 'Audrey', 'Aaliyah', 'Brooklyn', 'Elena', 'Savannah', 'Anna', 'Delilah', 'Emilia', 'Maya', 'Caroline', 'Kennedy', 'Kinsley', 'Genesis', 'Autumn', 'Skylar', 'Madelyn', 'Ivy', 'Piper', 'Ruby', 'Serenity', 'Eva', 'Nevaeh', 'Alice', 'Bella', 'Sarah', 'Vivian', 'Gabriella', 'Madeline', 'Sadie', 'Cora', 'Hailey', 'Isabelle', 'Athena', 'Jade', 'Maria', 'Julia', 'Valentina', 'Quinn', 'Ariana', 'Lucy', 'Victoria', 'Rose', 'Samantha', 'Josephine', 'Iris', 'Emery', 'Sophie', 'Brielle', 'Liliana', 'Reagan', 'Melody', 'Lydia', 'Adalynn', 'Gianna', 'Clara', 'Adalyn', 'Cecilia', 'Olive', 'Josephine', 'Raelynn', 'Peyton', 'Remi']);
  }
  uc6() {
    // Inline function 'kotlin.collections.random' call
    var this_0 = this.ic5_1;
    return random_0(this_0, Default_getInstance());
  }
  vc6() {
    // Inline function 'kotlin.collections.random' call
    var this_0 = this.jc5_1;
    return random_0(this_0, Default_getInstance());
  }
  kc5(gender) {
    var tmp;
    switch (gender.r3_1) {
      case 0:
        tmp = this.uc6();
        break;
      case 1:
        tmp = this.vc6();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
}
class createSettingsPanel$lambda$slambda {
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class SoundManager$slambda {
  constructor(this$0) {
    this.yc6_1 = this$0;
  }
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class SoundManager$playBounceSound$slambda {
  constructor(this$0) {
    this.zc6_1 = this$0;
  }
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class SoundManager$playReproductionSound$slambda {
  constructor(this$0) {
    this.ac7_1 = this$0;
  }
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class SoundManager$playAchievementSound$slambda {
  constructor(this$0) {
    this.bc7_1 = this$0;
  }
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class SoundManager$playFootstepSound$slambda {
  constructor(this$0) {
    this.cc7_1 = this$0;
  }
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class SoundManager$playStarCollectSound$slambda {
  constructor(this$0) {
    this.dc7_1 = this$0;
  }
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class SoundManager {
  constructor() {
    this.wc4_1 = true;
    this.xc4_1 = 1.0;
    this.yc4_1 = false;
    this.zc4_1 = null;
    this.ac5_1 = null;
    this.bc5_1 = null;
    this.cc5_1 = null;
    this.dc5_1 = null;
    this.ec5_1 = Companion_getInstance_0().o1x_1;
    var tmp = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp.fc5_1 = toDuration(50, DurationUnit_MILLISECONDS_getInstance());
    this.gc5_1 = CoroutineScope_0(Dispatchers_getInstance().y1d_1);
    launch(this.gc5_1, VOID, VOID, SoundManager$slambda_0(this));
  }
  ec7() {
    if (!this.wc4_1 || this.yc4_1)
      return Unit_instance;
    launch(this.gc5_1, VOID, VOID, SoundManager$playBounceSound$slambda_0(this));
  }
  fc7() {
    if (!this.wc4_1 || this.yc4_1)
      return Unit_instance;
    launch(this.gc5_1, VOID, VOID, SoundManager$playReproductionSound$slambda_0(this));
  }
  gc7() {
    if (!this.wc4_1 || this.yc4_1)
      return Unit_instance;
    launch(this.gc5_1, VOID, VOID, SoundManager$playAchievementSound$slambda_0(this));
  }
  hc5() {
    if (!this.wc4_1 || this.yc4_1)
      return Unit_instance;
    var currentTime = Companion_getInstance_0().s1x();
    if (Duration__compareTo_impl_pchp0f(DateTime__minus_impl_10njw8(currentTime, this.ec5_1), this.fc5_1) < 0) {
      return Unit_instance;
    }
    this.ec5_1 = currentTime;
    launch(this.gc5_1, VOID, VOID, SoundManager$playFootstepSound$slambda_0(this));
  }
  hc7() {
    if (!this.wc4_1 || this.yc4_1)
      return Unit_instance;
    launch(this.gc5_1, VOID, VOID, SoundManager$playStarCollectSound$slambda_0(this));
  }
  wc6() {
    this.yc4_1 = !this.yc4_1;
  }
  xc6(newVolume) {
    this.xc4_1 = coerceIn(newVolume, 0.0, 1.0);
  }
  ic7() {
    return this.wc4_1;
  }
}
class SpatialGrid {
  constructor(cellSize, gridWidth, gridHeight) {
    this.jc7_1 = cellSize;
    this.kc7_1 = gridWidth;
    this.lc7_1 = gridHeight;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.mc7_1 = LinkedHashMap.oc();
  }
  k3() {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.mc7_1.l3().b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'SpatialGrid.clear.<anonymous>' call
      element.k3();
    }
  }
  nc7(square) {
    var cellX = numberToInt(square.m2i() / this.jc7_1);
    var cellY = numberToInt(square.n2i() / this.jc7_1);
    var key = new Pair(cellX, cellY);
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.mc7_1;
    var value = this_0.f3(key);
    var tmp;
    if (value == null) {
      // Inline function 'SpatialGrid.insert.<anonymous>' call
      // Inline function 'kotlin.collections.mutableListOf' call
      var answer = ArrayList.j1();
      this_0.h3(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    tmp.h(square);
  }
  oc7(square) {
    var cellX = numberToInt(square.m2i() / this.jc7_1);
    var cellY = numberToInt(square.n2i() / this.jc7_1);
    // Inline function 'kotlin.collections.mutableListOf' call
    var nearby = ArrayList.j1();
    var inductionVariable = -1;
    if (inductionVariable <= 1)
      do {
        var dx = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = -1;
        if (inductionVariable_0 <= 1)
          do {
            var dy = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var key = new Pair(cellX + dx | 0, cellY + dy | 0);
            var tmp0_safe_receiver = this.mc7_1.f3(key);
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'SpatialGrid.getPotentialCollisions.<anonymous>' call
              nearby.g1(tmp0_safe_receiver);
            }
          }
           while (inductionVariable_0 <= 1);
      }
       while (inductionVariable <= 1);
    return nearby;
  }
}
class UpgradeState extends Enum {}
class UpgradeDefinition {
  constructor(id, name, description, getCurrentLevel, getMaxLevel, getCost, canAfford, getValueString, prerequisites, upgrade, icon, angle, distance) {
    getValueString = getValueString === VOID ? null : getValueString;
    prerequisites = prerequisites === VOID ? emptyList() : prerequisites;
    this.pc7_1 = id;
    this.qc7_1 = name;
    this.rc7_1 = description;
    this.sc7_1 = getCurrentLevel;
    this.tc7_1 = getMaxLevel;
    this.uc7_1 = getCost;
    this.vc7_1 = canAfford;
    this.wc7_1 = getValueString;
    this.xc7_1 = prerequisites;
    this.yc7_1 = upgrade;
    this.zc7_1 = icon;
    this.ac8_1 = angle;
    this.bc8_1 = distance;
  }
  toString() {
    return 'UpgradeDefinition(id=' + this.pc7_1 + ', name=' + this.qc7_1 + ', description=' + this.rc7_1 + ', getCurrentLevel=' + toString(this.sc7_1) + ', getMaxLevel=' + toString(this.tc7_1) + ', getCost=' + toString(this.uc7_1) + ', canAfford=' + toString(this.vc7_1) + ', getValueString=' + toString_0(this.wc7_1) + ', prerequisites=' + toString(this.xc7_1) + ', upgrade=' + toString(this.yc7_1) + ', icon=' + this.zc7_1.toString() + ', angle=' + this.ac8_1 + ', distance=' + this.bc8_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.pc7_1);
    result = imul(result, 31) + getStringHashCode(this.qc7_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.rc7_1) | 0;
    result = imul(result, 31) + hashCode(this.sc7_1) | 0;
    result = imul(result, 31) + hashCode(this.tc7_1) | 0;
    result = imul(result, 31) + hashCode(this.uc7_1) | 0;
    result = imul(result, 31) + hashCode(this.vc7_1) | 0;
    result = imul(result, 31) + (this.wc7_1 == null ? 0 : hashCode(this.wc7_1)) | 0;
    result = imul(result, 31) + hashCode(this.xc7_1) | 0;
    result = imul(result, 31) + hashCode(this.yc7_1) | 0;
    result = imul(result, 31) + hashCode(this.zc7_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ac8_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.bc8_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UpgradeDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof UpgradeDefinition ? other : THROW_CCE();
    if (!(this.pc7_1 === tmp0_other_with_cast.pc7_1))
      return false;
    if (!(this.qc7_1 === tmp0_other_with_cast.qc7_1))
      return false;
    if (!(this.rc7_1 === tmp0_other_with_cast.rc7_1))
      return false;
    if (!equals(this.sc7_1, tmp0_other_with_cast.sc7_1))
      return false;
    if (!equals(this.tc7_1, tmp0_other_with_cast.tc7_1))
      return false;
    if (!equals(this.uc7_1, tmp0_other_with_cast.uc7_1))
      return false;
    if (!equals(this.vc7_1, tmp0_other_with_cast.vc7_1))
      return false;
    if (!equals(this.wc7_1, tmp0_other_with_cast.wc7_1))
      return false;
    if (!equals(this.xc7_1, tmp0_other_with_cast.xc7_1))
      return false;
    if (!equals(this.yc7_1, tmp0_other_with_cast.yc7_1))
      return false;
    if (!equals(this.zc7_1, tmp0_other_with_cast.zc7_1))
      return false;
    if (!equals(this.ac8_1, tmp0_other_with_cast.ac8_1))
      return false;
    if (!equals(this.bc8_1, tmp0_other_with_cast.bc8_1))
      return false;
    return true;
  }
}
class UpgradeTreeScene$refreshUpgradeTree$slambda {
  constructor(this$0, $tc) {
    this.cc8_1 = this$0;
    this.dc8_1 = $tc;
  }
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class UpgradeTreeScene$setupScreen$slambda {
  constructor(this$0, $isDragging, $dragStartX, $dragStartY, $containerStartX, $tc, $containerStartY) {
    this.ica_1 = this$0;
    this.jca_1 = $isDragging;
    this.kca_1 = $dragStartX;
    this.lca_1 = $dragStartY;
    this.mca_1 = $containerStartX;
    this.nca_1 = $tc;
    this.oca_1 = $containerStartY;
  }
  pca(it, $completion) {
    if (it.sa1().c6n() && !this.ica_1.rc9_1) {
      this.jca_1._v = true;
      this.ica_1.pc9_1 = true;
      this.kca_1._v = it.qa1().a2a_1;
      this.lca_1._v = it.qa1().b2a_1;
      this.mca_1._v = this.nca_1.b6j();
      this.oca_1._v = this.nca_1.c6j();
    }
  }
  de(p1, $completion) {
    return this.pca(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class UpgradeTreeScene$setupScreen$lambda$slambda {
  constructor($handler, $it) {
    this.ec8_1 = $handler;
    this.fc8_1 = $it;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this), $completion);
  }
}
class UpgradeTreeScene$setupScreen$slambda_0 {
  constructor($isDragging, this$0) {
    this.qca_1 = $isDragging;
    this.rca_1 = this$0;
  }
  pca(it, $completion) {
    if (it.sa1().c6n()) {
      this.qca_1._v = false;
      this.rca_1.pc9_1 = false;
    }
  }
  de(p1, $completion) {
    return this.pca(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class UpgradeTreeScene$setupScreen$lambda$slambda_0 {
  constructor($handler, $it) {
    this.gc8_1 = $handler;
    this.hc8_1 = $it;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this), $completion);
  }
}
class UpgradeTreeScene$setupScreen$slambda_1 {
  constructor($isDragging, this$0) {
    this.sca_1 = $isDragging;
    this.tca_1 = this$0;
  }
  pca(it, $completion) {
    this.sca_1._v = false;
    this.tca_1.pc9_1 = false;
  }
  de(p1, $completion) {
    return this.pca(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class UpgradeTreeScene$setupScreen$lambda$slambda_1 {
  constructor($handler, $it) {
    this.ic8_1 = $handler;
    this.jc8_1 = $it;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this), $completion);
  }
}
class UpgradeTreeScene$setupScreen$slambda_2 {
  constructor($isDragging, this$0, $dragStartX, $dragStartY, $tc, $containerStartX, $containerStartY) {
    this.uca_1 = $isDragging;
    this.vca_1 = this$0;
    this.wca_1 = $dragStartX;
    this.xca_1 = $dragStartY;
    this.yca_1 = $tc;
    this.zca_1 = $containerStartX;
    this.acb_1 = $containerStartY;
  }
  pca(it, $completion) {
    if (this.uca_1._v && !this.vca_1.rc9_1) {
      var dx = it.qa1().a2a_1 - this.wca_1._v;
      var dy = it.qa1().b2a_1 - this.xca_1._v;
      this.yca_1.tai(this.zca_1._v + dx);
      this.yca_1.uai(this.acb_1._v + dy);
      this.vca_1.ec9_1 = this.yca_1.b6j();
      this.vca_1.fc9_1 = this.yca_1.c6j();
    }
  }
  de(p1, $completion) {
    return this.pca(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class UpgradeTreeScene$setupScreen$lambda$slambda_2 {
  constructor($handler, $it) {
    this.kc8_1 = $handler;
    this.lc8_1 = $it;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this), $completion);
  }
}
class UpgradeTreeScene$setupUpgrades$slambda {
  constructor(this$0, $centerX, $centerY) {
    this.xc9_1 = this$0;
    this.yc9_1 = $centerX;
    this.zc9_1 = $centerY;
  }
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class UpgradeTreeScene$createUpgradeCard$lambda$slambda {
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_15.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class UpgradeTreeScene$createUpgradeCard$slambda {
  pca(it, $completion) {
    if (it.sa1().c6n()) {
      it.ra1();
    }
  }
  de(p1, $completion) {
    return this.pca(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class UpgradeTreeScene$createUpgradeCard$lambda$slambda_0 {
  constructor($handler, $it) {
    this.aca_1 = $handler;
    this.bca_1 = $it;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_16.bind(VOID, this), $completion);
  }
}
class UpgradeTreeScene$createUpgradeCard$slambda_0 {
  pca(it, $completion) {
    if (it.sa1().c6n()) {
      it.ra1();
    }
  }
  de(p1, $completion) {
    return this.pca(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class UpgradeTreeScene$createUpgradeCard$lambda$slambda_1 {
  constructor($handler, $it) {
    this.cca_1 = $handler;
    this.dca_1 = $it;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_17.bind(VOID, this), $completion);
  }
}
class UpgradeTreeScene$createUpgradeCard$slambda_1 {
  constructor(this$0) {
    this.bcb_1 = this$0;
  }
  pca(it, $completion) {
    this.bcb_1.rc9_1;
  }
  de(p1, $completion) {
    return this.pca(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class UpgradeTreeScene$createUpgradeCard$lambda$slambda_2 {
  constructor($handler, $it) {
    this.eca_1 = $handler;
    this.fca_1 = $it;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_18.bind(VOID, this), $completion);
  }
}
class UpgradeTreeScene$createUpgradeCard$slambda_2 {
  constructor($$this$container, this$0) {
    this.gca_1 = $$this$container;
    this.hca_1 = this$0;
  }
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_19.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class UpgradeTreeScene extends Scene {
  constructor(config, playerScore, onClose, onUpgradeChanged) {
    var tmp;
    if (onUpgradeChanged === VOID) {
      tmp = UpgradeTreeScene$_init_$lambda_z068sn;
    } else {
      tmp = onUpgradeChanged;
    }
    onUpgradeChanged = tmp;
    super();
    this.wc8_1 = config;
    this.xc8_1 = playerScore;
    this.yc8_1 = onClose;
    this.zc8_1 = onUpgradeChanged;
    this.ac9_1 = false;
    this.bc9_1 = true;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.cc9_1 = ArrayList.j1();
    this.dc9_1 = null;
    this.ec9_1 = 0.0;
    this.fc9_1 = 0.0;
    this.gc9_1 = 1.0;
    this.hc9_1 = null;
    this.ic9_1 = null;
    this.jc9_1 = null;
    this.kc9_1 = null;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_1.lc9_1 = LinkedHashMap.oc();
    this.mc9_1 = null;
    this.nc9_1 = null;
    this.oc9_1 = false;
    this.pc9_1 = false;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_2.qc9_1 = LinkedHashMap.oc();
    this.rc9_1 = false;
    this.sc9_1 = null;
    this.tc9_1 = null;
    this.uc9_1 = 1.0;
    this.vc9_1 = to(0.0, 0.0);
    this.wc9_1 = to(0.0, 0.0);
  }
  pa7(_this__u8e3s4, $completion) {
    this.ka1().k9r_1 = Companion_getInstance_1().q4e(15, 15, 35, 255);
    // Inline function 'korlibs.korge.view.position' call
    xy(_this__u8e3s4, numberToDouble(0), numberToDouble(0));
    scale(_this__u8e3s4, 1.0);
  }
  qa7(_this__u8e3s4, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneMain__5xvlzl_0.bind(VOID, _this__u8e3s4, this), $completion);
  }
}
class CollisionType extends Enum {}
class GameScene$openUpgradeTree$slambda$lambda$slambda {
  constructor(this$0) {
    this.jcd_1 = this$0;
  }
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_21.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class GameScene$setupAchievements$lambda$slambda {
  constructor(this$0, $achievement) {
    this.scd_1 = this$0;
    this.tcd_1 = $achievement;
  }
  k1q($this$launch, $completion) {
    showAchievementNotification(this.scd_1, this.tcd_1);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class GameScene$setupUI$lambda$slambda {
  constructor(this$0) {
    this.ccb_1 = this$0;
  }
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_20.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class GameScene$showAchievementNotification$slambda {
  constructor(this$0, $achievement) {
    this.ucd_1 = this$0;
    this.vcd_1 = $achievement;
  }
  k1q($this$launch, $completion) {
    this.ucd_1.acc_1.gc7();
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.ucd_1.ccc_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'GameScene.showAchievementNotification.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.xbv_1 / 130.0;
      destination.h(tmp$ret$0);
    }
    var usedSlots = toSet(destination);
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var progression = numberRangeToNumber(0, this.ucd_1.ccc_1.f1());
      var inductionVariable = progression.b2_1;
      var last = progression.c2_1;
      if (inductionVariable <= last)
        do {
          var element = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'GameScene.showAchievementNotification.<anonymous>.<anonymous>' call
          var it = element;
          if (!usedSlots.x2(it)) {
            tmp$ret$4 = element;
            break $l$block;
          }
        }
         while (!(element === last));
      tmp$ret$4 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$4;
    var slotIndex = tmp0_elvis_lhs == null ? this.ucd_1.ccc_1.f1() : tmp0_elvis_lhs;
    var yOffset = slotIndex * 130.0;
    var notification = {_v: null};
    var tmp = this.ucd_1.oa2();
    notification._v = new AchievementNotification(tmp, this.vcd_1, yOffset, GameScene$showAchievementNotification$slambda$lambda(notification, this.ucd_1));
    this.ucd_1.ccc_1.h(notification._v);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class GameScene$openUpgradeTree$slambda {
  constructor(this$0) {
    this.kcd_1 = this$0;
  }
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_22.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class GameScene$spawnStar$lambda$slambda {
  constructor(this$0, $this_spawnStar) {
    this.lcd_1 = this$0;
    this.mcd_1 = $this_spawnStar;
  }
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_23.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class GameScene$setupGameLoop$lambda$slambda {
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_24.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class GameScene$setupGameLoop$lambda$slambda_0 {
  constructor(this$0, $this_addUpdater) {
    this.ncd_1 = this$0;
    this.ocd_1 = $this_addUpdater;
  }
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_25.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class GameScene$setupGameLoop$lambda$slambda_1 {
  constructor(this$0, $this_addUpdater) {
    this.pcd_1 = this$0;
    this.qcd_1 = $this_addUpdater;
  }
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_26.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class GameScene$checkForDeaths$slambda {
  constructor($gravestoneContainer) {
    this.rcd_1 = $gravestoneContainer;
  }
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_27.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class GameScene extends Scene {
  constructor() {
    super();
    this.ncb_1 = null;
    this.ocb_1 = get_globalConfig();
    this.pcb_1 = 0;
    this.qcb_1 = get_globalScore();
    this.rcb_1 = 2;
    this.scb_1 = 0.0;
    this.tcb_1 = 0.0;
    this.ucb_1 = false;
    this.vcb_1 = 0.0;
    this.wcb_1 = 2.0;
    this.xcb_1 = 0;
    this.ycb_1 = 0.0;
    this.zcb_1 = 0;
    this.acc_1 = new SoundManager();
    this.bcc_1 = get_globalAchievementManager();
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.ccc_1 = ArrayList.j1();
    this.dcc_1 = false;
    this.ncc_1 = false;
    this.occ_1 = false;
    this.pcc_1 = false;
    this.qcc_1 = null;
    this.rcc_1 = null;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.scc_1 = ArrayList.j1();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_1.tcc_1 = ArrayList.j1();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp_2.ucc_1 = LinkedHashSet.i1();
    var tmp_3 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_3.vcc_1 = LinkedHashMap.oc();
    this.wcc_1 = 400.0;
    this.xcc_1 = 1920.0 - this.wcc_1 - 40.0;
    this.ycc_1 = 1080.0 - 40.0;
    this.zcc_1 = 600.0;
    this.acd_1 = 20.0;
    this.bcd_1 = this.acd_1 * coerceIn(this.xcc_1 / this.zcc_1, 0.5, 2.0);
    this.ccd_1 = new SpatialGrid(100.0, this.xcc_1, this.ycc_1);
    this.dcd_1 = this.wcc_1 + 20.0;
    this.ecd_1 = 20.0;
    this.fcd_1 = this.bcd_1 / 2.0;
    this.gcd_1 = 2.0;
    this.hcd_1 = Companion_getInstance_1().x4f(65, 105, 225);
    this.icd_1 = Companion_getInstance_1().x4f(255, 69, 165);
  }
  qa7(_this__u8e3s4, $completion) {
    setupAchievements(this);
    setupUI(_this__u8e3s4, this);
    setupContainer(_this__u8e3s4, this);
    setupClickStar(_this__u8e3s4, this);
    this.ocb_1.pc3();
    spawnInitialSquares(_this__u8e3s4, this);
    setupGameLoop(_this__u8e3s4, this);
  }
}
class main$slambda {
  e9n($this$Korge, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_28.bind(VOID, this, $this$Korge), $completion);
  }
  de(p1, $completion) {
    return this.e9n(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class SaveStorage {
  wcd(data, $completion) {
    window.localStorage.setItem('savegame.json', data);
  }
  xcd($completion) {
    return window.localStorage.getItem('savegame.json');
  }
  ycd($completion) {
    return !(window.localStorage.getItem('savegame.json') == null);
  }
}
//endregion
function initializeAchievements($this) {
  $this.kbv_1.g1(listOf([new Achievement('pop_5', Localization_getInstance().hi('ach_pop_5_title'), Localization_getInstance().hi('ach_pop_5_desc'), new Population(5), new AchievementReward(100.0, Localization_getInstance().hi('ach_pop_5_reward'))), new Achievement('pop_10', Localization_getInstance().hi('ach_pop_10_title'), Localization_getInstance().hi('ach_pop_10_desc'), new Population(10), new AchievementReward(250.0, Localization_getInstance().hi('ach_pop_10_reward'))), new Achievement('pop_25', Localization_getInstance().hi('ach_pop_25_title'), Localization_getInstance().hi('ach_pop_25_desc'), new Population(25), new AchievementReward(500.0, Localization_getInstance().hi('ach_pop_25_reward'))), new Achievement('pop_50', Localization_getInstance().hi('ach_pop_50_title'), Localization_getInstance().hi('ach_pop_50_desc'), new Population(50), new AchievementReward(1000.0, Localization_getInstance().hi('ach_pop_50_reward'))), new Achievement('pop_100', Localization_getInstance().hi('ach_pop_100_title'), Localization_getInstance().hi('ach_pop_100_desc'), new Population(100), new AchievementReward(2500.0, Localization_getInstance().hi('ach_pop_100_reward'))), new Achievement('col_10', Localization_getInstance().hi('ach_col_10_title'), Localization_getInstance().hi('ach_col_10_desc'), new Collisions(10), new AchievementReward(50.0, Localization_getInstance().hi('ach_col_10_reward'))), new Achievement('col_50', Localization_getInstance().hi('ach_col_50_title'), Localization_getInstance().hi('ach_col_50_desc'), new Collisions(50), new AchievementReward(200.0, Localization_getInstance().hi('ach_col_50_reward'))), new Achievement('col_100', Localization_getInstance().hi('ach_col_100_title'), Localization_getInstance().hi('ach_col_100_desc'), new Collisions(100), new AchievementReward(500.0, Localization_getInstance().hi('ach_col_100_reward'))), new Achievement('col_500', Localization_getInstance().hi('ach_col_500_title'), Localization_getInstance().hi('ach_col_500_desc'), new Collisions(500), new AchievementReward(2000.0, Localization_getInstance().hi('ach_col_500_reward'))), new Achievement('score_5000', Localization_getInstance().hi('ach_score_5000_title'), Localization_getInstance().hi('ach_score_5000_desc'), new Score(5000.0), new AchievementReward(500.0, Localization_getInstance().hi('ach_score_5000_reward'))), new Achievement('score_10000', Localization_getInstance().hi('ach_score_10000_title'), Localization_getInstance().hi('ach_score_10000_desc'), new Score(10000.0), new AchievementReward(1000.0, Localization_getInstance().hi('ach_score_10000_reward'))), new Achievement('score_25000', Localization_getInstance().hi('ach_score_25000_title'), Localization_getInstance().hi('ach_score_25000_desc'), new Score(25000.0), new AchievementReward(2500.0, Localization_getInstance().hi('ach_score_25000_reward'))), new Achievement('time_120', Localization_getInstance().hi('ach_time_120_title'), Localization_getInstance().hi('ach_time_120_desc'), new TimeAlive(120.0), new AchievementReward(100.0, Localization_getInstance().hi('ach_time_120_reward'))), new Achievement('time_300', Localization_getInstance().hi('ach_time_300_title'), Localization_getInstance().hi('ach_time_300_desc'), new TimeAlive(300.0), new AchievementReward(500.0, Localization_getInstance().hi('ach_time_300_reward'))), new Achievement('time_600', Localization_getInstance().hi('ach_time_600_title'), Localization_getInstance().hi('ach_time_600_desc'), new TimeAlive(600.0), new AchievementReward(1500.0, Localization_getInstance().hi('ach_time_600_reward')))]));
}
function unlockAchievement($this, achievement) {
  achievement.abv_1 = true;
  achievement.bbv_1 = Companion_getInstance_0().s1x();
  notifyListeners($this, achievement);
  return achievement.zbu_1.ebv_1;
}
function notifyListeners($this, achievement) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = $this.lbv_1.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'AchievementManager.notifyListeners.<anonymous>' call
    element(achievement);
  }
}
function getAchievementIconBitmap(id) {
  switch (id) {
    case 'pop_5':
      return createPop5Icon();
    case 'pop_10':
      return createPop10Icon();
    case 'pop_25':
      return createPop25Icon();
    case 'pop_50':
      return createPop50Icon();
    case 'pop_100':
      return createPop100Icon();
    case 'col_10':
      return createCol10Icon();
    case 'col_50':
      return createCol50Icon();
    case 'col_100':
      return createCol100Icon();
    case 'col_500':
      return createCol500Icon();
    case 'score_5000':
      return createScore5000Icon();
    case 'score_10000':
      return createScore10000Icon();
    case 'score_25000':
      return createScore25000Icon();
    case 'time_120':
      return createTime120Icon();
    case 'time_300':
      return createTime300Icon();
    case 'time_600':
      return createTime600Icon();
    default:
      return createDefaultAchievementIcon();
  }
}
function createPop5Icon() {
  var bmp = Bitmap32.s3y(32, 32);
  var inductionVariable = 10;
  if (inductionVariable <= 22)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 10;
      if (inductionVariable_0 <= 22)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if ((imul(x - 16 | 0, x - 16 | 0) + imul(y - 16 | 0, y - 16 | 0) | 0) < 36) {
            bmp.o48(x, y, Companion_getInstance_1().x4f(255, 224, 189));
          }
        }
         while (inductionVariable_0 <= 22);
    }
     while (inductionVariable <= 22);
  bmp.o48(13, 16, Companion_getInstance_1().x4f(80, 80, 80));
  bmp.o48(19, 16, Companion_getInstance_1().x4f(80, 80, 80));
  bmp.o48(15, 19, Companion_getInstance_1().x4f(200, 100, 100));
  bmp.o48(16, 20, Companion_getInstance_1().x4f(200, 100, 100));
  bmp.o48(17, 19, Companion_getInstance_1().x4f(200, 100, 100));
  return bmp;
}
function createPop10Icon() {
  var bmp = Bitmap32.s3y(32, 32);
  var baseLeft = 11;
  var baseRight = 21;
  var baseTop = 15;
  var baseBottom = 25;
  var inductionVariable = baseTop;
  if (inductionVariable <= baseBottom)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = baseLeft;
      if (inductionVariable_0 <= baseRight)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          bmp.o48(x, y, Companion_getInstance_1().x4f(200, 170, 120));
        }
         while (!(x === baseRight));
    }
     while (!(y === baseBottom));
  var inductionVariable_1 = baseLeft - 1 | 0;
  var last = baseRight + 1 | 0;
  if (inductionVariable_1 <= last)
    do {
      var x_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      bmp.o48(x_0, baseTop - 1 | 0, Companion_getInstance_1().x4f(150, 75, 0));
    }
     while (!(x_0 === last));
  bmp.o48(16, baseBottom, Companion_getInstance_1().x4f(80, 80, 255));
  return bmp;
}
function createPop25Icon() {
  var bmp = Bitmap32.s3y(32, 32);
  var offsetX = 0;
  var baseY = 17;
  var baseH = 6;
  var inductionVariable = baseY;
  var last = baseY + baseH | 0;
  if (inductionVariable <= last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 6 + offsetX | 0;
      var last_0 = 10 + offsetX | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          bmp.o48(x, y, Companion_getInstance_1().x4f(200, 170, 120));
        }
         while (!(x === last_0));
    }
     while (!(y === last));
  var inductionVariable_1 = 5 + offsetX | 0;
  var last_1 = 11 + offsetX | 0;
  if (inductionVariable_1 <= last_1)
    do {
      var x_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      bmp.o48(x_0, baseY - 1 | 0, Companion_getInstance_1().x4f(150, 75, 0));
    }
     while (!(x_0 === last_1));
  var inductionVariable_2 = baseY;
  var last_2 = baseY + baseH | 0;
  if (inductionVariable_2 <= last_2)
    do {
      var y_0 = inductionVariable_2;
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      var inductionVariable_3 = 13 + offsetX | 0;
      var last_3 = 17 + offsetX | 0;
      if (inductionVariable_3 <= last_3)
        do {
          var x_1 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          bmp.o48(x_1, y_0, Companion_getInstance_1().x4f(200, 170, 120));
        }
         while (!(x_1 === last_3));
    }
     while (!(y_0 === last_2));
  var inductionVariable_4 = 12 + offsetX | 0;
  var last_4 = 18 + offsetX | 0;
  if (inductionVariable_4 <= last_4)
    do {
      var x_2 = inductionVariable_4;
      inductionVariable_4 = inductionVariable_4 + 1 | 0;
      bmp.o48(x_2, baseY - 1 | 0, Companion_getInstance_1().x4f(150, 75, 0));
    }
     while (!(x_2 === last_4));
  var inductionVariable_5 = baseY;
  var last_5 = baseY + baseH | 0;
  if (inductionVariable_5 <= last_5)
    do {
      var y_1 = inductionVariable_5;
      inductionVariable_5 = inductionVariable_5 + 1 | 0;
      var inductionVariable_6 = 20 + offsetX | 0;
      var last_6 = 24 + offsetX | 0;
      if (inductionVariable_6 <= last_6)
        do {
          var x_3 = inductionVariable_6;
          inductionVariable_6 = inductionVariable_6 + 1 | 0;
          bmp.o48(x_3, y_1, Companion_getInstance_1().x4f(200, 170, 120));
        }
         while (!(x_3 === last_6));
    }
     while (!(y_1 === last_5));
  var inductionVariable_7 = 19 + offsetX | 0;
  var last_7 = 25 + offsetX | 0;
  if (inductionVariable_7 <= last_7)
    do {
      var x_4 = inductionVariable_7;
      inductionVariable_7 = inductionVariable_7 + 1 | 0;
      bmp.o48(x_4, baseY - 1 | 0, Companion_getInstance_1().x4f(150, 75, 0));
    }
     while (!(x_4 === last_7));
  return bmp;
}
function createPop50Icon() {
  var bmp = Bitmap32.s3y(32, 32);
  var inductionVariable = 6;
  if (inductionVariable <= 25)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 13;
      if (inductionVariable_0 <= 19)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          bmp.o48(x, y, Companion_getInstance_1().x4f(180, 180, 200));
        }
         while (inductionVariable_0 <= 19);
    }
     while (inductionVariable <= 25);
  var inductionVariable_1 = 10;
  var last = getProgressionLastElement(10, 24, 3);
  if (inductionVariable_1 <= last)
    do {
      var y_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 3 | 0;
      var inductionVariable_2 = 15;
      if (inductionVariable_2 <= 17)
        do {
          var x_0 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          bmp.o48(x_0, y_0, Companion_getInstance_1().x4f(80, 80, 255));
        }
         while (inductionVariable_2 <= 17);
    }
     while (!(y_0 === last));
  return bmp;
}
function createPop100Icon() {
  var bmp = Bitmap32.s3y(32, 32);
  var inductionVariable = 0;
  if (inductionVariable <= 6)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var cx = 10 + imul(i % 3 | 0, 6) | 0;
      var cy = 12 + imul(i / 3 | 0, 6) | 0;
      var inductionVariable_0 = cy;
      var last = cy + 4 | 0;
      if (inductionVariable_0 <= last)
        do {
          var y = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var inductionVariable_1 = cx;
          var last_0 = cx + 4 | 0;
          if (inductionVariable_1 <= last_0)
            do {
              var x = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              if ((imul((x - cx | 0) - 2 | 0, (x - cx | 0) - 2 | 0) + imul((y - cy | 0) - 2 | 0, (y - cy | 0) - 2 | 0) | 0) < 6) {
                bmp.o48(x, y, Companion_getInstance_1().x4f(255, 224, 189));
              }
            }
             while (!(x === last_0));
        }
         while (!(y === last));
    }
     while (inductionVariable <= 6);
  return bmp;
}
function createCol10Icon() {
  var bmp = Bitmap32.s3y(32, 32);
  var inductionVariable = 13;
  if (inductionVariable <= 19)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 11;
      if (inductionVariable_0 <= 17)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if ((imul(x - 13 | 0, x - 13 | 0) + imul(y - 16 | 0, y - 16 | 0) | 0) < 9) {
            bmp.o48(x, y, Companion_getInstance_1().x4f(255, 200, 0));
          }
        }
         while (inductionVariable_0 <= 17);
    }
     while (inductionVariable <= 19);
  var inductionVariable_1 = 13;
  if (inductionVariable_1 <= 19)
    do {
      var y_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var inductionVariable_2 = 15;
      if (inductionVariable_2 <= 21)
        do {
          var x_0 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          if ((imul(x_0 - 19 | 0, x_0 - 19 | 0) + imul(y_0 - 16 | 0, y_0 - 16 | 0) | 0) < 9) {
            bmp.o48(x_0, y_0, Companion_getInstance_1().x4f(0, 200, 255));
          }
        }
         while (inductionVariable_2 <= 21);
    }
     while (inductionVariable_1 <= 19);
  return bmp;
}
function createCol50Icon() {
  var bmp = Bitmap32.s3y(32, 32);
  var inductionVariable = 13;
  if (inductionVariable <= 19)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 11;
      if (inductionVariable_0 <= 17)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if ((imul(x - 13 | 0, x - 13 | 0) + imul(y - 16 | 0, y - 16 | 0) | 0) < 9) {
            bmp.o48(x, y, Companion_getInstance_1().x4f(255, 200, 0));
          }
        }
         while (inductionVariable_0 <= 17);
    }
     while (inductionVariable <= 19);
  var inductionVariable_1 = 13;
  if (inductionVariable_1 <= 19)
    do {
      var y_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var inductionVariable_2 = 15;
      if (inductionVariable_2 <= 21)
        do {
          var x_0 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          if ((imul(x_0 - 19 | 0, x_0 - 19 | 0) + imul(y_0 - 16 | 0, y_0 - 16 | 0) | 0) < 9) {
            bmp.o48(x_0, y_0, Companion_getInstance_1().x4f(0, 200, 255));
          }
        }
         while (inductionVariable_2 <= 21);
    }
     while (inductionVariable_1 <= 19);
  var inductionVariable_3 = 10;
  if (inductionVariable_3 <= 16)
    do {
      var y_1 = inductionVariable_3;
      inductionVariable_3 = inductionVariable_3 + 1 | 0;
      var inductionVariable_4 = 14;
      if (inductionVariable_4 <= 20)
        do {
          var x_1 = inductionVariable_4;
          inductionVariable_4 = inductionVariable_4 + 1 | 0;
          if ((imul(x_1 - 17 | 0, x_1 - 17 | 0) + imul(y_1 - 13 | 0, y_1 - 13 | 0) | 0) < 9) {
            bmp.o48(x_1, y_1, Companion_getInstance_1().x4f(255, 80, 200));
          }
        }
         while (inductionVariable_4 <= 20);
    }
     while (inductionVariable_3 <= 16);
  return bmp;
}
function createCol100Icon() {
  var bmp = Bitmap32.s3y(32, 32);
  var inductionVariable = 13;
  if (inductionVariable <= 19)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 11;
      if (inductionVariable_0 <= 17)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if ((imul(x - 13 | 0, x - 13 | 0) + imul(y - 16 | 0, y - 16 | 0) | 0) < 9) {
            bmp.o48(x, y, Companion_getInstance_1().x4f(255, 200, 0));
          }
        }
         while (inductionVariable_0 <= 17);
    }
     while (inductionVariable <= 19);
  var inductionVariable_1 = 13;
  if (inductionVariable_1 <= 19)
    do {
      var y_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var inductionVariable_2 = 15;
      if (inductionVariable_2 <= 21)
        do {
          var x_0 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          if ((imul(x_0 - 19 | 0, x_0 - 19 | 0) + imul(y_0 - 16 | 0, y_0 - 16 | 0) | 0) < 9) {
            bmp.o48(x_0, y_0, Companion_getInstance_1().x4f(0, 200, 255));
          }
        }
         while (inductionVariable_2 <= 21);
    }
     while (inductionVariable_1 <= 19);
  var inductionVariable_3 = 10;
  if (inductionVariable_3 <= 16)
    do {
      var y_1 = inductionVariable_3;
      inductionVariable_3 = inductionVariable_3 + 1 | 0;
      var inductionVariable_4 = 14;
      if (inductionVariable_4 <= 20)
        do {
          var x_1 = inductionVariable_4;
          inductionVariable_4 = inductionVariable_4 + 1 | 0;
          if ((imul(x_1 - 17 | 0, x_1 - 17 | 0) + imul(y_1 - 13 | 0, y_1 - 13 | 0) | 0) < 9) {
            bmp.o48(x_1, y_1, Companion_getInstance_1().x4f(255, 80, 200));
          }
        }
         while (inductionVariable_4 <= 20);
    }
     while (inductionVariable_3 <= 16);
  var inductionVariable_5 = 16;
  if (inductionVariable_5 <= 22)
    do {
      var y_2 = inductionVariable_5;
      inductionVariable_5 = inductionVariable_5 + 1 | 0;
      var inductionVariable_6 = 14;
      if (inductionVariable_6 <= 20)
        do {
          var x_2 = inductionVariable_6;
          inductionVariable_6 = inductionVariable_6 + 1 | 0;
          if ((imul(x_2 - 17 | 0, x_2 - 17 | 0) + imul(y_2 - 19 | 0, y_2 - 19 | 0) | 0) < 9) {
            bmp.o48(x_2, y_2, Companion_getInstance_1().x4f(80, 255, 80));
          }
        }
         while (inductionVariable_6 <= 20);
    }
     while (inductionVariable_5 <= 22);
  return bmp;
}
function createCol500Icon() {
  var bmp = Bitmap32.s3y(32, 32);
  var inductionVariable = 0;
  if (inductionVariable <= 4)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var cx = (12 + imul(i % 2 | 0, 8) | 0) + imul(i / 4 | 0, 4) | 0;
      var cy = 12 + imul(i / 2 | 0, 6) | 0;
      var inductionVariable_0 = cy;
      var last = cy + 5 | 0;
      if (inductionVariable_0 <= last)
        do {
          var y = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var inductionVariable_1 = cx;
          var last_0 = cx + 5 | 0;
          if (inductionVariable_1 <= last_0)
            do {
              var x = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              if ((imul((x - cx | 0) - 2 | 0, (x - cx | 0) - 2 | 0) + imul((y - cy | 0) - 2 | 0, (y - cy | 0) - 2 | 0) | 0) < 8) {
                bmp.o48(x, y, Companion_getInstance_1().x4f(200, 200, 40 + imul(40, i) | 0));
              }
            }
             while (!(x === last_0));
        }
         while (!(y === last));
    }
     while (inductionVariable <= 4);
  return bmp;
}
function createScore5000Icon() {
  var bmp = Bitmap32.s3y(32, 32);
  var star = listOf([new Pair(16, 8), new Pair(20, 22), new Pair(8, 14), new Pair(24, 14), new Pair(12, 22)]);
  var _iterator__ex2g4s = star.b1();
  while (_iterator__ex2g4s.c1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.d1();
    var x = _destruct__k2r9zo.nl();
    var y = _destruct__k2r9zo.ol();
    bmp.o48(x, y, Companion_getInstance_1().x4f(255, 220, 80));
  }
  var inductionVariable = 14;
  if (inductionVariable <= 18)
    do {
      var y_0 = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 14;
      if (inductionVariable_0 <= 18)
        do {
          var x_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          bmp.o48(x_0, y_0, Companion_getInstance_1().x4f(255, 220, 80));
        }
         while (inductionVariable_0 <= 18);
    }
     while (inductionVariable <= 18);
  return bmp;
}
function createScore10000Icon() {
  var bmp = Bitmap32.s3y(32, 32);
  var inductionVariable = 10;
  if (inductionVariable <= 20)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 11;
      if (inductionVariable_0 <= 21)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          bmp.o48(x, y, Companion_getInstance_1().x4f(255, 215, 0));
        }
         while (inductionVariable_0 <= 21);
    }
     while (inductionVariable <= 20);
  var inductionVariable_1 = 14;
  if (inductionVariable_1 <= 18)
    do {
      var x_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      bmp.o48(x_0, 21, Companion_getInstance_1().x4f(180, 120, 40));
    }
     while (inductionVariable_1 <= 18);
  bmp.o48(11, 9, Companion_getInstance_1().x4f(255, 215, 0));
  bmp.o48(21, 9, Companion_getInstance_1().x4f(255, 215, 0));
  return bmp;
}
function createScore25000Icon() {
  var bmp = Bitmap32.s3y(32, 32);
  var inductionVariable = 10;
  if (inductionVariable <= 22)
    do {
      var x = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      bmp.o48(x, 18, Companion_getInstance_1().x4f(255, 215, 0));
    }
     while (inductionVariable <= 22);
  bmp.o48(10, 17, Companion_getInstance_1().x4f(255, 215, 0));
  bmp.o48(13, 15, Companion_getInstance_1().x4f(255, 215, 0));
  bmp.o48(16, 13, Companion_getInstance_1().x4f(255, 215, 0));
  bmp.o48(19, 15, Companion_getInstance_1().x4f(255, 215, 0));
  bmp.o48(22, 17, Companion_getInstance_1().x4f(255, 215, 0));
  var inductionVariable_0 = 12;
  if (inductionVariable_0 <= 20)
    do {
      var x_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      bmp.o48(x_0, 19, Companion_getInstance_1().x4f(180, 120, 40));
    }
     while (inductionVariable_0 <= 20);
  return bmp;
}
function createTime120Icon() {
  var bmp = Bitmap32.s3y(32, 32);
  var inductionVariable = 12;
  if (inductionVariable <= 20)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 12;
      if (inductionVariable_0 <= 20)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if ((imul(x - 16 | 0, x - 16 | 0) + imul(y - 16 | 0, y - 16 | 0) | 0) < 16) {
            bmp.o48(x, y, Companion_getInstance_1().x4f(220, 220, 220));
          }
        }
         while (inductionVariable_0 <= 20);
    }
     while (inductionVariable <= 20);
  var inductionVariable_1 = 0;
  if (inductionVariable_1 <= 2)
    do {
      var i = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      bmp.o48(16, 16 + i | 0, Companion_getInstance_1().x4f(80, 80, 80));
    }
     while (inductionVariable_1 <= 2);
  var inductionVariable_2 = 0;
  if (inductionVariable_2 <= 3)
    do {
      var i_0 = inductionVariable_2;
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      bmp.o48(16 + i_0 | 0, 16, Companion_getInstance_1().x4f(80, 80, 80));
    }
     while (inductionVariable_2 <= 3);
  return bmp;
}
function createTime300Icon() {
  var bmp = Bitmap32.s3y(32, 32);
  var inductionVariable = 12;
  if (inductionVariable <= 20)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 12;
      if (inductionVariable_0 <= 20)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if ((imul(x - 16 | 0, x - 16 | 0) + imul(y - 16 | 0, y - 16 | 0) | 0) < 16) {
            bmp.o48(x, y, Companion_getInstance_1().x4f(220, 220, 220));
          }
        }
         while (inductionVariable_0 <= 20);
    }
     while (inductionVariable <= 20);
  var inductionVariable_1 = 0;
  if (inductionVariable_1 <= 4)
    do {
      var i = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      bmp.o48(16, 16 + i | 0, Companion_getInstance_1().x4f(80, 80, 80));
    }
     while (inductionVariable_1 <= 4);
  var inductionVariable_2 = 0;
  if (inductionVariable_2 <= 2)
    do {
      var i_0 = inductionVariable_2;
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      bmp.o48(16 + i_0 | 0, 16, Companion_getInstance_1().x4f(80, 80, 80));
    }
     while (inductionVariable_2 <= 2);
  return bmp;
}
function createTime600Icon() {
  var bmp = Bitmap32.s3y(32, 32);
  var inductionVariable = 12;
  if (inductionVariable <= 20)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 12;
      if (inductionVariable_0 <= 20)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if ((imul(x - 16 | 0, x - 16 | 0) + imul(y - 16 | 0, y - 16 | 0) | 0) < 16) {
            bmp.o48(x, y, Companion_getInstance_1().x4f(220, 220, 220));
          }
        }
         while (inductionVariable_0 <= 20);
    }
     while (inductionVariable <= 20);
  var inductionVariable_1 = 0;
  if (inductionVariable_1 <= 6)
    do {
      var i = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      bmp.o48(16, 16 + i | 0, Companion_getInstance_1().x4f(80, 80, 80));
    }
     while (inductionVariable_1 <= 6);
  var inductionVariable_2 = 0;
  if (inductionVariable_2 <= 1)
    do {
      var i_0 = inductionVariable_2;
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      bmp.o48(16 + i_0 | 0, 16, Companion_getInstance_1().x4f(80, 80, 80));
    }
     while (inductionVariable_2 <= 1);
  return bmp;
}
function createDefaultAchievementIcon() {
  var bmp = Bitmap32.s3y(32, 32);
  var inductionVariable = 10;
  if (inductionVariable <= 22)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 10;
      if (inductionVariable_0 <= 22)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if ((imul(x - 16 | 0, x - 16 | 0) + imul(y - 16 | 0, y - 16 | 0) | 0) < 36) {
            bmp.o48(x, y, Companion_getInstance_1().x4f(180, 180, 180));
          }
        }
         while (inductionVariable_0 <= 22);
    }
     while (inductionVariable <= 22);
  return bmp;
}
function _get_background__3vp7tv($this) {
  var tmp = $this.ebw_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('background');
  }
}
function _get_titleText__jwdky4($this) {
  var tmp = $this.fbw_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('titleText');
  }
}
function _get_descText__m6fsgj($this) {
  var tmp = $this.gbw_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('descText');
  }
}
function _get_achievementNameText__stnz92($this) {
  var tmp = $this.hbw_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('achievementNameText');
  }
}
function _get_rewardText__gidtkh($this) {
  var tmp = $this.ibw_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('rewardText');
  }
}
function createNotification($this) {
  // Inline function 'kotlin.apply' call
  var this_0 = $this.vbv_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementNotification.createNotification.<anonymous>' call
  var baseY = 40.0 + $this.xbv_1;
  var baseX = ensureNotNull($this.vbv_1.ba5()).ka1().p9r_1 - $this.zbv_1 - 40.0;
  var tmp = $this;
  // Inline function 'korlibs.korge.view.solidRect' call
  var width = $this.zbv_1;
  var height = $this.abw_1;
  var color = Companion_getInstance_1().q4e(40, 40, 60, 220);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_1 = SolidRect.cbl(Size2D.f2i(width, height), color);
  // Inline function 'kotlin.apply' call
  var this_2 = addTo(this_1, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementNotification.createNotification.<anonymous>.<anonymous>' call
  position(this_2, baseX, baseY);
  tmp.ebw_1 = this_2;
  $this.dbw_1.h(_get_background__3vp7tv($this));
  var fadeStarted = {_v: false};
  addUpdater($this.vbv_1, AchievementNotification$createNotification$lambda($this, fadeStarted));
  // Inline function 'korlibs.korge.view.solidRect' call
  var width_0 = $this.zbv_1;
  var color_0 = Colors_getInstance().l42_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_3 = SolidRect.cbl(Size2D.f2i(width_0, 2.0), color_0);
  // Inline function 'kotlin.apply' call
  var this_4 = addTo(this_3, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementNotification.createNotification.<anonymous>.<anonymous>' call
  position(this_4, baseX, baseY);
  $this.dbw_1.h(this_4);
  // Inline function 'korlibs.korge.view.solidRect' call
  var width_1 = $this.zbv_1;
  var color_1 = Colors_getInstance().l42_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_5 = SolidRect.cbl(Size2D.f2i(width_1, 2.0), color_1);
  // Inline function 'kotlin.apply' call
  var this_6 = addTo(this_5, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementNotification.createNotification.<anonymous>.<anonymous>' call
  position(this_6, baseX, baseY + $this.abw_1 - 2.0);
  $this.dbw_1.h(this_6);
  // Inline function 'korlibs.korge.view.solidRect' call
  var height_0 = $this.abw_1;
  var color_2 = Colors_getInstance().l42_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_7 = SolidRect.cbl(Size2D.f2i(2.0, height_0), color_2);
  // Inline function 'kotlin.apply' call
  var this_8 = addTo(this_7, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementNotification.createNotification.<anonymous>.<anonymous>' call
  position(this_8, baseX, baseY);
  $this.dbw_1.h(this_8);
  // Inline function 'korlibs.korge.view.solidRect' call
  var height_1 = $this.abw_1;
  var color_3 = Colors_getInstance().l42_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_9 = SolidRect.cbl(Size2D.f2i(2.0, height_1), color_3);
  // Inline function 'kotlin.apply' call
  var this_10 = addTo(this_9, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementNotification.createNotification.<anonymous>.<anonymous>' call
  position(this_10, baseX + $this.zbv_1 - 2.0, baseY);
  $this.dbw_1.h(this_10);
  var iconSize = 48.0;
  // Inline function 'korlibs.korge.view.image' call
  var texture = getAchievementIconBitmap($this.wbv_1.vbu_1);
  var anchor = Companion_getInstance_4().b29_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_11 = Image.kbi(texture, anchor);
  // Inline function 'kotlin.apply' call
  var this_12 = addTo(this_11, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementNotification.createNotification.<anonymous>.<anonymous>' call
  position(this_12, baseX - 5.0, baseY + 5.0);
  scale(this_12, iconSize / 20.0);
  this_12.maj($this.wbv_1.abv_1 ? 1.0 : 0.3);
  this_12.ma1(false);
  var iconImage = this_12;
  $this.dbw_1.h(iconImage);
  var tmp_0 = $this;
  // Inline function 'korlibs.korge.view.text' call
  var text = Localization_getInstance().hi('achievement_unlocked');
  var font = get_gameFont();
  var color_4 = Colors_getInstance().g40_1;
  var alignment = Companion_getInstance_2().l4o_1;
  var renderer = get_DefaultStringTextRenderer();
  var autoScaling = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_13 = Text.lbp(text, numberToDouble(24.0), color_4, font, alignment, renderer, autoScaling, null, null);
  // Inline function 'kotlin.apply' call
  var this_14 = addTo(this_13, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementNotification.createNotification.<anonymous>.<anonymous>' call
  position(this_14, baseX + 70.0, baseY + 6.0);
  this_14.dbl(Colors_getInstance().l42_1);
  tmp_0.fbw_1 = this_14;
  $this.dbw_1.h(_get_titleText__jwdky4($this));
  var tmp_1 = $this;
  // Inline function 'korlibs.korge.view.text' call
  var text_0 = $this.wbv_1.wbu_1;
  var font_0 = get_gameFont();
  var color_5 = Colors_getInstance().g40_1;
  var alignment_0 = Companion_getInstance_2().l4o_1;
  var renderer_0 = get_DefaultStringTextRenderer();
  var autoScaling_0 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_15 = Text.lbp(text_0, numberToDouble(28.0), color_5, font_0, alignment_0, renderer_0, autoScaling_0, null, null);
  // Inline function 'kotlin.apply' call
  var this_16 = addTo(this_15, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementNotification.createNotification.<anonymous>.<anonymous>' call
  position(this_16, baseX + 70.0, baseY + 30.0);
  this_16.dbl(Colors_getInstance().g40_1);
  tmp_1.hbw_1 = this_16;
  $this.dbw_1.h(_get_achievementNameText__stnz92($this));
  var tmp_2 = $this;
  // Inline function 'korlibs.korge.view.text' call
  var text_1 = $this.wbv_1.xbu_1;
  var font_1 = get_gameFont();
  var color_6 = Colors_getInstance().g40_1;
  var alignment_1 = Companion_getInstance_2().l4o_1;
  var renderer_1 = get_DefaultStringTextRenderer();
  var autoScaling_1 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_17 = Text.lbp(text_1, numberToDouble(24.0), color_6, font_1, alignment_1, renderer_1, autoScaling_1, null, null);
  // Inline function 'kotlin.apply' call
  var this_18 = addTo(this_17, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementNotification.createNotification.<anonymous>.<anonymous>' call
  position(this_18, baseX + 70.0, baseY + 60.0);
  this_18.dbl(Companion_getInstance_1().x4f(200, 200, 200));
  tmp_2.gbw_1 = this_18;
  $this.dbw_1.h(_get_descText__m6fsgj($this));
  var tmp_3 = $this;
  // Inline function 'korlibs.korge.view.text' call
  var text_2 = Localization_getInstance().hi('reward') + ' ' + $this.wbv_1.zbu_1.fbv_1;
  var font_2 = get_gameFont();
  var color_7 = Colors_getInstance().g40_1;
  var alignment_2 = Companion_getInstance_2().l4o_1;
  var renderer_2 = get_DefaultStringTextRenderer();
  var autoScaling_2 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_19 = Text.lbp(text_2, numberToDouble(28.0), color_7, font_2, alignment_2, renderer_2, autoScaling_2, null, null);
  // Inline function 'kotlin.apply' call
  var this_20 = addTo(this_19, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementNotification.createNotification.<anonymous>.<anonymous>' call
  position(this_20, baseX + 70.0, baseY + 82.0);
  this_20.dbl(Colors_getInstance().l42_1);
  tmp_3.ibw_1 = this_20;
  $this.dbw_1.h(_get_rewardText__gidtkh($this));
}
function AchievementNotification$createNotification$lambda(this$0, $fadeStarted) {
  return function ($this$addUpdater, dt) {
    var tmp;
    if (this$0.kbw_1) {
      return Unit_instance;
    }
    this$0.bbw_1 = this$0.bbw_1 + get_seconds(dt.qj_1);
    var tmp_0;
    if (this$0.bbw_1 > this$0.cbw_1 - 1.0 && !$fadeStarted._v) {
      $fadeStarted._v = true;
      tmp_0 = Unit_instance;
    }
    var tmp_1;
    if ($fadeStarted._v) {
      var fadeProgress = this$0.bbw_1 - (this$0.cbw_1 - 1.0);
      var alpha = coerceIn(1.0 - fadeProgress, 0.0, 1.0);
      var tmp0_iterator = this$0.dbw_1.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'AchievementNotification.createNotification.<anonymous>.<anonymous>.<anonymous>' call
        element.maj(alpha);
      }
      tmp_1 = Unit_instance;
    }
    var tmp_2;
    if (this$0.bbw_1 >= this$0.cbw_1) {
      this$0.r6();
      tmp_2 = Unit_instance;
    }
    return Unit_instance;
  };
}
function createPanel($this) {
  // Inline function 'kotlin.apply' call
  var this_0 = $this.lbw_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementPanel.createPanel.<anonymous>' call
  // Inline function 'korlibs.korge.view.solidRect' call
  var width = ensureNotNull($this.lbw_1.ba5()).ka1().p9r_1;
  var height = ensureNotNull($this.lbw_1.ba5()).ka1().q9r_1;
  var color = Companion_getInstance_1().q4e(0, 0, 0, 180);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_1 = SolidRect.cbl(Size2D.h2b(width, height), color);
  // Inline function 'kotlin.apply' call
  var this_2 = addTo(this_1, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementPanel.createPanel.<anonymous>.<anonymous>' call
  // Inline function 'korlibs.korge.input.onClick' call
  var handler = AchievementPanel$createPanel$lambda($this);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop = click$factory();
  var tmp1_safe_receiver = this_2 == null ? null : this_2.gai();
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < tmp1_safe_receiver.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var tmp0_safe_receiver = tmp1_safe_receiver.e1(_unary__edvuaz);
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp = prop.get(tmp1_safe_receiver_0);
        tmp.q20(AchievementPanel$createPanel$lambda_0(handler));
      }
    }
  }
  var overlay = this_2;
  $this.qbw_1.h(overlay);
  // Inline function 'korlibs.korge.view.solidRect' call
  var width_0 = $this.obw_1;
  var height_0 = $this.pbw_1;
  var color_0 = Companion_getInstance_1().x4f(30, 30, 45);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_3 = SolidRect.cbl(Size2D.f2i(width_0, height_0), color_0);
  // Inline function 'kotlin.apply' call
  var this_4 = addTo(this_3, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementPanel.createPanel.<anonymous>.<anonymous>' call
  var stage = ensureNotNull($this.lbw_1.ba5());
  position(this_4, (stage.ka1().p9r_1 - $this.obw_1) / 2.0, (stage.ka1().q9r_1 - $this.pbw_1) / 2.0);
  var panel = this_4;
  $this.qbw_1.h(panel);
  // Inline function 'korlibs.korge.view.text' call
  var text = '\uD83C\uDFC6 ' + Localization_getInstance().hi('achievements');
  var font = get_gameFont();
  var color_1 = Colors_getInstance().g40_1;
  var alignment = Companion_getInstance_2().l4o_1;
  var renderer = get_DefaultStringTextRenderer();
  var autoScaling = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_5 = Text.lbp(text, numberToDouble(32.0), color_1, font, alignment, renderer, autoScaling, null, null);
  // Inline function 'kotlin.apply' call
  var this_6 = addTo(this_5, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementPanel.createPanel.<anonymous>.<anonymous>' call
  position(this_6, panel.b6j() + 20.0, panel.c6j() + 10.0);
  this_6.dbl(Colors_getInstance().l42_1);
  $this.qbw_1.h(this_6);
  var unlockedCount = $this.mbw_1.sbv();
  var totalCount = $this.mbw_1.tbv();
  // Inline function 'korlibs.korge.view.text' call
  var text_0 = '' + unlockedCount + ' / ' + totalCount + ' ' + Localization_getInstance().hi('unlocked_count');
  var font_0 = get_gameFont();
  var color_2 = Colors_getInstance().g40_1;
  var alignment_0 = Companion_getInstance_2().l4o_1;
  var renderer_0 = get_DefaultStringTextRenderer();
  var autoScaling_0 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_7 = Text.lbp(text_0, numberToDouble(32.0), color_2, font_0, alignment_0, renderer_0, autoScaling_0, null, null);
  // Inline function 'kotlin.apply' call
  var this_8 = addTo(this_7, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementPanel.createPanel.<anonymous>.<anonymous>' call
  position(this_8, panel.b6j() + 20.0, panel.c6j() + 45.0);
  this_8.dbl(Colors_getInstance().c43_1);
  $this.qbw_1.h(this_8);
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_9 = Container.za4(false);
  // Inline function 'kotlin.apply' call
  var this_10 = addTo(this_9, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementPanel.createPanel.<anonymous>.<anonymous>' call
  var btnWidth = 100.0;
  var btnHeight = 48.0;
  var borderColor = Colors_getInstance().g40_1;
  var bgColor = Companion_getInstance_1().r4g(borderColor, Colors_getInstance().h40_1, _Ratio___init__impl__9mwvn2(0.6));
  var bgHoverColor = Companion_getInstance_1().r4g(borderColor, Colors_getInstance().h40_1, _Ratio___init__impl__9mwvn2(0.75));
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_11 = SolidRect.cbl(Size2D.f2i(btnWidth, btnHeight), bgColor);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  var bg = addTo(this_11, this_10);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_12 = SolidRect.cbl(Size2D.f2i(btnWidth, 3.0), borderColor);
  // Inline function 'kotlin.apply' call
  var this_13 = addTo(this_12, this_10);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_13, 0.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_14 = SolidRect.cbl(Size2D.f2i(btnWidth, 3.0), borderColor);
  // Inline function 'kotlin.apply' call
  var this_15 = addTo(this_14, this_10);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_15, 0.0, btnHeight - 3);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_16 = SolidRect.cbl(Size2D.f2i(3.0, btnHeight), borderColor);
  // Inline function 'kotlin.apply' call
  var this_17 = addTo(this_16, this_10);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_17, 0.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_18 = SolidRect.cbl(Size2D.f2i(3.0, btnHeight), borderColor);
  // Inline function 'kotlin.apply' call
  var this_19 = addTo(this_18, this_10);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_19, btnWidth - 3, 0.0);
  // Inline function 'korlibs.korge.view.text' call
  var text_1 = '\uD83D\uDCCA ' + Localization_getInstance().hi('close');
  var textSize = Companion_instance.gbp_1;
  var color_3 = Colors_getInstance().g40_1;
  var font_1 = get_DefaultTtfFontAsBitmap();
  var alignment_1 = Companion_getInstance_2().l4o_1;
  var renderer_1 = get_DefaultStringTextRenderer();
  var autoScaling_1 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_20 = Text.lbp(text_1, numberToDouble(textSize), color_3, font_1, alignment_1, renderer_1, autoScaling_1, null, null);
  // Inline function 'kotlin.apply' call
  var this_21 = addTo(this_20, this_10);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementPanel.createPanel.<anonymous>.<anonymous>.<anonymous>' call
  this_21.kbp(get_gameFont());
  this_21.obp(32.0);
  this_21.dbl(borderColor);
  this_21.qbp(Companion_getInstance_2().y4o_1);
  position(this_21, btnWidth / 2, btnHeight / 2 - 2);
  var btnText = this_21;
  position(this_10, panel.b6j() + $this.obw_1 - btnWidth - 20.0, panel.c6j() + 15.0);
  // Inline function 'korlibs.korge.input.onClick' call
  var handler_0 = AchievementPanel$createPanel$lambda_1($this);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_0 = click$factory_0();
  var tmp1_safe_receiver_1 = this_10 == null ? null : this_10.gai();
  if (tmp1_safe_receiver_1 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_0 = 0;
    while (n_0 < tmp1_safe_receiver_1.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var tmp0_safe_receiver_0 = tmp1_safe_receiver_1.e1(_unary__edvuaz_0);
      var tmp1_safe_receiver_2 = tmp0_safe_receiver_0 == null ? null : get_mouse(tmp0_safe_receiver_0);
      if (tmp1_safe_receiver_2 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0 = prop_0.get(tmp1_safe_receiver_2);
        tmp_0.q20(AchievementPanel$createPanel$lambda_2(handler_0));
      }
    }
  }
  // Inline function 'korlibs.korge.input.onOver' call
  var handler_1 = AchievementPanel$createPanel$lambda_3(bg, bgHoverColor);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_1 = over$factory();
  var tmp1_safe_receiver_3 = this_10 == null ? null : this_10.gai();
  if (tmp1_safe_receiver_3 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_1 = 0;
    while (n_1 < tmp1_safe_receiver_3.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_1 = n_1;
      n_1 = _unary__edvuaz_1 + 1 | 0;
      var tmp0_safe_receiver_1 = tmp1_safe_receiver_3.e1(_unary__edvuaz_1);
      var tmp1_safe_receiver_4 = tmp0_safe_receiver_1 == null ? null : get_mouse(tmp0_safe_receiver_1);
      if (tmp1_safe_receiver_4 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_1 = prop_1.get(tmp1_safe_receiver_4);
        tmp_1.q20(AchievementPanel$createPanel$lambda_4(handler_1));
      }
    }
  }
  // Inline function 'korlibs.korge.input.onOut' call
  var handler_2 = AchievementPanel$createPanel$lambda_5(bg, bgColor);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_2 = out$factory();
  var tmp1_safe_receiver_5 = this_10 == null ? null : this_10.gai();
  if (tmp1_safe_receiver_5 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_2 = 0;
    while (n_2 < tmp1_safe_receiver_5.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_2 = n_2;
      n_2 = _unary__edvuaz_2 + 1 | 0;
      var tmp0_safe_receiver_2 = tmp1_safe_receiver_5.e1(_unary__edvuaz_2);
      var tmp1_safe_receiver_6 = tmp0_safe_receiver_2 == null ? null : get_mouse(tmp0_safe_receiver_2);
      if (tmp1_safe_receiver_6 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_2 = prop_2.get(tmp1_safe_receiver_6);
        tmp_2.q20(AchievementPanel$createPanel$lambda_6(handler_2));
      }
    }
  }
  var closeButton = this_10;
  $this.qbw_1.h(closeButton);
  // Inline function 'korlibs.korge.input.onClick' call
  var handler_3 = AchievementPanel$createPanel$lambda_7($this);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_3 = click$factory_1();
  var tmp1_safe_receiver_7 = closeButton == null ? null : closeButton.gai();
  if (tmp1_safe_receiver_7 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_3 = 0;
    while (n_3 < tmp1_safe_receiver_7.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_3 = n_3;
      n_3 = _unary__edvuaz_3 + 1 | 0;
      var tmp0_safe_receiver_3 = tmp1_safe_receiver_7.e1(_unary__edvuaz_3);
      var tmp1_safe_receiver_8 = tmp0_safe_receiver_3 == null ? null : get_mouse(tmp0_safe_receiver_3);
      if (tmp1_safe_receiver_8 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_3 = prop_3.get(tmp1_safe_receiver_8);
        tmp_3.q20(AchievementPanel$createPanel$lambda_8(handler_3));
      }
    }
  }
  var achievements = $this.mbw_1.rbv();
  var scrollAreaHeight = $this.pbw_1 - 110.0;
  var scrollAreaY = panel.c6j() + 90.0;
  var scrollAreaX = panel.b6j() + 0.0;
  var itemHeight = 75.0;
  var totalContentHeight = achievements.f1() * itemHeight;
  var scrollOffset = {_v: 0.0};
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_22 = Container.za4(false);
  // Inline function 'kotlin.apply' call
  var this_23 = addTo(this_22, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementPanel.createPanel.<anonymous>.<anonymous>' call
  position(this_23, scrollAreaX, scrollAreaY);
  var scrollContainer = this_23;
  // Inline function 'korlibs.korge.view.clipContainer' call
  var size = Size2D.f2i($this.obw_1, scrollAreaHeight);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_24 = ClipContainer.fb1(size);
  // Inline function 'kotlin.apply' call
  var this_25 = addTo(this_24, scrollContainer);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementPanel.createPanel.<anonymous>.<anonymous>' call
  this_25.l9t_1 = 'achievementsScrollClip';
  var clipView = this_25;
  $this.qbw_1.h(scrollContainer);
  createPanel$_anonymous_$renderAchievements_8szu37(clipView, scrollOffset, itemHeight, achievements, scrollAreaHeight, $this, panel);
  // Inline function 'korlibs.korge.input.onScroll' call
  var handler_4 = AchievementPanel$createPanel$lambda_9(scrollOffset, totalContentHeight, scrollAreaHeight, clipView, itemHeight, achievements, $this, panel);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_4 = scroll$factory();
  var tmp1_safe_receiver_9 = scrollContainer == null ? null : scrollContainer.gai();
  if (tmp1_safe_receiver_9 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_4 = 0;
    while (n_4 < tmp1_safe_receiver_9.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_4 = n_4;
      n_4 = _unary__edvuaz_4 + 1 | 0;
      var tmp0_safe_receiver_4 = tmp1_safe_receiver_9.e1(_unary__edvuaz_4);
      var tmp1_safe_receiver_10 = tmp0_safe_receiver_4 == null ? null : get_mouse(tmp0_safe_receiver_4);
      if (tmp1_safe_receiver_10 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_4 = prop_4.get(tmp1_safe_receiver_10);
        tmp_4.q20(AchievementPanel$createPanel$lambda_10(handler_4));
      }
    }
  }
  var timeSinceUpdate = {_v: 0.0};
  addUpdater($this.lbw_1, AchievementPanel$createPanel$lambda_11(timeSinceUpdate, clipView, scrollOffset, itemHeight, achievements, scrollAreaHeight, $this, panel));
}
function createAchievementItemIn($this, parent, panel, achievement, yOffset) {
  var itemY = yOffset;
  var itemX = 20.0;
  var itemWidth = $this.obw_1 - 40.0;
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementPanel.createAchievementItemIn.<anonymous>' call
  var bgColor = achievement.abv_1 ? Companion_getInstance_1().q4e(50, 80, 50, 150) : Companion_getInstance_1().q4e(50, 50, 50, 100);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SolidRect.cbl(Size2D.f2i(itemWidth, 70.0), bgColor);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, parent);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementPanel.createAchievementItemIn.<anonymous>.<anonymous>' call
  position(this_1, itemX, itemY);
  // Inline function 'korlibs.korge.view.image' call
  var texture = getAchievementIconBitmap(achievement.vbu_1);
  var anchor = Companion_getInstance_4().b29_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = Image.kbi(texture, anchor);
  // Inline function 'kotlin.apply' call
  var this_3 = addTo(this_2, parent);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementPanel.createAchievementItemIn.<anonymous>.<anonymous>' call
  var iconSize = 48.0;
  position(this_3, itemX - 5, itemY - 5);
  scale(this_3, iconSize / 24.0);
  this_3.maj(achievement.abv_1 ? 1.0 : 0.3);
  this_3.ma1(false);
  // Inline function 'korlibs.korge.view.text' call
  var text = achievement.wbu_1;
  var font = get_gameFont();
  var color = Colors_getInstance().g40_1;
  var alignment = Companion_getInstance_2().l4o_1;
  var renderer = get_DefaultStringTextRenderer();
  var autoScaling = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_4 = Text.lbp(text, numberToDouble(26.0), color, font, alignment, renderer, autoScaling, null, null);
  // Inline function 'kotlin.apply' call
  var this_5 = addTo(this_4, parent);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementPanel.createAchievementItemIn.<anonymous>.<anonymous>' call
  position(this_5, itemX + 60.0, itemY - 1);
  this_5.dbl(achievement.abv_1 ? Colors_getInstance().g40_1 : Colors_getInstance().j41_1);
  // Inline function 'korlibs.korge.view.text' call
  var text_0 = achievement.xbu_1;
  var font_0 = get_gameFont();
  var color_0 = Colors_getInstance().g40_1;
  var alignment_0 = Companion_getInstance_2().l4o_1;
  var renderer_0 = get_DefaultStringTextRenderer();
  var autoScaling_0 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_6 = Text.lbp(text_0, numberToDouble(22.0), color_0, font_0, alignment_0, renderer_0, autoScaling_0, null, null);
  // Inline function 'kotlin.apply' call
  var this_7 = addTo(this_6, parent);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementPanel.createAchievementItemIn.<anonymous>.<anonymous>' call
  position(this_7, itemX + 60.0, itemY + 22.0);
  this_7.dbl(achievement.abv_1 ? Colors_getInstance().c43_1 : Companion_getInstance_1().x4f(100, 100, 100));
  // Inline function 'korlibs.korge.view.text' call
  var text_1 = Localization_getInstance().hi('reward') + ' ' + achievement.zbu_1.fbv_1;
  var font_1 = get_gameFont();
  var color_1 = Colors_getInstance().g40_1;
  var alignment_1 = Companion_getInstance_2().l4o_1;
  var renderer_1 = get_DefaultStringTextRenderer();
  var autoScaling_1 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_8 = Text.lbp(text_1, numberToDouble(22.0), color_1, font_1, alignment_1, renderer_1, autoScaling_1, null, null);
  // Inline function 'kotlin.apply' call
  var this_9 = addTo(this_8, parent);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementPanel.createAchievementItemIn.<anonymous>.<anonymous>' call
  position(this_9, itemX + 60.0, itemY + 41.0);
  this_9.dbl(Colors_getInstance().l42_1);
  var tmp;
  if (achievement.abv_1) {
    tmp = '\u2713 ' + Localization_getInstance().hi('unlocked');
  } else {
    var condition = achievement.ybu_1;
    var tmp_0;
    if (condition instanceof Population) {
      tmp_0 = '' + achievement.cbv_1 + '/' + condition.gbv_1;
    } else {
      if (condition instanceof Collisions) {
        tmp_0 = '' + achievement.cbv_1 + '/' + condition.hbv_1;
      } else {
        if (condition instanceof Score) {
          tmp_0 = '' + achievement.cbv_1 + '/' + numberToInt(condition.ibv_1);
        } else {
          if (condition instanceof TimeAlive) {
            tmp_0 = '' + achievement.cbv_1 + 's/' + numberToInt(condition.jbv_1) + 's';
          } else {
            if (condition instanceof ReproductionStreak) {
              tmp_0 = '0/' + condition.rbw_1;
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }
    tmp = tmp_0;
  }
  var statusText = tmp;
  // Inline function 'korlibs.korge.view.text' call
  var font_2 = get_gameFont();
  var color_2 = Colors_getInstance().g40_1;
  var alignment_2 = Companion_getInstance_2().l4o_1;
  var renderer_2 = get_DefaultStringTextRenderer();
  var autoScaling_2 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_10 = Text.lbp(statusText, numberToDouble(22.0), color_2, font_2, alignment_2, renderer_2, autoScaling_2, null, null);
  // Inline function 'kotlin.apply' call
  var this_11 = addTo(this_10, parent);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'AchievementPanel.createAchievementItemIn.<anonymous>.<anonymous>' call
  position(this_11, itemX + itemWidth - 100.0, itemY + 15.0);
  this_11.dbl(achievement.abv_1 ? Colors_getInstance().l42_1 : Colors_getInstance().j41_1);
}
function closePanel($this) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = $this.qbw_1.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'AchievementPanel.closePanel.<anonymous>' call
    element.kak();
  }
  $this.qbw_1.k3();
  $this.nbw_1();
}
function createPanel$_anonymous_$renderAchievements_8szu37(clipView, scrollOffset, itemHeight, achievements, scrollAreaHeight, this$0, panel) {
  clipView.wah();
  // Inline function 'kotlin.comparisons.maxOf' call
  var b = numberToInt(scrollOffset._v / itemHeight);
  var startIdx = Math.max(0, b);
  // Inline function 'kotlin.comparisons.minOf' call
  var a = achievements.f1();
  var b_0 = numberToInt((scrollOffset._v + scrollAreaHeight) / itemHeight) + 2 | 0;
  var endIdx = Math.min(a, b_0);
  var inductionVariable = startIdx;
  if (inductionVariable < endIdx)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var y = i * itemHeight - scrollOffset._v;
      createAchievementItemIn(this$0, clipView, panel, achievements.e1(i), y);
    }
     while (inductionVariable < endIdx);
}
function AchievementPanel$createPanel$lambda(this$0) {
  return function (it) {
    closePanel(this$0);
    return Unit_instance;
  };
}
function AchievementPanel$createPanel$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function AchievementPanel$createPanel$lambda_1(this$0) {
  return function (it) {
    closePanel(this$0);
    return Unit_instance;
  };
}
function AchievementPanel$createPanel$lambda_2($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function AchievementPanel$createPanel$lambda_3($bg, $bgHoverColor) {
  return function (it) {
    $bg.dbl($bgHoverColor);
    return Unit_instance;
  };
}
function AchievementPanel$createPanel$lambda_4($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function AchievementPanel$createPanel$lambda_5($bg, $bgColor) {
  return function (it) {
    $bg.dbl($bgColor);
    return Unit_instance;
  };
}
function AchievementPanel$createPanel$lambda_6($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function AchievementPanel$createPanel$lambda_7(this$0) {
  return function (it) {
    closePanel(this$0);
    return Unit_instance;
  };
}
function AchievementPanel$createPanel$lambda_8($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function AchievementPanel$createPanel$lambda_9($scrollOffset, $totalContentHeight, $scrollAreaHeight, $clipView, $itemHeight, $achievements, this$0, $panel) {
  return function (event) {
    var scrollSpeed = 3.0;
    var delta = event.ta1() * scrollSpeed;
    $scrollOffset._v = coerceIn($scrollOffset._v + delta, 0.0, coerceAtLeast($totalContentHeight - $scrollAreaHeight, 0.0));
    createPanel$_anonymous_$renderAchievements_8szu37($clipView, $scrollOffset, $itemHeight, $achievements, $scrollAreaHeight, this$0, $panel);
    return Unit_instance;
  };
}
function AchievementPanel$createPanel$lambda_10($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function AchievementPanel$createPanel$lambda_11($timeSinceUpdate, $clipView, $scrollOffset, $itemHeight, $achievements, $scrollAreaHeight, this$0, $panel) {
  return function ($this$addUpdater, dt) {
    $timeSinceUpdate._v = $timeSinceUpdate._v + get_seconds(dt.qj_1);
    var tmp;
    if ($timeSinceUpdate._v >= 1.0) {
      $timeSinceUpdate._v = 0.0;
      createPanel$_anonymous_$renderAchievements_8szu37($clipView, $scrollOffset, $itemHeight, $achievements, $scrollAreaHeight, this$0, $panel);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function click$factory() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.t9z_1;
  }, null);
}
function click$factory_0() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.t9z_1;
  }, null);
}
function over$factory() {
  return getPropertyCallableRef('over', 1, KProperty1, function (receiver) {
    return receiver.u9z_1;
  }, null);
}
function out$factory() {
  return getPropertyCallableRef('out', 1, KProperty1, function (receiver) {
    return receiver.v9z_1;
  }, null);
}
function click$factory_1() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.t9z_1;
  }, null);
}
function scroll$factory() {
  return getPropertyCallableRef('scroll', 1, KProperty1, function (receiver) {
    return receiver.ia0_1;
  }, null);
}
var Companion_instance_0;
function Companion_getInstance_9() {
  return Companion_instance_0;
}
var Gender_MALE_instance;
var Gender_FEMALE_instance;
var Gender_entriesInitialized;
function Gender_initEntries() {
  if (Gender_entriesInitialized)
    return Unit_instance;
  Gender_entriesInitialized = true;
  Gender_MALE_instance = new Gender('MALE', 0);
  Gender_FEMALE_instance = new Gender('FEMALE', 1);
}
var HairStyle_SHORT_instance;
var HairStyle_SPIKY_instance;
var HairStyle_CURLY_instance;
function values() {
  return [HairStyle_SHORT_getInstance(), HairStyle_SPIKY_getInstance(), HairStyle_CURLY_getInstance()];
}
var HairStyle_entriesInitialized;
function HairStyle_initEntries() {
  if (HairStyle_entriesInitialized)
    return Unit_instance;
  HairStyle_entriesInitialized = true;
  HairStyle_SHORT_instance = new HairStyle('SHORT', 0);
  HairStyle_SPIKY_instance = new HairStyle('SPIKY', 1);
  HairStyle_CURLY_instance = new HairStyle('CURLY', 2);
}
var OutfitStyle_SIMPLE_instance;
var OutfitStyle_FANCY_instance;
var OutfitStyle_SPORTY_instance;
var OutfitStyle_CASUAL_instance;
var OutfitStyle_HOODIE_instance;
var OutfitStyle_BUSINESS_instance;
function values_0() {
  return [OutfitStyle_SIMPLE_getInstance(), OutfitStyle_FANCY_getInstance(), OutfitStyle_SPORTY_getInstance(), OutfitStyle_CASUAL_getInstance(), OutfitStyle_HOODIE_getInstance(), OutfitStyle_BUSINESS_getInstance()];
}
var OutfitStyle_entriesInitialized;
function OutfitStyle_initEntries() {
  if (OutfitStyle_entriesInitialized)
    return Unit_instance;
  OutfitStyle_entriesInitialized = true;
  OutfitStyle_SIMPLE_instance = new OutfitStyle('SIMPLE', 0);
  OutfitStyle_FANCY_instance = new OutfitStyle('FANCY', 1);
  OutfitStyle_SPORTY_instance = new OutfitStyle('SPORTY', 2);
  OutfitStyle_CASUAL_instance = new OutfitStyle('CASUAL', 3);
  OutfitStyle_HOODIE_instance = new OutfitStyle('HOODIE', 4);
  OutfitStyle_BUSINESS_instance = new OutfitStyle('BUSINESS', 5);
}
function _get_spriteImage__26biyj($this) {
  var tmp = $this.rc4_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('spriteImage');
  }
}
function generateRandomAppearance($this) {
  var hairColors = listOf([new RGBA(Companion_getInstance_1().x4f(101, 67, 33)), new RGBA(Companion_getInstance_1().x4f(255, 220, 90)), new RGBA(Companion_getInstance_1().x4f(20, 20, 20)), new RGBA(Companion_getInstance_1().x4f(165, 42, 42)), new RGBA(Companion_getInstance_1().x4f(128, 128, 128))]);
  var skinColors = listOf([new RGBA(Companion_getInstance_1().x4f(255, 220, 177)), new RGBA(Companion_getInstance_1().x4f(241, 194, 125)), new RGBA(Companion_getInstance_1().x4f(198, 134, 66)), new RGBA(Companion_getInstance_1().x4f(141, 85, 36))]);
  var hairStyles = values();
  var outfitStyles = values_0();
  // Inline function 'kotlin.collections.random' call
  var tmp = random(hairStyles, Default_getInstance());
  // Inline function 'kotlin.collections.random' call
  var tmp_0 = random_0(hairColors, Default_getInstance()).a4g_1;
  // Inline function 'kotlin.collections.random' call
  var tmp_1 = random(outfitStyles, Default_getInstance());
  // Inline function 'kotlin.collections.random' call
  var tmp$ret$3 = random_0(skinColors, Default_getInstance()).a4g_1;
  return new Appearance(tmp, tmp_0, tmp_1, tmp$ret$3);
}
function generateFixedAppearance($this, hairStyle, outfitStyle) {
  return new Appearance(hairStyle, Companion_getInstance_1().x4f(101, 67, 33), outfitStyle, Companion_getInstance_1().x4f(255, 220, 177));
}
function updateSprite($this) {
  var ageRatio = $this.gc4_1 / $this.nc4_1;
  var collisionColor = $this.tc4() ? $this.vc3_1 : Companion_getInstance_1().r4g(Colors_getInstance().g40_1, $this.vc3_1, _Ratio___init__impl__9mwvn2(0.5));
  var tmp;
  if ($this.kc4_1) {
    var darkenRatio = coerceIn((ageRatio - 0.7) / 0.3, 0.0, 1.0);
    tmp = Companion_getInstance_1().r4g(collisionColor, Colors_getInstance().h40_1, _Ratio___init__impl__9mwvn2(darkenRatio * 0.8));
  } else if (ageRatio >= 0.7) {
    var darkenRatio_0 = coerceIn((ageRatio - 0.7) / 0.3, 0.0, 1.0);
    tmp = Companion_getInstance_1().r4g(collisionColor, Colors_getInstance().h40_1, _Ratio___init__impl__9mwvn2(darkenRatio_0 * 0.8));
  } else {
    tmp = collisionColor;
  }
  var displayColor = tmp;
  var bitmap = HumanSpriteCache_getInstance().vc4(numberToInt($this.wc3_1), $this.sc4_1, displayColor, $this.qc4_1);
  if (!($this.rc4_1 == null)) {
    _get_spriteImage__26biyj($this).tav(slice(bitmap));
  } else {
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.view.image' call
    var this_0 = $this.cc4_1;
    var anchor = Companion_getInstance_4().b29_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = Image.kbi(bitmap, anchor);
    // Inline function 'kotlin.apply' call
    var this_2 = addTo(this_1, this_0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'GameSquare.updateSprite.<anonymous>' call
    position(this_2, 0.0, 0.0);
    tmp_0.rc4_1 = this_2;
  }
}
function updateDeathState($this, deltaTime) {
  $this.lc4_1 = $this.lc4_1 + deltaTime;
  var alpha = 1.0 - coerceIn($this.lc4_1 / $this.mc4_1, 0.0, 1.0);
  $this.cc4_1.maj(alpha);
}
function updateAnimation($this, deltaTime) {
  $this.pc4_1 = $this.pc4_1 + deltaTime;
  if ($this.pc4_1 >= 0.15) {
    $this.pc4_1 = 0.0;
    $this.qc4_1 = 1 - $this.qc4_1 | 0;
    updateSprite($this);
    var tmp0_safe_receiver = $this.ac4_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.hc5();
    }
  }
}
function updateFrozenState($this, deltaTime) {
  $this.ic4_1 = $this.ic4_1 - deltaTime;
  if ($this.ic4_1 <= 0) {
    unfreeze($this);
  }
}
function updateActiveState($this, deltaTime) {
  $this.gc4_1 = $this.gc4_1 + deltaTime;
  if ($this.jc4_1 > 0) {
    $this.jc4_1 = $this.jc4_1 - deltaTime;
  }
  updateColor($this);
}
function updateColor($this) {
  var newCanCollide = $this.tc4();
  if (!($this.rc4_1 == null)) {
    updateSprite($this);
  }
}
function unfreeze($this) {
  $this.hc4_1 = false;
  $this.ec4_1 = $this.fc4_1;
  $this.cc4_1.i8q(true);
  $this.jc4_1 = $this.zc3_1;
}
function GameSquare$lambda(this$0) {
  return function (it) {
    println('Clicked on person: ' + this$0.oc4_1 + ' (' + this$0.yc3_1.q3_1 + ')');
    return Unit_instance;
  };
}
function GameSquare$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function Gender_MALE_getInstance() {
  Gender_initEntries();
  return Gender_MALE_instance;
}
function Gender_FEMALE_getInstance() {
  Gender_initEntries();
  return Gender_FEMALE_instance;
}
function HairStyle_SHORT_getInstance() {
  HairStyle_initEntries();
  return HairStyle_SHORT_instance;
}
function HairStyle_SPIKY_getInstance() {
  HairStyle_initEntries();
  return HairStyle_SPIKY_instance;
}
function HairStyle_CURLY_getInstance() {
  HairStyle_initEntries();
  return HairStyle_CURLY_instance;
}
function OutfitStyle_SIMPLE_getInstance() {
  OutfitStyle_initEntries();
  return OutfitStyle_SIMPLE_instance;
}
function OutfitStyle_FANCY_getInstance() {
  OutfitStyle_initEntries();
  return OutfitStyle_FANCY_instance;
}
function OutfitStyle_SPORTY_getInstance() {
  OutfitStyle_initEntries();
  return OutfitStyle_SPORTY_instance;
}
function OutfitStyle_CASUAL_getInstance() {
  OutfitStyle_initEntries();
  return OutfitStyle_CASUAL_instance;
}
function OutfitStyle_HOODIE_getInstance() {
  OutfitStyle_initEntries();
  return OutfitStyle_HOODIE_instance;
}
function OutfitStyle_BUSINESS_getInstance() {
  OutfitStyle_initEntries();
  return OutfitStyle_BUSINESS_instance;
}
function click$factory_2() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.t9z_1;
  }, null);
}
function createGravestoneBitmap($this, size) {
  var bitmap = Bitmap32.s3y(size, size);
  var bg = Colors_getInstance().j41_1;
  var cross = Colors_getInstance().c43_1;
  var base = Colors_getInstance().w41_1;
  var px = size / 10 | 0;
  bitmap.x48(Colors_getInstance().l40_1);
  var inductionVariable = imul(2, px);
  var last = imul(8, px);
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = imul(3, px);
      var last_0 = imul(7, px);
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          bitmap.o48(x, y, bg);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  var inductionVariable_1 = 0;
  var last_1 = imul(2, px);
  if (inductionVariable_1 < last_1)
    do {
      var y_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var inductionVariable_2 = imul(3, px);
      var last_2 = imul(7, px);
      if (inductionVariable_2 < last_2)
        do {
          var x_0 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var dx = x_0 - imul(5, px) | 0;
          var dy = y_0 - imul(2, px) | 0;
          if ((imul(dx, dx) + imul(dy, dy) | 0) < imul(numberToInt(2.2 * px), numberToInt(2.2 * px))) {
            bitmap.o48(x_0, y_0, bg);
          }
        }
         while (inductionVariable_2 < last_2);
    }
     while (inductionVariable_1 < last_1);
  var inductionVariable_3 = imul(8, px);
  var last_3 = imul(10, px);
  if (inductionVariable_3 < last_3)
    do {
      var y_1 = inductionVariable_3;
      inductionVariable_3 = inductionVariable_3 + 1 | 0;
      var inductionVariable_4 = imul(2, px);
      var last_4 = imul(8, px);
      if (inductionVariable_4 < last_4)
        do {
          var x_1 = inductionVariable_4;
          inductionVariable_4 = inductionVariable_4 + 1 | 0;
          bitmap.o48(x_1, y_1, base);
        }
         while (inductionVariable_4 < last_4);
    }
     while (inductionVariable_3 < last_3);
  var inductionVariable_5 = imul(3, px);
  var last_5 = imul(7, px);
  if (inductionVariable_5 < last_5)
    do {
      var y_2 = inductionVariable_5;
      inductionVariable_5 = inductionVariable_5 + 1 | 0;
      var inductionVariable_6 = imul(4, px);
      var last_6 = imul(6, px);
      if (inductionVariable_6 < last_6)
        do {
          var x_2 = inductionVariable_6;
          inductionVariable_6 = inductionVariable_6 + 1 | 0;
          bitmap.o48(x_2, y_2, cross);
        }
         while (inductionVariable_6 < last_6);
    }
     while (inductionVariable_5 < last_5);
  var inductionVariable_7 = imul(4, px);
  var last_7 = imul(6, px);
  if (inductionVariable_7 < last_7)
    do {
      var y_3 = inductionVariable_7;
      inductionVariable_7 = inductionVariable_7 + 1 | 0;
      var inductionVariable_8 = imul(3, px);
      var last_8 = imul(7, px);
      if (inductionVariable_8 < last_8)
        do {
          var x_3 = inductionVariable_8;
          inductionVariable_8 = inductionVariable_8 + 1 | 0;
          bitmap.o48(x_3, y_3, cross);
        }
         while (inductionVariable_8 < last_8);
    }
     while (inductionVariable_7 < last_7);
  return bitmap;
}
var GravestoneSpriteCache_instance;
function GravestoneSpriteCache_getInstance() {
  if (GravestoneSpriteCache_instance === VOID)
    new GravestoneSpriteCache();
  return GravestoneSpriteCache_instance;
}
function createHumanBitmap($this, size, appearance, baseColor, frame) {
  var bitmap = Bitmap32.s3y(size, size);
  var pixelSize = size / 10 | 0;
  bitmap.x48(Colors_getInstance().l40_1);
  fillRect($this, bitmap, imul(pixelSize, 4), imul(pixelSize, 1), imul(pixelSize, 2), imul(pixelSize, 2), appearance.tc3_1);
  drawHair($this, bitmap, appearance.qc3_1, appearance.rc3_1, pixelSize);
  drawOutfit($this, bitmap, appearance.sc3_1, baseColor, pixelSize);
  if (frame === 0) {
    fillRect($this, bitmap, imul(pixelSize, 2), imul(pixelSize, 3), imul(pixelSize, 1), imul(pixelSize, 2), appearance.tc3_1);
    fillRect($this, bitmap, imul(pixelSize, 7), imul(pixelSize, 4), imul(pixelSize, 1), imul(pixelSize, 2), appearance.tc3_1);
  } else {
    fillRect($this, bitmap, imul(pixelSize, 2), imul(pixelSize, 4), imul(pixelSize, 1), imul(pixelSize, 2), appearance.tc3_1);
    fillRect($this, bitmap, imul(pixelSize, 7), imul(pixelSize, 3), imul(pixelSize, 1), imul(pixelSize, 2), appearance.tc3_1);
  }
  if (frame === 0) {
    fillRect($this, bitmap, imul(pixelSize, 4), imul(pixelSize, 6), imul(pixelSize, 1), imul(pixelSize, 3), baseColor);
    fillRect($this, bitmap, imul(pixelSize, 5), imul(pixelSize, 6) + (pixelSize / 2 | 0) | 0, imul(pixelSize, 1), imul(pixelSize, 3), baseColor);
  } else {
    fillRect($this, bitmap, imul(pixelSize, 4), imul(pixelSize, 6) + (pixelSize / 2 | 0) | 0, imul(pixelSize, 1), imul(pixelSize, 3), baseColor);
    fillRect($this, bitmap, imul(pixelSize, 5), imul(pixelSize, 6), imul(pixelSize, 1), imul(pixelSize, 3), baseColor);
  }
  return bitmap;
}
function fillRect($this, bitmap, x, y, width, height, color) {
  var inductionVariable = y;
  var last = coerceAtMost(y + height | 0, bitmap.a3z_1);
  if (inductionVariable < last)
    do {
      var py = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = x;
      var last_0 = coerceAtMost(x + width | 0, bitmap.z3y_1);
      if (inductionVariable_0 < last_0)
        do {
          var px = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (px >= 0 && py >= 0 && px < bitmap.z3y_1 && py < bitmap.a3z_1) {
            bitmap.o48(px, py, color);
          }
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
}
function drawHair($this, bitmap, style, color, pixelSize) {
  switch (style.r3_1) {
    case 0:
      fillRect($this, bitmap, imul(pixelSize, 4), pixelSize / 2 | 0, imul(pixelSize, 2), imul(pixelSize, 1), color);
      break;
    case 1:
      var spikeWidth = numberToInt(pixelSize * 0.6);
      fillRect($this, bitmap, imul(pixelSize, 4), 0, spikeWidth, pixelSize, color);
      fillRect($this, bitmap, imul(pixelSize, 4) + spikeWidth | 0, 0, spikeWidth, pixelSize, color);
      fillRect($this, bitmap, imul(pixelSize, 4) + imul(spikeWidth, 2) | 0, 0, spikeWidth, pixelSize, color);
      break;
    case 2:
      fillRect($this, bitmap, imul(pixelSize, 3) + (imul(pixelSize, 3) / 4 | 0) | 0, imul(pixelSize, 3) / 10 | 0, numberToInt(pixelSize * 2.5), numberToInt(pixelSize * 1.2), color);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
}
function drawOutfit($this, bitmap, style, color, pixelSize) {
  switch (style.r3_1) {
    case 0:
      fillRect($this, bitmap, imul(pixelSize, 3) + (pixelSize / 2 | 0) | 0, imul(pixelSize, 3), imul(pixelSize, 3), imul(pixelSize, 3), color);
      break;
    case 1:
      fillRect($this, bitmap, imul(pixelSize, 4), imul(pixelSize, 3), imul(pixelSize, 2), imul(pixelSize, 2), color);
      fillRect($this, bitmap, imul(pixelSize, 3), imul(pixelSize, 5), imul(pixelSize, 4), imul(pixelSize, 1), color);
      var accentColor = Colors_getInstance().w45_1;
      fillRect($this, bitmap, imul(pixelSize, 4) + (imul(pixelSize, 4) / 5 | 0) | 0, imul(pixelSize, 3) + (imul(pixelSize, 3) / 10 | 0) | 0, numberToInt(pixelSize * 0.4), numberToInt(pixelSize * 0.4), accentColor);
      fillRect($this, bitmap, imul(pixelSize, 4) + (imul(pixelSize, 4) / 5 | 0) | 0, imul(pixelSize, 4) + (imul(pixelSize, 3) / 10 | 0) | 0, numberToInt(pixelSize * 0.4), numberToInt(pixelSize * 0.4), accentColor);
      break;
    case 2:
      fillRect($this, bitmap, imul(pixelSize, 3) + (pixelSize / 2 | 0) | 0, imul(pixelSize, 3), imul(pixelSize, 3), imul(pixelSize, 3), color);
      fillRect($this, bitmap, imul(pixelSize, 3) + (pixelSize / 2 | 0) | 0, imul(pixelSize, 3), numberToInt(pixelSize * 0.6), imul(pixelSize, 3), Colors_getInstance().g40_1);
      fillRect($this, bitmap, imul(pixelSize, 5) + (imul(pixelSize, 9) / 10 | 0) | 0, imul(pixelSize, 3), numberToInt(pixelSize * 0.6), imul(pixelSize, 3), Colors_getInstance().g40_1);
      fillRect($this, bitmap, imul(pixelSize, 4) + (imul(pixelSize, 3) / 4 | 0) | 0, imul(pixelSize, 3) + (imul(pixelSize, 7) / 10 | 0) | 0, pixelSize / 2 | 0, imul(pixelSize, 3) / 2 | 0, Colors_getInstance().g40_1);
      break;
    case 3:
      fillRect($this, bitmap, imul(pixelSize, 3) + (pixelSize / 2 | 0) | 0, imul(pixelSize, 3), imul(pixelSize, 3), imul(pixelSize, 3), color);
      var stripeColor = Companion_getInstance_1().r4g(Colors_getInstance().g40_1, color, _Ratio___init__impl__9mwvn2(0.8));
      fillRect($this, bitmap, imul(pixelSize, 3) + (pixelSize / 2 | 0) | 0, imul(pixelSize, 3) + (imul(pixelSize, 7) / 10 | 0) | 0, imul(pixelSize, 3), pixelSize / 2 | 0, stripeColor);
      fillRect($this, bitmap, imul(pixelSize, 3) + (pixelSize / 2 | 0) | 0, imul(pixelSize, 5), imul(pixelSize, 3), pixelSize / 2 | 0, stripeColor);
      break;
    case 4:
      fillRect($this, bitmap, imul(pixelSize, 3) + (pixelSize / 2 | 0) | 0, imul(pixelSize, 3), imul(pixelSize, 3), imul(pixelSize, 3), color);
      var pocketColor = Companion_getInstance_1().r4g(Colors_getInstance().h40_1, color, _Ratio___init__impl__9mwvn2(0.6));
      fillRect($this, bitmap, imul(pixelSize, 4), imul(pixelSize, 4) + (imul(pixelSize, 4) / 5 | 0) | 0, imul(pixelSize, 2), numberToInt(pixelSize * 0.8), pocketColor);
      fillRect($this, bitmap, imul(pixelSize, 3) + (pixelSize / 2 | 0) | 0, imul(pixelSize, 1) + (pixelSize / 2 | 0) | 0, pixelSize / 2 | 0, pixelSize, color);
      fillRect($this, bitmap, imul(pixelSize, 6), imul(pixelSize, 1) + (pixelSize / 2 | 0) | 0, pixelSize / 2 | 0, pixelSize, color);
      break;
    case 5:
      fillRect($this, bitmap, imul(pixelSize, 3) + (pixelSize / 2 | 0) | 0, imul(pixelSize, 3), imul(pixelSize, 3), imul(pixelSize, 3), color);
      var vestColor = Companion_getInstance_1().r4g(Colors_getInstance().h40_1, color, _Ratio___init__impl__9mwvn2(0.7));
      fillRect($this, bitmap, imul(pixelSize, 4), imul(pixelSize, 3) + (pixelSize / 2 | 0) | 0, imul(pixelSize, 2), numberToInt(pixelSize * 2.5), vestColor);
      fillRect($this, bitmap, imul(pixelSize, 4) + (imul(pixelSize, 3) / 4 | 0) | 0, imul(pixelSize, 3) + (imul(pixelSize, 3) / 10 | 0) | 0, pixelSize / 2 | 0, imul(pixelSize, 2), Colors_getInstance().g40_1);
      fillRect($this, bitmap, imul(pixelSize, 4) + (imul(pixelSize, 13) / 20 | 0) | 0, imul(pixelSize, 3), numberToInt(pixelSize * 0.7), pixelSize / 2 | 0, Colors_getInstance().g40_1);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
}
var HumanSpriteCache_instance;
function HumanSpriteCache_getInstance() {
  if (HumanSpriteCache_instance === VOID)
    new HumanSpriteCache();
  return HumanSpriteCache_instance;
}
var Localization_instance;
function Localization_getInstance() {
  if (Localization_instance === VOID)
    new Localization();
  return Localization_instance;
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = delay_0(new Long(15000, 0), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.yc5_1.kak();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var this_0 = $this.zc5_1.oa2();
  var injects = [];
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var time = toDuration(0, DurationUnit_SECONDS_getInstance());
  var transition = this_0.r9x_1;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(GameScene);
  var injects_0 = injects.slice();
  var sceneInjector = this_0.q9x_1.l9q_1.e6c().c6c(getKClass(SceneContainer), this_0).c6c(getKClass(Resources), new Resources(this_0.b17(), this_0.q9x_1.s9y().t37_1, this_0.q9x_1.s9y()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.c6c(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'MainMenuScene.sceneMain.<anonymous>.<anonymous>.<anonymous>' call
  var newScene = new GameScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_3().ra8_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_1.x2x(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$3 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_1.y2x(level, tmp$ret$3);
    tmp_0 = Unit_instance;
  }
  if (true) {
    newScene.n6c(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    this_0.q9x_1.l9q_1.g6c(tmp_2, MainMenuScene$sceneMain$lambda$slambda$lambda(sceneInjector));
  }
  var tmp_3 = this_0.ta8(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function MainMenuScene$sceneMain$lambda$slambda$lambda($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'MainMenuScene.sceneMain.<anonymous>.<anonymous>.<anonymous>' call
    return new GameScene();
  };
}
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  get_globalConfig().p2u();
  set_globalScore(0.0);
  set_totalGameTime(0.0);
  set_currentRunTime(0.0);
  set_hasWon(false);
  get_globalAchievementManager().obv();
  var tmp = saveGameState($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var this_0 = $this.ac6_1.oa2();
  var injects = [];
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var time = toDuration(0, DurationUnit_SECONDS_getInstance());
  var transition = this_0.r9x_1;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(GameScene);
  var injects_0 = injects.slice();
  var sceneInjector = this_0.q9x_1.l9q_1.e6c().c6c(getKClass(SceneContainer), this_0).c6c(getKClass(Resources), new Resources(this_0.b17(), this_0.q9x_1.s9y().t37_1, this_0.q9x_1.s9y()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp_0 = getKClassFromExpression(inject);
    sceneInjector.c6c(isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE(), inject);
  }
  // Inline function 'MainMenuScene.sceneMain.<anonymous>.<anonymous>.<anonymous>' call
  var newScene = new GameScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_3().ra8_1;
  var level = Level_INFO_getInstance();
  var tmp_1;
  if (this_1.x2x(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$3 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_1.y2x(level, tmp$ret$3);
    tmp_1 = Unit_instance;
  }
  if (true) {
    newScene.n6c(sceneInjector);
    var tmp_2 = getKClassFromExpression(newScene);
    var tmp_3 = isInterface(tmp_2, KClass) ? tmp_2 : THROW_CCE();
    this_0.q9x_1.l9q_1.g6c(tmp_3, MainMenuScene$sceneMain$lambda$slambda$lambda_0(sceneInjector));
  }
  var tmp_4 = this_0.ta8(newScene, time, transition, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  return Unit_instance;
}
function MainMenuScene$sceneMain$lambda$slambda$lambda_0($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'MainMenuScene.sceneMain.<anonymous>.<anonymous>.<anonymous>' call
    return new GameScene();
  };
}
function *_generator_sceneMain__5xvlzl(_this__u8e3s4, $this, $completion) {
  // Inline function 'korlibs.korge.view.solidRect' call
  var width = $this.ka1().p9r_1;
  var height = $this.ka1().q9r_1;
  var color = Colors_getInstance().y4f('#2b2b2b');
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SolidRect.cbl(Size2D.h2b(width, height), color);
  // Inline function 'kotlin.apply' call
  addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  var peopleContainer = _this__u8e3s4;
  // Inline function 'kotlin.repeat' call
  // Inline function 'kotlin.contracts.contract' call
  var inductionVariable = 0;
  if (inductionVariable < 12)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'MainMenuScene.sceneMain.<anonymous>' call
      var gender = Default_getInstance().vo() ? Gender_MALE_getInstance() : Gender_FEMALE_getInstance();
      var tmp;
      if (gender.equals(Gender_MALE_getInstance())) {
        tmp = Companion_getInstance_1().x4f(65, 105, 225);
      } else {
        tmp = Companion_getInstance_1().x4f(255, 69, 165);
      }
      var baseColor = tmp;
      var tmp_0 = Default_getInstance().xo(100.0, $this.ka1().p9r_1 - 100.0);
      var tmp_1 = Default_getInstance().xo(100.0, $this.ka1().q9r_1 - 100.0);
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'MainMenuScene.sceneMain.<anonymous>.<anonymous>' call
      var it = Default_getInstance().xo(-100.0, 100.0);
      var tmp_2;
      // Inline function 'kotlin.math.abs' call
      if (Math.abs(it) < 30.0) {
        tmp_2 = it < 0 ? -50.0 : 50.0;
      } else {
        tmp_2 = it;
      }
      var tmp_3 = tmp_2;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'MainMenuScene.sceneMain.<anonymous>.<anonymous>' call
      var it_0 = Default_getInstance().xo(-100.0, 100.0);
      var tmp_4;
      // Inline function 'kotlin.math.abs' call
      if (Math.abs(it_0) < 30.0) {
        tmp_4 = it_0 < 0 ? -50.0 : 50.0;
      } else {
        tmp_4 = it_0;
      }
      var tmp$ret$9 = tmp_4;
      var person = new GameSquare(peopleContainer, tmp_0, tmp_1, baseColor, Vector2D.k2c(tmp_3, tmp$ret$9), 40.0, 0.0, gender, VOID, VOID, 5.0, null, null);
      person.tc5($this.mc6_1.qby_1);
      $this.nc6_1.h(person);
    }
     while (inductionVariable < 12);
  addUpdater(_this__u8e3s4, MainMenuScene$sceneMain$lambda($this));
  var tmp_5 = $this;
  // Inline function 'korlibs.korge.view.text' call
  var text = 'People Maker';
  var textSize = Companion_instance.gbp_1;
  var color_0 = Colors_getInstance().g40_1;
  var font = get_DefaultTtfFontAsBitmap();
  var alignment = Companion_getInstance_2().l4o_1;
  var renderer = get_DefaultStringTextRenderer();
  var autoScaling = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_1 = Text.lbp(text, numberToDouble(textSize), color_0, font, alignment, renderer, autoScaling, null, null);
  // Inline function 'kotlin.apply' call
  var this_2 = addTo(this_1, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'MainMenuScene.sceneMain.<anonymous>' call
  this_2.qbp(Companion_getInstance_2().y4o_1);
  // Inline function 'korlibs.korge.view.position' call
  var x = $this.ka1().p9r_1 / 2 | 0;
  xy(this_2, numberToDouble(x), numberToDouble(150.0));
  this_2.dbl(Colors_getInstance().g40_1);
  this_2.obp(64.0);
  this_2.kbp(get_mainMenuTitleFont());
  tmp_5.oc6_1 = this_2;
  var buttonWidth = 400.0;
  var buttonHeight = 70.0;
  var buttonX = ($this.ka1().p9r_1 - buttonWidth) / 2;
  var currentY = 400.0;
  var buttonSpacing = 90.0;
  var tmp_6 = hasSaveGame($completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  var hasSave = tmp_6;
  if (hasSave) {
    var tmp_7 = $this;
    var tmp_8 = currentY;
    var tmp_9 = Localization_getInstance().hi('continue_playing');
    var tmp_10 = get_mainMenuNormalFont();
    tmp_7.pc6_1 = createMenuButton(_this__u8e3s4, $this, buttonX, tmp_8, buttonWidth, buttonHeight, tmp_9, tmp_10, MainMenuScene$sceneMain$lambda_0($this));
    currentY = currentY + buttonSpacing;
  }
  var tmp_11 = $this;
  var tmp_12 = currentY;
  var tmp_13 = Localization_getInstance().hi('new_game');
  var tmp_14 = get_mainMenuNormalFont();
  tmp_11.qc6_1 = createMenuButton(_this__u8e3s4, $this, buttonX, tmp_12, buttonWidth, buttonHeight, tmp_13, tmp_14, MainMenuScene$sceneMain$lambda_1($this));
  currentY = currentY + buttonSpacing;
  var tmp_15 = $this;
  var tmp_16 = currentY;
  var tmp_17 = Localization_getInstance().hi('settings');
  var tmp_18 = get_mainMenuNormalFont();
  tmp_15.rc6_1 = createMenuButton(_this__u8e3s4, $this, buttonX, tmp_16, buttonWidth, buttonHeight, tmp_17, tmp_18, MainMenuScene$sceneMain$lambda_2($this, _this__u8e3s4));
  currentY = currentY + buttonSpacing;
  var tmp_19 = $this;
  var tmp_20 = currentY;
  var tmp_21 = Localization_getInstance().hi('quit');
  var tmp_22 = get_mainMenuNormalFont();
  tmp_19.sc6_1 = createMenuButton(_this__u8e3s4, $this, buttonX, tmp_20, buttonWidth, buttonHeight, tmp_21, tmp_22, MainMenuScene$sceneMain$lambda_3($this));
  return Unit_instance;
}
function updateLanguage($this) {
  var tmp0_safe_receiver = $this.pc6_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.mbp(Localization_getInstance().hi('continue_playing'));
  }
  var tmp1_safe_receiver = $this.qc6_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.mbp(Localization_getInstance().hi('new_game'));
  }
  var tmp2_safe_receiver = $this.rc6_1;
  if (tmp2_safe_receiver == null)
    null;
  else {
    tmp2_safe_receiver.mbp(Localization_getInstance().hi('settings'));
  }
  var tmp3_safe_receiver = $this.sc6_1;
  if (tmp3_safe_receiver == null)
    null;
  else {
    tmp3_safe_receiver.mbp(Localization_getInstance().hi('quit'));
  }
}
function createMenuButton(_this__u8e3s4, $this, x, y, width, height, label, font, onClick) {
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.za4(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'MainMenuScene.createMenuButton.<anonymous>' call
  position(this_1, x, y);
  var borderColor = Colors_getInstance().c43_1;
  var bgColor = Companion_getInstance_1().r4g(borderColor, Colors_getInstance().h40_1, _Ratio___init__impl__9mwvn2(0.6));
  var bgHoverColor = Companion_getInstance_1().r4g(borderColor, Colors_getInstance().h40_1, _Ratio___init__impl__9mwvn2(0.75));
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = SolidRect.cbl(Size2D.f2i(width, height), bgColor);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  var bg = addTo(this_2, this_1);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_3 = SolidRect.cbl(Size2D.f2i(width, 3.0), borderColor);
  // Inline function 'kotlin.apply' call
  var this_4 = addTo(this_3, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_4, 0.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_5 = SolidRect.cbl(Size2D.f2i(width, 3.0), borderColor);
  // Inline function 'kotlin.apply' call
  var this_6 = addTo(this_5, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_6, 0.0, height - 3);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_7 = SolidRect.cbl(Size2D.f2i(3.0, height), borderColor);
  // Inline function 'kotlin.apply' call
  var this_8 = addTo(this_7, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_8, 0.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_9 = SolidRect.cbl(Size2D.f2i(3.0, height), borderColor);
  // Inline function 'kotlin.apply' call
  var this_10 = addTo(this_9, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_10, width - 3, 0.0);
  // Inline function 'korlibs.korge.input.onClick' call
  var handler = MainMenuScene$createMenuButton$lambda(onClick);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop = click$factory_3();
  var tmp1_safe_receiver = this_1 == null ? null : this_1.gai();
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < tmp1_safe_receiver.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var tmp0_safe_receiver = tmp1_safe_receiver.e1(_unary__edvuaz);
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp = prop.get(tmp1_safe_receiver_0);
        tmp.q20(MainMenuScene$createMenuButton$lambda_0(handler));
      }
    }
  }
  // Inline function 'korlibs.korge.input.onOver' call
  var handler_0 = MainMenuScene$createMenuButton$lambda_1(bg, bgHoverColor);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_0 = over$factory_0();
  var tmp1_safe_receiver_1 = this_1 == null ? null : this_1.gai();
  if (tmp1_safe_receiver_1 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_0 = 0;
    while (n_0 < tmp1_safe_receiver_1.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var tmp0_safe_receiver_0 = tmp1_safe_receiver_1.e1(_unary__edvuaz_0);
      var tmp1_safe_receiver_2 = tmp0_safe_receiver_0 == null ? null : get_mouse(tmp0_safe_receiver_0);
      if (tmp1_safe_receiver_2 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0 = prop_0.get(tmp1_safe_receiver_2);
        tmp_0.q20(MainMenuScene$createMenuButton$lambda_2(handler_0));
      }
    }
  }
  // Inline function 'korlibs.korge.input.onOut' call
  var handler_1 = MainMenuScene$createMenuButton$lambda_3(bg, bgColor);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_1 = out$factory_0();
  var tmp1_safe_receiver_3 = this_1 == null ? null : this_1.gai();
  if (tmp1_safe_receiver_3 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_1 = 0;
    while (n_1 < tmp1_safe_receiver_3.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_1 = n_1;
      n_1 = _unary__edvuaz_1 + 1 | 0;
      var tmp0_safe_receiver_1 = tmp1_safe_receiver_3.e1(_unary__edvuaz_1);
      var tmp1_safe_receiver_4 = tmp0_safe_receiver_1 == null ? null : get_mouse(tmp0_safe_receiver_1);
      if (tmp1_safe_receiver_4 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_1 = prop_1.get(tmp1_safe_receiver_4);
        tmp_1.q20(MainMenuScene$createMenuButton$lambda_4(handler_1));
      }
    }
  }
  var buttonContainer = this_1;
  // Inline function 'korlibs.korge.view.text' call
  var textSize = Companion_instance.gbp_1;
  var color = Colors_getInstance().g40_1;
  var font_0 = get_DefaultTtfFontAsBitmap();
  var alignment = Companion_getInstance_2().l4o_1;
  var renderer = get_DefaultStringTextRenderer();
  var autoScaling = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_11 = Text.lbp(label, numberToDouble(textSize), color, font_0, alignment, renderer, autoScaling, null, null);
  // Inline function 'kotlin.apply' call
  var this_12 = addTo(this_11, buttonContainer);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'MainMenuScene.createMenuButton.<anonymous>' call
  this_12.qbp(Companion_getInstance_2().y4o_1);
  position(this_12, width / 2, height / 2 - 2);
  this_12.dbl(Colors_getInstance().c43_1);
  this_12.obp(36.0);
  if (!(font == null)) {
    this_12.kbp(font);
  }
  var buttonText = this_12;
  return buttonText;
}
function openSettingsPanel(_this__u8e3s4, $this) {
  createSettingsPanel(_this__u8e3s4, $this.tc6_1, MainMenuScene$openSettingsPanel$lambda($this), null);
}
function MainMenuScene$sceneMain$lambda$slambda_2($gravestoneContainer) {
  var i = new MainMenuScene$sceneMain$lambda$slambda($gravestoneContainer);
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function MainMenuScene$sceneMain$lambda(this$0) {
  return function ($this$addUpdater, dt) {
    var tmp0_safe_receiver = $this$addUpdater.ba5();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q8b();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var mousePos = tmp;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this$0.nc6_1.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'MainMenuScene.sceneMain.<anonymous>.<anonymous>' call
        var bounds = element.dc4_1;
        var globalBounds = bounds.rak();
        if (mousePos.a2a_1 >= globalBounds.r2a() && mousePos.a2a_1 <= globalBounds.s2a() && mousePos.b2a_1 >= globalBounds.t2a() && mousePos.b2a_1 <= globalBounds.u2a()) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var hoveredPerson = tmp$ret$1;
    var tmp_0;
    if (!(hoveredPerson == null)) {
      if (this$0.lc6_1 == null) {
        var tmp_1 = this$0;
        // Inline function 'korlibs.korge.view.text' call
        var text = hoveredPerson.oc4_1;
        var textSize = Companion_instance.gbp_1;
        var color = Colors_getInstance().g40_1;
        var font = get_DefaultTtfFontAsBitmap();
        var alignment = Companion_getInstance_2().l4o_1;
        var renderer = get_DefaultStringTextRenderer();
        var autoScaling = Companion_instance.hbp_1;
        // Inline function 'korlibs.korge.view.addTo' call
        var this_0 = Text.lbp(text, numberToDouble(textSize), color, font, alignment, renderer, autoScaling, null, null);
        // Inline function 'kotlin.apply' call
        var this_1 = addTo(this_0, $this$addUpdater);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'MainMenuScene.sceneMain.<anonymous>.<anonymous>' call
        this_1.dbl(Colors_getInstance().g40_1);
        this_1.obp(16.0);
        // Inline function 'korlibs.korge.view.position' call
        xy(this_1, numberToDouble(0), numberToDouble(-4));
        tmp_1.lc6_1 = this_1;
      } else {
        var tmp_2 = this$0.lc6_1;
        var tmp2_safe_receiver = tmp_2 instanceof Text ? tmp_2 : null;
        if (tmp2_safe_receiver == null)
          null;
        else {
          tmp2_safe_receiver.mbp(hoveredPerson.oc4_1);
        }
      }
      var tmp_3 = this$0.lc6_1;
      var tooltip = tmp_3 instanceof Text ? tmp_3 : null;
      var tmp_4;
      if (!(tooltip == null)) {
        var textWidth = tooltip.rbp().m2a_1;
        position(tooltip, hoveredPerson.m2i() - textWidth / 2, hoveredPerson.n2i() - 40.0);
        tmp_4 = Unit_instance;
      }
      tmp_0 = tmp_4;
    } else {
      var tmp3_safe_receiver = this$0.lc6_1;
      if (tmp3_safe_receiver == null)
        null;
      else {
        tmp3_safe_receiver.kak();
      }
      this$0.lc6_1 = null;
      tmp_0 = Unit_instance;
    }
    var deltaTime = get_seconds(dt.qj_1);
    // Inline function 'kotlin.collections.mutableListOf' call
    var peopleToRemove = ArrayList.j1();
    var tmp0_iterator_0 = this$0.nc6_1.b1();
    while (tmp0_iterator_0.c1()) {
      var element_0 = tmp0_iterator_0.d1();
      // Inline function 'MainMenuScene.sceneMain.<anonymous>.<anonymous>' call
      element_0.oc5(deltaTime);
      element_0.pc5(deltaTime);
      if (!element_0.kc4_1 && element_0.gc4_1 >= this$0.mc6_1.qby_1) {
        element_0.sc5();
      }
      if (element_0.nc5()) {
        peopleToRemove.h(element_0);
      }
      var posX = element_0.m2i();
      var posY = element_0.n2i();
      var vel = element_0.ec4_1;
      var maxWidth = this$0.ka1().p9r_1;
      var maxHeight = this$0.ka1().q9r_1;
      if (posX < 50 || posX > maxWidth - 50) {
        element_0.ec4_1 = Vector2D.k2c(-vel.a2a_1, vel.b2a_1);
      }
      if (posY < 50 || posY > maxHeight - 50) {
        element_0.ec4_1 = Vector2D.k2c(vel.a2a_1, -vel.b2a_1);
      }
    }
    var tmp0_iterator_1 = peopleToRemove.b1();
    while (tmp0_iterator_1.c1()) {
      var element_1 = tmp0_iterator_1.d1();
      // Inline function 'MainMenuScene.sceneMain.<anonymous>.<anonymous>' call
      var gravestoneX = element_1.m2i() - element_1.dc4_1.d2m() / 2;
      var gravestoneY = element_1.n2i() - element_1.dc4_1.e2m() / 2;
      var gravestoneW = element_1.dc4_1.d2m();
      var gravestoneH = element_1.dc4_1.e2m();
      var gravestoneSize = coerceAtLeast_0(numberToInt(coerceAtLeast(gravestoneW, gravestoneH)), 24);
      var gravestoneBitmap = GravestoneSpriteCache_getInstance().vc5(gravestoneSize);
      // Inline function 'korlibs.korge.view.container' call
      // Inline function 'korlibs.korge.view.addTo' call
      var this_2 = Container.za4(false);
      // Inline function 'kotlin.apply' call
      var this_3 = addTo(this_2, $this$addUpdater);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'MainMenuScene.sceneMain.<anonymous>.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.korge.view.text' call
      var text_0 = element_1.oc4_1;
      var textSize_0 = Companion_instance.gbp_1;
      var color_0 = Colors_getInstance().g40_1;
      var font_0 = get_DefaultTtfFontAsBitmap();
      var alignment_0 = Companion_getInstance_2().l4o_1;
      var renderer_0 = get_DefaultStringTextRenderer();
      var autoScaling_0 = Companion_instance.hbp_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_4 = Text.lbp(text_0, numberToDouble(textSize_0), color_0, font_0, alignment_0, renderer_0, autoScaling_0, null, null);
      // Inline function 'kotlin.apply' call
      var this_5 = addTo(this_4, this_3);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'MainMenuScene.sceneMain.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      this_5.dbl(Colors_getInstance().c43_1);
      this_5.obp(18.0);
      var textWidth_0 = this_5.rbp().m2a_1;
      position(this_5, gravestoneX + gravestoneW / 2 - textWidth_0 / 2, gravestoneY - 28.0);
      // Inline function 'korlibs.korge.view.image' call
      var anchor = Companion_getInstance_4().b29_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_6 = Image.kbi(gravestoneBitmap, anchor);
      // Inline function 'kotlin.apply' call
      var this_7 = addTo(this_6, this_3);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'MainMenuScene.sceneMain.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      position(this_7, gravestoneX, gravestoneY);
      this_7.yai(gravestoneW / gravestoneSize);
      this_7.aaj(gravestoneH / gravestoneSize);
      this_7.maj(0.85);
      var gravestoneContainer = this_3;
      launch(this$0, VOID, VOID, MainMenuScene$sceneMain$lambda$slambda_2(gravestoneContainer));
      element_1.r6();
      this$0.nc6_1.m3(element_1);
    }
    var inductionVariable = 0;
    var last = this$0.nc6_1.f1() - 1 | 0;
    var tmp_5;
    if (inductionVariable <= last) {
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = i + 1 | 0;
        var last_0 = this$0.nc6_1.f1();
        if (inductionVariable_0 < last_0)
          do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var person1 = this$0.nc6_1.e1(i);
            var person2 = this$0.nc6_1.e1(j);
            var dx = person2.m2i() - person1.m2i();
            var dy = person2.n2i() - person1.n2i();
            // Inline function 'kotlin.math.sqrt' call
            var x = dx * dx + dy * dy;
            var distance = Math.sqrt(x);
            var minDistance = 40.0;
            if (distance < minDistance && distance > 0) {
              var nx = dx / distance;
              var ny = dy / distance;
              var vel1 = person1.ec4_1;
              var vel2 = person2.ec4_1;
              var v1n = vel1.a2a_1 * nx + vel1.b2a_1 * ny;
              var v2n = vel2.a2a_1 * nx + vel2.b2a_1 * ny;
              person1.ec4_1 = Vector2D.k2c(vel1.a2a_1 + (v2n - v1n) * nx, vel1.b2a_1 + (v2n - v1n) * ny);
              person2.ec4_1 = Vector2D.k2c(vel2.a2a_1 + (v1n - v2n) * nx, vel2.b2a_1 + (v1n - v2n) * ny);
            }
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable <= last);
      tmp_5 = Unit_instance;
    }
    return Unit_instance;
  };
}
function MainMenuScene$sceneMain$lambda$slambda_3(this$0) {
  var i = new MainMenuScene$sceneMain$lambda$slambda_0(this$0);
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function MainMenuScene$sceneMain$lambda_0(this$0) {
  return function () {
    var tmp = this$0.ka1();
    launch(tmp, VOID, VOID, MainMenuScene$sceneMain$lambda$slambda_3(this$0));
    return Unit_instance;
  };
}
function MainMenuScene$sceneMain$lambda$slambda_4(this$0) {
  var i = new MainMenuScene$sceneMain$lambda$slambda_1(this$0);
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function MainMenuScene$sceneMain$lambda_1(this$0) {
  return function () {
    var tmp = this$0.ka1();
    launch(tmp, VOID, VOID, MainMenuScene$sceneMain$lambda$slambda_4(this$0));
    return Unit_instance;
  };
}
function MainMenuScene$sceneMain$lambda_2(this$0, $this_sceneMain) {
  return function () {
    openSettingsPanel($this_sceneMain, this$0);
    return Unit_instance;
  };
}
function MainMenuScene$sceneMain$lambda_3(this$0) {
  return function () {
    this$0.ka1().p9q_1.r8q();
    return Unit_instance;
  };
}
function MainMenuScene$createMenuButton$lambda($onClick) {
  return function (it) {
    $onClick();
    return Unit_instance;
  };
}
function MainMenuScene$createMenuButton$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function MainMenuScene$createMenuButton$lambda_1($bg, $bgHoverColor) {
  return function (it) {
    $bg.dbl($bgHoverColor);
    return Unit_instance;
  };
}
function MainMenuScene$createMenuButton$lambda_2($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function MainMenuScene$createMenuButton$lambda_3($bg, $bgColor) {
  return function (it) {
    $bg.dbl($bgColor);
    return Unit_instance;
  };
}
function MainMenuScene$createMenuButton$lambda_4($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function MainMenuScene$openSettingsPanel$lambda(this$0) {
  return function () {
    updateLanguage(this$0);
    return Unit_instance;
  };
}
function click$factory_3() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.t9z_1;
  }, null);
}
function over$factory_0() {
  return getPropertyCallableRef('over', 1, KProperty1, function (receiver) {
    return receiver.u9z_1;
  }, null);
}
function out$factory_0() {
  return getPropertyCallableRef('out', 1, KProperty1, function (receiver) {
    return receiver.v9z_1;
  }, null);
}
var NameGenerator_instance;
function NameGenerator_getInstance() {
  if (NameGenerator_instance === VOID)
    new NameGenerator();
  return NameGenerator_instance;
}
function createSettingsPanel(_this__u8e3s4, soundManager, onLanguageChange, onClose) {
  onLanguageChange = onLanguageChange === VOID ? null : onLanguageChange;
  onClose = onClose === VOID ? null : onClose;
  var parentContainer = _this__u8e3s4;
  var sceneViews = ensureNotNull(_this__u8e3s4.ba5()).ka1();
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.za4(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'createSettingsPanel.<anonymous>' call
  var panel = this_1;
  // Inline function 'korlibs.korge.view.solidRect' call
  var width = sceneViews.p9r_1;
  var height = sceneViews.q9r_1;
  var color = RGBA__withAd_impl_cralao(Colors_getInstance().h40_1, 0.7);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = SolidRect.cbl(Size2D.f2i(width, height), color);
  // Inline function 'kotlin.apply' call
  addTo(this_2, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  var panelWidth = 700.0;
  var panelHeight = 650.0;
  var panelX = (sceneViews.p9r_1 - panelWidth) / 2;
  var panelY = (sceneViews.q9r_1 - panelHeight) / 2;
  // Inline function 'korlibs.korge.view.solidRect' call
  var color_0 = Colors_getInstance().y4f('#1a1a1a');
  // Inline function 'korlibs.korge.view.addTo' call
  var this_3 = SolidRect.cbl(Size2D.f2i(panelWidth, panelHeight), color_0);
  // Inline function 'kotlin.apply' call
  var this_4 = addTo(this_3, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'createSettingsPanel.<anonymous>.<anonymous>' call
  position(this_4, panelX, panelY);
  // Inline function 'korlibs.korge.view.solidRect' call
  var color_1 = Colors_getInstance().g40_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_5 = SolidRect.cbl(Size2D.f2i(panelWidth, 3.0), color_1);
  // Inline function 'kotlin.apply' call
  var this_6 = addTo(this_5, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_6, panelX, panelY);
  // Inline function 'korlibs.korge.view.solidRect' call
  var color_2 = Colors_getInstance().g40_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_7 = SolidRect.cbl(Size2D.f2i(panelWidth, 3.0), color_2);
  // Inline function 'kotlin.apply' call
  var this_8 = addTo(this_7, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_8, panelX, panelY + panelHeight - 3);
  // Inline function 'korlibs.korge.view.solidRect' call
  var color_3 = Colors_getInstance().g40_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_9 = SolidRect.cbl(Size2D.f2i(3.0, panelHeight), color_3);
  // Inline function 'kotlin.apply' call
  var this_10 = addTo(this_9, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_10, panelX, panelY);
  // Inline function 'korlibs.korge.view.solidRect' call
  var color_4 = Colors_getInstance().g40_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_11 = SolidRect.cbl(Size2D.f2i(3.0, panelHeight), color_4);
  // Inline function 'kotlin.apply' call
  var this_12 = addTo(this_11, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_12, panelX + panelWidth - 3, panelY);
  var titleText = {_v: null};
  var languageLabel = {_v: null};
  var languageText = null;
  var soundLabel = {_v: null};
  var soundToggleText = {_v: null};
  var volumeLabel = {_v: null};
  var totalTimeLabel = {_v: null};
  var totalTimeValue = {_v: null};
  var currentTimeLabel = {_v: null};
  var currentTimeValue = {_v: null};
  var closeButtonText = {_v: null};
  // Inline function 'korlibs.korge.view.text' call
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var text = Localization_getInstance().hi('settings_title').toUpperCase();
  var textSize = Companion_instance.gbp_1;
  var color_5 = Colors_getInstance().g40_1;
  var font = get_DefaultTtfFontAsBitmap();
  var alignment = Companion_getInstance_2().l4o_1;
  var renderer = get_DefaultStringTextRenderer();
  var autoScaling = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_13 = Text.lbp(text, numberToDouble(textSize), color_5, font, alignment, renderer, autoScaling, null, null);
  // Inline function 'kotlin.apply' call
  var this_14 = addTo(this_13, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'createSettingsPanel.<anonymous>.<anonymous>' call
  this_14.kbp(get_gameFont());
  this_14.qbp(Companion_getInstance_2().y4o_1);
  position(this_14, panelX + panelWidth / 2, panelY + 50);
  this_14.dbl(Colors_getInstance().g40_1);
  this_14.obp(36.0);
  titleText._v = this_14;
  var currentY = panelY + 100.0;
  var leftMargin = 50.0;
  var rightMargin = 50.0;
  var contentWidth = panelWidth - leftMargin - rightMargin;
  var labelWidth = 250.0;
  var valueX = panelX + leftMargin + labelWidth;
  // Inline function 'korlibs.korge.view.text' call
  var text_0 = Localization_getInstance().hi('language');
  var textSize_0 = Companion_instance.gbp_1;
  var color_6 = Colors_getInstance().g40_1;
  var font_0 = get_DefaultTtfFontAsBitmap();
  var alignment_0 = Companion_getInstance_2().l4o_1;
  var renderer_0 = get_DefaultStringTextRenderer();
  var autoScaling_0 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_15 = Text.lbp(text_0, numberToDouble(textSize_0), color_6, font_0, alignment_0, renderer_0, autoScaling_0, null, null);
  // Inline function 'kotlin.apply' call
  var this_16 = addTo(this_15, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'createSettingsPanel.<anonymous>.<anonymous>' call
  this_16.kbp(get_gameFont());
  position(this_16, panelX + leftMargin, currentY);
  this_16.dbl(Colors_getInstance().c43_1);
  this_16.obp(32.0);
  languageLabel._v = this_16;
  // Inline function 'korlibs.korge.view.text' call
  var text_1 = Localization_getInstance().xc5(Localization_getInstance().mbv_1);
  var textSize_1 = Companion_instance.gbp_1;
  var color_7 = Colors_getInstance().g40_1;
  var font_1 = get_DefaultTtfFontAsBitmap();
  var alignment_1 = Companion_getInstance_2().l4o_1;
  var renderer_1 = get_DefaultStringTextRenderer();
  var autoScaling_1 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_17 = Text.lbp(text_1, numberToDouble(textSize_1), color_7, font_1, alignment_1, renderer_1, autoScaling_1, null, null);
  // Inline function 'kotlin.apply' call
  var this_18 = addTo(this_17, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'createSettingsPanel.<anonymous>.<anonymous>' call
  this_18.kbp(get_gameFont());
  position(this_18, valueX, currentY);
  this_18.dbl(Colors_getInstance().j44_1);
  this_18.obp(32.0);
  // Inline function 'korlibs.korge.input.onClick' call
  var handler = createSettingsPanel$lambda(this_18, titleText, languageLabel, soundLabel, soundToggleText, soundManager, volumeLabel, totalTimeLabel, currentTimeLabel, closeButtonText, onLanguageChange, sceneViews);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop = click$factory_4();
  var tmp1_safe_receiver = this_18 == null ? null : this_18.gai();
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < tmp1_safe_receiver.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var tmp0_safe_receiver = tmp1_safe_receiver.e1(_unary__edvuaz);
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp = prop.get(tmp1_safe_receiver_0);
        tmp.q20(createSettingsPanel$lambda_0(handler));
      }
    }
  }
  languageText = this_18;
  currentY = currentY + 60.0;
  // Inline function 'korlibs.korge.view.text' call
  var text_2 = Localization_getInstance().hi('sound');
  var textSize_2 = Companion_instance.gbp_1;
  var color_8 = Colors_getInstance().g40_1;
  var font_2 = get_DefaultTtfFontAsBitmap();
  var alignment_2 = Companion_getInstance_2().l4o_1;
  var renderer_2 = get_DefaultStringTextRenderer();
  var autoScaling_2 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_19 = Text.lbp(text_2, numberToDouble(textSize_2), color_8, font_2, alignment_2, renderer_2, autoScaling_2, null, null);
  // Inline function 'kotlin.apply' call
  var this_20 = addTo(this_19, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'createSettingsPanel.<anonymous>.<anonymous>' call
  this_20.kbp(get_gameFont());
  position(this_20, panelX + leftMargin, currentY);
  this_20.dbl(Colors_getInstance().c43_1);
  this_20.obp(32.0);
  soundLabel._v = this_20;
  // Inline function 'korlibs.korge.view.text' call
  var text_3 = soundManager.yc4_1 ? Localization_getInstance().hi('off') : Localization_getInstance().hi('on');
  var textSize_3 = Companion_instance.gbp_1;
  var color_9 = Colors_getInstance().g40_1;
  var font_3 = get_DefaultTtfFontAsBitmap();
  var alignment_3 = Companion_getInstance_2().l4o_1;
  var renderer_3 = get_DefaultStringTextRenderer();
  var autoScaling_3 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_21 = Text.lbp(text_3, numberToDouble(textSize_3), color_9, font_3, alignment_3, renderer_3, autoScaling_3, null, null);
  // Inline function 'kotlin.apply' call
  var this_22 = addTo(this_21, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'createSettingsPanel.<anonymous>.<anonymous>' call
  this_22.kbp(get_gameFont());
  position(this_22, valueX, currentY);
  this_22.dbl(soundManager.yc4_1 ? Colors_getInstance().i40_1 : Colors_getInstance().j40_1);
  this_22.obp(32.0);
  // Inline function 'korlibs.korge.input.onClick' call
  var handler_0 = createSettingsPanel$lambda_1(soundManager, this_22);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_0 = click$factory_5();
  var tmp1_safe_receiver_1 = this_22 == null ? null : this_22.gai();
  if (tmp1_safe_receiver_1 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_0 = 0;
    while (n_0 < tmp1_safe_receiver_1.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var tmp0_safe_receiver_0 = tmp1_safe_receiver_1.e1(_unary__edvuaz_0);
      var tmp1_safe_receiver_2 = tmp0_safe_receiver_0 == null ? null : get_mouse(tmp0_safe_receiver_0);
      if (tmp1_safe_receiver_2 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0 = prop_0.get(tmp1_safe_receiver_2);
        tmp_0.q20(createSettingsPanel$lambda_2(handler_0));
      }
    }
  }
  soundToggleText._v = this_22;
  currentY = currentY + 60.0;
  // Inline function 'korlibs.korge.view.text' call
  var text_4 = Localization_getInstance().hi('volume') + ' ' + numberToInt(soundManager.xc4_1 * 100) + '%';
  var textSize_4 = Companion_instance.gbp_1;
  var color_10 = Colors_getInstance().g40_1;
  var font_4 = get_DefaultTtfFontAsBitmap();
  var alignment_4 = Companion_getInstance_2().l4o_1;
  var renderer_4 = get_DefaultStringTextRenderer();
  var autoScaling_4 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_23 = Text.lbp(text_4, numberToDouble(textSize_4), color_10, font_4, alignment_4, renderer_4, autoScaling_4, null, null);
  // Inline function 'kotlin.apply' call
  var this_24 = addTo(this_23, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'createSettingsPanel.<anonymous>.<anonymous>' call
  this_24.kbp(get_gameFont());
  position(this_24, panelX + leftMargin, currentY);
  this_24.dbl(Colors_getInstance().c43_1);
  this_24.obp(32.0);
  volumeLabel._v = this_24;
  currentY = currentY + 40.0;
  var sliderWidth = contentWidth;
  var sliderHeight = 32.0;
  var sliderX = panelX + leftMargin;
  var sliderY = currentY;
  // Inline function 'korlibs.korge.view.solidRect' call
  var color_11 = Colors_getInstance().w41_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_25 = SolidRect.cbl(Size2D.f2i(sliderWidth, sliderHeight), color_11);
  // Inline function 'kotlin.apply' call
  var this_26 = addTo(this_25, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'createSettingsPanel.<anonymous>.<anonymous>' call
  position(this_26, sliderX, sliderY);
  // Inline function 'korlibs.korge.view.solidRect' call
  var width_0 = sliderWidth * soundManager.xc4_1;
  var color_12 = Colors_getInstance().j40_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_27 = SolidRect.cbl(Size2D.f2i(width_0, sliderHeight), color_12);
  // Inline function 'kotlin.apply' call
  var this_28 = addTo(this_27, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'createSettingsPanel.<anonymous>.<anonymous>' call
  position(this_28, sliderX, sliderY);
  var volumeFill = this_28;
  // Inline function 'korlibs.korge.view.solidRect' call
  var color_13 = Colors_getInstance().l40_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_29 = SolidRect.cbl(Size2D.f2i(sliderWidth, sliderHeight), color_13);
  // Inline function 'kotlin.apply' call
  var this_30 = addTo(this_29, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'createSettingsPanel.<anonymous>.<anonymous>' call
  position(this_30, sliderX, sliderY);
  // Inline function 'korlibs.korge.input.onClick' call
  var handler_1 = createSettingsPanel$lambda_3(sliderWidth, soundManager, volumeFill, volumeLabel);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_1 = click$factory_6();
  var tmp1_safe_receiver_3 = this_30 == null ? null : this_30.gai();
  if (tmp1_safe_receiver_3 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_1 = 0;
    while (n_1 < tmp1_safe_receiver_3.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_1 = n_1;
      n_1 = _unary__edvuaz_1 + 1 | 0;
      var tmp0_safe_receiver_1 = tmp1_safe_receiver_3.e1(_unary__edvuaz_1);
      var tmp1_safe_receiver_4 = tmp0_safe_receiver_1 == null ? null : get_mouse(tmp0_safe_receiver_1);
      if (tmp1_safe_receiver_4 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_1 = prop_1.get(tmp1_safe_receiver_4);
        tmp_1.q20(createSettingsPanel$lambda_4(handler_1));
      }
    }
  }
  currentY = currentY + 60.0;
  // Inline function 'korlibs.korge.view.text' call
  var text_5 = Localization_getInstance().hi('total_time_played');
  var textSize_5 = Companion_instance.gbp_1;
  var color_14 = Colors_getInstance().g40_1;
  var font_5 = get_DefaultTtfFontAsBitmap();
  var alignment_5 = Companion_getInstance_2().l4o_1;
  var renderer_5 = get_DefaultStringTextRenderer();
  var autoScaling_5 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_31 = Text.lbp(text_5, numberToDouble(textSize_5), color_14, font_5, alignment_5, renderer_5, autoScaling_5, null, null);
  // Inline function 'kotlin.apply' call
  var this_32 = addTo(this_31, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'createSettingsPanel.<anonymous>.<anonymous>' call
  this_32.kbp(get_gameFont());
  position(this_32, panelX + leftMargin, currentY);
  this_32.dbl(Colors_getInstance().c43_1);
  this_32.obp(32.0);
  totalTimeLabel._v = this_32;
  // Inline function 'korlibs.korge.view.text' call
  var text_6 = formatTime(get_totalGameTime());
  var textSize_6 = Companion_instance.gbp_1;
  var color_15 = Colors_getInstance().g40_1;
  var font_6 = get_DefaultTtfFontAsBitmap();
  var alignment_6 = Companion_getInstance_2().l4o_1;
  var renderer_6 = get_DefaultStringTextRenderer();
  var autoScaling_6 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_33 = Text.lbp(text_6, numberToDouble(textSize_6), color_15, font_6, alignment_6, renderer_6, autoScaling_6, null, null);
  // Inline function 'kotlin.apply' call
  var this_34 = addTo(this_33, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'createSettingsPanel.<anonymous>.<anonymous>' call
  this_34.kbp(get_gameFont());
  position(this_34, valueX, currentY);
  this_34.dbl(Colors_getInstance().y42_1);
  this_34.obp(32.0);
  totalTimeValue._v = this_34;
  currentY = currentY + 60.0;
  if (get_currentRunTime() > 0) {
    // Inline function 'korlibs.korge.view.text' call
    var text_7 = Localization_getInstance().hi('current_run');
    var textSize_7 = Companion_instance.gbp_1;
    var color_16 = Colors_getInstance().g40_1;
    var font_7 = get_DefaultTtfFontAsBitmap();
    var alignment_7 = Companion_getInstance_2().l4o_1;
    var renderer_7 = get_DefaultStringTextRenderer();
    var autoScaling_7 = Companion_instance.hbp_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_35 = Text.lbp(text_7, numberToDouble(textSize_7), color_16, font_7, alignment_7, renderer_7, autoScaling_7, null, null);
    // Inline function 'kotlin.apply' call
    var this_36 = addTo(this_35, this_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'createSettingsPanel.<anonymous>.<anonymous>' call
    this_36.kbp(get_gameFont());
    position(this_36, panelX + leftMargin, currentY);
    this_36.dbl(Colors_getInstance().c43_1);
    this_36.obp(32.0);
    currentTimeLabel._v = this_36;
    // Inline function 'korlibs.korge.view.text' call
    var text_8 = formatTime(get_currentRunTime());
    var textSize_8 = Companion_instance.gbp_1;
    var color_17 = Colors_getInstance().g40_1;
    var font_8 = get_DefaultTtfFontAsBitmap();
    var alignment_8 = Companion_getInstance_2().l4o_1;
    var renderer_8 = get_DefaultStringTextRenderer();
    var autoScaling_8 = Companion_instance.hbp_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_37 = Text.lbp(text_8, numberToDouble(textSize_8), color_17, font_8, alignment_8, renderer_8, autoScaling_8, null, null);
    // Inline function 'kotlin.apply' call
    var this_38 = addTo(this_37, this_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'createSettingsPanel.<anonymous>.<anonymous>' call
    this_38.kbp(get_gameFont());
    position(this_38, valueX, currentY);
    this_38.dbl(Colors_getInstance().m43_1);
    this_38.obp(32.0);
    currentTimeValue._v = this_38;
    currentY = currentY + 60.0;
  }
  addUpdater(this_1, createSettingsPanel$lambda_5(totalTimeValue, currentTimeValue));
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_39 = Container.za4(false);
  // Inline function 'kotlin.apply' call
  var this_40 = addTo(this_39, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'createSettingsPanel.<anonymous>.<anonymous>' call
  var btnWidth = 340.0;
  var btnHeight = 48.0;
  var borderColor = Colors_getInstance().g40_1;
  var bgColor = Companion_getInstance_1().r4g(borderColor, Colors_getInstance().h40_1, _Ratio___init__impl__9mwvn2(0.6));
  var bgHoverColor = Companion_getInstance_1().r4g(borderColor, Colors_getInstance().h40_1, _Ratio___init__impl__9mwvn2(0.75));
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_41 = SolidRect.cbl(Size2D.f2i(btnWidth, btnHeight), bgColor);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  var bg = addTo(this_41, this_40);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_42 = SolidRect.cbl(Size2D.f2i(btnWidth, 3.0), borderColor);
  // Inline function 'kotlin.apply' call
  var this_43 = addTo(this_42, this_40);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_43, 0.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_44 = SolidRect.cbl(Size2D.f2i(btnWidth, 3.0), borderColor);
  // Inline function 'kotlin.apply' call
  var this_45 = addTo(this_44, this_40);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_45, 0.0, btnHeight - 3);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_46 = SolidRect.cbl(Size2D.f2i(3.0, btnHeight), borderColor);
  // Inline function 'kotlin.apply' call
  var this_47 = addTo(this_46, this_40);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_47, 0.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_48 = SolidRect.cbl(Size2D.f2i(3.0, btnHeight), borderColor);
  // Inline function 'kotlin.apply' call
  var this_49 = addTo(this_48, this_40);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_49, btnWidth - 3, 0.0);
  // Inline function 'korlibs.korge.view.text' call
  var text_9 = Localization_getInstance().hi('close');
  var textSize_9 = Companion_instance.gbp_1;
  var color_18 = Colors_getInstance().g40_1;
  var font_9 = get_DefaultTtfFontAsBitmap();
  var alignment_9 = Companion_getInstance_2().l4o_1;
  var renderer_9 = get_DefaultStringTextRenderer();
  var autoScaling_9 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_50 = Text.lbp(text_9, numberToDouble(textSize_9), color_18, font_9, alignment_9, renderer_9, autoScaling_9, null, null);
  // Inline function 'kotlin.apply' call
  var this_51 = addTo(this_50, this_40);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'createSettingsPanel.<anonymous>.<anonymous>.<anonymous>' call
  this_51.kbp(get_gameFont());
  this_51.qbp(Companion_getInstance_2().y4o_1);
  position(this_51, btnWidth / 2, btnHeight / 2 - 2);
  this_51.dbl(borderColor);
  this_51.obp(32.0);
  closeButtonText._v = this_51;
  position(this_40, panelX + panelWidth / 2, panelY + panelHeight - 60);
  // Inline function 'korlibs.korge.input.onClick' call
  var handler_2 = createSettingsPanel$lambda_6(panel, onClose);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_2 = click$factory_7();
  var tmp1_safe_receiver_5 = this_40 == null ? null : this_40.gai();
  if (tmp1_safe_receiver_5 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_2 = 0;
    while (n_2 < tmp1_safe_receiver_5.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_2 = n_2;
      n_2 = _unary__edvuaz_2 + 1 | 0;
      var tmp0_safe_receiver_2 = tmp1_safe_receiver_5.e1(_unary__edvuaz_2);
      var tmp1_safe_receiver_6 = tmp0_safe_receiver_2 == null ? null : get_mouse(tmp0_safe_receiver_2);
      if (tmp1_safe_receiver_6 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_2 = prop_2.get(tmp1_safe_receiver_6);
        tmp_2.q20(createSettingsPanel$lambda_7(handler_2));
      }
    }
  }
  // Inline function 'korlibs.korge.input.onOver' call
  var handler_3 = createSettingsPanel$lambda_8(bg, bgHoverColor);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_3 = over$factory_1();
  var tmp1_safe_receiver_7 = this_40 == null ? null : this_40.gai();
  if (tmp1_safe_receiver_7 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_3 = 0;
    while (n_3 < tmp1_safe_receiver_7.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_3 = n_3;
      n_3 = _unary__edvuaz_3 + 1 | 0;
      var tmp0_safe_receiver_3 = tmp1_safe_receiver_7.e1(_unary__edvuaz_3);
      var tmp1_safe_receiver_8 = tmp0_safe_receiver_3 == null ? null : get_mouse(tmp0_safe_receiver_3);
      if (tmp1_safe_receiver_8 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_3 = prop_3.get(tmp1_safe_receiver_8);
        tmp_3.q20(createSettingsPanel$lambda_9(handler_3));
      }
    }
  }
  // Inline function 'korlibs.korge.input.onOut' call
  var handler_4 = createSettingsPanel$lambda_10(bg, bgColor);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_4 = out$factory_1();
  var tmp1_safe_receiver_9 = this_40 == null ? null : this_40.gai();
  if (tmp1_safe_receiver_9 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_4 = 0;
    while (n_4 < tmp1_safe_receiver_9.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_4 = n_4;
      n_4 = _unary__edvuaz_4 + 1 | 0;
      var tmp0_safe_receiver_4 = tmp1_safe_receiver_9.e1(_unary__edvuaz_4);
      var tmp1_safe_receiver_10 = tmp0_safe_receiver_4 == null ? null : get_mouse(tmp0_safe_receiver_4);
      if (tmp1_safe_receiver_10 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_4 = prop_4.get(tmp1_safe_receiver_10);
        tmp_4.q20(createSettingsPanel$lambda_11(handler_4));
      }
    }
  }
  return this_1;
}
function formatTime(seconds) {
  var hours = numberToInt(seconds / 3600);
  var minutes = numberToInt(seconds % 3600 / 60);
  var secs = numberToInt(seconds % 60);
  var pad2 = formatTime$lambda;
  var tmp;
  if (hours > 0) {
    tmp = '' + hours + ':' + pad2(minutes) + ':' + pad2(secs);
  } else {
    tmp = '' + minutes + ':' + pad2(secs);
  }
  return tmp;
}
function *_generator_invoke__zhh2q8_2($this, $this$launch, $completion) {
  var tmp = saveGameState($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function createSettingsPanel$lambda$slambda_0() {
  var i = new createSettingsPanel$lambda$slambda();
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function createSettingsPanel$lambda($$this$text, $titleText, $languageLabel, $soundLabel, $soundToggleText, $soundManager, $volumeLabel, $totalTimeLabel, $currentTimeLabel, $closeButtonText, $onLanguageChange, $sceneViews) {
  return function (it) {
    var languages = listOf(['en', 'de', 'ru', 'cs', 'fr']);
    var currentIndex = languages.z2(Localization_getInstance().mbv_1);
    var nextIndex = (currentIndex + 1 | 0) % languages.f1() | 0;
    Localization_getInstance().mbv_1 = languages.e1(nextIndex);
    $$this$text.mbp(Localization_getInstance().xc5(Localization_getInstance().mbv_1));
    var tmp;
    if ($titleText._v == null) {
      throwUninitializedPropertyAccessException('titleText');
    } else {
      tmp = $titleText._v;
    }
    var tmp_0 = tmp;
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = Localization_getInstance().hi('settings_title').toUpperCase();
    tmp_0.mbp(tmp$ret$1);
    var tmp_1;
    if ($languageLabel._v == null) {
      throwUninitializedPropertyAccessException('languageLabel');
    } else {
      tmp_1 = $languageLabel._v;
    }
    tmp_1.mbp(Localization_getInstance().hi('language'));
    var tmp_2;
    if ($soundLabel._v == null) {
      throwUninitializedPropertyAccessException('soundLabel');
    } else {
      tmp_2 = $soundLabel._v;
    }
    tmp_2.mbp(Localization_getInstance().hi('sound'));
    var tmp_3;
    if ($soundToggleText._v == null) {
      throwUninitializedPropertyAccessException('soundToggleText');
    } else {
      tmp_3 = $soundToggleText._v;
    }
    tmp_3.mbp($soundManager.yc4_1 ? Localization_getInstance().hi('off') : Localization_getInstance().hi('on'));
    var tmp_4;
    if ($volumeLabel._v == null) {
      throwUninitializedPropertyAccessException('volumeLabel');
    } else {
      tmp_4 = $volumeLabel._v;
    }
    tmp_4.mbp(Localization_getInstance().hi('volume') + ' ' + numberToInt($soundManager.xc4_1 * 100) + '%');
    var tmp_5;
    if ($totalTimeLabel._v == null) {
      throwUninitializedPropertyAccessException('totalTimeLabel');
    } else {
      tmp_5 = $totalTimeLabel._v;
    }
    tmp_5.mbp(Localization_getInstance().hi('total_time_played'));
    var tmp_6;
    if (get_currentRunTime() > 0) {
      var tmp0_safe_receiver = $currentTimeLabel._v;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.mbp(Localization_getInstance().hi('current_run'));
      }
      tmp_6 = Unit_instance;
    }
    var tmp_7;
    if ($closeButtonText._v == null) {
      throwUninitializedPropertyAccessException('closeButtonText');
    } else {
      tmp_7 = $closeButtonText._v;
    }
    tmp_7.mbp(Localization_getInstance().hi('close'));
    var tmp1_safe_receiver = $onLanguageChange;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver();
    launch($sceneViews, VOID, VOID, createSettingsPanel$lambda$slambda_0());
    return Unit_instance;
  };
}
function createSettingsPanel$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function createSettingsPanel$lambda_1($soundManager, $$this$text) {
  return function (it) {
    $soundManager.wc6();
    $$this$text.mbp($soundManager.yc4_1 ? Localization_getInstance().hi('off') : Localization_getInstance().hi('on'));
    $$this$text.dbl($soundManager.yc4_1 ? Colors_getInstance().i40_1 : Colors_getInstance().j40_1);
    return Unit_instance;
  };
}
function createSettingsPanel$lambda_2($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function createSettingsPanel$lambda_3($sliderWidth, $soundManager, $volumeFill, $volumeLabel) {
  return function (event) {
    var localX = event.oa1().a2a_1;
    var newVolume = coerceIn(localX / $sliderWidth, 0.0, 1.0);
    $soundManager.xc6(newVolume);
    $volumeFill.tbi($sliderWidth * $soundManager.xc4_1);
    var tmp;
    if ($volumeLabel._v == null) {
      throwUninitializedPropertyAccessException('volumeLabel');
    } else {
      tmp = $volumeLabel._v;
    }
    tmp.mbp(Localization_getInstance().hi('volume') + ' ' + numberToInt($soundManager.xc4_1 * 100) + '%');
    return Unit_instance;
  };
}
function createSettingsPanel$lambda_4($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function createSettingsPanel$lambda_5($totalTimeValue, $currentTimeValue) {
  return function ($this$addUpdater, it) {
    var tmp;
    if ($totalTimeValue._v == null) {
      throwUninitializedPropertyAccessException('totalTimeValue');
    } else {
      tmp = $totalTimeValue._v;
    }
    tmp.mbp(formatTime(get_totalGameTime()));
    var tmp_0;
    if (get_currentRunTime() > 0) {
      var tmp0_safe_receiver = $currentTimeValue._v;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.mbp(formatTime(get_currentRunTime()));
      }
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  };
}
function createSettingsPanel$lambda_6($panel, $onClose) {
  return function (it) {
    $panel.kak();
    var tmp0_safe_receiver = $onClose;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
    return Unit_instance;
  };
}
function createSettingsPanel$lambda_7($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function createSettingsPanel$lambda_8($bg, $bgHoverColor) {
  return function (it) {
    $bg.dbl($bgHoverColor);
    return Unit_instance;
  };
}
function createSettingsPanel$lambda_9($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function createSettingsPanel$lambda_10($bg, $bgColor) {
  return function (it) {
    $bg.dbl($bgColor);
    return Unit_instance;
  };
}
function createSettingsPanel$lambda_11($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function formatTime$lambda(n) {
  return n < 10 ? '0' + n : '' + n;
}
function click$factory_4() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.t9z_1;
  }, null);
}
function click$factory_5() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.t9z_1;
  }, null);
}
function click$factory_6() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.t9z_1;
  }, null);
}
function click$factory_7() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.t9z_1;
  }, null);
}
function over$factory_1() {
  return getPropertyCallableRef('over', 1, KProperty1, function (receiver) {
    return receiver.u9z_1;
  }, null);
}
function out$factory_1() {
  return getPropertyCallableRef('out', 1, KProperty1, function (receiver) {
    return receiver.v9z_1;
  }, null);
}
function *_generator_invoke__zhh2q8_3($this, $this$launch, $completion) {
  try {
    println('Loading sounds from sfx/...');
    var tmp = $this.yc6_1;
    var tmp_0 = readSound(get_resourcesVfs().hi('sfx/male_collision.wav'), VOID, VOID, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp.zc4_1 = tmp_0;
    println('Loaded male_collision.wav');
    var tmp_1 = $this.yc6_1;
    var tmp_2 = readSound(get_resourcesVfs().hi('sfx/collision.wav'), VOID, VOID, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    tmp_1.ac5_1 = tmp_2;
    println('Loaded collision.wav');
    var tmp_3 = $this.yc6_1;
    var tmp_4 = readSound(get_resourcesVfs().hi('sfx/achievement.wav'), VOID, VOID, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    tmp_3.bc5_1 = tmp_4;
    println('Loaded achievement.wav');
    var tmp_5 = $this.yc6_1;
    var tmp_6 = readSound(get_resourcesVfs().hi('sfx/step.wav'), VOID, VOID, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    tmp_5.cc5_1 = tmp_6;
    println('Loaded step.wav');
    var tmp_7 = $this.yc6_1;
    var tmp_8 = readSound(get_resourcesVfs().hi('sfx/star_collect.wav'), VOID, VOID, $completion);
    if (tmp_8 === get_COROUTINE_SUSPENDED())
      tmp_8 = yield tmp_8;
    tmp_7.dc5_1 = tmp_8;
    println('Loaded star_collect.wav');
    println('All sounds loaded successfully!');
  } catch ($p) {
    if ($p instanceof Exception) {
      var e = $p;
      println('Failed to load sounds: ' + e.message);
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, $this$launch, $completion) {
  try {
    println('Playing male collision sound: ' + !($this.zc6_1.zc4_1 == null));
    var tmp0_safe_receiver = $this.zc6_1.zc4_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp = tmp0_safe_receiver.n68(new PlaybackParameters(VOID, VOID, VOID, $this.zc6_1.xc4_1), $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
  } catch ($p) {
    if ($p instanceof Exception) {
      var e = $p;
      println('Error playing bounce sound: ' + e.message);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $this$launch, $completion) {
  try {
    var tmp0_safe_receiver = $this.ac7_1.ac5_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp = tmp0_safe_receiver.n68(new PlaybackParameters(VOID, VOID, VOID, $this.ac7_1.xc4_1), $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
  } catch ($p) {
    if ($p instanceof Exception) {
      var e = $p;
      println('Error playing reproduction sound: ' + e.message);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $this$launch, $completion) {
  try {
    println('Playing achievement sound: ' + !($this.bc7_1.bc5_1 == null));
    var tmp0_safe_receiver = $this.bc7_1.bc5_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp = tmp0_safe_receiver.n68(new PlaybackParameters(VOID, VOID, VOID, 0.15 * $this.bc7_1.xc4_1), $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
  } catch ($p) {
    if ($p instanceof Exception) {
      var e = $p;
      println('Error playing achievement sound: ' + e.message);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_7($this, $this$launch, $completion) {
  try {
    var tmp0_safe_receiver = $this.cc7_1.cc5_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp = tmp0_safe_receiver.n68(new PlaybackParameters(VOID, VOID, VOID, 0.25 * $this.cc7_1.xc4_1), $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
  } catch ($p) {
    if ($p instanceof Exception) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_8($this, $this$launch, $completion) {
  try {
    println('Playing star collect sound: ' + !($this.dc7_1.dc5_1 == null));
    var tmp0_safe_receiver = $this.dc7_1.dc5_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp = tmp0_safe_receiver.n68(new PlaybackParameters(VOID, VOID, VOID, $this.dc7_1.xc4_1), $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
  } catch ($p) {
    if ($p instanceof Exception) {
      var e = $p;
      println('Error playing star collect sound: ' + e.message);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function SoundManager$slambda_0(this$0) {
  var i = new SoundManager$slambda(this$0);
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function SoundManager$playBounceSound$slambda_0(this$0) {
  var i = new SoundManager$playBounceSound$slambda(this$0);
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function SoundManager$playReproductionSound$slambda_0(this$0) {
  var i = new SoundManager$playReproductionSound$slambda(this$0);
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function SoundManager$playAchievementSound$slambda_0(this$0) {
  var i = new SoundManager$playAchievementSound$slambda(this$0);
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function SoundManager$playFootstepSound$slambda_0(this$0) {
  var i = new SoundManager$playFootstepSound$slambda(this$0);
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function SoundManager$playStarCollectSound$slambda_0(this$0) {
  var i = new SoundManager$playStarCollectSound$slambda(this$0);
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
var UpgradeState_LOCKED_instance;
var UpgradeState_UNAVAILABLE_instance;
var UpgradeState_AVAILABLE_instance;
var UpgradeState_entriesInitialized;
function UpgradeState_initEntries() {
  if (UpgradeState_entriesInitialized)
    return Unit_instance;
  UpgradeState_entriesInitialized = true;
  UpgradeState_LOCKED_instance = new UpgradeState('LOCKED', 0);
  UpgradeState_UNAVAILABLE_instance = new UpgradeState('UNAVAILABLE', 1);
  UpgradeState_AVAILABLE_instance = new UpgradeState('AVAILABLE', 2);
}
function *_generator_invoke__zhh2q8_9($this, $this$launch, $completion) {
  var tmp = updateUpgradeStates($this.dc8_1, $this.cc8_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_10($this, $completion) {
  var tmp = $this.ec8_1($this.fc8_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_11($this, $completion) {
  var tmp = $this.gc8_1($this.hc8_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_12($this, $completion) {
  var tmp = $this.ic8_1($this.jc8_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_13($this, $completion) {
  var tmp = $this.kc8_1($this.lc8_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_14($this, $this$launch, $completion) {
  while (true) {
    var tmp = delay_0(new Long(200, 0), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    if (!$this.xc9_1.pc9_1) {
      var tmp0_safe_receiver = $this.xc9_1.kc9_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.korge.view.Graphics.updateShape' call
        var result;
        // Inline function 'korlibs.image.vector.buildShape' call
        // Inline function 'kotlin.apply' call
        var this_0 = new ShapeBuilder(null, null);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
        this_0.k3();
        drawDynamicConnectionLines(this_0, $this.xc9_1, $this.xc9_1.lc9_1, $this.yc9_1, $this.zc9_1);
        result = Unit_instance;
        var tmp$ret$1 = this_0.n4n();
        tmp0_safe_receiver.nbf(tmp$ret$1);
      }
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_15($this, $this$launch, $completion) {
  var tmp = saveGameState($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_16($this, $completion) {
  var tmp = $this.aca_1($this.bca_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_17($this, $completion) {
  var tmp = $this.cca_1($this.dca_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_18($this, $completion) {
  var tmp = $this.eca_1($this.fca_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_19($this, $this$launch, $completion) {
  var baseX = $this.gca_1.b6j();
  var baseY = $this.gca_1.c6j();
  var floatRange = 3.0;
  var updateInterval = 150;
  var speedFactor = 0.045;
  var phaseX = Default_getInstance().wo() * 3.141592653589793 * 2;
  var phaseY = Default_getInstance().wo() * 3.141592653589793 * 2;
  var speedX = 0.8 + Default_getInstance().wo() * 0.4;
  var speedY = 0.8 + Default_getInstance().wo() * 0.4;
  while (true) {
    var tmp = delay_0(toLong(updateInterval), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    if (!$this.hca_1.pc9_1) {
      phaseX = phaseX + speedFactor * speedX;
      phaseY = phaseY + speedFactor * speedY;
      // Inline function 'kotlin.math.sin' call
      var x = phaseX;
      var offsetX = Math.sin(x) * floatRange;
      // Inline function 'kotlin.math.sin' call
      var x_0 = phaseY;
      var offsetY = Math.sin(x_0) * floatRange;
      $this.gca_1.tai(baseX + offsetX);
      $this.gca_1.uai(baseY + offsetY);
    }
  }
  return Unit_instance;
}
function *_generator_sceneMain__5xvlzl_0(_this__u8e3s4, $this, $completion) {
  $this.dc9_1 = _this__u8e3s4;
  var screenWidth = $this.ka1().p9r_1;
  var screenHeight = $this.ka1().q9r_1;
  var actualPixelWidth = $this.ka1().k9q_1.y6n().r6n_1;
  var actualPixelHeight = $this.ka1().k9q_1.y6n().s6n_1;
  var stageWidth = $this.ka1().v9r_1.d2m();
  var stageHeight = $this.ka1().v9r_1.e2m();
  var windowAspect = actualPixelWidth / actualPixelHeight;
  var virtualAspect = screenWidth / screenHeight;
  var renderedWidth;
  var renderedHeight;
  if (windowAspect > virtualAspect) {
    renderedHeight = screenHeight;
    renderedWidth = screenHeight * windowAspect;
  } else {
    renderedWidth = screenWidth;
    renderedHeight = screenWidth / windowAspect;
  }
  var marginX = (renderedWidth - screenWidth) / 2.0;
  var marginY = (renderedHeight - screenHeight) / 2.0;
  println('DEBUG sceneMain: window=' + actualPixelWidth + 'x' + actualPixelHeight + ', aspect=' + windowAspect);
  println('DEBUG sceneMain: rendered=' + renderedWidth + 'x' + renderedHeight + ', margin=' + marginX + 'x' + marginY);
  // Inline function 'korlibs.korge.view.solidRect' call
  var width = renderedWidth;
  var height = renderedHeight;
  var color = Companion_getInstance_1().q4e(15, 15, 35, 255);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SolidRect.cbl(Size2D.f2i(width, height), color);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.sceneMain.<anonymous>' call
  position(this_1, -marginX, -marginY);
  createUpgradeDefinitions($this);
  var tmp = setupScreen(_this__u8e3s4, $this, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function refreshUpgradeTree($this) {
  var tmp0_safe_receiver = $this.mc9_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.mbp(Localization_getInstance().hi('score') + ' ' + roundDecimalPlaces($this.xc8_1, 1));
  }
  var tmp1_safe_receiver = $this.hc9_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'UpgradeTreeScene.refreshUpgradeTree.<anonymous>' call
    var tmp = $this.ka1();
    launch(tmp, VOID, VOID, UpgradeTreeScene$refreshUpgradeTree$slambda_0($this, tmp1_safe_receiver));
  }
}
function createUpgradeDefinitions($this) {
  $this.cc9_1.k3();
  if ($this.bc9_1) {
    $this.cc9_1.g1(createAllUpgrades());
  }
}
function getUpgradeState($this, upgrade) {
  if ($this.ac9_1) {
    return UpgradeState_AVAILABLE_getInstance();
  }
  var _iterator__ex2g4s = upgrade.xc7_1.b1();
  $l$loop: while (_iterator__ex2g4s.c1()) {
    var prereqId = _iterator__ex2g4s.d1();
    // Inline function 'kotlin.collections.find' call
    var this_0 = $this.cc9_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this_0.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'UpgradeTreeScene.getUpgradeState.<anonymous>' call
        if (element.pc7_1 === prereqId) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      continue $l$loop;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var prereq = tmp;
    if (prereq.sc7_1($this.wc8_1) < 1) {
      return UpgradeState_LOCKED_getInstance();
    }
  }
  var tmp_0;
  if (upgrade.vc7_1($this.wc8_1, $this.xc8_1)) {
    tmp_0 = UpgradeState_AVAILABLE_getInstance();
  } else {
    tmp_0 = UpgradeState_UNAVAILABLE_getInstance();
  }
  return tmp_0;
}
function getTierColor($this, upgradeId, state) {
  var tier;
  switch (upgradeId) {
    case 'start':
      tier = 0;
      break;
    case 'collision_cooldown':
    case 'adult_age':
    case 'max_speed':
      tier = 1;
      break;
    case 'max_population':
    case 'lifespan':
    case 'movement_efficiency':
    case 'fertility_rate':
      tier = 2;
      break;
    case 'birth_bonus':
    case 'starting_population':
    case 'collision_range':
    case 'instant_maturity':
    case 'ultra_speed':
      tier = 3;
      break;
    case 'gender_balance':
    case 'score_multiplier':
    case 'click_power':
    case 'time_acceleration':
      tier = 4;
      break;
    case 'auto_spawn':
    case 'fertility_explosion':
    case 'mega_population':
    case 'score_ascension':
    case 'click_power_boost':
    case 'star_speed':
      tier = 5;
      break;
    case 'auto_spawn_rate':
    case 'starting_population_boost':
    case 'star_speed_boost':
    case 'click_power_mega':
      tier = 6;
      break;
    case 'mass_reproduction':
    case 'starting_population_mega':
    case 'star_speed_mega':
      tier = 7;
      break;
    case 'evolution_bonus':
    case 'reproduction_frenzy':
      tier = 8;
      break;
    case 'time_dilation':
    case 'cosmic_convergence':
      tier = 9;
      break;
    case 'transcendence':
      tier = 10;
      break;
    default:
      tier = 1;
      break;
  }
  var tierColors;
  switch (tier) {
    case 0:
      tierColors = new Pair(new RGBA(Colors_getInstance().y4f('#4d4d1e')), new RGBA(Colors_getInstance().y4f('#FFEB3B')));
      break;
    case 1:
      tierColors = new Pair(new RGBA(Colors_getInstance().y4f('#2d3d2e')), new RGBA(Colors_getInstance().y4f('#4CAF50')));
      break;
    case 2:
      tierColors = new Pair(new RGBA(Colors_getInstance().y4f('#2e3d3d')), new RGBA(Colors_getInstance().y4f('#2196F3')));
      break;
    case 3:
      tierColors = new Pair(new RGBA(Colors_getInstance().y4f('#3d2e3d')), new RGBA(Colors_getInstance().y4f('#9C27B0')));
      break;
    case 4:
      tierColors = new Pair(new RGBA(Colors_getInstance().y4f('#3d2e2e')), new RGBA(Colors_getInstance().y4f('#FF5722')));
      break;
    case 5:
      tierColors = new Pair(new RGBA(Colors_getInstance().y4f('#3d1e1e')), new RGBA(Colors_getInstance().y4f('#F44336')));
      break;
    case 6:
      tierColors = new Pair(new RGBA(Colors_getInstance().y4f('#1e1e3d')), new RGBA(Colors_getInstance().y4f('#3F51B5')));
      break;
    case 7:
      tierColors = new Pair(new RGBA(Colors_getInstance().y4f('#3d1e3d')), new RGBA(Colors_getInstance().y4f('#E91E63')));
      break;
    case 8:
      tierColors = new Pair(new RGBA(Colors_getInstance().y4f('#1e3d3d')), new RGBA(Colors_getInstance().y4f('#00BCD4')));
      break;
    case 9:
      tierColors = new Pair(new RGBA(Colors_getInstance().y4f('#3d3d1e')), new RGBA(Colors_getInstance().y4f('#FFD700')));
      break;
    case 10:
      tierColors = new Pair(new RGBA(Colors_getInstance().y4f('#2a0a2a')), new RGBA(Colors_getInstance().y4f('#FF00FF')));
      break;
    default:
      tierColors = new Pair(new RGBA(Colors_getInstance().y4f('#2d3d2e')), new RGBA(Colors_getInstance().y4f('#4CAF50')));
      break;
  }
  var tmp;
  switch (state.r3_1) {
    case 2:
      tmp = tierColors;
      break;
    case 1:
      tmp = new Pair(new RGBA(Colors_getInstance().y4f('#404040')), new RGBA(Colors_getInstance().y4f('#808080')));
      break;
    case 0:
      tmp = new Pair(new RGBA(Colors_getInstance().y4f('#202020')), new RGBA(Colors_getInstance().y4f('#404040')));
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function *_generator_setupScreen__959ng5(_this__u8e3s4, $this, $completion) {
  var screenWidth = $this.ka1().p9r_1;
  var screenHeight = $this.ka1().q9r_1;
  var actualPixelWidth = $this.ka1().k9q_1.y6n().r6n_1;
  var actualPixelHeight = $this.ka1().k9q_1.y6n().s6n_1;
  var windowAspect = actualPixelWidth / actualPixelHeight;
  var virtualAspect = screenWidth / screenHeight;
  var renderedWidth;
  var renderedHeight;
  if (windowAspect > virtualAspect) {
    renderedHeight = screenHeight;
    renderedWidth = screenHeight * windowAspect;
  } else {
    renderedWidth = screenWidth;
    renderedHeight = screenWidth / windowAspect;
  }
  var marginX = (renderedWidth - screenWidth) / 2.0;
  var marginY = (renderedHeight - screenHeight) / 2.0;
  println('DEBUG setupScreen: window=' + actualPixelWidth + 'x' + actualPixelHeight);
  println('DEBUG setupScreen: rendered=' + renderedWidth + 'x' + renderedHeight + ', stars area=' + renderedWidth * renderedHeight);
  // Inline function 'kotlin.collections.mutableListOf' call
  var starLayers = ArrayList.j1();
  var inductionVariable = 0;
  if (inductionVariable <= 3)
    do {
      var layer = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tileWidth = numberToInt(renderedWidth * 2);
      var tileHeight = numberToInt(renderedHeight * 2);
      // Inline function 'kotlin.also' call
      var this_0 = Bitmap32.s3y(tileWidth, tileHeight);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'UpgradeTreeScene.setupScreen.<anonymous>' call
      var numStars = 87;
      // Inline function 'kotlin.collections.mutableListOf' call
      var placedStars = ArrayList.j1();
      var minDistance = 40;
      var attempts = 0;
      var placedCount = 0;
      while (placedCount < numStars && attempts < imul(numStars, 50)) {
        attempts = attempts + 1 | 0;
        var x = numberToInt(Default_getInstance().wo() * renderedWidth);
        var y = numberToInt(Default_getInstance().wo() * renderedHeight);
        var tmp$ret$2;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(placedStars, Collection)) {
            tmp = placedStars.h1();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$2 = false;
            break $l$block_0;
          }
          var tmp0_iterator = placedStars.b1();
          while (tmp0_iterator.c1()) {
            var element = tmp0_iterator.d1();
            // Inline function 'UpgradeTreeScene.setupScreen.<anonymous>.<anonymous>' call
            var px = element.nl();
            var py = element.ol();
            var dx = x - px | 0;
            var dy = y - py | 0;
            // Inline function 'kotlin.comparisons.minOf' call
            var a = abs(dx);
            var b = numberToInt(renderedWidth) - abs(dx) | 0;
            var distX = Math.min(a, b);
            // Inline function 'kotlin.comparisons.minOf' call
            var a_0 = abs(dy);
            var b_0 = numberToInt(renderedHeight) - abs(dy) | 0;
            var distY = Math.min(a_0, b_0);
            // Inline function 'kotlin.math.sqrt' call
            var x_0 = imul(distX, distX) + imul(distY, distY) | 0;
            if (Math.sqrt(x_0) < minDistance) {
              tmp$ret$2 = true;
              break $l$block_0;
            }
          }
          tmp$ret$2 = false;
        }
        var tooClose = tmp$ret$2;
        if (!tooClose) {
          placedStars.h(new Pair(x, y));
          placedCount = placedCount + 1 | 0;
          var size = numberToInt(Default_getInstance().wo() * 1.5 + 0.5);
          var brightnessRange;
          switch (layer) {
            case 0:
              brightnessRange = numberRangeToNumber(200, 255);
              break;
            case 1:
              brightnessRange = numberRangeToNumber(170, 210);
              break;
            case 2:
              brightnessRange = numberRangeToNumber(140, 180);
              break;
            default:
              brightnessRange = numberRangeToNumber(110, 150);
              break;
          }
          var brightness = Default_getInstance().uo(brightnessRange.b2_1, brightnessRange.c2_1);
          var color = RGBA__withAd_impl_cralao(Colors_getInstance().g40_1, brightness / 255.0);
          var inductionVariable_0 = 0;
          if (inductionVariable_0 <= 1)
            do {
              var tileY = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var inductionVariable_1 = 0;
              if (inductionVariable_1 <= 1)
                do {
                  var tileX = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  var offsetX = imul(tileX, numberToInt(renderedWidth));
                  var offsetY = imul(tileY, numberToInt(renderedHeight));
                  var inductionVariable_2 = -size | 0;
                  if (inductionVariable_2 <= size)
                    do {
                      var dy_0 = inductionVariable_2;
                      inductionVariable_2 = inductionVariable_2 + 1 | 0;
                      var inductionVariable_3 = -size | 0;
                      if (inductionVariable_3 <= size)
                        do {
                          var dx_0 = inductionVariable_3;
                          inductionVariable_3 = inductionVariable_3 + 1 | 0;
                          if ((imul(dx_0, dx_0) + imul(dy_0, dy_0) | 0) <= imul(size, size)) {
                            var px_0 = (x + dx_0 | 0) + offsetX | 0;
                            var py_0 = (y + dy_0 | 0) + offsetY | 0;
                            if ((0 <= px_0 ? px_0 < this_0.z3y_1 : false) && (0 <= py_0 ? py_0 < this_0.a3z_1 : false)) {
                              this_0.b40(px_0, py_0, color);
                            }
                          }
                        }
                         while (!(dx_0 === size));
                    }
                     while (!(dy_0 === size));
                }
                 while (inductionVariable_1 <= 1);
            }
             while (inductionVariable_0 <= 1);
        }
      }
      println('DEBUG: Layer ' + layer + ' - placed ' + placedCount + ' stars after ' + attempts + ' attempts');
      var starsBitmap = this_0;
      // Inline function 'korlibs.korge.view.image' call
      var anchor = Companion_getInstance_4().b29_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_1 = Image.kbi(starsBitmap, anchor);
      // Inline function 'kotlin.apply' call
      var this_2 = addTo(this_1, _this__u8e3s4);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'UpgradeTreeScene.setupScreen.<anonymous>' call
      position(this_2, -marginX, -marginY);
      this_2.ma1(false);
      var starsImage = this_2;
      var velocities;
      switch (layer) {
        case 0:
          velocities = new Pair(3.0, 0.5);
          break;
        case 1:
          velocities = new Pair(-1.5, 2.0);
          break;
        case 2:
          velocities = new Pair(0.8, -1.2);
          break;
        default:
          velocities = new Pair(-2.2, -0.8);
          break;
      }
      starLayers.h(new Pair(starsImage, velocities));
    }
     while (inductionVariable <= 3);
  println('DEBUG: Created ' + starLayers.f1() + ' star layers with different directions');
  // Inline function 'kotlin.collections.mutableListOf' call
  var layerScrolls = ArrayList.j1();
  // Inline function 'kotlin.repeat' call
  var times = starLayers.f1();
  // Inline function 'kotlin.contracts.contract' call
  var inductionVariable_4 = 0;
  if (inductionVariable_4 < times)
    do {
      var index = inductionVariable_4;
      inductionVariable_4 = inductionVariable_4 + 1 | 0;
      // Inline function 'UpgradeTreeScene.setupScreen.<anonymous>' call
      layerScrolls.h(new Pair(0.0, 0.0));
    }
     while (inductionVariable_4 < times);
  addUpdater(_this__u8e3s4, UpgradeTreeScene$setupScreen$lambda($this, starLayers, layerScrolls, renderedWidth, renderedHeight, marginX, marginY));
  var uiX = 50.0;
  var uiY = 50.0;
  // Inline function 'korlibs.korge.view.text' call
  var text = Localization_getInstance().hi('upgrade_tree');
  var textSize = Companion_instance.gbp_1;
  var color_0 = Colors_getInstance().g40_1;
  var font = get_DefaultTtfFontAsBitmap();
  var alignment = Companion_getInstance_2().l4o_1;
  var renderer = get_DefaultStringTextRenderer();
  var autoScaling = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_3 = Text.lbp(text, numberToDouble(textSize), color_0, font, alignment, renderer, autoScaling, null, null);
  // Inline function 'kotlin.apply' call
  var this_4 = addTo(this_3, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.setupScreen.<anonymous>' call
  this_4.kbp(get_gameFont());
  position(this_4, uiX, uiY);
  this_4.dbl(Colors_getInstance().g40_1);
  this_4.obp(64.0);
  var tmp_0 = $this;
  // Inline function 'korlibs.korge.view.text' call
  var text_0 = Localization_getInstance().hi('score') + ' ' + roundDecimalPlaces($this.xc8_1, 1);
  var textSize_0 = Companion_instance.gbp_1;
  var color_1 = Colors_getInstance().g40_1;
  var font_0 = get_DefaultTtfFontAsBitmap();
  var alignment_0 = Companion_getInstance_2().l4o_1;
  var renderer_0 = get_DefaultStringTextRenderer();
  var autoScaling_0 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_5 = Text.lbp(text_0, numberToDouble(textSize_0), color_1, font_0, alignment_0, renderer_0, autoScaling_0, null, null);
  // Inline function 'kotlin.apply' call
  var this_6 = addTo(this_5, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.setupScreen.<anonymous>' call
  this_6.kbp(get_gameFont());
  position(this_6, uiX, uiY + 60.0);
  this_6.dbl(Colors_getInstance().w45_1);
  this_6.obp(46.0);
  tmp_0.mc9_1 = this_6;
  var tmp_1 = $this;
  // Inline function 'korlibs.korge.view.text' call
  var text_1 = Localization_getInstance().hi('fps') + ' 0';
  var textSize_1 = Companion_instance.gbp_1;
  var color_2 = Colors_getInstance().g40_1;
  var font_1 = get_DefaultTtfFontAsBitmap();
  var alignment_1 = Companion_getInstance_2().l4o_1;
  var renderer_1 = get_DefaultStringTextRenderer();
  var autoScaling_1 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_7 = Text.lbp(text_1, numberToDouble(textSize_1), color_2, font_1, alignment_1, renderer_1, autoScaling_1, null, null);
  // Inline function 'kotlin.apply' call
  var this_8 = addTo(this_7, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.setupScreen.<anonymous>' call
  this_8.kbp(get_gameFont());
  position(this_8, uiX, uiY + 110.0);
  this_8.dbl(Colors_getInstance().j40_1);
  this_8.obp(32.0);
  tmp_1.nc9_1 = this_8;
  var frameCount = {_v: 0};
  var fpsAccumulator = {_v: 0.0};
  addUpdater(_this__u8e3s4, UpgradeTreeScene$setupScreen$lambda_0(frameCount, fpsAccumulator, $this));
  // Inline function 'korlibs.korge.view.text' call
  var text_2 = Localization_getInstance().hi('zoom_mouse');
  var textSize_2 = Companion_instance.gbp_1;
  var color_3 = Colors_getInstance().g40_1;
  var font_2 = get_DefaultTtfFontAsBitmap();
  var alignment_2 = Companion_getInstance_2().l4o_1;
  var renderer_2 = get_DefaultStringTextRenderer();
  var autoScaling_2 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_9 = Text.lbp(text_2, numberToDouble(textSize_2), color_3, font_2, alignment_2, renderer_2, autoScaling_2, null, null);
  // Inline function 'kotlin.apply' call
  var this_10 = addTo(this_9, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.setupScreen.<anonymous>' call
  this_10.kbp(get_gameFont());
  position(this_10, uiX, uiY + 150.0);
  this_10.dbl(Colors_getInstance().c43_1);
  this_10.obp(32.0);
  if ($this.hc9_1 == null) {
    var availableWidth = screenWidth - 350.0;
    var viewportCenterX = 350.0 + availableWidth / 2;
    var viewportCenterY = screenHeight / 2;
    if (!(get_treeViewX() == null) && !(get_treeViewY() == null) && !(get_treeViewScale() == null)) {
      $this.ec9_1 = ensureNotNull(get_treeViewX());
      $this.fc9_1 = ensureNotNull(get_treeViewY());
      $this.gc9_1 = ensureNotNull(get_treeViewScale());
    } else {
      var angle = -100.9 * 3.141592653589793 / 180.0;
      var distance = 665.76;
      // Inline function 'kotlin.math.cos' call
      var genesisX = 600.0 + distance * Math.cos(angle);
      // Inline function 'kotlin.math.sin' call
      var genesisY = 300.0 + distance * Math.sin(angle);
      $this.ec9_1 = viewportCenterX - genesisX;
      $this.fc9_1 = viewportCenterY - genesisY;
      $this.gc9_1 = 1.0;
    }
    var tmp_2 = $this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_11 = Container.za4(false);
    // Inline function 'kotlin.apply' call
    var this_12 = addTo(this_11, _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'UpgradeTreeScene.setupScreen.<anonymous>' call
    position(this_12, $this.ec9_1, $this.fc9_1);
    this_12.wai($this.gc9_1);
    tmp_2.hc9_1 = this_12;
    var tmp_3 = $this;
    // Inline function 'korlibs.korge.view.graphics' call
    var this_13 = ensureNotNull($this.hc9_1);
    var renderer_3 = GraphicsRenderer_SYSTEM_getInstance();
    // Inline function 'kotlin.also' call
    var this_14 = addTo(Graphics.pbf(EmptyShape_instance, renderer_3), this_13);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.graphics.<anonymous>' call
    // Inline function 'korlibs.korge.view.Graphics.updateShape' call
    var result;
    // Inline function 'korlibs.image.vector.buildShape' call
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
    // Inline function 'korlibs.korge.view.graphics.<anonymous>' call
    result = Unit_instance;
    var tmp$ret$31 = (new ShapeBuilder(null, null)).n4n();
    this_14.nbf(tmp$ret$31);
    this_14.tbf();
    tmp_3.kc9_1 = this_14;
    var tmp_4 = setupUpgrades(ensureNotNull($this.hc9_1), $this, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    _this__u8e3s4.xah(ensureNotNull($this.hc9_1));
    var tmp_5 = $this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_15 = Container.za4(false);
    // Inline function 'kotlin.apply' call
    var this_16 = addTo(this_15, _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'UpgradeTreeScene.setupScreen.<anonymous>' call
    position(this_16, 0.0, 0.0);
    tmp_5.ic9_1 = this_16;
    _this__u8e3s4.xah(ensureNotNull($this.ic9_1));
  } else {
    var tmp_6 = updateUpgradeStates(ensureNotNull($this.hc9_1), $this, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
  }
  var tc = ensureNotNull($this.hc9_1);
  if (!$this.oc9_1) {
    var isDragging = {_v: false};
    var dragStartX = {_v: 0.0};
    var dragStartY = {_v: 0.0};
    var containerStartX = {_v: 0.0};
    var containerStartY = {_v: 0.0};
    // Inline function 'korlibs.korge.input.mouse' call
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var $this$mouse = get_mouse(_this__u8e3s4);
    // Inline function 'korlibs.korge.input.MouseEvents.onDown' call
    var handler = UpgradeTreeScene$setupScreen$slambda_3($this, isDragging, dragStartX, dragStartY, containerStartX, tc, containerStartY);
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_7 = down$factory().get($this$mouse);
    tmp_7.q20(UpgradeTreeScene$setupScreen$lambda_1($this$mouse, handler));
    // Inline function 'korlibs.korge.input.MouseEvents.onUp' call
    var handler_0 = UpgradeTreeScene$setupScreen$slambda_4(isDragging, $this);
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_8 = up$factory().get($this$mouse);
    tmp_8.q20(UpgradeTreeScene$setupScreen$lambda_2($this$mouse, handler_0));
    // Inline function 'korlibs.korge.input.MouseEvents.onUpAnywhere' call
    var handler_1 = UpgradeTreeScene$setupScreen$slambda_5(isDragging, $this);
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_9 = upAnywhere$factory().get($this$mouse);
    tmp_9.q20(UpgradeTreeScene$setupScreen$lambda_3($this$mouse, handler_1));
    // Inline function 'korlibs.korge.input.MouseEvents.onMove' call
    var handler_2 = UpgradeTreeScene$setupScreen$slambda_6(isDragging, $this, dragStartX, dragStartY, tc, containerStartX, containerStartY);
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_10 = move$factory().get($this$mouse);
    tmp_10.q20(UpgradeTreeScene$setupScreen$lambda_4($this$mouse, handler_2));
    $this.oc9_1 = true;
  }
  // Inline function 'korlibs.korge.input.onScroll' call
  var handler_3 = UpgradeTreeScene$setupScreen$lambda_5(tc, $this);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop = scroll$factory_0();
  var tmp1_safe_receiver = _this__u8e3s4 == null ? null : _this__u8e3s4.gai();
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < tmp1_safe_receiver.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var tmp0_safe_receiver = tmp1_safe_receiver.e1(_unary__edvuaz);
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_11 = prop.get(tmp1_safe_receiver_0);
        tmp_11.q20(UpgradeTreeScene$setupScreen$lambda_6(handler_3));
      }
    }
  }
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_17 = Container.za4(false);
  // Inline function 'kotlin.apply' call
  var this_18 = addTo(this_17, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.setupScreen.<anonymous>' call
  position(this_18, uiX, screenHeight - 160.0);
  var borderColor = Colors_getInstance().y4f('#4CAF50');
  var bgColor = Companion_getInstance_1().r4g(borderColor, Colors_getInstance().h40_1, _Ratio___init__impl__9mwvn2(0.6));
  var bgHoverColor = Companion_getInstance_1().r4g(borderColor, Colors_getInstance().h40_1, _Ratio___init__impl__9mwvn2(0.75));
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_19 = SolidRect.cbl(Size2D.h2b(250, 50), bgColor);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  var btnBg = addTo(this_19, this_18);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_20 = SolidRect.cbl(Size2D.h2b(250, 3), borderColor);
  // Inline function 'kotlin.apply' call
  var this_21 = addTo(this_20, this_18);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  xy(this_21, 0.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_22 = SolidRect.cbl(Size2D.h2b(250, 3), borderColor);
  // Inline function 'kotlin.apply' call
  var this_23 = addTo(this_22, this_18);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  xy(this_23, 0.0, 47.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_24 = SolidRect.cbl(Size2D.h2b(3, 50), borderColor);
  // Inline function 'kotlin.apply' call
  var this_25 = addTo(this_24, this_18);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  xy(this_25, 0.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_26 = SolidRect.cbl(Size2D.h2b(3, 50), borderColor);
  // Inline function 'kotlin.apply' call
  var this_27 = addTo(this_26, this_18);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  xy(this_27, 247.0, 0.0);
  // Inline function 'korlibs.korge.view.text' call
  var text_3 = Localization_getInstance().hi('return_to_game');
  var textSize_3 = Companion_instance.gbp_1;
  var color_4 = Colors_getInstance().g40_1;
  var font_3 = get_DefaultTtfFontAsBitmap();
  var alignment_3 = Companion_getInstance_2().l4o_1;
  var renderer_4 = get_DefaultStringTextRenderer();
  var autoScaling_3 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_28 = Text.lbp(text_3, numberToDouble(textSize_3), color_4, font_3, alignment_3, renderer_4, autoScaling_3, null, null);
  // Inline function 'kotlin.apply' call
  var this_29 = addTo(this_28, this_18);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.setupScreen.<anonymous>.<anonymous>' call
  this_29.kbp(get_gameFont());
  position(this_29, 30.0, 5.0);
  this_29.dbl(Colors_getInstance().g40_1);
  this_29.obp(32.0);
  // Inline function 'korlibs.korge.input.onClick' call
  var handler_4 = UpgradeTreeScene$setupScreen$lambda_7($this);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_0 = click$factory_8();
  var tmp1_safe_receiver_1 = this_18 == null ? null : this_18.gai();
  if (tmp1_safe_receiver_1 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_0 = 0;
    while (n_0 < tmp1_safe_receiver_1.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var tmp0_safe_receiver_0 = tmp1_safe_receiver_1.e1(_unary__edvuaz_0);
      var tmp1_safe_receiver_2 = tmp0_safe_receiver_0 == null ? null : get_mouse(tmp0_safe_receiver_0);
      if (tmp1_safe_receiver_2 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_12 = prop_0.get(tmp1_safe_receiver_2);
        tmp_12.q20(UpgradeTreeScene$setupScreen$lambda_8(handler_4));
      }
    }
  }
  // Inline function 'korlibs.korge.input.onOver' call
  var handler_5 = UpgradeTreeScene$setupScreen$lambda_9(btnBg, bgHoverColor);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_1 = over$factory_2();
  var tmp1_safe_receiver_3 = this_18 == null ? null : this_18.gai();
  if (tmp1_safe_receiver_3 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_1 = 0;
    while (n_1 < tmp1_safe_receiver_3.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_1 = n_1;
      n_1 = _unary__edvuaz_1 + 1 | 0;
      var tmp0_safe_receiver_1 = tmp1_safe_receiver_3.e1(_unary__edvuaz_1);
      var tmp1_safe_receiver_4 = tmp0_safe_receiver_1 == null ? null : get_mouse(tmp0_safe_receiver_1);
      if (tmp1_safe_receiver_4 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_13 = prop_1.get(tmp1_safe_receiver_4);
        tmp_13.q20(UpgradeTreeScene$setupScreen$lambda_10(handler_5));
      }
    }
  }
  // Inline function 'korlibs.korge.input.onOut' call
  var handler_6 = UpgradeTreeScene$setupScreen$lambda_11(btnBg, bgColor);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_2 = out$factory_2();
  var tmp1_safe_receiver_5 = this_18 == null ? null : this_18.gai();
  if (tmp1_safe_receiver_5 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_2 = 0;
    while (n_2 < tmp1_safe_receiver_5.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_2 = n_2;
      n_2 = _unary__edvuaz_2 + 1 | 0;
      var tmp0_safe_receiver_2 = tmp1_safe_receiver_5.e1(_unary__edvuaz_2);
      var tmp1_safe_receiver_6 = tmp0_safe_receiver_2 == null ? null : get_mouse(tmp0_safe_receiver_2);
      if (tmp1_safe_receiver_6 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_14 = prop_2.get(tmp1_safe_receiver_6);
        tmp_14.q20(UpgradeTreeScene$setupScreen$lambda_12(handler_6));
      }
    }
  }
  return Unit_instance;
}
function setupScreen(_this__u8e3s4, $this, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_setupScreen__959ng5.bind(VOID, _this__u8e3s4, $this), $completion);
}
function *_generator_setupUpgrades__zc8wg0(_this__u8e3s4, $this, $completion) {
  var centerX = 600.0;
  var centerY = 300.0;
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = $this.lc9_1.l3().b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'UpgradeTreeScene.setupUpgrades.<anonymous>' call
    element.kak();
  }
  $this.lc9_1.k3();
  var _iterator__ex2g4s = $this.cc9_1.b1();
  $l$loop: while (_iterator__ex2g4s.c1()) {
    var upgrade = _iterator__ex2g4s.d1();
    var state = getUpgradeState($this, upgrade);
    if (state.equals(UpgradeState_LOCKED_getInstance()))
      continue $l$loop;
    var angleRad = upgrade.ac8_1 * 3.141592653589793 / 180.0;
    // Inline function 'kotlin.math.cos' call
    var tmp$ret$0 = Math.cos(angleRad);
    var x = centerX + upgrade.bc8_1 * tmp$ret$0;
    // Inline function 'kotlin.math.sin' call
    var tmp$ret$1 = Math.sin(angleRad);
    var y = centerY + upgrade.bc8_1 * tmp$ret$1;
    var tmp = createUpgradeCard(_this__u8e3s4, $this, x, y, upgrade, state, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var card = tmp;
    // Inline function 'kotlin.collections.set' call
    var this_0 = $this.lc9_1;
    var key = upgrade.pc7_1;
    this_0.h3(key, card);
  }
  var tmp0_safe_receiver = $this.jc9_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.j18();
  }
  var tmp_0 = $this;
  var tmp_1 = $this.ka1();
  tmp_0.jc9_1 = launch(tmp_1, VOID, VOID, UpgradeTreeScene$setupUpgrades$slambda_0($this, centerX, centerY));
  return Unit_instance;
}
function setupUpgrades(_this__u8e3s4, $this, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_setupUpgrades__zc8wg0.bind(VOID, _this__u8e3s4, $this), $completion);
}
function drawDynamicConnectionLines(_this__u8e3s4, $this, cardContainers, centerX, centerY) {
  var lineColor = Colors_getInstance().y4f('#4CAF50');
  var activeColor = Colors_getInstance().y4f('#4CAF50');
  var _iterator__ex2g4s = $this.cc9_1.b1();
  $l$loop_1: while (_iterator__ex2g4s.c1()) {
    var upgrade = _iterator__ex2g4s.d1();
    if (upgrade.xc7_1.h1())
      continue $l$loop_1;
    var state = getUpgradeState($this, upgrade);
    if (state.equals(UpgradeState_LOCKED_getInstance()))
      continue $l$loop_1;
    var tmp0_elvis_lhs = cardContainers.f3(upgrade.pc7_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      continue $l$loop_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var card2 = tmp;
    var cardSize = 128.0;
    var x2 = card2.b6j() + cardSize / 2;
    var y2 = card2.c6j() + cardSize / 2;
    var _iterator__ex2g4s_0 = upgrade.xc7_1.b1();
    $l$loop_4: while (_iterator__ex2g4s_0.c1()) {
      var prereqId = _iterator__ex2g4s_0.d1();
      // Inline function 'kotlin.collections.find' call
      var this_0 = $this.cc9_1;
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = this_0.b1();
        while (tmp0_iterator.c1()) {
          var element = tmp0_iterator.d1();
          // Inline function 'UpgradeTreeScene.drawDynamicConnectionLines.<anonymous>' call
          if (element.pc7_1 === prereqId) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      var tmp1_elvis_lhs = tmp$ret$1;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        continue $l$loop_4;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var prereq = tmp_0;
      var prereqState = getUpgradeState($this, prereq);
      if (prereqState.equals(UpgradeState_LOCKED_getInstance()))
        continue $l$loop_4;
      var tmp2_elvis_lhs = cardContainers.f3(prereqId);
      var tmp_1;
      if (tmp2_elvis_lhs == null) {
        continue $l$loop_4;
      } else {
        tmp_1 = tmp2_elvis_lhs;
      }
      var card1 = tmp_1;
      var x1 = card1.b6j() + cardSize / 2;
      var y1 = card1.c6j() + cardSize / 2;
      var isActive = prereq.sc7_1($this.wc8_1) >= 1;
      var color = isActive ? activeColor : lineColor;
      // Inline function 'korlibs.image.vector.Context2d.stroke' call
      var paint = new RGBA(color);
      var lineCap = _this__u8e3s4.t4q();
      var lineJoin = _this__u8e3s4.u4q();
      var miterLimit = _this__u8e3s4.v4q();
      var lineDash = _this__u8e3s4.w4q();
      var lineDashOffset = _this__u8e3s4.x4q();
      if (true) {
        _this__u8e3s4.f4p();
      }
      // Inline function 'UpgradeTreeScene.drawDynamicConnectionLines.<anonymous>' call
      _this__u8e3s4.k3o(x1, y1);
      _this__u8e3s4.l3o(x2, y2);
      // Inline function 'korlibs.image.vector.Context2d.keep' call
      _this__u8e3s4.y4q();
      try {
        // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
        _this__u8e3s4.z4q(numberToDouble(3.0));
        _this__u8e3s4.a4r(lineCap);
        _this__u8e3s4.b4r(lineJoin);
        _this__u8e3s4.c4r(numberToDouble(miterLimit));
        _this__u8e3s4.d4r(lineDash);
        _this__u8e3s4.e4r(numberToDouble(lineDashOffset));
        _this__u8e3s4.f4r(paint);
      }finally {
        _this__u8e3s4.g4r();
      }
    }
  }
}
function createUpgradeCard(_this__u8e3s4, $this, x, y, upgrade, state, $completion) {
  var cardSize = 140.0;
  var _destruct__k2r9zo = getTierColor($this, upgrade.pc7_1, state);
  var cardColor = _destruct__k2r9zo.nl().a4g_1;
  var borderColor = _destruct__k2r9zo.ol().a4g_1;
  var currentLevel = $this.ac9_1 ? upgrade.tc7_1($this.wc8_1) : upgrade.sc7_1($this.wc8_1);
  var maxLevel = upgrade.tc7_1($this.wc8_1);
  var cost = upgrade.uc7_1($this.wc8_1);
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.za4(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>' call
  this_1.l9t_1 = 'upgrade_' + upgrade.pc7_1;
  position(this_1, x - cardSize / 2, y - cardSize / 2);
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = SolidRect.cbl(Size2D.f2i(cardSize, cardSize), cardColor);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>' call
  addTo(this_2, this_1).ma1(false);
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_3 = SolidRect.cbl(Size2D.f2i(cardSize, 3.0), borderColor);
  // Inline function 'kotlin.apply' call
  var this_4 = addTo(this_3, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>' call
  xy(this_4, 0.0, 0.0).ma1(false);
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_5 = SolidRect.cbl(Size2D.f2i(cardSize, 3.0), borderColor);
  // Inline function 'kotlin.apply' call
  var this_6 = addTo(this_5, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>' call
  xy(this_6, 0.0, cardSize - 3).ma1(false);
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_7 = SolidRect.cbl(Size2D.f2i(3.0, cardSize), borderColor);
  // Inline function 'kotlin.apply' call
  var this_8 = addTo(this_7, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>' call
  xy(this_8, 0.0, 0.0).ma1(false);
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_9 = SolidRect.cbl(Size2D.f2i(3.0, cardSize), borderColor);
  // Inline function 'kotlin.apply' call
  var this_10 = addTo(this_9, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>' call
  xy(this_10, cardSize - 3, 0.0).ma1(false);
  // Inline function 'korlibs.korge.view.image' call
  var texture = upgrade.zc7_1;
  var anchor = Companion_getInstance_4().b29_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_11 = Image.kbi(texture, anchor);
  // Inline function 'kotlin.apply' call
  var this_12 = addTo(this_11, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>' call
  var iconSize = 48.0;
  position(this_12, (cardSize - iconSize) / 2, 8.0);
  scale(this_12, iconSize / 32.0);
  this_12.ma1(false);
  var titleText = upgrade.qc7_1;
  var maxCharsPerLine = 13;
  var isTwoLine = titleText.length > maxCharsPerLine;
  if (isTwoLine) {
    var words = split(titleText, [' ']);
    var line1 = '';
    var line2 = '';
    var currentLine = 1;
    var _iterator__ex2g4s = words.b1();
    while (_iterator__ex2g4s.c1()) {
      var word = _iterator__ex2g4s.d1();
      var tmp;
      // Inline function 'kotlin.text.isEmpty' call
      var this_13 = line1;
      if (charSequenceLength(this_13) === 0) {
        tmp = word;
      } else {
        tmp = line1 + ' ' + word;
      }
      var testLine = tmp;
      if (currentLine === 1 && testLine.length <= maxCharsPerLine) {
        line1 = testLine;
      } else {
        currentLine = 2;
        var tmp_0;
        // Inline function 'kotlin.text.isEmpty' call
        var this_14 = line2;
        if (charSequenceLength(this_14) === 0) {
          tmp_0 = word;
        } else {
          tmp_0 = line2 + ' ' + word;
        }
        line2 = tmp_0;
      }
    }
    var tmp_1;
    // Inline function 'kotlin.text.isEmpty' call
    var this_15 = line2;
    if (charSequenceLength(this_15) === 0) {
      tmp_1 = line1.length > maxCharsPerLine;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      line2 = line1.substring(maxCharsPerLine);
      line1 = take(line1, maxCharsPerLine);
    }
    // Inline function 'korlibs.korge.view.text' call
    var text = line1;
    var textSize = Companion_instance.gbp_1;
    var color = Colors_getInstance().g40_1;
    var font = get_DefaultTtfFontAsBitmap();
    var alignment = Companion_getInstance_2().l4o_1;
    var renderer = get_DefaultStringTextRenderer();
    var autoScaling = Companion_instance.hbp_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_16 = Text.lbp(text, numberToDouble(textSize), color, font, alignment, renderer, autoScaling, null, null);
    // Inline function 'kotlin.apply' call
    var this_17 = addTo(this_16, this_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>' call
    this_17.kbp(get_gameFont());
    position(this_17, 10.0, 54.0);
    this_17.dbl(Colors_getInstance().g40_1);
    this_17.obp(22.0);
    this_17.ma1(false);
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_18 = line2;
    if (charSequenceLength(this_18) > 0) {
      // Inline function 'korlibs.korge.view.text' call
      var text_0 = line2;
      var textSize_0 = Companion_instance.gbp_1;
      var color_0 = Colors_getInstance().g40_1;
      var font_0 = get_DefaultTtfFontAsBitmap();
      var alignment_0 = Companion_getInstance_2().l4o_1;
      var renderer_0 = get_DefaultStringTextRenderer();
      var autoScaling_0 = Companion_instance.hbp_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_19 = Text.lbp(text_0, numberToDouble(textSize_0), color_0, font_0, alignment_0, renderer_0, autoScaling_0, null, null);
      // Inline function 'kotlin.apply' call
      var this_20 = addTo(this_19, this_1);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>' call
      this_20.kbp(get_gameFont());
      position(this_20, 10.0, 72.0);
      this_20.dbl(Colors_getInstance().g40_1);
      this_20.obp(22.0);
      this_20.ma1(false);
    }
  } else {
    // Inline function 'korlibs.korge.view.text' call
    var textSize_1 = Companion_instance.gbp_1;
    var color_1 = Colors_getInstance().g40_1;
    var font_1 = get_DefaultTtfFontAsBitmap();
    var alignment_1 = Companion_getInstance_2().l4o_1;
    var renderer_1 = get_DefaultStringTextRenderer();
    var autoScaling_1 = Companion_instance.hbp_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_21 = Text.lbp(titleText, numberToDouble(textSize_1), color_1, font_1, alignment_1, renderer_1, autoScaling_1, null, null);
    // Inline function 'kotlin.apply' call
    var this_22 = addTo(this_21, this_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>' call
    this_22.kbp(get_gameFont());
    position(this_22, 10.0, 54.0);
    this_22.dbl(Colors_getInstance().g40_1);
    this_22.obp(22.0);
    this_22.ma1(false);
  }
  // Inline function 'korlibs.korge.view.text' call
  var text_1 = '' + currentLevel + '/' + maxLevel;
  var textSize_2 = Companion_instance.gbp_1;
  var color_2 = Colors_getInstance().g40_1;
  var font_2 = get_DefaultTtfFontAsBitmap();
  var alignment_2 = Companion_getInstance_2().l4o_1;
  var renderer_2 = get_DefaultStringTextRenderer();
  var autoScaling_2 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_23 = Text.lbp(text_1, numberToDouble(textSize_2), color_2, font_2, alignment_2, renderer_2, autoScaling_2, null, null);
  // Inline function 'kotlin.apply' call
  var this_24 = addTo(this_23, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>' call
  this_24.l9t_1 = 'levelText';
  this_24.kbp(get_gameFont());
  position(this_24, 12.0, 132.0);
  this_24.dbl(Colors_getInstance().c43_1);
  this_24.obp(22.0);
  this_24.ma1(false);
  if (currentLevel < maxLevel) {
    // Inline function 'korlibs.korge.view.text' call
    var text_2 = '' + cost + '\u2605';
    var textSize_3 = Companion_instance.gbp_1;
    var color_3 = Colors_getInstance().g40_1;
    var font_3 = get_DefaultTtfFontAsBitmap();
    var alignment_3 = Companion_getInstance_2().l4o_1;
    var renderer_3 = get_DefaultStringTextRenderer();
    var autoScaling_3 = Companion_instance.hbp_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_25 = Text.lbp(text_2, numberToDouble(textSize_3), color_3, font_3, alignment_3, renderer_3, autoScaling_3, null, null);
    // Inline function 'kotlin.apply' call
    var this_26 = addTo(this_25, this_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>' call
    this_26.l9t_1 = 'costText';
    this_26.kbp(get_gameFont());
    this_26.dbl(state.equals(UpgradeState_AVAILABLE_getInstance()) ? Colors_getInstance().w45_1 : Colors_getInstance().j41_1);
    this_26.obp(22.0);
    this_26.ma1(false);
    var costText = this_26;
    var costTextWidth = costText.rbp().m2a_1;
    position(costText, cardSize - costTextWidth - 12.0, 108.0);
  }
  // Inline function 'korlibs.korge.view.solidRect' call
  var color_4 = RGBA__withAd_impl_cralao(Colors_getInstance().h40_1, 0.0);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_27 = SolidRect.cbl(Size2D.f2i(cardSize, cardSize), color_4);
  // Inline function 'kotlin.apply' call
  var this_28 = addTo(this_27, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>' call
  position(this_28, 0.0, 0.0);
  var hoverArea = this_28;
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_29 = Container.za4(false);
  // Inline function 'kotlin.apply' call
  var this_30 = addTo(this_29, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>' call
  this_30.l9t_1 = 'tooltip_' + upgrade.pc7_1;
  this_30.i8q(false);
  position(this_30, cardSize + 5, -20.0);
  var tooltipWidth = 300.0;
  var tooltipHeight = 160.0;
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.korge.view.solidRect' call
  var color_5 = Colors_getInstance().y4f('#2a2a3e');
  // Inline function 'korlibs.korge.view.addTo' call
  var this_31 = SolidRect.cbl(Size2D.f2i(tooltipWidth, tooltipHeight), color_5);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>.<anonymous>' call
  addTo(this_31, this_30).ma1(false);
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.korge.view.solidRect' call
  var color_6 = Colors_getInstance().g40_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_32 = SolidRect.cbl(Size2D.f2i(tooltipWidth, 2.0), color_6);
  // Inline function 'kotlin.apply' call
  var this_33 = addTo(this_32, this_30);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>.<anonymous>' call
  position(this_33, 0.0, 0.0).ma1(false);
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.korge.view.solidRect' call
  var color_7 = Colors_getInstance().g40_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_34 = SolidRect.cbl(Size2D.f2i(tooltipWidth, 2.0), color_7);
  // Inline function 'kotlin.apply' call
  var this_35 = addTo(this_34, this_30);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>.<anonymous>' call
  position(this_35, 0.0, tooltipHeight - 2).ma1(false);
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.korge.view.solidRect' call
  var color_8 = Colors_getInstance().g40_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_36 = SolidRect.cbl(Size2D.f2i(2.0, tooltipHeight), color_8);
  // Inline function 'kotlin.apply' call
  var this_37 = addTo(this_36, this_30);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>.<anonymous>' call
  position(this_37, 0.0, 0.0).ma1(false);
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.korge.view.solidRect' call
  var color_9 = Colors_getInstance().g40_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_38 = SolidRect.cbl(Size2D.f2i(2.0, tooltipHeight), color_9);
  // Inline function 'kotlin.apply' call
  var this_39 = addTo(this_38, this_30);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>.<anonymous>' call
  position(this_39, tooltipWidth - 2, 0.0).ma1(false);
  // Inline function 'korlibs.korge.view.text' call
  var text_3 = upgrade.qc7_1;
  var textSize_4 = Companion_instance.gbp_1;
  var color_10 = Colors_getInstance().g40_1;
  var font_4 = get_DefaultTtfFontAsBitmap();
  var alignment_4 = Companion_getInstance_2().l4o_1;
  var renderer_4 = get_DefaultStringTextRenderer();
  var autoScaling_4 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_40 = Text.lbp(text_3, numberToDouble(textSize_4), color_10, font_4, alignment_4, renderer_4, autoScaling_4, null, null);
  // Inline function 'kotlin.apply' call
  var this_41 = addTo(this_40, this_30);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>.<anonymous>' call
  this_41.kbp(get_gameFont());
  position(this_41, 10.0, 0.0);
  this_41.dbl(Colors_getInstance().g40_1);
  this_41.obp(30.0);
  this_41.ma1(false);
  var tmp_2;
  if (upgrade.rc7_1.length > 30) {
    var mid = upgrade.rc7_1.length / 2 | 0;
    // Inline function 'kotlin.takeIf' call
    var this_42 = indexOf(upgrade.rc7_1, _Char___init__impl__6a9atx(32), mid);
    // Inline function 'kotlin.contracts.contract' call
    var tmp_3;
    // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>.<anonymous>' call
    if (!(this_42 === -1)) {
      tmp_3 = this_42;
    } else {
      tmp_3 = null;
    }
    var tmp0_elvis_lhs = tmp_3;
    var splitIdx = tmp0_elvis_lhs == null ? mid : tmp0_elvis_lhs;
    // Inline function 'kotlin.text.trim' call
    var this_43 = take(upgrade.rc7_1, splitIdx);
    var tmp_4 = toString(trim(isCharSequence(this_43) ? this_43 : THROW_CCE()));
    // Inline function 'kotlin.text.trim' call
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    var this_44 = upgrade.rc7_1.substring(splitIdx);
    var tmp$ret$85 = toString(trim(isCharSequence(this_44) ? this_44 : THROW_CCE()));
    tmp_2 = listOf([tmp_4, tmp$ret$85]);
  } else {
    tmp_2 = listOf_0(upgrade.rc7_1);
  }
  var descLines = tmp_2;
  var iterator = descLines.b1();
  var index = 0;
  while (iterator.c1()) {
    var i = index;
    index = index + 1 | 0;
    var line = iterator.d1();
    // Inline function 'korlibs.korge.view.text' call
    var textSize_5 = Companion_instance.gbp_1;
    var color_11 = Colors_getInstance().g40_1;
    var font_5 = get_DefaultTtfFontAsBitmap();
    var alignment_5 = Companion_getInstance_2().l4o_1;
    var renderer_5 = get_DefaultStringTextRenderer();
    var autoScaling_5 = Companion_instance.hbp_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_45 = Text.lbp(line, numberToDouble(textSize_5), color_11, font_5, alignment_5, renderer_5, autoScaling_5, null, null);
    // Inline function 'kotlin.apply' call
    var this_46 = addTo(this_45, this_30);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>.<anonymous>' call
    this_46.kbp(get_gameFont());
    position(this_46, 10.0, 29.0 + i * 24.0);
    this_46.dbl(Colors_getInstance().c43_1);
    this_46.obp(24.0);
    this_46.ma1(false);
  }
  if (currentLevel < maxLevel) {
    // Inline function 'korlibs.korge.view.text' call
    var text_4 = Localization_getInstance().hi('cost') + ' ' + cost;
    var textSize_6 = Companion_instance.gbp_1;
    var color_12 = Colors_getInstance().g40_1;
    var font_6 = get_DefaultTtfFontAsBitmap();
    var alignment_6 = Companion_getInstance_2().l4o_1;
    var renderer_6 = get_DefaultStringTextRenderer();
    var autoScaling_6 = Companion_instance.hbp_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_47 = Text.lbp(text_4, numberToDouble(textSize_6), color_12, font_6, alignment_6, renderer_6, autoScaling_6, null, null);
    // Inline function 'kotlin.apply' call
    var this_48 = addTo(this_47, this_30);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>.<anonymous>' call
    this_48.l9t_1 = 'tooltipCostText';
    this_48.kbp(get_gameFont());
    position(this_48, 10.0, 77.0);
    this_48.dbl(Colors_getInstance().w45_1);
    this_48.obp(24.0);
    this_48.ma1(false);
    var valueString = upgrade.wc7_1;
    if (!(valueString == null)) {
      var currentValue = valueString($this.wc8_1, currentLevel);
      var nextValue = currentLevel < maxLevel ? valueString($this.wc8_1, currentLevel + 1 | 0) : null;
      // Inline function 'korlibs.korge.view.text' call
      var text_5 = currentValue + ' -> ' + nextValue;
      var textSize_7 = Companion_instance.gbp_1;
      var color_13 = Colors_getInstance().g40_1;
      var font_7 = get_DefaultTtfFontAsBitmap();
      var alignment_7 = Companion_getInstance_2().l4o_1;
      var renderer_7 = get_DefaultStringTextRenderer();
      var autoScaling_7 = Companion_instance.hbp_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_49 = Text.lbp(text_5, numberToDouble(textSize_7), color_13, font_7, alignment_7, renderer_7, autoScaling_7, null, null);
      // Inline function 'kotlin.apply' call
      var this_50 = addTo(this_49, this_30);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>.<anonymous>' call
      this_50.l9t_1 = 'valueText';
      this_50.kbp(get_gameFont());
      position(this_50, 10.0, 103.0);
      this_50.dbl(Colors_getInstance().c43_1);
      this_50.obp(24.0);
      this_50.ma1(false);
    }
    // Inline function 'korlibs.korge.view.text' call
    var text_6 = Localization_getInstance().hi('level') + ' ' + currentLevel + ' / ' + maxLevel;
    var textSize_8 = Companion_instance.gbp_1;
    var color_14 = Colors_getInstance().g40_1;
    var font_8 = get_DefaultTtfFontAsBitmap();
    var alignment_8 = Companion_getInstance_2().l4o_1;
    var renderer_8 = get_DefaultStringTextRenderer();
    var autoScaling_8 = Companion_instance.hbp_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_51 = Text.lbp(text_6, numberToDouble(textSize_8), color_14, font_8, alignment_8, renderer_8, autoScaling_8, null, null);
    // Inline function 'kotlin.apply' call
    var this_52 = addTo(this_51, this_30);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>.<anonymous>' call
    this_52.l9t_1 = 'tooltipLevelText';
    this_52.kbp(get_gameFont());
    position(this_52, 10.0, 130.0);
    this_52.dbl(Colors_getInstance().c43_1);
    this_52.obp(24.0);
    this_52.ma1(false);
  } else {
    // Inline function 'korlibs.korge.view.text' call
    var text_7 = Localization_getInstance().hi('max_level');
    var textSize_9 = Companion_instance.gbp_1;
    var color_15 = Colors_getInstance().g40_1;
    var font_9 = get_DefaultTtfFontAsBitmap();
    var alignment_9 = Companion_getInstance_2().l4o_1;
    var renderer_9 = get_DefaultStringTextRenderer();
    var autoScaling_9 = Companion_instance.hbp_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_53 = Text.lbp(text_7, numberToDouble(textSize_9), color_15, font_9, alignment_9, renderer_9, autoScaling_9, null, null);
    // Inline function 'kotlin.apply' call
    var this_54 = addTo(this_53, this_30);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>.<anonymous>' call
    this_54.kbp(get_gameFont());
    position(this_54, 10.0, 130.0);
    this_54.dbl(Colors_getInstance().l42_1);
    this_54.obp(24.0);
    this_54.ma1(false);
  }
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'UpgradeTreeScene.createUpgradeCard.<anonymous>.<anonymous>' call
  this_30.ma1(false);
  this_30.qaj(false);
  this_30.kak();
  var tooltip = this_30;
  // Inline function 'korlibs.korge.input.onOver' call
  var handler = UpgradeTreeScene$createUpgradeCard$lambda(this_1, cardSize, tooltip, $this);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop = over$factory_3();
  var tmp1_safe_receiver = hoverArea == null ? null : hoverArea.gai();
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < tmp1_safe_receiver.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var tmp0_safe_receiver = tmp1_safe_receiver.e1(_unary__edvuaz);
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_5 = prop.get(tmp1_safe_receiver_0);
        tmp_5.q20(UpgradeTreeScene$createUpgradeCard$lambda_0(handler));
      }
    }
  }
  // Inline function 'korlibs.korge.input.onOut' call
  var handler_0 = UpgradeTreeScene$createUpgradeCard$lambda_1(tooltip);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_0 = out$factory_3();
  var tmp1_safe_receiver_1 = hoverArea == null ? null : hoverArea.gai();
  if (tmp1_safe_receiver_1 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_0 = 0;
    while (n_0 < tmp1_safe_receiver_1.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var tmp0_safe_receiver_0 = tmp1_safe_receiver_1.e1(_unary__edvuaz_0);
      var tmp1_safe_receiver_2 = tmp0_safe_receiver_0 == null ? null : get_mouse(tmp0_safe_receiver_0);
      if (tmp1_safe_receiver_2 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_6 = prop_0.get(tmp1_safe_receiver_2);
        tmp_6.q20(UpgradeTreeScene$createUpgradeCard$lambda_2(handler_0));
      }
    }
  }
  if (state.equals(UpgradeState_AVAILABLE_getInstance()) && currentLevel < maxLevel) {
    // Inline function 'korlibs.korge.input.onClick' call
    var handler_1 = UpgradeTreeScene$createUpgradeCard$lambda_3(upgrade, $this);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop_1 = click$factory_9();
    var tmp1_safe_receiver_3 = this_1 == null ? null : this_1.gai();
    if (tmp1_safe_receiver_3 == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n_1 = 0;
      while (n_1 < tmp1_safe_receiver_3.f1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz_1 = n_1;
        n_1 = _unary__edvuaz_1 + 1 | 0;
        var tmp0_safe_receiver_1 = tmp1_safe_receiver_3.e1(_unary__edvuaz_1);
        var tmp1_safe_receiver_4 = tmp0_safe_receiver_1 == null ? null : get_mouse(tmp0_safe_receiver_1);
        if (tmp1_safe_receiver_4 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_7 = prop_1.get(tmp1_safe_receiver_4);
          tmp_7.q20(UpgradeTreeScene$createUpgradeCard$lambda_4(handler_1));
        }
      }
    }
  }
  // Inline function 'korlibs.korge.input.mouse' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  var $this$mouse = get_mouse(this_1);
  // Inline function 'korlibs.korge.input.MouseEvents.onDown' call
  var handler_2 = UpgradeTreeScene$createUpgradeCard$slambda_3();
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
  var tmp_8 = down$factory_0().get($this$mouse);
  tmp_8.q20(UpgradeTreeScene$createUpgradeCard$lambda_5($this$mouse, handler_2));
  // Inline function 'korlibs.korge.input.MouseEvents.onUp' call
  var handler_3 = UpgradeTreeScene$createUpgradeCard$slambda_4();
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
  var tmp_9 = up$factory_0().get($this$mouse);
  tmp_9.q20(UpgradeTreeScene$createUpgradeCard$lambda_6($this$mouse, handler_3));
  // Inline function 'korlibs.korge.input.MouseEvents.onMove' call
  var handler_4 = UpgradeTreeScene$createUpgradeCard$slambda_5($this);
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
  var tmp_10 = move$factory_0().get($this$mouse);
  tmp_10.q20(UpgradeTreeScene$createUpgradeCard$lambda_7($this$mouse, handler_4));
  var dragStartX = 0.0;
  var dragStartY = 0.0;
  var cardStartX = 0.0;
  var cardStartY = 0.0;
  var animationJob = null;
  var tmp_11 = $this.ka1();
  animationJob = launch(tmp_11, VOID, VOID, UpgradeTreeScene$createUpgradeCard$slambda_6(this_1, $this));
  var card = this_1;
  return card;
}
function *_generator_updateUpgradeStates__37nztt(_this__u8e3s4, $this, $completion) {
  var centerX = 600.0;
  var centerY = 300.0;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterIsInstance' call
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var this_0 = _this__u8e3s4.sa4_1;
  var destination = ArrayList.j1();
  var tmp0_iterator = this_0.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    if (element instanceof Container) {
      destination.h(element);
    }
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList.j1();
  var tmp0_iterator_0 = destination.b1();
  while (tmp0_iterator_0.c1()) {
    var element_0 = tmp0_iterator_0.d1();
    // Inline function 'UpgradeTreeScene.updateUpgradeStates.<anonymous>' call
    var tmp0_safe_receiver = element_0.l9t_1;
    if ((tmp0_safe_receiver == null ? null : startsWith(tmp0_safe_receiver, 'upgrade_')) === true) {
      destination_0.h(element_0);
    }
  }
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_1 = ArrayList.j1();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_1 = destination_0.b1();
  while (tmp0_iterator_1.c1()) {
    var element_1 = tmp0_iterator_1.d1();
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'UpgradeTreeScene.updateUpgradeStates.<anonymous>' call
    var tmp0_safe_receiver_0 = element_1.l9t_1;
    var tmp0_safe_receiver_1 = tmp0_safe_receiver_0 == null ? null : removePrefix(tmp0_safe_receiver_0, 'upgrade_');
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination_1.h(tmp0_safe_receiver_1);
    }
  }
  var existingCardIds = toSet(destination_1);
  var _iterator__ex2g4s = _this__u8e3s4.sa4_1.b1();
  $l$loop: while (_iterator__ex2g4s.c1()) {
    var child = _iterator__ex2g4s.d1();
    println('Updating ' + child.l9t_1);
    var tmp;
    if (child instanceof Container) {
      var tmp6_safe_receiver = child.l9t_1;
      tmp = (tmp6_safe_receiver == null ? null : startsWith(tmp6_safe_receiver, 'upgrade_')) === true;
    } else {
      tmp = false;
    }
    if (tmp) {
      println('Can update ' + child.l9t_1);
      var tmp0_safe_receiver_2 = child.l9t_1;
      var upgradeId = tmp0_safe_receiver_2 == null ? null : removePrefix(tmp0_safe_receiver_2, 'upgrade_');
      // Inline function 'kotlin.collections.find' call
      var this_1 = $this.cc9_1;
      var tmp$ret$10;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator_2 = this_1.b1();
        while (tmp0_iterator_2.c1()) {
          var element_2 = tmp0_iterator_2.d1();
          // Inline function 'UpgradeTreeScene.updateUpgradeStates.<anonymous>' call
          if (element_2.pc7_1 === upgradeId) {
            tmp$ret$10 = element_2;
            break $l$block;
          }
        }
        tmp$ret$10 = null;
      }
      var tmp1_elvis_lhs = tmp$ret$10;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var upgrade = tmp_0;
      var state = getUpgradeState($this, upgrade);
      var _destruct__k2r9zo = getTierColor($this, upgrade.pc7_1, state);
      var cardColor = _destruct__k2r9zo.nl().a4g_1;
      var borderColor = _destruct__k2r9zo.ol().a4g_1;
      // Inline function 'kotlin.collections.filterIsInstance' call
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var this_2 = child.sa4_1;
      var destination_2 = ArrayList.j1();
      var tmp0_iterator_3 = this_2.b1();
      while (tmp0_iterator_3.c1()) {
        var element_3 = tmp0_iterator_3.d1();
        if (element_3 instanceof SolidRect) {
          destination_2.h(element_3);
        }
      }
      var backgrounds = destination_2;
      if (backgrounds.f1() >= 5) {
        backgrounds.e1(0).dbl(cardColor);
        backgrounds.e1(1).dbl(borderColor);
        backgrounds.e1(2).dbl(borderColor);
        backgrounds.e1(3).dbl(borderColor);
        backgrounds.e1(4).dbl(borderColor);
      }
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_3 = child.sa4_1;
      var destination_3 = ArrayList.j1();
      var tmp0_iterator_4 = this_3.b1();
      while (tmp0_iterator_4.c1()) {
        var element_4 = tmp0_iterator_4.d1();
        // Inline function 'UpgradeTreeScene.updateUpgradeStates.<anonymous>' call
        var tmp_1;
        if (element_4 instanceof Text) {
          tmp_1 = equals(element_4.k28(), child);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          destination_3.h(element_4);
        }
      }
      var tmp_2 = destination_3;
      var texts = isInterface(tmp_2, KtList) ? tmp_2 : THROW_CCE();
      var valueString = upgrade.wc7_1;
      var currentLevel = $this.ac9_1 ? upgrade.tc7_1($this.wc8_1) : upgrade.sc7_1($this.wc8_1);
      var maxLevel = upgrade.tc7_1($this.wc8_1);
      var cost = upgrade.uc7_1($this.wc8_1);
      // Inline function 'kotlin.collections.find' call
      var tmp$ret$18;
      $l$block_0: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator_5 = texts.b1();
        while (tmp0_iterator_5.c1()) {
          var element_5 = tmp0_iterator_5.d1();
          // Inline function 'UpgradeTreeScene.updateUpgradeStates.<anonymous>' call
          if (element_5.l9t_1 === 'levelText') {
            tmp$ret$18 = element_5;
            break $l$block_0;
          }
        }
        tmp$ret$18 = null;
      }
      var levelText = tmp$ret$18;
      if (!(levelText == null)) {
        levelText.mbp('' + currentLevel + '/' + maxLevel);
      }
      // Inline function 'kotlin.collections.find' call
      var tmp$ret$21;
      $l$block_1: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator_6 = texts.b1();
        while (tmp0_iterator_6.c1()) {
          var element_6 = tmp0_iterator_6.d1();
          // Inline function 'UpgradeTreeScene.updateUpgradeStates.<anonymous>' call
          if (element_6.l9t_1 === 'costText') {
            tmp$ret$21 = element_6;
            break $l$block_1;
          }
        }
        tmp$ret$21 = null;
      }
      var costText = tmp$ret$21;
      if (currentLevel < maxLevel && !(costText == null)) {
        costText.mbp('' + cost + '\u2605');
        costText.dbl(state.equals(UpgradeState_AVAILABLE_getInstance()) ? Colors_getInstance().w45_1 : Colors_getInstance().j41_1);
        // Inline function 'kotlin.collections.filterIsInstance' call
        // Inline function 'kotlin.collections.filterIsInstanceTo' call
        var this_4 = child.sa4_1;
        var destination_4 = ArrayList.j1();
        var tmp0_iterator_7 = this_4.b1();
        while (tmp0_iterator_7.c1()) {
          var element_7 = tmp0_iterator_7.d1();
          if (element_7 instanceof SolidRect) {
            destination_4.h(element_7);
          }
        }
        var backgrounds_0 = destination_4;
        var tmp2_safe_receiver = firstOrNull(backgrounds_0);
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.d2m();
        var cardWidth = tmp3_elvis_lhs == null ? 128.0 : tmp3_elvis_lhs;
        var costTextWidth = costText.rbp().m2a_1;
        position(costText, cardWidth - costTextWidth - 12.0, 108.0);
      }
      var tmp4_safe_receiver = $this.ic9_1;
      var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.sa4_1;
      var tmp_3;
      if (tmp5_safe_receiver == null) {
        tmp_3 = null;
      } else {
        // Inline function 'kotlin.collections.find' call
        var tmp$ret$26;
        $l$block_2: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator_8 = tmp5_safe_receiver.b1();
          while (tmp0_iterator_8.c1()) {
            var element_8 = tmp0_iterator_8.d1();
            // Inline function 'UpgradeTreeScene.updateUpgradeStates.<anonymous>' call
            if (element_8.l9t_1 === 'tooltip_' + upgrade.pc7_1) {
              tmp$ret$26 = element_8;
              break $l$block_2;
            }
          }
          tmp$ret$26 = null;
        }
        tmp_3 = tmp$ret$26;
      }
      var tmp_4 = tmp_3;
      var tooltip = tmp_4 instanceof Container ? tmp_4 : null;
      if (!(tooltip == null)) {
        // Inline function 'kotlin.collections.find' call
        var this_5 = tooltip.sa4_1;
        var tmp$ret$29;
        $l$block_3: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator_9 = this_5.b1();
          while (tmp0_iterator_9.c1()) {
            var element_9 = tmp0_iterator_9.d1();
            // Inline function 'UpgradeTreeScene.updateUpgradeStates.<anonymous>' call
            if (element_9.l9t_1 === 'tooltipLevelText') {
              tmp$ret$29 = element_9;
              break $l$block_3;
            }
          }
          tmp$ret$29 = null;
        }
        var tmp_5 = tmp$ret$29;
        var tooltipLevelText = tmp_5 instanceof Text ? tmp_5 : null;
        if (!(tooltipLevelText == null)) {
          tooltipLevelText.mbp(Localization_getInstance().hi('level') + ' ' + currentLevel + ' / ' + maxLevel);
        }
        // Inline function 'kotlin.collections.find' call
        var this_6 = tooltip.sa4_1;
        var tmp$ret$32;
        $l$block_4: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator_10 = this_6.b1();
          while (tmp0_iterator_10.c1()) {
            var element_10 = tmp0_iterator_10.d1();
            // Inline function 'UpgradeTreeScene.updateUpgradeStates.<anonymous>' call
            if (element_10.l9t_1 === 'tooltipCostText') {
              tmp$ret$32 = element_10;
              break $l$block_4;
            }
          }
          tmp$ret$32 = null;
        }
        var tmp_6 = tmp$ret$32;
        var tooltipCostText = tmp_6 instanceof Text ? tmp_6 : null;
        if (!(tooltipCostText == null)) {
          tooltipCostText.mbp(Localization_getInstance().hi('cost') + ' ' + cost);
        }
        var valueString_0 = upgrade.wc7_1;
        // Inline function 'kotlin.collections.find' call
        var this_7 = tooltip.sa4_1;
        var tmp$ret$35;
        $l$block_5: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator_11 = this_7.b1();
          while (tmp0_iterator_11.c1()) {
            var element_11 = tmp0_iterator_11.d1();
            // Inline function 'UpgradeTreeScene.updateUpgradeStates.<anonymous>' call
            if (element_11.l9t_1 === 'valueText') {
              tmp$ret$35 = element_11;
              break $l$block_5;
            }
          }
          tmp$ret$35 = null;
        }
        var tmp_7 = tmp$ret$35;
        var valueText = tmp_7 instanceof Text ? tmp_7 : null;
        if (!(valueString_0 == null) && !(valueText == null)) {
          var currentValue = valueString_0($this.wc8_1, currentLevel);
          var nextValue = currentLevel < maxLevel ? valueString_0($this.wc8_1, currentLevel + 1 | 0) : null;
          valueText.mbp(currentValue + ' -> ' + nextValue);
        }
      }
    }
  }
  var _iterator__ex2g4s_0 = $this.cc9_1.b1();
  $l$loop_0: while (_iterator__ex2g4s_0.c1()) {
    var upgrade_0 = _iterator__ex2g4s_0.d1();
    var state_0 = getUpgradeState($this, upgrade_0);
    if (state_0.equals(UpgradeState_LOCKED_getInstance()) || existingCardIds.x2(upgrade_0.pc7_1))
      continue $l$loop_0;
    var angleRad = upgrade_0.ac8_1 * 3.141592653589793 / 180.0;
    // Inline function 'kotlin.math.cos' call
    var tmp$ret$37 = Math.cos(angleRad);
    var x = centerX + upgrade_0.bc8_1 * tmp$ret$37;
    // Inline function 'kotlin.math.sin' call
    var tmp$ret$38 = Math.sin(angleRad);
    var y = centerY + upgrade_0.bc8_1 * tmp$ret$38;
    var tmp_8 = createUpgradeCard(_this__u8e3s4, $this, x, y, upgrade_0, state_0, $completion);
    if (tmp_8 === get_COROUTINE_SUSPENDED())
      tmp_8 = yield tmp_8;
    var card = tmp_8;
    // Inline function 'kotlin.collections.set' call
    var this_8 = $this.lc9_1;
    var key = upgrade_0.pc7_1;
    this_8.h3(key, card);
  }
  return Unit_instance;
}
function updateUpgradeStates(_this__u8e3s4, $this, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_updateUpgradeStates__37nztt.bind(VOID, _this__u8e3s4, $this), $completion);
}
function UpgradeTreeScene$_init_$lambda_z068sn() {
  return Unit_instance;
}
function UpgradeTreeScene$refreshUpgradeTree$slambda_0(this$0, $tc) {
  var i = new UpgradeTreeScene$refreshUpgradeTree$slambda(this$0, $tc);
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function UpgradeTreeScene$setupScreen$lambda(this$0, $starLayers, $layerScrolls, $renderedWidth, $renderedHeight, $marginX, $marginY) {
  return function ($this$addUpdater, dt) {
    var tmp;
    if (!this$0.pc9_1) {
      var index = 0;
      var tmp0_iterator = $starLayers.b1();
      while (tmp0_iterator.c1()) {
        var item = tmp0_iterator.d1();
        // Inline function 'UpgradeTreeScene.setupScreen.<anonymous>.<anonymous>' call
        var tmp1 = index;
        index = tmp1 + 1 | 0;
        var index_0 = checkIndexOverflow(tmp1);
        var image = item.nl();
        var velocity = item.ol();
        var _destruct__k2r9zo = $layerScrolls.e1(index_0);
        var scrollX = _destruct__k2r9zo.nl();
        var scrollY = _destruct__k2r9zo.ol();
        var velX = velocity.nl();
        var velY = velocity.ol();
        var newScrollX = scrollX + velX * get_seconds(dt.qj_1);
        var newScrollY = scrollY + velY * get_seconds(dt.qj_1);
        var wrappedX = newScrollX % $renderedWidth;
        var wrappedY = newScrollY % $renderedHeight;
        image.tai(-$marginX + wrappedX);
        image.uai(-$marginY + wrappedY);
        $layerScrolls.o3(index_0, new Pair(newScrollX, newScrollY));
      }
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function UpgradeTreeScene$setupScreen$lambda_0($frameCount, $fpsAccumulator, this$0) {
  return function ($this$addUpdater, dt) {
    var _unary__edvuaz = $frameCount._v;
    $frameCount._v = _unary__edvuaz + 1 | 0;
    $fpsAccumulator._v = $fpsAccumulator._v + get_seconds(dt.qj_1);
    var tmp;
    if ($fpsAccumulator._v >= 0.5) {
      var fps = $frameCount._v / $fpsAccumulator._v;
      var tmp0_safe_receiver = this$0.nc9_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.mbp(Localization_getInstance().hi('fps') + ' ' + roundDecimalPlaces(fps, 0));
      }
      $frameCount._v = 0;
      $fpsAccumulator._v = 0.0;
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function UpgradeTreeScene$setupScreen$slambda_3(this$0, $isDragging, $dragStartX, $dragStartY, $containerStartX, $tc, $containerStartY) {
  var i = new UpgradeTreeScene$setupScreen$slambda(this$0, $isDragging, $dragStartX, $dragStartY, $containerStartX, $tc, $containerStartY);
  var l = function (it, $completion) {
    return i.pca(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function UpgradeTreeScene$setupScreen$lambda$slambda_3($handler, $it) {
  var i = new UpgradeTreeScene$setupScreen$lambda$slambda($handler, $it);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function UpgradeTreeScene$setupScreen$lambda_1($this, $handler) {
  return function (it) {
    var tmp = $this.na1();
    launchImmediately(tmp, UpgradeTreeScene$setupScreen$lambda$slambda_3($handler, it));
    return Unit_instance;
  };
}
function UpgradeTreeScene$setupScreen$slambda_4($isDragging, this$0) {
  var i = new UpgradeTreeScene$setupScreen$slambda_0($isDragging, this$0);
  var l = function (it, $completion) {
    return i.pca(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function UpgradeTreeScene$setupScreen$lambda$slambda_4($handler, $it) {
  var i = new UpgradeTreeScene$setupScreen$lambda$slambda_0($handler, $it);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function UpgradeTreeScene$setupScreen$lambda_2($this, $handler) {
  return function (it) {
    var tmp = $this.na1();
    launchImmediately(tmp, UpgradeTreeScene$setupScreen$lambda$slambda_4($handler, it));
    return Unit_instance;
  };
}
function UpgradeTreeScene$setupScreen$slambda_5($isDragging, this$0) {
  var i = new UpgradeTreeScene$setupScreen$slambda_1($isDragging, this$0);
  var l = function (it, $completion) {
    return i.pca(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function UpgradeTreeScene$setupScreen$lambda$slambda_5($handler, $it) {
  var i = new UpgradeTreeScene$setupScreen$lambda$slambda_1($handler, $it);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function UpgradeTreeScene$setupScreen$lambda_3($this, $handler) {
  return function (it) {
    var tmp = $this.na1();
    launchImmediately(tmp, UpgradeTreeScene$setupScreen$lambda$slambda_5($handler, it));
    return Unit_instance;
  };
}
function UpgradeTreeScene$setupScreen$slambda_6($isDragging, this$0, $dragStartX, $dragStartY, $tc, $containerStartX, $containerStartY) {
  var i = new UpgradeTreeScene$setupScreen$slambda_2($isDragging, this$0, $dragStartX, $dragStartY, $tc, $containerStartX, $containerStartY);
  var l = function (it, $completion) {
    return i.pca(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function UpgradeTreeScene$setupScreen$lambda$slambda_6($handler, $it) {
  var i = new UpgradeTreeScene$setupScreen$lambda$slambda_2($handler, $it);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function UpgradeTreeScene$setupScreen$lambda_4($this, $handler) {
  return function (it) {
    var tmp = $this.na1();
    launchImmediately(tmp, UpgradeTreeScene$setupScreen$lambda$slambda_6($handler, it));
    return Unit_instance;
  };
}
function UpgradeTreeScene$setupScreen$lambda_5($tc, this$0) {
  return function (it) {
    var zoomFactor = it.ta1() > 0 ? 0.9 : 1.1;
    var newScale = coerceIn($tc.xai() * zoomFactor, 0.5, 2.0);
    var mouseX = it.oa1().a2a_1;
    var mouseY = it.oa1().b2a_1;
    var oldWorldX = (mouseX - $tc.b6j()) / $tc.xai();
    var oldWorldY = (mouseY - $tc.c6j()) / $tc.xai();
    $tc.wai(newScale);
    this$0.gc9_1 = newScale;
    var newWorldX = (mouseX - $tc.b6j()) / $tc.xai();
    var newWorldY = (mouseY - $tc.c6j()) / $tc.xai();
    var _receiver__tnumb7 = $tc;
    _receiver__tnumb7.tai(_receiver__tnumb7.b6j() + (newWorldX - oldWorldX) * $tc.xai());
    var _receiver__tnumb7_0 = $tc;
    _receiver__tnumb7_0.uai(_receiver__tnumb7_0.c6j() + (newWorldY - oldWorldY) * $tc.xai());
    this$0.ec9_1 = $tc.b6j();
    this$0.fc9_1 = $tc.c6j();
    return Unit_instance;
  };
}
function UpgradeTreeScene$setupScreen$lambda_6($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function UpgradeTreeScene$setupScreen$lambda_7(this$0) {
  return function (it) {
    set_treeViewX(this$0.ec9_1);
    set_treeViewY(this$0.fc9_1);
    set_treeViewScale(this$0.gc9_1);
    this$0.ka1().k9r_1 = Colors_getInstance().y4f('#2b2b2b');
    this$0.yc8_1(this$0.xc8_1);
    return Unit_instance;
  };
}
function UpgradeTreeScene$setupScreen$lambda_8($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function UpgradeTreeScene$setupScreen$lambda_9($btnBg, $bgHoverColor) {
  return function (it) {
    $btnBg.dbl($bgHoverColor);
    return Unit_instance;
  };
}
function UpgradeTreeScene$setupScreen$lambda_10($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function UpgradeTreeScene$setupScreen$lambda_11($btnBg, $bgColor) {
  return function (it) {
    $btnBg.dbl($bgColor);
    return Unit_instance;
  };
}
function UpgradeTreeScene$setupScreen$lambda_12($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function UpgradeTreeScene$setupUpgrades$slambda_0(this$0, $centerX, $centerY) {
  var i = new UpgradeTreeScene$setupUpgrades$slambda(this$0, $centerX, $centerY);
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function UpgradeTreeScene$createUpgradeCard$lambda($$this$container, $cardSize, $tooltip, this$0) {
  return function (it) {
    var cardScreenPos = $$this$container.gak(Vector2D.k2c($cardSize, 0.0));
    position($tooltip, cardScreenPos.a2a_1 + 10, cardScreenPos.b2a_1);
    var tmp0_safe_receiver = this$0.ic9_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.xah($tooltip);
    }
    $tooltip.i8q(true);
    return Unit_instance;
  };
}
function UpgradeTreeScene$createUpgradeCard$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function UpgradeTreeScene$createUpgradeCard$lambda_1($tooltip) {
  return function (it) {
    $tooltip.kak();
    return Unit_instance;
  };
}
function UpgradeTreeScene$createUpgradeCard$lambda_2($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function UpgradeTreeScene$createUpgradeCard$lambda$slambda_3() {
  var i = new UpgradeTreeScene$createUpgradeCard$lambda$slambda();
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function UpgradeTreeScene$createUpgradeCard$lambda_3($upgrade, this$0) {
  return function (it) {
    var currentCost = $upgrade.uc7_1(this$0.wc8_1);
    var tmp;
    if (this$0.xc8_1 >= currentCost && $upgrade.vc7_1(this$0.wc8_1, this$0.xc8_1) && $upgrade.yc7_1(this$0.wc8_1)) {
      this$0.xc8_1 = this$0.xc8_1 - currentCost;
      var tmp_0 = this$0.ka1();
      launch(tmp_0, VOID, VOID, UpgradeTreeScene$createUpgradeCard$lambda$slambda_3());
      refreshUpgradeTree(this$0);
      tmp = this$0.zc8_1();
    }
    it.ra1();
    return Unit_instance;
  };
}
function UpgradeTreeScene$createUpgradeCard$lambda_4($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function UpgradeTreeScene$createUpgradeCard$slambda_3() {
  var i = new UpgradeTreeScene$createUpgradeCard$slambda();
  var l = function (it, $completion) {
    return i.pca(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function UpgradeTreeScene$createUpgradeCard$lambda$slambda_4($handler, $it) {
  var i = new UpgradeTreeScene$createUpgradeCard$lambda$slambda_0($handler, $it);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function UpgradeTreeScene$createUpgradeCard$lambda_5($this, $handler) {
  return function (it) {
    var tmp = $this.na1();
    launchImmediately(tmp, UpgradeTreeScene$createUpgradeCard$lambda$slambda_4($handler, it));
    return Unit_instance;
  };
}
function UpgradeTreeScene$createUpgradeCard$slambda_4() {
  var i = new UpgradeTreeScene$createUpgradeCard$slambda_0();
  var l = function (it, $completion) {
    return i.pca(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function UpgradeTreeScene$createUpgradeCard$lambda$slambda_5($handler, $it) {
  var i = new UpgradeTreeScene$createUpgradeCard$lambda$slambda_1($handler, $it);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function UpgradeTreeScene$createUpgradeCard$lambda_6($this, $handler) {
  return function (it) {
    var tmp = $this.na1();
    launchImmediately(tmp, UpgradeTreeScene$createUpgradeCard$lambda$slambda_5($handler, it));
    return Unit_instance;
  };
}
function UpgradeTreeScene$createUpgradeCard$slambda_5(this$0) {
  var i = new UpgradeTreeScene$createUpgradeCard$slambda_1(this$0);
  var l = function (it, $completion) {
    return i.pca(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function UpgradeTreeScene$createUpgradeCard$lambda$slambda_6($handler, $it) {
  var i = new UpgradeTreeScene$createUpgradeCard$lambda$slambda_2($handler, $it);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function UpgradeTreeScene$createUpgradeCard$lambda_7($this, $handler) {
  return function (it) {
    var tmp = $this.na1();
    launchImmediately(tmp, UpgradeTreeScene$createUpgradeCard$lambda$slambda_6($handler, it));
    return Unit_instance;
  };
}
function UpgradeTreeScene$createUpgradeCard$slambda_6($$this$container, this$0) {
  var i = new UpgradeTreeScene$createUpgradeCard$slambda_2($$this$container, this$0);
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function UpgradeState_LOCKED_getInstance() {
  UpgradeState_initEntries();
  return UpgradeState_LOCKED_instance;
}
function UpgradeState_UNAVAILABLE_getInstance() {
  UpgradeState_initEntries();
  return UpgradeState_UNAVAILABLE_instance;
}
function UpgradeState_AVAILABLE_getInstance() {
  UpgradeState_initEntries();
  return UpgradeState_AVAILABLE_instance;
}
function down$factory() {
  return getPropertyCallableRef('down', 1, KProperty1, function (receiver) {
    return receiver.w9z_1;
  }, null);
}
function up$factory() {
  return getPropertyCallableRef('up', 1, KProperty1, function (receiver) {
    return receiver.z9z_1;
  }, null);
}
function upAnywhere$factory() {
  return getPropertyCallableRef('upAnywhere', 1, KProperty1, function (receiver) {
    return receiver.da0_1;
  }, null);
}
function move$factory() {
  return getPropertyCallableRef('move', 1, KProperty1, function (receiver) {
    return receiver.ea0_1;
  }, null);
}
function scroll$factory_0() {
  return getPropertyCallableRef('scroll', 1, KProperty1, function (receiver) {
    return receiver.ia0_1;
  }, null);
}
function click$factory_8() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.t9z_1;
  }, null);
}
function over$factory_2() {
  return getPropertyCallableRef('over', 1, KProperty1, function (receiver) {
    return receiver.u9z_1;
  }, null);
}
function out$factory_2() {
  return getPropertyCallableRef('out', 1, KProperty1, function (receiver) {
    return receiver.v9z_1;
  }, null);
}
function over$factory_3() {
  return getPropertyCallableRef('over', 1, KProperty1, function (receiver) {
    return receiver.u9z_1;
  }, null);
}
function out$factory_3() {
  return getPropertyCallableRef('out', 1, KProperty1, function (receiver) {
    return receiver.v9z_1;
  }, null);
}
function click$factory_9() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.t9z_1;
  }, null);
}
function down$factory_0() {
  return getPropertyCallableRef('down', 1, KProperty1, function (receiver) {
    return receiver.w9z_1;
  }, null);
}
function up$factory_0() {
  return getPropertyCallableRef('up', 1, KProperty1, function (receiver) {
    return receiver.z9z_1;
  }, null);
}
function move$factory_0() {
  return getPropertyCallableRef('move', 1, KProperty1, function (receiver) {
    return receiver.ea0_1;
  }, null);
}
function createAllUpgrades() {
  // Inline function 'kotlin.collections.mutableListOf' call
  var upgrades = ArrayList.j1();
  var tmp = Localization_getInstance().hi('upgrade_start');
  var tmp_0 = Localization_getInstance().hi('upgrade_start_desc');
  var tmp_1 = createAllUpgrades$lambda;
  var tmp_2 = createAllUpgrades$lambda_0;
  var tmp_3 = createAllUpgrades$lambda_1;
  var tmp_4 = createAllUpgrades$lambda_2;
  var tmp_5 = emptyList();
  upgrades.h(new UpgradeDefinition('start', tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, VOID, tmp_5, createAllUpgrades$lambda_3, createStartIcon(), -105.8, 672.0));
  var tmp_6 = Localization_getInstance().hi('upgrade_collision_cooldown');
  var tmp_7 = Localization_getInstance().hi('upgrade_collision_cooldown_desc');
  var tmp_8 = createAllUpgrades$lambda_4;
  var tmp_9 = createAllUpgrades$lambda_5;
  var tmp_10 = createAllUpgrades$lambda_6;
  var tmp_11 = createAllUpgrades$lambda_7;
  var tmp_12 = createAllUpgrades$lambda_8;
  var tmp_13 = listOf_0('start');
  upgrades.h(new UpgradeDefinition('collision_cooldown', tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, createAllUpgrades$lambda_9, createClockIcon(), -62.6, 686.7));
  var tmp_14 = Localization_getInstance().hi('upgrade_adult_age');
  var tmp_15 = Localization_getInstance().hi('upgrade_adult_age_desc');
  var tmp_16 = createAllUpgrades$lambda_10;
  var tmp_17 = createAllUpgrades$lambda_11;
  var tmp_18 = createAllUpgrades$lambda_12;
  var tmp_19 = createAllUpgrades$lambda_13;
  var tmp_20 = createAllUpgrades$lambda_14;
  var tmp_21 = listOf_0('start');
  upgrades.h(new UpgradeDefinition('adult_age', tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, createAllUpgrades$lambda_15, createGrowthIcon(), -142.2, 840.0));
  var tmp_22 = Localization_getInstance().hi('upgrade_max_speed');
  var tmp_23 = Localization_getInstance().hi('upgrade_max_speed_desc');
  var tmp_24 = createAllUpgrades$lambda_16;
  var tmp_25 = createAllUpgrades$lambda_17;
  var tmp_26 = createAllUpgrades$lambda_18;
  var tmp_27 = createAllUpgrades$lambda_19;
  var tmp_28 = createAllUpgrades$lambda_20;
  var tmp_29 = listOf_0('start');
  upgrades.h(new UpgradeDefinition('max_speed', tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, tmp_28, tmp_29, createAllUpgrades$lambda_21, createSpeedIcon(), -95.6, 473.8));
  var tmp_30 = Localization_getInstance().hi('upgrade_starting_population');
  var tmp_31 = Localization_getInstance().hi('upgrade_starting_population_desc');
  var tmp_32 = createAllUpgrades$lambda_22;
  var tmp_33 = createAllUpgrades$lambda_23;
  var tmp_34 = createAllUpgrades$lambda_24;
  var tmp_35 = createAllUpgrades$lambda_25;
  var tmp_36 = createAllUpgrades$lambda_26;
  var tmp_37 = listOf(['collision_cooldown', 'max_speed']);
  upgrades.h(new UpgradeDefinition('starting_population', tmp_30, tmp_31, tmp_32, tmp_33, tmp_34, tmp_35, tmp_36, tmp_37, createAllUpgrades$lambda_27, createStartingPopulationIcon(), -38.4, 632.7));
  var tmp_38 = Localization_getInstance().hi('upgrade_birth_bonus');
  var tmp_39 = Localization_getInstance().hi('upgrade_birth_bonus_desc');
  var tmp_40 = createAllUpgrades$lambda_28;
  var tmp_41 = createAllUpgrades$lambda_29;
  var tmp_42 = createAllUpgrades$lambda_30;
  var tmp_43 = createAllUpgrades$lambda_31;
  var tmp_44 = createAllUpgrades$lambda_32;
  var tmp_45 = listOf_0('max_population');
  upgrades.h(new UpgradeDefinition('birth_bonus', tmp_38, tmp_39, tmp_40, tmp_41, tmp_42, tmp_43, tmp_44, tmp_45, createAllUpgrades$lambda_33, createBirthIcon(), -81.8, 233.8));
  var tmp_46 = Localization_getInstance().hi('upgrade_movement_efficiency');
  var tmp_47 = Localization_getInstance().hi('upgrade_movement_efficiency_desc');
  var tmp_48 = createAllUpgrades$lambda_34;
  var tmp_49 = createAllUpgrades$lambda_35;
  var tmp_50 = createAllUpgrades$lambda_36;
  var tmp_51 = createAllUpgrades$lambda_37;
  var tmp_52 = createAllUpgrades$lambda_38;
  var tmp_53 = listOf_0('max_speed');
  upgrades.h(new UpgradeDefinition('movement_efficiency', tmp_46, tmp_47, tmp_48, tmp_49, tmp_50, tmp_51, tmp_52, tmp_53, createAllUpgrades$lambda_39, createEfficiencyIcon(), -123.1, 411.5));
  var tmp_54 = Localization_getInstance().hi('upgrade_fertility_rate');
  var tmp_55 = Localization_getInstance().hi('upgrade_fertility_rate_desc');
  var tmp_56 = createAllUpgrades$lambda_40;
  var tmp_57 = createAllUpgrades$lambda_41;
  var tmp_58 = createAllUpgrades$lambda_42;
  var tmp_59 = createAllUpgrades$lambda_43;
  var tmp_60 = createAllUpgrades$lambda_44;
  var tmp_61 = listOf_0('collision_cooldown');
  upgrades.h(new UpgradeDefinition('fertility_rate', tmp_54, tmp_55, tmp_56, tmp_57, tmp_58, tmp_59, tmp_60, tmp_61, createAllUpgrades$lambda_45, createFertilityIcon(), -50.4, 1012.3));
  var tmp_62 = Localization_getInstance().hi('upgrade_lifespan');
  var tmp_63 = Localization_getInstance().hi('upgrade_lifespan_desc');
  var tmp_64 = createAllUpgrades$lambda_46;
  var tmp_65 = createAllUpgrades$lambda_47;
  var tmp_66 = createAllUpgrades$lambda_48;
  var tmp_67 = createAllUpgrades$lambda_49;
  var tmp_68 = createAllUpgrades$lambda_50;
  var tmp_69 = listOf_0('adult_age');
  upgrades.h(new UpgradeDefinition('lifespan', tmp_62, tmp_63, tmp_64, tmp_65, tmp_66, tmp_67, tmp_68, tmp_69, createAllUpgrades$lambda_51, createLifespanIcon(), -155.9, 1088.7));
  var tmp_70 = Localization_getInstance().hi('upgrade_gender_balance');
  var tmp_71 = Localization_getInstance().hi('upgrade_gender_balance_desc');
  var tmp_72 = createAllUpgrades$lambda_52;
  var tmp_73 = createAllUpgrades$lambda_53;
  var tmp_74 = createAllUpgrades$lambda_54;
  var tmp_75 = createAllUpgrades$lambda_55;
  var tmp_76 = createAllUpgrades$lambda_56;
  var tmp_77 = listOf(['starting_population', 'fertility_rate']);
  upgrades.h(new UpgradeDefinition('gender_balance', tmp_70, tmp_71, tmp_72, tmp_73, tmp_74, tmp_75, tmp_76, tmp_77, createAllUpgrades$lambda_57, createGenderIcon(), -23.6, 782.6));
  var tmp_78 = Localization_getInstance().hi('upgrade_collision_range');
  var tmp_79 = Localization_getInstance().hi('upgrade_collision_range_desc');
  var tmp_80 = createAllUpgrades$lambda_58;
  var tmp_81 = createAllUpgrades$lambda_59;
  var tmp_82 = createAllUpgrades$lambda_60;
  var tmp_83 = createAllUpgrades$lambda_61;
  var tmp_84 = createAllUpgrades$lambda_62;
  var tmp_85 = listOf_0('movement_efficiency');
  upgrades.h(new UpgradeDefinition('collision_range', tmp_78, tmp_79, tmp_80, tmp_81, tmp_82, tmp_83, tmp_84, tmp_85, createAllUpgrades$lambda_63, createRangeIcon(), -165.7, 586.0));
  var tmp_86 = Localization_getInstance().hi('upgrade_fertility_age');
  var tmp_87 = Localization_getInstance().hi('upgrade_fertility_age_desc');
  var tmp_88 = createAllUpgrades$lambda_64;
  var tmp_89 = createAllUpgrades$lambda_65;
  var tmp_90 = createAllUpgrades$lambda_66;
  var tmp_91 = createAllUpgrades$lambda_67;
  var tmp_92 = createAllUpgrades$lambda_68;
  var tmp_93 = listOf(['lifespan', 'fertility_rate']);
  upgrades.h(new UpgradeDefinition('fertility_age', tmp_86, tmp_87, tmp_88, tmp_89, tmp_90, tmp_91, tmp_92, tmp_93, createAllUpgrades$lambda_69, createFertilityAgeIcon(), -132.4, 1054.3));
  var tmp_94 = Localization_getInstance().hi('upgrade_auto_spawn');
  var tmp_95 = Localization_getInstance().hi('upgrade_auto_spawn_desc');
  var tmp_96 = createAllUpgrades$lambda_70;
  var tmp_97 = createAllUpgrades$lambda_71;
  var tmp_98 = createAllUpgrades$lambda_72;
  var tmp_99 = createAllUpgrades$lambda_73;
  var tmp_100 = createAllUpgrades$lambda_74;
  var tmp_101 = listOf_0('gender_balance');
  upgrades.h(new UpgradeDefinition('auto_spawn', tmp_94, tmp_95, tmp_96, tmp_97, tmp_98, tmp_99, tmp_100, tmp_101, createAllUpgrades$lambda_75, createAutoSpawnIcon(), 5.6, 805.3));
  var tmp_102 = Localization_getInstance().hi('upgrade_auto_spawn_rate');
  var tmp_103 = Localization_getInstance().hi('upgrade_auto_spawn_rate_desc');
  var tmp_104 = createAllUpgrades$lambda_76;
  var tmp_105 = createAllUpgrades$lambda_77;
  var tmp_106 = createAllUpgrades$lambda_78;
  var tmp_107 = createAllUpgrades$lambda_79;
  var tmp_108 = createAllUpgrades$lambda_80;
  var tmp_109 = listOf_0('auto_spawn');
  upgrades.h(new UpgradeDefinition('auto_spawn_rate', tmp_102, tmp_103, tmp_104, tmp_105, tmp_106, tmp_107, tmp_108, tmp_109, createAllUpgrades$lambda_81, createSpawnRateIcon(), 27.6, 737.0));
  var tmp_110 = Localization_getInstance().hi('upgrade_score_multiplier');
  var tmp_111 = Localization_getInstance().hi('upgrade_score_multiplier_desc');
  var tmp_112 = createAllUpgrades$lambda_82;
  var tmp_113 = createAllUpgrades$lambda_83;
  var tmp_114 = createAllUpgrades$lambda_84;
  var tmp_115 = createAllUpgrades$lambda_85;
  var tmp_116 = createAllUpgrades$lambda_86;
  var tmp_117 = listOf_0('birth_bonus');
  upgrades.h(new UpgradeDefinition('score_multiplier', tmp_110, tmp_111, tmp_112, tmp_113, tmp_114, tmp_115, tmp_116, tmp_117, createAllUpgrades$lambda_87, createScoreIcon(), 38.1, 238.4));
  var tmp_118 = Localization_getInstance().hi('upgrade_time_acceleration');
  var tmp_119 = Localization_getInstance().hi('upgrade_time_acceleration_desc');
  var tmp_120 = createAllUpgrades$lambda_88;
  var tmp_121 = createAllUpgrades$lambda_89;
  var tmp_122 = createAllUpgrades$lambda_90;
  var tmp_123 = createAllUpgrades$lambda_91;
  var tmp_124 = createAllUpgrades$lambda_92;
  var tmp_125 = listOf(['lifespan', 'collision_range']);
  upgrades.h(new UpgradeDefinition('time_acceleration', tmp_118, tmp_119, tmp_120, tmp_121, tmp_122, tmp_123, tmp_124, tmp_125, createAllUpgrades$lambda_93, createTimeIcon(), 168.7, 1043.8));
  var tmp_126 = Localization_getInstance().hi('upgrade_mass_reproduction');
  var tmp_127 = Localization_getInstance().hi('upgrade_mass_reproduction_desc');
  var tmp_128 = createAllUpgrades$lambda_94;
  var tmp_129 = createAllUpgrades$lambda_95;
  var tmp_130 = createAllUpgrades$lambda_96;
  var tmp_131 = createAllUpgrades$lambda_97;
  var tmp_132 = createAllUpgrades$lambda_98;
  var tmp_133 = listOf(['auto_spawn_rate', 'score_multiplier']);
  upgrades.h(new UpgradeDefinition('mass_reproduction', tmp_126, tmp_127, tmp_128, tmp_129, tmp_130, tmp_131, tmp_132, tmp_133, createAllUpgrades$lambda_99, createMassReproIcon(), 57.6, 544.5));
  var tmp_134 = Localization_getInstance().hi('upgrade_evolution_bonus');
  var tmp_135 = Localization_getInstance().hi('upgrade_evolution_bonus_desc');
  var tmp_136 = createAllUpgrades$lambda_100;
  var tmp_137 = createAllUpgrades$lambda_101;
  var tmp_138 = createAllUpgrades$lambda_102;
  var tmp_139 = createAllUpgrades$lambda_103;
  var tmp_140 = createAllUpgrades$lambda_104;
  var tmp_141 = listOf(['time_acceleration', 'mass_reproduction', 'star_speed_mega']);
  upgrades.h(new UpgradeDefinition('evolution_bonus', tmp_134, tmp_135, tmp_136, tmp_137, tmp_138, tmp_139, tmp_140, tmp_141, createAllUpgrades$lambda_105, createEvolutionIcon(), 123.0, 804.2));
  var tmp_142 = Localization_getInstance().hi('upgrade_ultra_speed');
  var tmp_143 = Localization_getInstance().hi('upgrade_ultra_speed_desc');
  var tmp_144 = createAllUpgrades$lambda_106;
  var tmp_145 = createAllUpgrades$lambda_107;
  var tmp_146 = createAllUpgrades$lambda_108;
  var tmp_147 = createAllUpgrades$lambda_109;
  var tmp_148 = createAllUpgrades$lambda_110;
  var tmp_149 = listOf(['max_speed', 'movement_efficiency']);
  upgrades.h(new UpgradeDefinition('ultra_speed', tmp_142, tmp_143, tmp_144, tmp_145, tmp_146, tmp_147, tmp_148, tmp_149, createAllUpgrades$lambda_111, createUltraSpeedIcon(), -136.3, 603.3));
  var tmp0_name = Localization_getInstance().hi('upgrade_instant_maturity');
  var tmp1_description = Localization_getInstance().hi('upgrade_instant_maturity_desc');
  var tmp2_prerequisites = listOf(['adult_age', 'lifespan']);
  var tmp3_icon = createInstantMaturityIcon();
  var tmp4_angle = -163.0;
  var tmp_150 = createAllUpgrades$lambda_112;
  var tmp_151 = createAllUpgrades$lambda_113;
  var tmp_152 = createAllUpgrades$lambda_114;
  var tmp_153 = createAllUpgrades$lambda_115;
  var tmp_154 = createAllUpgrades$lambda_116;
  upgrades.h(new UpgradeDefinition('instant_maturity', tmp0_name, tmp1_description, tmp_150, tmp_151, tmp_152, tmp_153, tmp_154, tmp2_prerequisites, createAllUpgrades$lambda_117, tmp3_icon, tmp4_angle, 814.7));
  var tmp5_name = Localization_getInstance().hi('upgrade_mega_population');
  var tmp6_description = Localization_getInstance().hi('upgrade_mega_population_desc');
  var tmp7_prerequisites = listOf(['max_population', 'score_multiplier']);
  var tmp8_icon = createMegaPopulationIcon();
  var tmp9_angle = -14.4;
  var tmp_155 = createAllUpgrades$lambda_118;
  var tmp_156 = createAllUpgrades$lambda_119;
  var tmp_157 = createAllUpgrades$lambda_120;
  var tmp_158 = createAllUpgrades$lambda_121;
  var tmp_159 = createAllUpgrades$lambda_122;
  upgrades.h(new UpgradeDefinition('mega_population', tmp5_name, tmp6_description, tmp_155, tmp_156, tmp_157, tmp_158, tmp_159, tmp7_prerequisites, createAllUpgrades$lambda_123, tmp8_icon, tmp9_angle, 308.8));
  var tmp10_name = Localization_getInstance().hi('upgrade_infinite_population');
  var tmp11_description = Localization_getInstance().hi('upgrade_infinite_population_desc');
  var tmp12_prerequisites = listOf(['reproduction_frenzy', 'cosmic_convergence']);
  var tmp13_icon = createInfinitePopulationIcon();
  var tmp_160 = createAllUpgrades$lambda_124;
  var tmp_161 = createAllUpgrades$lambda_125;
  var tmp_162 = createAllUpgrades$lambda_126;
  var tmp_163 = createAllUpgrades$lambda_127;
  var tmp_164 = createAllUpgrades$lambda_128;
  upgrades.h(new UpgradeDefinition('infinite_population', tmp10_name, tmp11_description, tmp_160, tmp_161, tmp_162, tmp_163, tmp_164, tmp12_prerequisites, createAllUpgrades$lambda_129, tmp13_icon, 63.2, 962.1));
  var tmp_165 = Localization_getInstance().hi('upgrade_fertility_explosion');
  var tmp_166 = Localization_getInstance().hi('upgrade_fertility_explosion_desc');
  var tmp_167 = createAllUpgrades$lambda_130;
  var tmp_168 = createAllUpgrades$lambda_131;
  var tmp_169 = createAllUpgrades$lambda_132;
  var tmp_170 = createAllUpgrades$lambda_133;
  var tmp_171 = listOf(['fertility_rate', 'gender_balance']);
  upgrades.h(new UpgradeDefinition('fertility_explosion', tmp_165, tmp_166, tmp_167, tmp_168, tmp_169, tmp_170, VOID, tmp_171, createAllUpgrades$lambda_134, createFertilityExplosionIcon(), -5.1, 1035.4));
  var tmp14_name = Localization_getInstance().hi('upgrade_score_ascension');
  var tmp15_description = Localization_getInstance().hi('upgrade_score_ascension_desc');
  var tmp16_prerequisites = listOf(['score_multiplier', 'birth_bonus']);
  var tmp17_icon = createScoreAscensionIcon();
  var tmp_172 = createAllUpgrades$lambda_135;
  var tmp_173 = createAllUpgrades$lambda_136;
  var tmp_174 = createAllUpgrades$lambda_137;
  var tmp_175 = createAllUpgrades$lambda_138;
  var tmp_176 = createAllUpgrades$lambda_139;
  upgrades.h(new UpgradeDefinition('score_ascension', tmp14_name, tmp15_description, tmp_172, tmp_173, tmp_174, tmp_175, tmp_176, tmp16_prerequisites, createAllUpgrades$lambda_140, tmp17_icon, 131.1, 123.8));
  var tmp18_name = Localization_getInstance().hi('upgrade_time_dilation');
  var tmp19_description = Localization_getInstance().hi('upgrade_time_dilation_desc');
  var tmp20_prerequisites = listOf(['time_acceleration', 'evolution_bonus']);
  var tmp21_icon = createTimeDilationIcon();
  var tmp_177 = createAllUpgrades$lambda_141;
  var tmp_178 = createAllUpgrades$lambda_142;
  var tmp_179 = createAllUpgrades$lambda_143;
  var tmp_180 = createAllUpgrades$lambda_144;
  var tmp_181 = createAllUpgrades$lambda_145;
  upgrades.h(new UpgradeDefinition('time_dilation', tmp18_name, tmp19_description, tmp_177, tmp_178, tmp_179, tmp_180, tmp_181, tmp20_prerequisites, createAllUpgrades$lambda_146, tmp21_icon, 120.1, 1074.6));
  var tmp22_name = Localization_getInstance().hi('upgrade_reproduction_frenzy');
  var tmp23_description = Localization_getInstance().hi('upgrade_reproduction_frenzy_desc');
  var tmp24_prerequisites = listOf(['mass_reproduction', 'fertility_explosion', 'auto_spawn_rate']);
  var tmp25_icon = createReproductionFrenzyIcon();
  var tmp_182 = createAllUpgrades$lambda_147;
  var tmp_183 = createAllUpgrades$lambda_148;
  var tmp_184 = createAllUpgrades$lambda_149;
  var tmp_185 = createAllUpgrades$lambda_150;
  var tmp_186 = createAllUpgrades$lambda_151;
  upgrades.h(new UpgradeDefinition('reproduction_frenzy', tmp22_name, tmp23_description, tmp_182, tmp_183, tmp_184, tmp_185, tmp_186, tmp24_prerequisites, createAllUpgrades$lambda_152, tmp25_icon, 33.1, 986.0));
  var tmp26_name = Localization_getInstance().hi('upgrade_cosmic_convergence');
  var tmp27_description = Localization_getInstance().hi('upgrade_cosmic_convergence_desc');
  var tmp28_prerequisites = listOf(['evolution_bonus', 'reproduction_frenzy']);
  var tmp29_icon = createCosmicConvergenceIcon();
  var tmp_187 = createAllUpgrades$lambda_153;
  var tmp_188 = createAllUpgrades$lambda_154;
  var tmp_189 = createAllUpgrades$lambda_155;
  var tmp_190 = createAllUpgrades$lambda_156;
  var tmp_191 = createAllUpgrades$lambda_157;
  upgrades.h(new UpgradeDefinition('cosmic_convergence', tmp26_name, tmp27_description, tmp_187, tmp_188, tmp_189, tmp_190, tmp_191, tmp28_prerequisites, createAllUpgrades$lambda_158, tmp29_icon, 78.0, 696.2));
  var tmp30_name = Localization_getInstance().hi('upgrade_transcendence');
  var tmp31_description = Localization_getInstance().hi('upgrade_transcendence_desc');
  var tmp32_prerequisites = listOf(['infinite_population', 'time_dilation', 'cosmic_convergence']);
  var tmp33_icon = createTranscendenceIcon();
  var tmp_192 = createAllUpgrades$lambda_159;
  var tmp_193 = createAllUpgrades$lambda_160;
  var tmp_194 = createAllUpgrades$lambda_161;
  var tmp_195 = createAllUpgrades$lambda_162;
  var tmp_196 = createAllUpgrades$lambda_163;
  upgrades.h(new UpgradeDefinition('transcendence', tmp30_name, tmp31_description, tmp_192, tmp_193, tmp_194, tmp_195, tmp_196, tmp32_prerequisites, createAllUpgrades$lambda_164, tmp33_icon, 94.1, 977.6));
  var tmp_197 = Localization_getInstance().hi('upgrade_max_population');
  var tmp_198 = Localization_getInstance().hi('upgrade_max_population_desc');
  var tmp_199 = createAllUpgrades$lambda_165;
  var tmp_200 = createAllUpgrades$lambda_166;
  var tmp_201 = createAllUpgrades$lambda_167;
  var tmp_202 = createAllUpgrades$lambda_168;
  var tmp_203 = createAllUpgrades$lambda_169;
  var tmp_204 = listOf_0('starting_population');
  upgrades.h(new UpgradeDefinition('max_population', tmp_197, tmp_198, tmp_199, tmp_200, tmp_201, tmp_202, tmp_203, tmp_204, createAllUpgrades$lambda_170, createPopulationIcon(), -49.7, 414.7));
  var tmp34_name = Localization_getInstance().hi('upgrade_starting_population_boost');
  var tmp35_description = Localization_getInstance().hi('upgrade_starting_population_boost_desc');
  var tmp36_prerequisites = listOf(['starting_population', 'gender_balance']);
  var tmp37_icon = createStartingPopulationBoostIcon();
  var tmp38_angle = -5.4;
  var tmp_205 = createAllUpgrades$lambda_171;
  var tmp_206 = createAllUpgrades$lambda_172;
  var tmp_207 = createAllUpgrades$lambda_173;
  var tmp_208 = createAllUpgrades$lambda_174;
  var tmp_209 = createAllUpgrades$lambda_175;
  upgrades.h(new UpgradeDefinition('starting_population_boost', tmp34_name, tmp35_description, tmp_205, tmp_206, tmp_207, tmp_208, tmp_209, tmp36_prerequisites, createAllUpgrades$lambda_176, tmp37_icon, tmp38_angle, 553.3));
  var tmp39_name = Localization_getInstance().hi('upgrade_starting_population_mega');
  var tmp40_description = Localization_getInstance().hi('upgrade_starting_population_mega_desc');
  var tmp41_prerequisites = listOf_0('starting_population_boost');
  var tmp42_icon = createStartingPopulationMegaIcon();
  var tmp_210 = createAllUpgrades$lambda_177;
  var tmp_211 = createAllUpgrades$lambda_178;
  var tmp_212 = createAllUpgrades$lambda_179;
  var tmp_213 = createAllUpgrades$lambda_180;
  var tmp_214 = createAllUpgrades$lambda_181;
  upgrades.h(new UpgradeDefinition('starting_population_mega', tmp39_name, tmp40_description, tmp_210, tmp_211, tmp_212, tmp_213, tmp_214, tmp41_prerequisites, createAllUpgrades$lambda_182, tmp42_icon, 28.2, 480.6));
  var tmp_215 = Localization_getInstance().hi('upgrade_click_power');
  var tmp_216 = Localization_getInstance().hi('upgrade_click_power_desc');
  var tmp_217 = createAllUpgrades$lambda_183;
  var tmp_218 = createAllUpgrades$lambda_184;
  var tmp_219 = createAllUpgrades$lambda_185;
  var tmp_220 = createAllUpgrades$lambda_186;
  var tmp_221 = listOf_0('birth_bonus');
  upgrades.h(new UpgradeDefinition('click_power', tmp_215, tmp_216, tmp_217, tmp_218, tmp_219, tmp_220, VOID, tmp_221, createAllUpgrades$lambda_187, createClickPowerIcon(), -162.2, 316.8));
  var tmp43_name = Localization_getInstance().hi('upgrade_click_power_boost');
  var tmp44_description = Localization_getInstance().hi('upgrade_click_power_boost_desc');
  var tmp45_prerequisites = listOf(['click_power', 'birth_bonus']);
  var tmp46_icon = createClickPowerBoostIcon();
  var tmp_222 = createAllUpgrades$lambda_188;
  var tmp_223 = createAllUpgrades$lambda_189;
  var tmp_224 = createAllUpgrades$lambda_190;
  var tmp_225 = createAllUpgrades$lambda_191;
  var tmp_226 = createAllUpgrades$lambda_192;
  upgrades.h(new UpgradeDefinition('click_power_boost', tmp43_name, tmp44_description, tmp_222, tmp_223, tmp_224, tmp_225, tmp_226, tmp45_prerequisites, createAllUpgrades$lambda_193, tmp46_icon, 155.3, 387.4));
  var tmp47_name = Localization_getInstance().hi('upgrade_click_power_mega');
  var tmp48_description = Localization_getInstance().hi('upgrade_click_power_mega_desc');
  var tmp49_prerequisites = listOf(['click_power_boost', 'score_ascension']);
  var tmp50_icon = createClickPowerMegaIcon();
  var tmp_227 = createAllUpgrades$lambda_194;
  var tmp_228 = createAllUpgrades$lambda_195;
  var tmp_229 = createAllUpgrades$lambda_196;
  var tmp_230 = createAllUpgrades$lambda_197;
  var tmp_231 = createAllUpgrades$lambda_198;
  upgrades.h(new UpgradeDefinition('click_power_mega', tmp47_name, tmp48_description, tmp_227, tmp_228, tmp_229, tmp_230, tmp_231, tmp49_prerequisites, createAllUpgrades$lambda_199, tmp50_icon, 93.9, 368.1));
  var tmp51_name = Localization_getInstance().hi('upgrade_star_speed');
  var tmp52_description = Localization_getInstance().hi('upgrade_star_speed_desc');
  var tmp53_prerequisites = listOf_0('click_power');
  var tmp54_icon = createStarSpeedIcon();
  var tmp_232 = createAllUpgrades$lambda_200;
  var tmp_233 = createAllUpgrades$lambda_201;
  var tmp_234 = createAllUpgrades$lambda_202;
  var tmp_235 = createAllUpgrades$lambda_203;
  var tmp_236 = createAllUpgrades$lambda_204;
  upgrades.h(new UpgradeDefinition('star_speed', tmp51_name, tmp52_description, tmp_232, tmp_233, tmp_234, tmp_235, tmp_236, tmp53_prerequisites, createAllUpgrades$lambda_205, tmp54_icon, 167.6, 723.6));
  var tmp55_name = Localization_getInstance().hi('upgrade_star_speed_boost');
  var tmp56_description = Localization_getInstance().hi('upgrade_star_speed_boost_desc');
  var tmp57_prerequisites = listOf(['star_speed', 'click_power_boost']);
  var tmp58_icon = createStarSpeedBoostIcon();
  var tmp_237 = createAllUpgrades$lambda_206;
  var tmp_238 = createAllUpgrades$lambda_207;
  var tmp_239 = createAllUpgrades$lambda_208;
  var tmp_240 = createAllUpgrades$lambda_209;
  var tmp_241 = createAllUpgrades$lambda_210;
  upgrades.h(new UpgradeDefinition('star_speed_boost', tmp55_name, tmp56_description, tmp_237, tmp_238, tmp_239, tmp_240, tmp_241, tmp57_prerequisites, createAllUpgrades$lambda_211, tmp58_icon, 148.9, 666.2));
  var tmp59_name = Localization_getInstance().hi('upgrade_star_speed_mega');
  var tmp60_description = Localization_getInstance().hi('upgrade_star_speed_mega_desc');
  var tmp61_prerequisites = listOf(['star_speed_boost', 'click_power_mega']);
  var tmp62_icon = createStarSpeedMegaIcon();
  var tmp_242 = createAllUpgrades$lambda_212;
  var tmp_243 = createAllUpgrades$lambda_213;
  var tmp_244 = createAllUpgrades$lambda_214;
  var tmp_245 = createAllUpgrades$lambda_215;
  var tmp_246 = createAllUpgrades$lambda_216;
  upgrades.h(new UpgradeDefinition('star_speed_mega', tmp59_name, tmp60_description, tmp_242, tmp_243, tmp_244, tmp_245, tmp_246, tmp61_prerequisites, createAllUpgrades$lambda_217, tmp62_icon, 124.9, 533.3));
  return upgrades;
}
function createClockIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var clockColor = Companion_getInstance_1().x4f(100, 200, 255);
  var handColor = Companion_getInstance_1().x4f(255, 255, 255);
  var inductionVariable = 10;
  if (inductionVariable <= 22)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 10;
      if (inductionVariable_0 <= 22)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var dx = x - 16 | 0;
          var dy = y - 16 | 0;
          if ((imul(dx, dx) + imul(dy, dy) | 0) < 36) {
            bmp.o48(x, y, clockColor);
          }
        }
         while (inductionVariable_0 <= 22);
    }
     while (inductionVariable <= 22);
  var inductionVariable_1 = 0;
  if (inductionVariable_1 <= 4)
    do {
      var i = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      bmp.o48(16, 16 - i | 0, handColor);
    }
     while (inductionVariable_1 <= 4);
  var inductionVariable_2 = 0;
  if (inductionVariable_2 <= 6)
    do {
      var i_0 = inductionVariable_2;
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      bmp.o48(16 + i_0 | 0, 16, handColor);
    }
     while (inductionVariable_2 <= 6);
  return bmp;
}
function createGrowthIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(100, 255, 100);
  var inductionVariable = 8;
  if (inductionVariable <= 12)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var width = imul(y - 8 | 0, 2) + 1 | 0;
      var inductionVariable_0 = 16 - (width / 2 | 0) | 0;
      var last = 16 + (width / 2 | 0) | 0;
      if (inductionVariable_0 <= last)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          bmp.o48(x, 12 - (y - 8 | 0) | 0, color);
        }
         while (!(x === last));
    }
     while (inductionVariable <= 12);
  var inductionVariable_1 = 12;
  if (inductionVariable_1 <= 24)
    do {
      var y_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var inductionVariable_2 = 14;
      if (inductionVariable_2 <= 18)
        do {
          var x_0 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          bmp.o48(x_0, y_0, color);
        }
         while (inductionVariable_2 <= 18);
    }
     while (inductionVariable_1 <= 24);
  return bmp;
}
function createPopulationIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(255, 200, 100);
  createPopulationIcon$drawPerson(bmp, color, 10, 12);
  createPopulationIcon$drawPerson(bmp, color, 16, 8);
  createPopulationIcon$drawPerson(bmp, color, 22, 12);
  return bmp;
}
function createSpeedIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(255, 255, 100);
  var points = listOf([to(18, 6), to(14, 12), to(16, 12), to(12, 20), to(16, 14), to(14, 14)]);
  var inductionVariable = 6;
  if (inductionVariable <= 20)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 12;
      if (inductionVariable_0 <= 18)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var relY = y - 6 | 0;
          var relX = x - 12 | 0;
          if (relY < 6 && relX >= (6 - relY | 0) && relX <= 8 || (relY >= 6 && relY < 10 && relX >= (relY - 6 | 0) && relX <= (relY - 2 | 0)) || (relY >= 10 && relX >= (14 - relY | 0) && relX <= (18 - relY | 0))) {
            bmp.o48(x, y, color);
          }
        }
         while (inductionVariable_0 <= 18);
    }
     while (inductionVariable <= 20);
  return bmp;
}
function createStartIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(255, 215, 0);
  var centerX = 16;
  var centerY = 16;
  var inductionVariable = 8;
  if (inductionVariable <= 24)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 8;
      if (inductionVariable_0 <= 24)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var dx = x - centerX | 0;
          var dy = y - centerY | 0;
          // Inline function 'kotlin.math.sqrt' call
          var x_0 = imul(dx, dx) + imul(dy, dy) | 0;
          var dist = Math.sqrt(x_0);
          // Inline function 'kotlin.math.atan2' call
          var angle = Math.atan2(dy, dx);
          var normalizedAngle = (angle + 3.141592653589793) / (2 * 3.141592653589793) * 10;
          var segment = numberToInt(normalizedAngle) % 2 | 0;
          if (dist < 8 && segment === 0) {
            bmp.o48(x, y, color);
          } else if (dist < 4) {
            bmp.o48(x, y, color);
          }
        }
         while (inductionVariable_0 <= 24);
    }
     while (inductionVariable <= 24);
  return bmp;
}
function createBirthIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(255, 200, 150);
  var inductionVariable = 8;
  if (inductionVariable <= 24)
    do {
      var x = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 16;
      if (inductionVariable_0 <= 22)
        do {
          var y = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (y === 22 || x === 8 || x === 24) {
            bmp.o48(x, y, color);
          }
        }
         while (inductionVariable_0 <= 22);
    }
     while (inductionVariable <= 24);
  var inductionVariable_1 = 12;
  if (inductionVariable_1 <= 15)
    do {
      var y_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var inductionVariable_2 = 13;
      if (inductionVariable_2 <= 19)
        do {
          var x_0 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          bmp.o48(x_0, y_0, color);
        }
         while (inductionVariable_2 <= 19);
    }
     while (inductionVariable_1 <= 15);
  return bmp;
}
function createEfficiencyIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(150, 255, 150);
  var cx = 16;
  var cy = 16;
  var inductionVariable = 10;
  if (inductionVariable <= 22)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 10;
      if (inductionVariable_0 <= 22)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var dx = x - cx | 0;
          var dy = y - cy | 0;
          // Inline function 'kotlin.math.sqrt' call
          var x_0 = imul(dx, dx) + imul(dy, dy) | 0;
          var dist = Math.sqrt(x_0);
          if (dist < 6.0 && dist > 3.0) {
            bmp.o48(x, y, color);
          }
        }
         while (inductionVariable_0 <= 22);
    }
     while (inductionVariable <= 22);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = listOf([to(16, 8), to(16, 24), to(8, 16), to(24, 16)]).b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'createEfficiencyIcon.<anonymous>' call
    var x_1 = element.nl();
    var y_0 = element.ol();
    bmp.o48(x_1, y_0, color);
    if (x_1 < 16) {
      bmp.o48(x_1 - 1 | 0, y_0, color);
    } else if (x_1 > 16) {
      bmp.o48(x_1 + 1 | 0, y_0, color);
    }
    if (y_0 < 16) {
      bmp.o48(x_1, y_0 - 1 | 0, color);
    } else if (y_0 > 16) {
      bmp.o48(x_1, y_0 + 1 | 0, color);
    }
  }
  return bmp;
}
function createFertilityIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(200, 100, 255);
  var inductionVariable = 10;
  if (inductionVariable <= 20)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 8;
      if (inductionVariable_0 <= 24)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var lx = x - 12 | 0;
          var rx = x - 20 | 0;
          var dy = y - 12 | 0;
          if (((imul(lx, lx) + imul(dy, dy) | 0) < 16 || (imul(rx, rx) + imul(dy, dy) | 0) < 16) && y < 20) {
            bmp.o48(x, y, color);
          } else if (y >= 16 && x >= (16 - (y - 16 | 0) | 0) && x <= (16 + (y - 16 | 0) | 0) && y < 21) {
            bmp.o48(x, y, color);
          }
        }
         while (inductionVariable_0 <= 24);
    }
     while (inductionVariable <= 20);
  return bmp;
}
function createGenderIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var blue = Companion_getInstance_1().x4f(100, 150, 255);
  var pink = Companion_getInstance_1().x4f(255, 100, 200);
  var inductionVariable = 12;
  if (inductionVariable <= 18)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 8;
      if (inductionVariable_0 <= 14)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var dx = x - 11 | 0;
          var dy = y - 15 | 0;
          if ((imul(dx, dx) + imul(dy, dy) | 0) < 9) {
            bmp.o48(x, y, blue);
          }
        }
         while (inductionVariable_0 <= 14);
    }
     while (inductionVariable <= 18);
  var inductionVariable_1 = 0;
  if (inductionVariable_1 <= 3)
    do {
      var i = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      bmp.o48(14 + i | 0, 9 - i | 0, blue);
      bmp.o48(15 + i | 0, 9 - i | 0, blue);
    }
     while (inductionVariable_1 <= 3);
  var inductionVariable_2 = 12;
  if (inductionVariable_2 <= 18)
    do {
      var y_0 = inductionVariable_2;
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      var inductionVariable_3 = 18;
      if (inductionVariable_3 <= 24)
        do {
          var x_0 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          var dx_0 = x_0 - 21 | 0;
          var dy_0 = y_0 - 15 | 0;
          if ((imul(dx_0, dx_0) + imul(dy_0, dy_0) | 0) < 9) {
            bmp.o48(x_0, y_0, pink);
          }
        }
         while (inductionVariable_3 <= 24);
    }
     while (inductionVariable_2 <= 18);
  var inductionVariable_4 = 19;
  if (inductionVariable_4 <= 23)
    do {
      var i_0 = inductionVariable_4;
      inductionVariable_4 = inductionVariable_4 + 1 | 0;
      bmp.o48(21, i_0, pink);
    }
     while (inductionVariable_4 <= 23);
  var inductionVariable_5 = 19;
  if (inductionVariable_5 <= 23)
    do {
      var i_1 = inductionVariable_5;
      inductionVariable_5 = inductionVariable_5 + 1 | 0;
      bmp.o48(i_1, 21, pink);
    }
     while (inductionVariable_5 <= 23);
  return bmp;
}
function createLifespanIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(180, 180, 180);
  var inductionVariable = 8;
  if (inductionVariable <= 24)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 10;
      if (inductionVariable_0 <= 22)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (y === 8 || y === 24) {
            bmp.o48(x, y, color);
          } else if (y < 16) {
            var width = (y - 8 | 0) / 2 | 0;
            if (x >= (16 - width | 0) && x <= (16 + width | 0)) {
              bmp.o48(x, y, color);
            }
          } else {
            var width_0 = (24 - y | 0) / 2 | 0;
            if (x >= (16 - width_0 | 0) && x <= (16 + width_0 | 0)) {
              bmp.o48(x, y, color);
            }
          }
        }
         while (inductionVariable_0 <= 22);
    }
     while (inductionVariable <= 24);
  return bmp;
}
function createRangeIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(100, 255, 255);
  var cx = 16;
  var cy = 16;
  var _iterator__ex2g4s = listOf([4, 8, 12]).b1();
  while (_iterator__ex2g4s.c1()) {
    var r = _iterator__ex2g4s.d1();
    var inductionVariable = 0;
    var last = getProgressionLastElement(0, 360, 10);
    if (inductionVariable <= last)
      do {
        var angle = inductionVariable;
        inductionVariable = inductionVariable + 10 | 0;
        var rad = angle * 3.141592653589793 / 180;
        // Inline function 'kotlin.math.cos' call
        var tmp$ret$0 = Math.cos(rad);
        var x = numberToInt(cx + r * tmp$ret$0);
        // Inline function 'kotlin.math.sin' call
        var tmp$ret$1 = Math.sin(rad);
        var y = numberToInt(cy + r * tmp$ret$1);
        if ((0 <= x ? x <= 31 : false) && (0 <= y ? y <= 31 : false)) {
          bmp.o48(x, y, color);
        }
      }
       while (!(angle === last));
  }
  bmp.o48(16, 16, color);
  return bmp;
}
function createFertilityAgeIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var youngColor = Companion_getInstance_1().x4f(100, 255, 100);
  var oldColor = Companion_getInstance_1().x4f(150, 150, 255);
  var inductionVariable = 4;
  if (inductionVariable <= 6)
    do {
      var x = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 10;
      if (inductionVariable_0 <= 14)
        do {
          var y = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          bmp.o48(x, y, youngColor);
        }
         while (inductionVariable_0 <= 14);
    }
     while (inductionVariable <= 6);
  bmp.o48(5, 8, youngColor);
  bmp.o48(5, 9, youngColor);
  var heart = listOf([to(8, 14), to(9, 13), to(10, 14), to(12, 14), to(13, 13), to(14, 14), to(11, 15), to(11, 16), to(11, 17), to(10, 16), to(12, 16)]);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = heart.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'createFertilityAgeIcon.<anonymous>' call
    var x_0 = element.nl();
    var y_0 = element.ol();
    if ((0 <= x_0 ? x_0 <= 31 : false) && (0 <= y_0 ? y_0 <= 31 : false)) {
      bmp.o48(x_0, y_0, Companion_getInstance_1().x4f(255, 100, 150));
    }
  }
  var inductionVariable_1 = 18;
  if (inductionVariable_1 <= 20)
    do {
      var x_1 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var inductionVariable_2 = 10;
      if (inductionVariable_2 <= 14)
        do {
          var y_1 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          bmp.o48(x_1, y_1, oldColor);
        }
         while (inductionVariable_2 <= 14);
    }
     while (inductionVariable_1 <= 20);
  bmp.o48(19, 8, oldColor);
  bmp.o48(19, 9, oldColor);
  var inductionVariable_3 = 22;
  if (inductionVariable_3 <= 28)
    do {
      var x_2 = inductionVariable_3;
      inductionVariable_3 = inductionVariable_3 + 1 | 0;
      bmp.o48(x_2, 12, Companion_getInstance_1().x4f(200, 200, 100));
    }
     while (inductionVariable_3 <= 28);
  bmp.o48(27, 11, Companion_getInstance_1().x4f(200, 200, 100));
  bmp.o48(27, 13, Companion_getInstance_1().x4f(200, 200, 100));
  return bmp;
}
function createAutoSpawnIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(255, 215, 100);
  var inductionVariable = 0;
  if (inductionVariable <= 10)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      bmp.o48(10 + i | 0, 22 - i | 0, color);
      bmp.o48(9 + i | 0, 22 - i | 0, color);
    }
     while (inductionVariable <= 10);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = listOf([to(18, 8), to(22, 10), to(20, 6), to(8, 18), to(6, 16)]).b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'createAutoSpawnIcon.<anonymous>' call
    var x = element.nl();
    var y = element.ol();
    bmp.o48(x, y, color);
    bmp.o48(x - 1 | 0, y, color);
    bmp.o48(x + 1 | 0, y, color);
    bmp.o48(x, y - 1 | 0, color);
    bmp.o48(x, y + 1 | 0, color);
  }
  return bmp;
}
function createSpawnRateIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(255, 150, 50);
  var _iterator__ex2g4s = listOf([0, 8, 16]).b1();
  while (_iterator__ex2g4s.c1()) {
    var offset = _iterator__ex2g4s.d1();
    var x = 8 + offset | 0;
    var inductionVariable = 8;
    if (inductionVariable <= 20)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (y < 16) {
          bmp.o48(x, y, color);
        } else {
          var width = (y - 16 | 0) / 2 | 0;
          if (abs((16 + offset | 0) - x | 0) <= width) {
            bmp.o48(x, y, color);
          }
        }
      }
       while (inductionVariable <= 20);
  }
  return bmp;
}
function createScoreIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(255, 215, 0);
  var cx = 16;
  var cy = 16;
  var inductionVariable = 8;
  if (inductionVariable <= 24)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 10;
      if (inductionVariable_0 <= 22)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var dx = x - cx | 0;
          var dy = y - cy | 0;
          if (imul(dx, dx) / 36.0 + imul(dy, dy) / 64.0 < 1.0) {
            bmp.o48(x, y, color);
          }
        }
         while (inductionVariable_0 <= 22);
    }
     while (inductionVariable <= 24);
  var dark = Companion_getInstance_1().x4f(200, 150, 0);
  var inductionVariable_1 = 12;
  if (inductionVariable_1 <= 20)
    do {
      var y_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      bmp.o48(16, y_0, dark);
    }
     while (inductionVariable_1 <= 20);
  var inductionVariable_2 = 13;
  if (inductionVariable_2 <= 19)
    do {
      var x_0 = inductionVariable_2;
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      var _iterator__ex2g4s = listOf([13, 16, 19]).b1();
      while (_iterator__ex2g4s.c1()) {
        var y_1 = _iterator__ex2g4s.d1();
        bmp.o48(x_0, y_1, dark);
      }
    }
     while (inductionVariable_2 <= 19);
  return bmp;
}
function createTimeIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(150, 100, 255);
  var cx = 16;
  var cy = 16;
  var inductionVariable = 10;
  if (inductionVariable <= 22)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 10;
      if (inductionVariable_0 <= 22)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var dx = x - cx | 0;
          var dy = y - cy | 0;
          if ((imul(dx, dx) + imul(dy, dy) | 0) < 36) {
            bmp.o48(x, y, color);
          }
        }
         while (inductionVariable_0 <= 22);
    }
     while (inductionVariable <= 22);
  var inductionVariable_1 = 0;
  if (inductionVariable_1 <= 4)
    do {
      var i = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      bmp.o48(18 + i | 0, 16 - (i / 2 | 0) | 0, Companion_getInstance_1().x4f(255, 255, 255));
      bmp.o48(18 + i | 0, 16 + (i / 2 | 0) | 0, Companion_getInstance_1().x4f(255, 255, 255));
    }
     while (inductionVariable_1 <= 4);
  return bmp;
}
function createMassReproIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(255, 180, 200);
  createMassReproIcon$drawSmallPerson(bmp, color, 6, 8);
  createMassReproIcon$drawSmallPerson(bmp, color, 14, 6);
  createMassReproIcon$drawSmallPerson(bmp, color, 22, 8);
  createMassReproIcon$drawSmallPerson(bmp, color, 10, 16);
  createMassReproIcon$drawSmallPerson(bmp, color, 18, 16);
  return bmp;
}
function createEvolutionIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(100, 255, 100);
  var inductionVariable = 6;
  if (inductionVariable <= 26)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var angle = y * 30.0;
      // Inline function 'kotlin.math.cos' call
      var x = angle * 3.141592653589793 / 180;
      var tmp$ret$0 = Math.cos(x);
      var x1 = numberToInt(16 + 6 * tmp$ret$0);
      // Inline function 'kotlin.math.cos' call
      var x_0 = angle * 3.141592653589793 / 180;
      var tmp$ret$1 = Math.cos(x_0);
      var x2 = numberToInt(16 - 6 * tmp$ret$1);
      if (0 <= x1 ? x1 <= 31 : false) {
        bmp.o48(x1, y, color);
      }
      if (0 <= x2 ? x2 <= 31 : false) {
        bmp.o48(x2, y, color);
      }
      if ((y % 4 | 0) === 0) {
        // Inline function 'kotlin.math.min' call
        var inductionVariable_0 = Math.min(x1, x2);
        // Inline function 'kotlin.math.max' call
        var last = Math.max(x1, x2);
        if (inductionVariable_0 <= last)
          do {
            var x_1 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            bmp.o48(x_1, y, color);
          }
           while (!(x_1 === last));
      }
    }
     while (inductionVariable <= 26);
  return bmp;
}
function createUltraSpeedIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(255, 100, 255);
  var _iterator__ex2g4s = listOf([-4, 4]).b1();
  while (_iterator__ex2g4s.c1()) {
    var offset = _iterator__ex2g4s.d1();
    var inductionVariable = 6;
    if (inductionVariable <= 20)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 12;
        if (inductionVariable_0 <= 18)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var relY = y - 6 | 0;
            var relX = (x - 12 | 0) + offset | 0;
            if (relY < 6 && relX >= (6 - relY | 0) && relX <= 8 || (relY >= 6 && relY < 10 && relX >= (relY - 6 | 0) && relX <= (relY - 2 | 0))) {
              var containsArg = x + offset | 0;
              if (0 <= containsArg ? containsArg <= 31 : false) {
                bmp.o48(x + offset | 0, y, color);
              }
            }
          }
           while (inductionVariable_0 <= 18);
      }
       while (inductionVariable <= 20);
  }
  return bmp;
}
function createInstantMaturityIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(255, 255, 100);
  var inductionVariable = 8;
  if (inductionVariable <= 24)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 11;
      if (inductionVariable_0 <= 21)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (y < 14) {
            var dx = x - 16 | 0;
            var dy = y - 11 | 0;
            if ((imul(dx, dx) + imul(dy, dy) | 0) < 9) {
              bmp.o48(x, y, color);
            }
          } else {
            if (x >= 13 && x <= 19) {
              bmp.o48(x, y, color);
            }
          }
        }
         while (inductionVariable_0 <= 21);
    }
     while (inductionVariable <= 24);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = listOf([to(8, 8), to(24, 8), to(8, 24), to(24, 24)]).b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'createInstantMaturityIcon.<anonymous>' call
    var x_0 = element.nl();
    var y_0 = element.ol();
    bmp.o48(x_0, y_0, color);
    bmp.o48(x_0 - 1 | 0, y_0, color);
    bmp.o48(x_0 + 1 | 0, y_0, color);
    bmp.o48(x_0, y_0 - 1 | 0, color);
    bmp.o48(x_0, y_0 + 1 | 0, color);
  }
  return bmp;
}
function createMegaPopulationIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(255, 100, 100);
  var inductionVariable = 8;
  var last = getProgressionLastElement(8, 24, 6);
  if (inductionVariable <= last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 6 | 0;
      var inductionVariable_0 = 8;
      var last_0 = getProgressionLastElement(8, 24, 6);
      if (inductionVariable_0 <= last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 6 | 0;
          createMegaPopulationIcon$drawTinyPerson(bmp, color, x, y);
        }
         while (!(x === last_0));
    }
     while (!(y === last));
  return bmp;
}
function createInfinitePopulationIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var gold = Companion_getInstance_1().x4f(255, 215, 0);
  var inductionVariable = 0;
  var last = getProgressionLastElement(0, 360, 3);
  if (inductionVariable <= last)
    do {
      var angle = inductionVariable;
      inductionVariable = inductionVariable + 3 | 0;
      var rad = angle * 3.141592653589793 / 180;
      // Inline function 'kotlin.math.cos' call
      var tmp = 16 + 8 * Math.cos(rad);
      // Inline function 'kotlin.math.cos' call
      var x = 2 * rad;
      var tmp$ret$1 = Math.cos(x);
      var x_0 = numberToInt(tmp + 4 * tmp$ret$1);
      // Inline function 'kotlin.math.sin' call
      var tmp$ret$2 = Math.sin(rad);
      var y = numberToInt(16 + 6 * tmp$ret$2);
      if ((0 <= x_0 ? x_0 <= 31 : false) && (0 <= y ? y <= 31 : false)) {
        bmp.o48(x_0, y, gold);
        if ((x_0 + 1 | 0) < 32) {
          bmp.o48(x_0 + 1 | 0, y, gold);
        }
        if ((y + 1 | 0) < 32) {
          bmp.o48(x_0, y + 1 | 0, gold);
        }
      }
    }
     while (!(angle === last));
  return bmp;
}
function createFertilityExplosionIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(255, 50, 255);
  var cx = 16;
  var cy = 16;
  var inductionVariable = 0;
  var last = getProgressionLastElement(0, 360, 45);
  if (inductionVariable <= last)
    do {
      var angle = inductionVariable;
      inductionVariable = inductionVariable + 45 | 0;
      var rad = angle * 3.141592653589793 / 180;
      var inductionVariable_0 = 4;
      var last_0 = getProgressionLastElement(4, 12, 2);
      if (inductionVariable_0 <= last_0)
        do {
          var r = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 2 | 0;
          // Inline function 'kotlin.math.cos' call
          var tmp$ret$0 = Math.cos(rad);
          var x = numberToInt(cx + r * tmp$ret$0);
          // Inline function 'kotlin.math.sin' call
          var tmp$ret$1 = Math.sin(rad);
          var y = numberToInt(cy + r * tmp$ret$1);
          if ((0 <= x ? x <= 31 : false) && (0 <= y ? y <= 31 : false)) {
            bmp.o48(x, y, color);
            var containsArg = x + 1 | 0;
            if (0 <= containsArg ? containsArg <= 31 : false) {
              bmp.o48(x + 1 | 0, y, color);
            }
          }
        }
         while (!(r === last_0));
    }
     while (!(angle === last));
  return bmp;
}
function createScoreAscensionIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(255, 215, 0);
  var inductionVariable = 14;
  if (inductionVariable <= 18)
    do {
      var x = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 12;
      if (inductionVariable_0 <= 26)
        do {
          var y = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          bmp.o48(x, y, color);
        }
         while (inductionVariable_0 <= 26);
    }
     while (inductionVariable <= 18);
  var inductionVariable_1 = 0;
  if (inductionVariable_1 <= 6)
    do {
      var i = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var inductionVariable_2 = 16 - i | 0;
      var last = 16 + i | 0;
      if (inductionVariable_2 <= last)
        do {
          var x_0 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          if (0 <= x_0 ? x_0 <= 31 : false) {
            bmp.o48(x_0, 12 - i | 0, color);
          }
        }
         while (!(x_0 === last));
    }
     while (inductionVariable_1 <= 6);
  return bmp;
}
function createTimeDilationIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(200, 100, 255);
  var cx = 16;
  var cy = 16;
  var inductionVariable = 0;
  var last = getProgressionLastElement(0, 720, 15);
  if (inductionVariable <= last)
    do {
      var angle = inductionVariable;
      inductionVariable = inductionVariable + 15 | 0;
      var rad = angle * 3.141592653589793 / 180;
      var r = angle / 60.0;
      // Inline function 'kotlin.math.cos' call
      var tmp$ret$0 = Math.cos(rad);
      var x = numberToInt(cx + r * tmp$ret$0);
      // Inline function 'kotlin.math.sin' call
      var tmp$ret$1 = Math.sin(rad);
      var y = numberToInt(cy + r * tmp$ret$1);
      if ((0 <= x ? x <= 31 : false) && (0 <= y ? y <= 31 : false)) {
        bmp.o48(x, y, color);
      }
    }
     while (!(angle === last));
  return bmp;
}
function createReproductionFrenzyIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(255, 100, 150);
  createReproductionFrenzyIcon$drawBaby(bmp, color, 8, 8, 3);
  createReproductionFrenzyIcon$drawBaby(bmp, color, 24, 8, 3);
  createReproductionFrenzyIcon$drawBaby(bmp, color, 16, 12, 4);
  createReproductionFrenzyIcon$drawBaby(bmp, color, 8, 20, 3);
  createReproductionFrenzyIcon$drawBaby(bmp, color, 24, 20, 3);
  return bmp;
}
function createStartingPopulationIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(100, 255, 200);
  createStartingPopulationIcon$drawPerson(bmp, color, 12, 12);
  createStartingPopulationIcon$drawPerson(bmp, color, 20, 12);
  return bmp;
}
function createStartingPopulationBoostIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(100, 255, 150);
  createStartingPopulationBoostIcon$drawPerson(bmp, color, 10, 10);
  createStartingPopulationBoostIcon$drawPerson(bmp, color, 22, 10);
  createStartingPopulationBoostIcon$drawPerson(bmp, color, 10, 20);
  createStartingPopulationBoostIcon$drawPerson(bmp, color, 22, 20);
  return bmp;
}
function createStartingPopulationMegaIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(50, 255, 100);
  var inductionVariable = 8;
  var last = getProgressionLastElement(8, 24, 4);
  if (inductionVariable <= last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 4 | 0;
      var inductionVariable_0 = 8;
      var last_0 = getProgressionLastElement(8, 24, 4);
      if (inductionVariable_0 <= last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 4 | 0;
          bmp.o48(x, y, color);
          bmp.o48(x + 1 | 0, y, color);
          bmp.o48(x, y + 1 | 0, color);
          bmp.o48(x + 1 | 0, y + 1 | 0, color);
        }
         while (!(x === last_0));
    }
     while (!(y === last));
  var inductionVariable_1 = 14;
  if (inductionVariable_1 <= 18)
    do {
      var x_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      bmp.o48(x_0, 4, color);
    }
     while (inductionVariable_1 <= 18);
  var inductionVariable_2 = 2;
  if (inductionVariable_2 <= 6)
    do {
      var y_0 = inductionVariable_2;
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      bmp.o48(16, y_0, color);
    }
     while (inductionVariable_2 <= 6);
  return bmp;
}
function createClickPowerIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(255, 255, 100);
  var cx = 16.0;
  var cy = 16.0;
  var outerRadius = 12.0;
  var innerRadius = 5.0;
  var inductionVariable = 0;
  if (inductionVariable <= 4)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var angle1 = (imul(i, 72) - 90 | 0) * 3.141592653589793 / 180;
      var angle2 = ((imul(i, 72) + 36 | 0) - 90 | 0) * 3.141592653589793 / 180;
      var angle3 = (imul(i + 1 | 0, 72) - 90 | 0) * 3.141592653589793 / 180;
      // Inline function 'kotlin.math.cos' call
      var tmp$ret$0 = Math.cos(angle1);
      var x1 = numberToInt(cx + outerRadius * tmp$ret$0);
      // Inline function 'kotlin.math.sin' call
      var tmp$ret$1 = Math.sin(angle1);
      var y1 = numberToInt(cy + outerRadius * tmp$ret$1);
      // Inline function 'kotlin.math.cos' call
      var tmp$ret$2 = Math.cos(angle2);
      var x2 = numberToInt(cx + innerRadius * tmp$ret$2);
      // Inline function 'kotlin.math.sin' call
      var tmp$ret$3 = Math.sin(angle2);
      var y2 = numberToInt(cy + innerRadius * tmp$ret$3);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 <= 10)
        do {
          var t = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var tx = x1 + (imul(x2 - x1 | 0, t) / 10 | 0) | 0;
          var ty = y1 + (imul(y2 - y1 | 0, t) / 10 | 0) | 0;
          if ((0 <= tx ? tx <= 31 : false) && (0 <= ty ? ty <= 31 : false)) {
            bmp.o48(tx, ty, color);
          }
        }
         while (inductionVariable_0 <= 10);
    }
     while (inductionVariable <= 4);
  var inductionVariable_1 = 12;
  if (inductionVariable_1 <= 20)
    do {
      var y = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var inductionVariable_2 = 12;
      if (inductionVariable_2 <= 20)
        do {
          var x = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var dx = x - 16 | 0;
          var dy = y - 16 | 0;
          if ((imul(dx, dx) + imul(dy, dy) | 0) < 16) {
            bmp.o48(x, y, color);
          }
        }
         while (inductionVariable_2 <= 20);
    }
     while (inductionVariable_1 <= 20);
  return bmp;
}
function createClickPowerBoostIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(255, 200, 50);
  var cx = 16.0;
  var cy = 16.0;
  var inductionVariable = 12;
  if (inductionVariable <= 20)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 12;
      if (inductionVariable_0 <= 20)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var dx = x - 16 | 0;
          var dy = y - 16 | 0;
          if ((imul(dx, dx) + imul(dy, dy) | 0) < 20) {
            bmp.o48(x, y, color);
          }
        }
         while (inductionVariable_0 <= 20);
    }
     while (inductionVariable <= 20);
  var inductionVariable_1 = 0;
  var last = getProgressionLastElement(0, 360, 45);
  if (inductionVariable_1 <= last)
    do {
      var angle = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 45 | 0;
      var rad = angle * 3.141592653589793 / 180;
      var inductionVariable_2 = 10;
      if (inductionVariable_2 <= 14)
        do {
          var r = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          // Inline function 'kotlin.math.cos' call
          var tmp$ret$0 = Math.cos(rad);
          var x_0 = numberToInt(cx + r * tmp$ret$0);
          // Inline function 'kotlin.math.sin' call
          var tmp$ret$1 = Math.sin(rad);
          var y_0 = numberToInt(cy + r * tmp$ret$1);
          if ((0 <= x_0 ? x_0 <= 31 : false) && (0 <= y_0 ? y_0 <= 31 : false)) {
            bmp.o48(x_0, y_0, color);
          }
        }
         while (inductionVariable_2 <= 14);
    }
     while (!(angle === last));
  return bmp;
}
function createClickPowerMegaIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(255, 150, 0);
  var cx = 16.0;
  var cy = 16.0;
  var inductionVariable = 0;
  if (inductionVariable <= 2)
    do {
      var layer = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last = getProgressionLastElement(0, 360, 30);
      if (inductionVariable_0 <= last)
        do {
          var angle = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 30 | 0;
          var rad = angle * 3.141592653589793 / 180;
          var startR = 8 + imul(layer, 2) | 0;
          var endR = 14 + imul(layer, 3) | 0;
          var inductionVariable_1 = startR;
          if (inductionVariable_1 <= endR)
            do {
              var r = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              // Inline function 'kotlin.math.cos' call
              var tmp$ret$0 = Math.cos(rad);
              var x = numberToInt(cx + r * tmp$ret$0);
              // Inline function 'kotlin.math.sin' call
              var tmp$ret$1 = Math.sin(rad);
              var y = numberToInt(cy + r * tmp$ret$1);
              if ((0 <= x ? x <= 31 : false) && (0 <= y ? y <= 31 : false)) {
                bmp.o48(x, y, color);
              }
            }
             while (!(r === endR));
        }
         while (!(angle === last));
    }
     while (inductionVariable <= 2);
  var inductionVariable_2 = 13;
  if (inductionVariable_2 <= 19)
    do {
      var y_0 = inductionVariable_2;
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      var inductionVariable_3 = 13;
      if (inductionVariable_3 <= 19)
        do {
          var x_0 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          bmp.o48(x_0, y_0, Companion_getInstance_1().x4f(255, 255, 255));
        }
         while (inductionVariable_3 <= 19);
    }
     while (inductionVariable_2 <= 19);
  return bmp;
}
function createStarSpeedIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var starColor = Companion_getInstance_1().x4f(100, 255, 255);
  var inductionVariable = 13;
  if (inductionVariable <= 19)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 13;
      if (inductionVariable_0 <= 19)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          bmp.o48(x, y, starColor);
        }
         while (inductionVariable_0 <= 19);
    }
     while (inductionVariable <= 19);
  var inductionVariable_1 = 0;
  if (inductionVariable_1 <= 2)
    do {
      var i = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var y_0 = 14 + imul(i, 2) | 0;
      var inductionVariable_2 = 4;
      if (inductionVariable_2 <= 10)
        do {
          var x_0 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          bmp.o48(x_0, y_0, starColor);
        }
         while (inductionVariable_2 <= 10);
    }
     while (inductionVariable_1 <= 2);
  return bmp;
}
function createStarSpeedBoostIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var starColor = Companion_getInstance_1().x4f(50, 255, 255);
  var inductionVariable = 12;
  if (inductionVariable <= 20)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 12;
      if (inductionVariable_0 <= 20)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          bmp.o48(x, y, starColor);
        }
         while (inductionVariable_0 <= 20);
    }
     while (inductionVariable <= 20);
  var inductionVariable_1 = 0;
  if (inductionVariable_1 <= 4)
    do {
      var i = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var y_0 = 12 + imul(i, 2) | 0;
      var inductionVariable_2 = 2;
      if (inductionVariable_2 <= 9)
        do {
          var x_0 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          bmp.o48(x_0, y_0, starColor);
        }
         while (inductionVariable_2 <= 9);
    }
     while (inductionVariable_1 <= 4);
  return bmp;
}
function createStarSpeedMegaIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var starColor = Companion_getInstance_1().x4f(0, 255, 255);
  var inductionVariable = 11;
  if (inductionVariable <= 21)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 11;
      if (inductionVariable_0 <= 21)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          bmp.o48(x, y, starColor);
        }
         while (inductionVariable_0 <= 21);
    }
     while (inductionVariable <= 21);
  var inductionVariable_1 = 8;
  var last = getProgressionLastElement(8, 24, 2);
  if (inductionVariable_1 <= last)
    do {
      var y_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 2 | 0;
      var inductionVariable_2 = 1;
      if (inductionVariable_2 <= 8)
        do {
          var x_0 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          bmp.o48(x_0, y_0, starColor);
        }
         while (inductionVariable_2 <= 8);
    }
     while (!(y_0 === last));
  var inductionVariable_3 = 24;
  if (inductionVariable_3 <= 28)
    do {
      var x_1 = inductionVariable_3;
      inductionVariable_3 = inductionVariable_3 + 1 | 0;
      bmp.o48(x_1, 16, Companion_getInstance_1().x4f(255, 255, 255));
    }
     while (inductionVariable_3 <= 28);
  return bmp;
}
function createCosmicConvergenceIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color1 = Companion_getInstance_1().x4f(255, 100, 255);
  var color2 = Companion_getInstance_1().x4f(100, 255, 255);
  var inductionVariable = 0;
  var last = getProgressionLastElement(0, 360, 10);
  if (inductionVariable <= last)
    do {
      var angle = inductionVariable;
      inductionVariable = inductionVariable + 10 | 0;
      var rad = angle * 3.141592653589793 / 180.0;
      var radius = 12 - (angle / 30 | 0) | 0;
      // Inline function 'kotlin.math.cos' call
      var tmp$ret$0 = Math.cos(rad);
      var x = numberToInt(16 + radius * tmp$ret$0);
      // Inline function 'kotlin.math.sin' call
      var tmp$ret$1 = Math.sin(rad);
      var y = numberToInt(16 + radius * tmp$ret$1);
      if ((0 <= x ? x <= 31 : false) && (0 <= y ? y <= 31 : false)) {
        bmp.o48(x, y, color1);
      }
      // Inline function 'kotlin.math.cos' call
      var x_0 = rad + 3.141592653589793;
      var tmp$ret$2 = Math.cos(x_0);
      var x2 = numberToInt(16 + radius * tmp$ret$2);
      // Inline function 'kotlin.math.sin' call
      var x_1 = rad + 3.141592653589793;
      var tmp$ret$3 = Math.sin(x_1);
      var y2 = numberToInt(16 + radius * tmp$ret$3);
      if ((0 <= x2 ? x2 <= 31 : false) && (0 <= y2 ? y2 <= 31 : false)) {
        bmp.o48(x2, y2, color2);
      }
    }
     while (!(angle === last));
  var inductionVariable_0 = 14;
  if (inductionVariable_0 <= 18)
    do {
      var y_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var inductionVariable_1 = 14;
      if (inductionVariable_1 <= 18)
        do {
          var x_2 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          bmp.o48(x_2, y_0, Companion_getInstance_1().x4f(255, 255, 255));
        }
         while (inductionVariable_1 <= 18);
    }
     while (inductionVariable_0 <= 18);
  return bmp;
}
function createTranscendenceIcon() {
  var size = 32;
  var bmp = Bitmap32.s3y(size, size);
  var color = Companion_getInstance_1().x4f(255, 0, 255);
  var white = Companion_getInstance_1().x4f(255, 255, 255);
  var inductionVariable = 0;
  var last = getProgressionLastElement(0, 360, 30);
  if (inductionVariable <= last)
    do {
      var angle = inductionVariable;
      inductionVariable = inductionVariable + 30 | 0;
      var rad = angle * 3.141592653589793 / 180.0;
      var inductionVariable_0 = 4;
      if (inductionVariable_0 <= 14)
        do {
          var r = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'kotlin.math.cos' call
          var tmp$ret$0 = Math.cos(rad);
          var x = numberToInt(16 + r * tmp$ret$0);
          // Inline function 'kotlin.math.sin' call
          var tmp$ret$1 = Math.sin(rad);
          var y = numberToInt(16 + r * tmp$ret$1);
          if ((0 <= x ? x <= 31 : false) && (0 <= y ? y <= 31 : false)) {
            bmp.o48(x, y, r < 8 ? white : color);
          }
        }
         while (inductionVariable_0 <= 14);
    }
     while (!(angle === last));
  var inductionVariable_1 = 13;
  if (inductionVariable_1 <= 19)
    do {
      var y_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var inductionVariable_2 = 13;
      if (inductionVariable_2 <= 19)
        do {
          var x_0 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          // Inline function 'kotlin.math.sqrt' call
          var x_1 = imul(x_0 - 16 | 0, x_0 - 16 | 0) + imul(y_0 - 16 | 0, y_0 - 16 | 0) | 0;
          var dist = Math.sqrt(x_1);
          if (dist < 4) {
            bmp.o48(x_0, y_0, white);
          }
        }
         while (inductionVariable_2 <= 19);
    }
     while (inductionVariable_1 <= 19);
  var inductionVariable_3 = 0;
  var last_0 = getProgressionLastElement(0, 360, 5);
  if (inductionVariable_3 <= last_0)
    do {
      var angle_0 = inductionVariable_3;
      inductionVariable_3 = inductionVariable_3 + 5 | 0;
      var rad_0 = angle_0 * 3.141592653589793 / 180.0;
      // Inline function 'kotlin.math.cos' call
      var tmp$ret$3 = Math.cos(rad_0);
      var x_2 = numberToInt(16 + 14 * tmp$ret$3);
      // Inline function 'kotlin.math.sin' call
      var tmp$ret$4 = Math.sin(rad_0);
      var y_1 = numberToInt(16 + 14 * tmp$ret$4);
      if ((0 <= x_2 ? x_2 <= 31 : false) && (0 <= y_1 ? y_1 <= 31 : false)) {
        bmp.o48(x_2, y_1, color);
      }
    }
     while (!(angle_0 === last_0));
  return bmp;
}
function createPopulationIcon$drawPerson(bmp, color, cx, cy) {
  var inductionVariable = cy;
  var last = cy + 2 | 0;
  if (inductionVariable <= last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = cx - 1 | 0;
      var last_0 = cx + 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          bmp.o48(x, y, color);
        }
         while (!(x === last_0));
    }
     while (!(y === last));
  var inductionVariable_1 = cy + 3 | 0;
  var last_1 = cy + 6 | 0;
  if (inductionVariable_1 <= last_1)
    do {
      var y_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var inductionVariable_2 = cx - 2 | 0;
      var last_2 = cx + 2 | 0;
      if (inductionVariable_2 <= last_2)
        do {
          var x_0 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          bmp.o48(x_0, y_0, color);
        }
         while (!(x_0 === last_2));
    }
     while (!(y_0 === last_1));
}
function createMassReproIcon$drawSmallPerson(bmp, color, ox, oy) {
  var inductionVariable = oy;
  var last = oy + 2 | 0;
  if (inductionVariable <= last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = ox;
      var last_0 = ox + 2 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          bmp.o48(x, y, color);
        }
         while (!(x === last_0));
    }
     while (!(y === last));
  var inductionVariable_1 = oy + 3 | 0;
  var last_1 = oy + 5 | 0;
  if (inductionVariable_1 <= last_1)
    do {
      var y_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      bmp.o48(ox + 1 | 0, y_0, color);
    }
     while (!(y_0 === last_1));
}
function createMegaPopulationIcon$drawTinyPerson(bmp, color, cx, cy) {
  bmp.o48(cx, cy, color);
  bmp.o48(cx, cy + 1 | 0, color);
  bmp.o48(cx - 1 | 0, cy + 1 | 0, color);
  bmp.o48(cx + 1 | 0, cy + 1 | 0, color);
}
function createReproductionFrenzyIcon$drawBaby(bmp, color, cx, cy, size) {
  var inductionVariable = cy;
  var last = cy + size | 0;
  if (inductionVariable <= last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = cx - (size / 2 | 0) | 0;
      var last_0 = cx + (size / 2 | 0) | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if ((0 <= x ? x <= 31 : false) && (0 <= y ? y <= 31 : false)) {
            bmp.o48(x, y, color);
          }
        }
         while (!(x === last_0));
    }
     while (!(y === last));
}
function createStartingPopulationIcon$drawPerson(bmp, color, cx, cy) {
  var inductionVariable = cy;
  var last = cy + 2 | 0;
  if (inductionVariable <= last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = cx - 1 | 0;
      var last_0 = cx + 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if ((0 <= x ? x <= 31 : false) && (0 <= y ? y <= 31 : false)) {
            bmp.o48(x, y, color);
          }
        }
         while (!(x === last_0));
    }
     while (!(y === last));
  var inductionVariable_1 = cy + 3 | 0;
  var last_1 = cy + 6 | 0;
  if (inductionVariable_1 <= last_1)
    do {
      var y_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var inductionVariable_2 = cx - 1 | 0;
      var last_2 = cx + 1 | 0;
      if (inductionVariable_2 <= last_2)
        do {
          var x_0 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          if ((0 <= x_0 ? x_0 <= 31 : false) && (0 <= y_0 ? y_0 <= 31 : false)) {
            bmp.o48(x_0, y_0, color);
          }
        }
         while (!(x_0 === last_2));
    }
     while (!(y_0 === last_1));
}
function createStartingPopulationBoostIcon$drawPerson(bmp, color, cx, cy) {
  var inductionVariable = cy;
  var last = cy + 3 | 0;
  if (inductionVariable <= last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = cx - 1 | 0;
      var last_0 = cx + 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if ((0 <= x ? x <= 31 : false) && (0 <= y ? y <= 31 : false)) {
            bmp.o48(x, y, color);
          }
        }
         while (!(x === last_0));
    }
     while (!(y === last));
}
function createAllUpgrades$lambda(it) {
  return it.gby_1;
}
function createAllUpgrades$lambda_0(it) {
  return 1;
}
function createAllUpgrades$lambda_1(it) {
  return it.gby_1 === 0 ? 1 : 0;
}
function createAllUpgrades$lambda_2(cfg, score) {
  return score >= 1.0 && cfg.gby_1 === 0;
}
function createAllUpgrades$lambda_3(it) {
  return it.ec2();
}
function createAllUpgrades$lambda_4(it) {
  return it.uc0_1;
}
function createAllUpgrades$lambda_5(it) {
  return 8;
}
function createAllUpgrades$lambda_6(it) {
  return it.lbz_1;
}
function createAllUpgrades$lambda_7(cfg, score) {
  return score >= cfg.lbz_1 && cfg.fc2();
}
function createAllUpgrades$lambda_8(cfg, level) {
  var current = coerceAtLeast(cfg.hby_1 - 0.5 * (level - cfg.uc0_1 | 0), 1.0);
  var next = coerceAtLeast(cfg.hby_1 - 0.5 * ((level - cfg.uc0_1 | 0) + 1 | 0), 1.0);
  return removeSuffix(current.toString(), '.0') + ' -> ' + removeSuffix(next.toString(), '.0') + ' ' + Localization_getInstance().hi('seconds');
}
function createAllUpgrades$lambda_9(it) {
  var tmp;
  if (it.fc2()) {
    it.hby_1 = coerceAtLeast(it.hby_1 - 0.5, 1.0);
    it.uc0_1 = it.uc0_1 + 1 | 0;
    it.lbz_1 = numberToInt(it.lbz_1 * 1.5);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_10(it) {
  return it.vc0_1;
}
function createAllUpgrades$lambda_11(it) {
  return 12;
}
function createAllUpgrades$lambda_12(it) {
  return it.mbz_1;
}
function createAllUpgrades$lambda_13(cfg, score) {
  return score >= cfg.mbz_1 && cfg.gc2();
}
function createAllUpgrades$lambda_14(cfg, level) {
  var current = coerceAtLeast(cfg.iby_1 - 1.0 * (level - cfg.vc0_1 | 0), 3.0);
  var next = coerceAtLeast(cfg.iby_1 - 1.0 * ((level - cfg.vc0_1 | 0) + 1 | 0), 3.0);
  return removeSuffix(current.toString(), '.0') + ' -> ' + removeSuffix(next.toString(), '.0') + ' ' + Localization_getInstance().hi('seconds');
}
function createAllUpgrades$lambda_15(it) {
  var tmp;
  if (it.gc2()) {
    it.iby_1 = coerceAtLeast(it.iby_1 - 1.0, 3.0);
    it.vc0_1 = it.vc0_1 + 1 | 0;
    it.mbz_1 = numberToInt(it.mbz_1 * 1.5);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_16(it) {
  return it.xc0_1;
}
function createAllUpgrades$lambda_17(it) {
  return 10;
}
function createAllUpgrades$lambda_18(it) {
  return it.obz_1;
}
function createAllUpgrades$lambda_19(cfg, score) {
  return score >= cfg.obz_1 && cfg.ic2();
}
function createAllUpgrades$lambda_20(cfg, level) {
  var current = cfg.kby_1 + 10.0 * (level - cfg.xc0_1 | 0);
  var next = current + 10.0;
  return '' + numberToInt(current) + ' -> ' + numberToInt(next) + ' ' + Localization_getInstance().hi('px_per_sec');
}
function createAllUpgrades$lambda_21(it) {
  var tmp;
  if (it.ic2()) {
    it.lby_1 = it.lby_1 + 10.0;
    it.kby_1 = it.kby_1 + 10.0;
    it.xc0_1 = it.xc0_1 + 1 | 0;
    it.obz_1 = numberToInt(it.obz_1 * 1.5);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_22(it) {
  return it.vc1_1;
}
function createAllUpgrades$lambda_23(it) {
  return 5;
}
function createAllUpgrades$lambda_24(it) {
  return it.lc0_1;
}
function createAllUpgrades$lambda_25(cfg, score) {
  return score >= cfg.lc0_1 && cfg.fc3();
}
function createAllUpgrades$lambda_26(cfg, level) {
  var current = cfg.hbz_1 + imul(2, level - cfg.vc1_1 | 0) | 0;
  var next = current + 2 | 0;
  return '' + current + ' -> ' + next;
}
function createAllUpgrades$lambda_27(it) {
  var tmp;
  if (it.fc3()) {
    it.hbz_1 = it.hbz_1 + 2 | 0;
    it.vc1_1 = it.vc1_1 + 1 | 0;
    it.lc0_1 = numberToInt(it.lc0_1 * 2.5);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_28(it) {
  return it.yc0_1;
}
function createAllUpgrades$lambda_29(it) {
  return 5;
}
function createAllUpgrades$lambda_30(it) {
  return it.pbz_1;
}
function createAllUpgrades$lambda_31(cfg, score) {
  return score >= cfg.pbz_1 && cfg.jc2();
}
function createAllUpgrades$lambda_32(cfg, level) {
  var current = cfg.mby_1 + 0.5 * (level - cfg.yc0_1 | 0);
  var next = current + 0.5;
  return '+' + numberToInt(current * 100) + '% -> +' + numberToInt(next * 100) + '%';
}
function createAllUpgrades$lambda_33(it) {
  var tmp;
  if (it.jc2()) {
    it.mby_1 = it.mby_1 + 0.5;
    it.yc0_1 = it.yc0_1 + 1 | 0;
    it.pbz_1 = numberToInt(it.pbz_1 * 1.8);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_34(it) {
  return it.zc0_1;
}
function createAllUpgrades$lambda_35(it) {
  return 5;
}
function createAllUpgrades$lambda_36(it) {
  return it.qbz_1;
}
function createAllUpgrades$lambda_37(cfg, score) {
  return score >= cfg.qbz_1 && cfg.kc2();
}
function createAllUpgrades$lambda_38(cfg, level) {
  var current = cfg.nby_1 + 0.2 * (level - cfg.zc0_1 | 0);
  var next = current + 0.2;
  return '+' + numberToInt(current * 100) + '% -> +' + numberToInt(next * 100) + '%';
}
function createAllUpgrades$lambda_39(it) {
  var tmp;
  if (it.kc2()) {
    it.nby_1 = it.nby_1 + 0.2;
    it.zc0_1 = it.zc0_1 + 1 | 0;
    it.qbz_1 = numberToInt(it.qbz_1 * 1.8);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_40(it) {
  return it.ac1_1;
}
function createAllUpgrades$lambda_41(it) {
  return 5;
}
function createAllUpgrades$lambda_42(it) {
  return it.rbz_1;
}
function createAllUpgrades$lambda_43(cfg, score) {
  return score >= cfg.rbz_1 && cfg.lc2();
}
function createAllUpgrades$lambda_44(cfg, level) {
  var current = cfg.oby_1 + 0.1 * (level - cfg.ac1_1 | 0);
  var next = current + 0.1;
  return '+' + numberToInt(current * 100) + '% -> +' + numberToInt(next * 100) + '%';
}
function createAllUpgrades$lambda_45(it) {
  var tmp;
  if (it.lc2()) {
    it.oby_1 = it.oby_1 + 0.1;
    it.ac1_1 = it.ac1_1 + 1 | 0;
    it.rbz_1 = numberToInt(it.rbz_1 * 1.8);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_46(it) {
  return it.cc1_1;
}
function createAllUpgrades$lambda_47(it) {
  return 5;
}
function createAllUpgrades$lambda_48(it) {
  return it.tbz_1;
}
function createAllUpgrades$lambda_49(cfg, score) {
  return score >= cfg.tbz_1 && cfg.nc2();
}
function createAllUpgrades$lambda_50(cfg, _unused_var__etf5q3) {
  var next;
  switch (cfg.cc1_1) {
    case 0:
      next = 120.0;
      break;
    case 1:
      next = 200.0;
      break;
    case 2:
      next = 300.0;
      break;
    case 3:
      next = 400.0;
      break;
    default:
      next = 600.0;
      break;
  }
  return '' + numberToInt(next) + ' ' + Localization_getInstance().hi('seconds');
}
function createAllUpgrades$lambda_51(it) {
  var tmp;
  if (it.nc2()) {
    var tmp_0 = it;
    switch (it.cc1_1) {
      case 0:
        tmp_0.qby_1 = 120.0;
        break;
      case 1:
        tmp_0.qby_1 = 200.0;
        break;
      case 2:
        tmp_0.qby_1 = 300.0;
        break;
      case 3:
        tmp_0.qby_1 = 400.0;
        break;
      default:
        tmp_0.qby_1 = 600.0;
        break;
    }
    it.cc1_1 = it.cc1_1 + 1 | 0;
    it.tbz_1 = numberToInt(it.tbz_1 * 2.0);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_52(it) {
  return it.bc1_1;
}
function createAllUpgrades$lambda_53(it) {
  return 3;
}
function createAllUpgrades$lambda_54(it) {
  return it.sbz_1;
}
function createAllUpgrades$lambda_55(cfg, score) {
  return score >= cfg.sbz_1 && cfg.mc2();
}
function createAllUpgrades$lambda_56(cfg, _unused_var__etf5q3) {
  var next;
  switch (cfg.bc1_1) {
    case 0:
      next = Localization_getInstance().hi('gender_60_male');
      break;
    case 1:
      next = Localization_getInstance().hi('gender_40_male');
      break;
    default:
      next = Localization_getInstance().hi('gender_50_male');
      break;
  }
  return Localization_getInstance().hi(next);
}
function createAllUpgrades$lambda_57(it) {
  var tmp;
  if (it.mc2()) {
    var tmp_0 = it;
    switch (it.bc1_1) {
      case 0:
        tmp_0.pby_1 = 0.6;
        break;
      case 1:
        tmp_0.pby_1 = 0.4;
        break;
      default:
        tmp_0.pby_1 = 0.5;
        break;
    }
    it.bc1_1 = it.bc1_1 + 1 | 0;
    it.sbz_1 = numberToInt(it.sbz_1 * 2.0);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_58(it) {
  return it.dc1_1;
}
function createAllUpgrades$lambda_59(it) {
  return 5;
}
function createAllUpgrades$lambda_60(it) {
  return it.ubz_1;
}
function createAllUpgrades$lambda_61(cfg, score) {
  return score >= cfg.ubz_1 && cfg.oc2();
}
function createAllUpgrades$lambda_62(cfg, _unused_var__etf5q3) {
  var next = cfg.rby_1 + 5.0;
  return '+' + numberToInt(next) + ' ' + Localization_getInstance().hi('pixels');
}
function createAllUpgrades$lambda_63(it) {
  var tmp;
  if (it.oc2()) {
    it.rby_1 = it.rby_1 + 5.0;
    it.dc1_1 = it.dc1_1 + 1 | 0;
    it.ubz_1 = numberToInt(it.ubz_1 * 2.0);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_64(it) {
  return it.ec1_1;
}
function createAllUpgrades$lambda_65(it) {
  return 5;
}
function createAllUpgrades$lambda_66(it) {
  return it.vbz_1;
}
function createAllUpgrades$lambda_67(cfg, score) {
  return score >= cfg.vbz_1 && cfg.pc2();
}
function createAllUpgrades$lambda_68(cfg, level) {
  var current = numberToInt(coerceAtMost_0(cfg.sby_1 + 0.04 * (level - cfg.ec1_1 | 0), 1.0) * 100);
  var next = numberToInt(coerceAtMost_0(cfg.sby_1 + 0.04 * ((level - cfg.ec1_1 | 0) + 1 | 0), 1.0) * 100);
  return '' + current + '% -> ' + next + '%';
}
function createAllUpgrades$lambda_69(it) {
  var tmp;
  if (it.pc2()) {
    it.sby_1 = it.sby_1 + 0.04;
    it.ec1_1 = it.ec1_1 + 1 | 0;
    it.vbz_1 = numberToInt(it.vbz_1 * 2.5);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_70(it) {
  return it.fc1_1;
}
function createAllUpgrades$lambda_71(it) {
  return 1;
}
function createAllUpgrades$lambda_72(it) {
  return it.wbz_1;
}
function createAllUpgrades$lambda_73(cfg, score) {
  return score >= cfg.wbz_1 && cfg.qc2();
}
function createAllUpgrades$lambda_74(cfg, _unused_var__etf5q3) {
  return Localization_getInstance().hi(!cfg.tby_1 ? 'enabled' : 'already_enabled');
}
function createAllUpgrades$lambda_75(it) {
  var tmp;
  if (it.qc2()) {
    it.tby_1 = true;
    it.fc1_1 = it.fc1_1 + 1 | 0;
    it.wbz_1 = numberToInt(it.wbz_1 * 2.5);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_76(it) {
  return it.gc1_1;
}
function createAllUpgrades$lambda_77(it) {
  return 5;
}
function createAllUpgrades$lambda_78(it) {
  return it.xbz_1;
}
function createAllUpgrades$lambda_79(cfg, score) {
  return score >= cfg.xbz_1 && cfg.rc2();
}
function createAllUpgrades$lambda_80(cfg, level) {
  var current = coerceAtLeast(cfg.uby_1 - 1.5 * (level - cfg.gc1_1 | 0), 2.5);
  var next = coerceAtLeast(cfg.uby_1 - 1.5 * ((level - cfg.gc1_1 | 0) + 1 | 0), 2.5);
  return removeSuffix(current.toString(), '.0') + ' -> ' + removeSuffix(next.toString(), '.0') + ' ' + Localization_getInstance().hi('seconds');
}
function createAllUpgrades$lambda_81(it) {
  var tmp;
  if (it.rc2()) {
    it.uby_1 = coerceAtLeast(it.uby_1 - 1.5, 2.5);
    it.gc1_1 = it.gc1_1 + 1 | 0;
    it.xbz_1 = numberToInt(it.xbz_1 * 2.5);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_82(it) {
  return it.hc1_1;
}
function createAllUpgrades$lambda_83(it) {
  return 10;
}
function createAllUpgrades$lambda_84(it) {
  return it.ybz_1;
}
function createAllUpgrades$lambda_85(cfg, score) {
  return score >= cfg.ybz_1 && cfg.sc2();
}
function createAllUpgrades$lambda_86(cfg, level) {
  var current = cfg.vby_1 + 0.2 * (level - cfg.hc1_1 | 0);
  var next = current + 0.2;
  return 'x' + format('%.2f', [current]) + ' -> x' + format('%.2f', [next]);
}
function createAllUpgrades$lambda_87(it) {
  var tmp;
  if (it.sc2()) {
    it.vby_1 = it.vby_1 + 0.2;
    it.hc1_1 = it.hc1_1 + 1 | 0;
    it.ybz_1 = numberToInt(it.ybz_1 * 2.5);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_88(it) {
  return it.ic1_1;
}
function createAllUpgrades$lambda_89(it) {
  return 5;
}
function createAllUpgrades$lambda_90(it) {
  return it.zbz_1;
}
function createAllUpgrades$lambda_91(cfg, score) {
  return score >= cfg.zbz_1 && cfg.tc2();
}
function createAllUpgrades$lambda_92(cfg, level) {
  var current = cfg.wby_1 + 0.2 * (level - cfg.ic1_1 | 0);
  var next = current + 0.2;
  return 'x' + format('%.2f', [current]) + ' -> x' + format('%.2f', [next]);
}
function createAllUpgrades$lambda_93(it) {
  var tmp;
  if (it.tc2()) {
    it.wby_1 = it.wby_1 + 0.2;
    it.ic1_1 = it.ic1_1 + 1 | 0;
    it.zbz_1 = numberToInt(it.zbz_1 * 3.0);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_94(it) {
  return it.jc1_1;
}
function createAllUpgrades$lambda_95(it) {
  return 1;
}
function createAllUpgrades$lambda_96(it) {
  return it.ac0_1;
}
function createAllUpgrades$lambda_97(cfg, score) {
  return score >= cfg.ac0_1 && cfg.uc2();
}
function createAllUpgrades$lambda_98(cfg, _unused_var__etf5q3) {
  return Localization_getInstance().hi(!cfg.xby_1 ? 'enabled' : 'already_enabled');
}
function createAllUpgrades$lambda_99(it) {
  var tmp;
  if (it.uc2()) {
    it.xby_1 = true;
    it.jc1_1 = it.jc1_1 + 1 | 0;
    it.ac0_1 = numberToInt(it.ac0_1 * 3.0);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_100(it) {
  return it.kc1_1;
}
function createAllUpgrades$lambda_101(it) {
  return 3;
}
function createAllUpgrades$lambda_102(it) {
  return it.bc0_1;
}
function createAllUpgrades$lambda_103(cfg, score) {
  return score >= cfg.bc0_1 && cfg.vc2();
}
function createAllUpgrades$lambda_104(cfg, _unused_var__etf5q3) {
  var next = cfg.yby_1 + 0.15;
  return '+' + numberToInt(next * 100) + '%';
}
function createAllUpgrades$lambda_105(it) {
  var tmp;
  if (it.vc2()) {
    it.yby_1 = it.yby_1 + 0.15;
    it.kc1_1 = it.kc1_1 + 1 | 0;
    it.bc0_1 = numberToInt(it.bc0_1 * 3.0);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_106(it) {
  return it.lc1_1;
}
function createAllUpgrades$lambda_107(it) {
  return 1;
}
function createAllUpgrades$lambda_108(it) {
  return it.cc0_1;
}
function createAllUpgrades$lambda_109(cfg, score) {
  return score >= cfg.cc0_1 && cfg.wc2();
}
function createAllUpgrades$lambda_110(cfg, _unused_var__etf5q3) {
  return !cfg.zby_1 ? '+200 ' + Localization_getInstance().hi('px_per_sec') : Localization_getInstance().hi('already_enabled');
}
function createAllUpgrades$lambda_111(it) {
  var tmp;
  if (it.wc2()) {
    it.zby_1 = true;
    it.lby_1 = it.lby_1 + 200.0;
    it.kby_1 = it.kby_1 + 200.0;
    it.lc1_1 = it.lc1_1 + 1 | 0;
    it.cc0_1 = numberToInt(it.cc0_1 * 5.0);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_112(it) {
  return it.mc1_1;
}
function createAllUpgrades$lambda_113(it) {
  return 1;
}
function createAllUpgrades$lambda_114(it) {
  return it.dc0_1;
}
function createAllUpgrades$lambda_115(cfg, score) {
  return score >= cfg.dc0_1 && cfg.xc2();
}
function createAllUpgrades$lambda_116(cfg, _unused_var__etf5q3) {
  return !cfg.abz_1 ? Localization_getInstance().hi('enabled') : Localization_getInstance().hi('already_enabled');
}
function createAllUpgrades$lambda_117(it) {
  var tmp;
  if (it.xc2()) {
    it.abz_1 = true;
    it.mc1_1 = it.mc1_1 + 1 | 0;
    it.dc0_1 = numberToInt(it.dc0_1 * 5.0);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_118(it) {
  return it.nc1_1;
}
function createAllUpgrades$lambda_119(it) {
  return 1;
}
function createAllUpgrades$lambda_120(it) {
  return it.ec0_1;
}
function createAllUpgrades$lambda_121(cfg, score) {
  return score >= cfg.ec0_1 && cfg.yc2();
}
function createAllUpgrades$lambda_122(cfg, _unused_var__etf5q3) {
  return !cfg.bbz_1 ? '+100 ' + Localization_getInstance().hi('max_population') : Localization_getInstance().hi('already_enabled');
}
function createAllUpgrades$lambda_123(it) {
  var tmp;
  if (it.yc2()) {
    it.bbz_1 = true;
    it.jby_1 = it.jby_1 + 100 | 0;
    it.nc1_1 = it.nc1_1 + 1 | 0;
    it.ec0_1 = numberToInt(it.ec0_1 * 5.0);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_124(it) {
  return it.sc1_1;
}
function createAllUpgrades$lambda_125(it) {
  return 1;
}
function createAllUpgrades$lambda_126(it) {
  return it.sc1_1 === 0 ? 150000 : 0;
}
function createAllUpgrades$lambda_127(cfg, score) {
  return score >= 150000.0 && cfg.sc1_1 === 0;
}
function createAllUpgrades$lambda_128(cfg, _unused_var__etf5q3) {
  return !cfg.cbz_1 ? '500 ' + Localization_getInstance().hi('max_population') : Localization_getInstance().hi('already_enabled');
}
function createAllUpgrades$lambda_129(it) {
  var tmp;
  if (it.oc3()) {
    it.cbz_1 = true;
    it.jby_1 = 500;
    it.sc1_1 = 1;
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_130(it) {
  return it.oc1_1;
}
function createAllUpgrades$lambda_131(it) {
  return 1;
}
function createAllUpgrades$lambda_132(it) {
  return it.fc0_1;
}
function createAllUpgrades$lambda_133(cfg, score) {
  return score >= cfg.fc0_1 && cfg.zc2();
}
function createAllUpgrades$lambda_134(it) {
  var tmp;
  if (it.zc2()) {
    it.dbz_1 = true;
    it.oby_1 = it.oby_1 + 2.0;
    it.oc1_1 = it.oc1_1 + 1 | 0;
    it.fc0_1 = numberToInt(it.fc0_1 * 5.0);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_135(it) {
  return it.pc1_1;
}
function createAllUpgrades$lambda_136(it) {
  return 5;
}
function createAllUpgrades$lambda_137(it) {
  return it.gc0_1;
}
function createAllUpgrades$lambda_138(cfg, score) {
  return score >= cfg.gc0_1 && cfg.ac3();
}
function createAllUpgrades$lambda_139(cfg, level) {
  var current = cfg.ebz_1 + 1.0 * (level - cfg.pc1_1 | 0);
  var next = current + 1.0;
  return 'x' + current + ' -> x' + next;
}
function createAllUpgrades$lambda_140(it) {
  var tmp;
  if (it.ac3()) {
    it.ebz_1 = it.ebz_1 + 1.0;
    it.pc1_1 = it.pc1_1 + 1 | 0;
    it.gc0_1 = numberToInt(it.gc0_1 * 4.0);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_141(it) {
  return it.qc1_1;
}
function createAllUpgrades$lambda_142(it) {
  return 1;
}
function createAllUpgrades$lambda_143(it) {
  return it.hc0_1;
}
function createAllUpgrades$lambda_144(cfg, score) {
  return score >= cfg.hc0_1 && cfg.bc3();
}
function createAllUpgrades$lambda_145(cfg, _unused_var__etf5q3) {
  return !cfg.fbz_1 ? '+0.5 ' + Localization_getInstance().hi('time_acceleration') : Localization_getInstance().hi('already_enabled');
}
function createAllUpgrades$lambda_146(it) {
  var tmp;
  if (it.bc3()) {
    it.fbz_1 = true;
    it.wby_1 = it.wby_1 + 0.5;
    it.qc1_1 = it.qc1_1 + 1 | 0;
    it.hc0_1 = numberToInt(it.hc0_1 * 5.0);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_147(it) {
  return it.rc1_1;
}
function createAllUpgrades$lambda_148(it) {
  return 1;
}
function createAllUpgrades$lambda_149(it) {
  return it.ic0_1;
}
function createAllUpgrades$lambda_150(cfg, score) {
  return score >= cfg.ic0_1 && cfg.cc3();
}
function createAllUpgrades$lambda_151(cfg, _unused_var__etf5q3) {
  return !cfg.gbz_1 ? Localization_getInstance().hi('enabled') : Localization_getInstance().hi('already_enabled');
}
function createAllUpgrades$lambda_152(it) {
  var tmp;
  if (it.cc3()) {
    it.gbz_1 = true;
    it.rc1_1 = it.rc1_1 + 1 | 0;
    it.ic0_1 = numberToInt(it.ic0_1 * 5.0);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_153(it) {
  return it.tc1_1;
}
function createAllUpgrades$lambda_154(it) {
  return 1;
}
function createAllUpgrades$lambda_155(it) {
  return it.jc0_1;
}
function createAllUpgrades$lambda_156(cfg, score) {
  return score >= cfg.jc0_1 && cfg.dc3();
}
function createAllUpgrades$lambda_157(cfg, _unused_var__etf5q3) {
  return cfg.tc1_1 === 0 ? Localization_getInstance().hi('enabled') : Localization_getInstance().hi('already_enabled');
}
function createAllUpgrades$lambda_158(it) {
  var tmp;
  if (it.dc3()) {
    it.tc1_1 = it.tc1_1 + 1 | 0;
    it.jc0_1 = numberToInt(it.jc0_1 * 10.0);
    it.hby_1 = coerceAtLeast(it.hby_1 * 0.5, 10.0);
    it.iby_1 = coerceAtLeast(it.iby_1 * 0.5, 500.0);
    it.oby_1 = coerceAtLeast(it.oby_1 * 0.5, 10.0);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_159(it) {
  return it.uc1_1;
}
function createAllUpgrades$lambda_160(it) {
  return 1;
}
function createAllUpgrades$lambda_161(it) {
  return it.kc0_1;
}
function createAllUpgrades$lambda_162(cfg, score) {
  return score >= cfg.kc0_1 && cfg.ec3();
}
function createAllUpgrades$lambda_163(cfg, _unused_var__etf5q3) {
  return cfg.uc1_1 === 0 ? Localization_getInstance().hi('enabled') : Localization_getInstance().hi('already_enabled');
}
function createAllUpgrades$lambda_164(it) {
  var tmp;
  if (it.ec3()) {
    it.uc1_1 = it.uc1_1 + 1 | 0;
    it.kc0_1 = numberToInt(it.kc0_1 * 100.0);
    it.hby_1 = 1.0;
    it.iby_1 = 100.0;
    it.oby_1 = 1.0;
    it.qby_1 = 1000000.0;
    it.vby_1 = it.vby_1 * 10.0;
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_165(it) {
  return it.wc0_1;
}
function createAllUpgrades$lambda_166(it) {
  return 10;
}
function createAllUpgrades$lambda_167(it) {
  return it.nbz_1;
}
function createAllUpgrades$lambda_168(cfg, score) {
  return score >= cfg.nbz_1 && cfg.hc2();
}
function createAllUpgrades$lambda_169(cfg, level) {
  var current = cfg.jby_1 + imul(5, level - cfg.wc0_1 | 0) | 0;
  var next = current + 5 | 0;
  return '' + current + ' -> ' + next;
}
function createAllUpgrades$lambda_170(it) {
  var tmp;
  if (it.hc2()) {
    it.jby_1 = it.jby_1 + 5 | 0;
    it.wc0_1 = it.wc0_1 + 1 | 0;
    it.nbz_1 = numberToInt(it.nbz_1 * 1.5);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_171(it) {
  return it.wc1_1;
}
function createAllUpgrades$lambda_172(it) {
  return 5;
}
function createAllUpgrades$lambda_173(it) {
  return it.mc0_1;
}
function createAllUpgrades$lambda_174(cfg, score) {
  return score >= cfg.mc0_1 && cfg.gc3();
}
function createAllUpgrades$lambda_175(cfg, _unused_var__etf5q3) {
  return '+4 ' + Localization_getInstance().hi('starting_population');
}
function createAllUpgrades$lambda_176(it) {
  var tmp;
  if (it.gc3()) {
    it.hbz_1 = it.hbz_1 + 4 | 0;
    it.wc1_1 = it.wc1_1 + 1 | 0;
    it.mc0_1 = numberToInt(it.mc0_1 * 2.5);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_177(it) {
  return it.xc1_1;
}
function createAllUpgrades$lambda_178(it) {
  return 1;
}
function createAllUpgrades$lambda_179(it) {
  return it.nc0_1;
}
function createAllUpgrades$lambda_180(cfg, score) {
  return score >= cfg.nc0_1 && cfg.hc3();
}
function createAllUpgrades$lambda_181(cfg, _unused_var__etf5q3) {
  return '+20 ' + Localization_getInstance().hi('starting_population');
}
function createAllUpgrades$lambda_182(it) {
  var tmp;
  if (it.hc3()) {
    it.hbz_1 = it.hbz_1 + 20 | 0;
    it.xc1_1 = it.xc1_1 + 1 | 0;
    it.nc0_1 = numberToInt(it.nc0_1 * 5.0);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_183(it) {
  return it.yc1_1;
}
function createAllUpgrades$lambda_184(it) {
  return 5;
}
function createAllUpgrades$lambda_185(it) {
  return it.oc0_1;
}
function createAllUpgrades$lambda_186(cfg, score) {
  return score >= cfg.oc0_1 && cfg.ic3();
}
function createAllUpgrades$lambda_187(it) {
  var tmp;
  if (it.ic3()) {
    it.jbz_1 = it.jbz_1 * 2.0;
    it.yc1_1 = it.yc1_1 + 1 | 0;
    it.oc0_1 = numberToInt(it.oc0_1 * 2.5);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_188(it) {
  return it.zc1_1;
}
function createAllUpgrades$lambda_189(it) {
  return 5;
}
function createAllUpgrades$lambda_190(it) {
  return it.pc0_1;
}
function createAllUpgrades$lambda_191(cfg, score) {
  return score >= cfg.pc0_1 && cfg.jc3();
}
function createAllUpgrades$lambda_192(cfg, _unused_var__etf5q3) {
  return 'x' + cfg.jbz_1 * 2;
}
function createAllUpgrades$lambda_193(it) {
  var tmp;
  if (it.jc3()) {
    it.jbz_1 = it.jbz_1 * 2.0;
    it.zc1_1 = it.zc1_1 + 1 | 0;
    it.pc0_1 = numberToInt(it.pc0_1 * 3.0);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_194(it) {
  return it.ac2_1;
}
function createAllUpgrades$lambda_195(it) {
  return 1;
}
function createAllUpgrades$lambda_196(it) {
  return it.qc0_1;
}
function createAllUpgrades$lambda_197(cfg, score) {
  return score >= cfg.qc0_1 && cfg.kc3();
}
function createAllUpgrades$lambda_198(cfg, _unused_var__etf5q3) {
  return 'x' + cfg.jbz_1 * 2;
}
function createAllUpgrades$lambda_199(it) {
  var tmp;
  if (it.kc3()) {
    it.jbz_1 = it.jbz_1 * 2.0;
    it.ac2_1 = it.ac2_1 + 1 | 0;
    it.qc0_1 = numberToInt(it.qc0_1 * 5.0);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_200(it) {
  return it.bc2_1;
}
function createAllUpgrades$lambda_201(it) {
  return 5;
}
function createAllUpgrades$lambda_202(it) {
  return it.rc0_1;
}
function createAllUpgrades$lambda_203(cfg, score) {
  return score >= cfg.rc0_1 && cfg.lc3();
}
function createAllUpgrades$lambda_204(cfg, _unused_var__etf5q3) {
  return '' + numberToInt(cfg.kbz_1 * 0.75) + ' ' + Localization_getInstance().hi('seconds');
}
function createAllUpgrades$lambda_205(it) {
  var tmp;
  if (it.lc3()) {
    it.kbz_1 = it.kbz_1 * 0.75;
    it.bc2_1 = it.bc2_1 + 1 | 0;
    it.rc0_1 = numberToInt(it.rc0_1 * 2.5);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_206(it) {
  return it.cc2_1;
}
function createAllUpgrades$lambda_207(it) {
  return 5;
}
function createAllUpgrades$lambda_208(it) {
  return it.sc0_1;
}
function createAllUpgrades$lambda_209(cfg, score) {
  return score >= cfg.sc0_1 && cfg.mc3();
}
function createAllUpgrades$lambda_210(cfg, _unused_var__etf5q3) {
  return '' + numberToInt(cfg.kbz_1 * 0.75) + ' ' + Localization_getInstance().hi('seconds');
}
function createAllUpgrades$lambda_211(it) {
  var tmp;
  if (it.mc3()) {
    it.kbz_1 = it.kbz_1 * 0.75;
    it.cc2_1 = it.cc2_1 + 1 | 0;
    it.sc0_1 = numberToInt(it.sc0_1 * 3.0);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function createAllUpgrades$lambda_212(it) {
  return it.dc2_1;
}
function createAllUpgrades$lambda_213(it) {
  return 1;
}
function createAllUpgrades$lambda_214(it) {
  return it.tc0_1;
}
function createAllUpgrades$lambda_215(cfg, score) {
  return score >= cfg.tc0_1 && cfg.nc3();
}
function createAllUpgrades$lambda_216(cfg, _unused_var__etf5q3) {
  return '' + numberToInt(cfg.kbz_1 * 0.5) + ' ' + Localization_getInstance().hi('seconds');
}
function createAllUpgrades$lambda_217(it) {
  var tmp;
  if (it.nc3()) {
    it.kbz_1 = it.kbz_1 * 0.5;
    it.dc2_1 = it.dc2_1 + 1 | 0;
    it.tc0_1 = numberToInt(it.tc0_1 * 5.0);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function get_globalConfig() {
  _init_properties_main_kt__ykjpl3();
  return globalConfig;
}
var globalConfig;
function get_globalAchievementManager() {
  _init_properties_main_kt__ykjpl3();
  return globalAchievementManager;
}
var globalAchievementManager;
function set_globalScore(_set____db54di) {
  _init_properties_main_kt__ykjpl3();
  globalScore = _set____db54di;
}
function get_globalScore() {
  _init_properties_main_kt__ykjpl3();
  return globalScore;
}
var globalScore;
function set_hasWon(_set____db54di) {
  _init_properties_main_kt__ykjpl3();
  hasWon = _set____db54di;
}
function get_hasWon() {
  _init_properties_main_kt__ykjpl3();
  return hasWon;
}
var hasWon;
function set_totalGameTime(_set____db54di) {
  _init_properties_main_kt__ykjpl3();
  totalGameTime = _set____db54di;
}
function get_totalGameTime() {
  _init_properties_main_kt__ykjpl3();
  return totalGameTime;
}
var totalGameTime;
function set_currentRunTime(_set____db54di) {
  _init_properties_main_kt__ykjpl3();
  currentRunTime = _set____db54di;
}
function get_currentRunTime() {
  _init_properties_main_kt__ykjpl3();
  return currentRunTime;
}
var currentRunTime;
function set_totalCollisionCount(_set____db54di) {
  _init_properties_main_kt__ykjpl3();
  totalCollisionCount = _set____db54di;
}
function get_totalCollisionCount() {
  _init_properties_main_kt__ykjpl3();
  return totalCollisionCount;
}
var totalCollisionCount;
function set_treeViewX(_set____db54di) {
  _init_properties_main_kt__ykjpl3();
  treeViewX = _set____db54di;
}
function get_treeViewX() {
  _init_properties_main_kt__ykjpl3();
  return treeViewX;
}
var treeViewX;
function set_treeViewY(_set____db54di) {
  _init_properties_main_kt__ykjpl3();
  treeViewY = _set____db54di;
}
function get_treeViewY() {
  _init_properties_main_kt__ykjpl3();
  return treeViewY;
}
var treeViewY;
function set_treeViewScale(_set____db54di) {
  _init_properties_main_kt__ykjpl3();
  treeViewScale = _set____db54di;
}
function get_treeViewScale() {
  _init_properties_main_kt__ykjpl3();
  return treeViewScale;
}
var treeViewScale;
var globalSavedScore;
var globalSavedConfig;
function set_gameFont(_set____db54di) {
  _init_properties_main_kt__ykjpl3();
  gameFont = _set____db54di;
}
function get_gameFont() {
  _init_properties_main_kt__ykjpl3();
  var tmp = gameFont;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('gameFont');
  }
}
var gameFont;
function set_mainMenuNormalFont(_set____db54di) {
  _init_properties_main_kt__ykjpl3();
  mainMenuNormalFont = _set____db54di;
}
function get_mainMenuNormalFont() {
  _init_properties_main_kt__ykjpl3();
  var tmp = mainMenuNormalFont;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('mainMenuNormalFont');
  }
}
var mainMenuNormalFont;
function set_mainMenuTitleFont(_set____db54di) {
  _init_properties_main_kt__ykjpl3();
  mainMenuTitleFont = _set____db54di;
}
function get_mainMenuTitleFont() {
  _init_properties_main_kt__ykjpl3();
  var tmp = mainMenuTitleFont;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('mainMenuTitleFont');
  }
}
var mainMenuTitleFont;
function main($completion) {
  var tmp = Colors_getInstance().y4f('#2b2b2b');
  return Korge(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, 1920, 1080, VOID, VOID, VOID, false, VOID, VOID, VOID, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, main$slambda_0(), $completion);
}
var CollisionType_REPRODUCTION_instance;
var CollisionType_BOUNCE_ONLY_instance;
var CollisionType_entriesInitialized;
function CollisionType_initEntries() {
  if (CollisionType_entriesInitialized)
    return Unit_instance;
  CollisionType_entriesInitialized = true;
  CollisionType_REPRODUCTION_instance = new CollisionType('REPRODUCTION', 0);
  CollisionType_BOUNCE_ONLY_instance = new CollisionType('BOUNCE_ONLY', 1);
}
function *_generator_invoke__zhh2q8_20($this, $this$launch, $completion) {
  var tmp = saveGameState($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var this_0 = $this.ccb_1.oa2();
  var injects = [];
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var time = toDuration(0, DurationUnit_SECONDS_getInstance());
  var transition = this_0.r9x_1;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(MainMenuScene);
  var injects_0 = injects.slice();
  var sceneInjector = this_0.q9x_1.l9q_1.e6c().c6c(getKClass(SceneContainer), this_0).c6c(getKClass(Resources), new Resources(this_0.b17(), this_0.q9x_1.s9y().t37_1, this_0.q9x_1.s9y()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp_0 = getKClassFromExpression(inject);
    sceneInjector.c6c(isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE(), inject);
  }
  // Inline function 'GameScene.setupUI.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
  var newScene = new MainMenuScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_3().ra8_1;
  var level = Level_INFO_getInstance();
  var tmp_1;
  if (this_1.x2x(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$3 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_1.y2x(level, tmp$ret$3);
    tmp_1 = Unit_instance;
  }
  if (true) {
    newScene.n6c(sceneInjector);
    var tmp_2 = getKClassFromExpression(newScene);
    var tmp_3 = isInterface(tmp_2, KClass) ? tmp_2 : THROW_CCE();
    this_0.q9x_1.l9q_1.g6c(tmp_3, GameScene$setupUI$lambda$slambda$lambda(sceneInjector));
  }
  var tmp_4 = this_0.ta8(newScene, time, transition, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  return Unit_instance;
}
function GameScene$setupUI$lambda$slambda$lambda($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'GameScene.setupUI.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    return new MainMenuScene();
  };
}
function GameScene$showAchievementNotification$slambda$lambda($notification, this$0) {
  return function () {
    var tmp0_safe_receiver = $notification._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this$0.ccc_1.m3(tmp0_safe_receiver);
    }
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_21($this, $this$launch, $completion) {
  var tmp = saveGameState($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var this_0 = $this.jcd_1.oa2();
  var injects = [];
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var time = toDuration(0, DurationUnit_SECONDS_getInstance());
  var transition = this_0.r9x_1;
  var tmp_0 = this_0.mae(getKClass(GameScene), injects.slice(), time, transition, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_22($this, $this$launch, $completion) {
  var tmp = saveGameState($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.kcd_1.qcb_1;
  var tmp_1 = GameScene$openUpgradeTree$slambda$lambda($this.kcd_1);
  var upgScene = new UpgradeTreeScene($this.kcd_1.ocb_1, tmp_0, tmp_1, GameScene$openUpgradeTree$slambda$lambda_0($this.kcd_1));
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var this_0 = $this.kcd_1.oa2();
  var injects = [];
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var time = toDuration(0, DurationUnit_SECONDS_getInstance());
  var transition = this_0.r9x_1;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(UpgradeTreeScene);
  var injects_0 = injects.slice();
  var sceneInjector = this_0.q9x_1.l9q_1.e6c().c6c(getKClass(SceneContainer), this_0).c6c(getKClass(Resources), new Resources(this_0.b17(), this_0.q9x_1.s9y().t37_1, this_0.q9x_1.s9y()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp_2 = getKClassFromExpression(inject);
    sceneInjector.c6c(isInterface(tmp_2, KClass) ? tmp_2 : THROW_CCE(), inject);
  }
  // Inline function 'GameScene.openUpgradeTree.<anonymous>.<anonymous>' call
  var newScene = upgScene;
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_3().ra8_1;
  var level = Level_INFO_getInstance();
  var tmp_3;
  if (this_1.x2x(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$3 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_1.y2x(level, tmp$ret$3);
    tmp_3 = Unit_instance;
  }
  if (true) {
    newScene.n6c(sceneInjector);
    var tmp_4 = getKClassFromExpression(newScene);
    var tmp_5 = isInterface(tmp_4, KClass) ? tmp_4 : THROW_CCE();
    this_0.q9x_1.l9q_1.g6c(tmp_5, GameScene$openUpgradeTree$slambda$lambda_1(sceneInjector, upgScene));
  }
  var tmp_6 = this_0.ta8(newScene, time, transition, $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  return Unit_instance;
}
function GameScene$openUpgradeTree$slambda$lambda$slambda_0(this$0) {
  var i = new GameScene$openUpgradeTree$slambda$lambda$slambda(this$0);
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameScene$openUpgradeTree$slambda$lambda(this$0) {
  return function (returnedScore) {
    set_globalScore(returnedScore);
    var tmp = this$0.ka1();
    launch(tmp, VOID, VOID, GameScene$openUpgradeTree$slambda$lambda$slambda_0(this$0));
    return Unit_instance;
  };
}
function GameScene$openUpgradeTree$slambda$lambda_0(this$0) {
  return function () {
    var tmp0_iterator = this$0.scc_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'GameScene.openUpgradeTree.<anonymous>.<anonymous>.<anonymous>' call
      element.tc5(this$0.ocb_1.qby_1);
    }
    return Unit_instance;
  };
}
function GameScene$openUpgradeTree$slambda$lambda_1($sceneInjector, $upgScene) {
  return function ($this$mapPrototype) {
    // Inline function 'GameScene.openUpgradeTree.<anonymous>.<anonymous>' call
    return $upgScene;
  };
}
function *_generator_invoke__zhh2q8_23($this, $this$launch, $completion) {
  // Inline function 'korlibs.time.seconds' call
  var this_0 = $this.lcd_1.ocb_1.kbz_1;
  var tmp$ret$0 = toDuration(this_0, DurationUnit_SECONDS_getInstance());
  var tmp = delay($this.lcd_1, tmp$ret$0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (!$this.lcd_1.occ_1 && !get_hasWon()) {
    spawnStar($this.mcd_1, $this.lcd_1);
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_24($this, $this$launch, $completion) {
  var tmp = saveGameState($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_25($this, $this$launch, $completion) {
  var tmp = showVictoryScreen($this.ocd_1, $this.ncd_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_26($this, $this$launch, $completion) {
  var tmp = showGameOverScreen($this.qcd_1, $this.pcd_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_27($this, $this$launch, $completion) {
  var tmp = delay_0(new Long(15000, 0), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.rcd_1.kak();
  return Unit_instance;
}
function _get_statsText__ixs61n($this) {
  var tmp = $this.ecc_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('statsText');
  }
}
function _get_resetButton__lir900($this) {
  var tmp = $this.fcc_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('resetButton');
  }
}
function _get_fpsText__d9bdut($this) {
  var tmp = $this.gcc_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('fpsText');
  }
}
function _get_maleBar__yqi039($this) {
  var tmp = $this.hcc_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('maleBar');
  }
}
function _get_femaleBar__wmo3jq($this) {
  var tmp = $this.icc_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('femaleBar');
  }
}
function _get_soundButton__fse1kg($this) {
  var tmp = $this.jcc_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('soundButton');
  }
}
function _get_achievementButton__awzb9s($this) {
  var tmp = $this.kcc_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('achievementButton');
  }
}
function _get_stressTestButton__i3tbir($this) {
  var tmp = $this.lcc_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('stressTestButton');
  }
}
function _get_settingsButton__qak9sa($this) {
  var tmp = $this.mcc_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('settingsButton');
  }
}
function setupAchievements($this) {
  $this.bcc_1.qbv(GameScene$setupAchievements$lambda($this));
}
function setupUI(_this__u8e3s4, $this) {
  var uiX = 30.0;
  var uiStartY = 30.0;
  var uiSpacing = 64.0;
  var currentY = uiStartY;
  var statsFrameWidth = 340.0;
  var statsFrameHeight = uiSpacing * 2.6;
  var statsFrameX = uiX;
  var statsFrameY = currentY - 10.0;
  var borderColor = Colors_getInstance().c43_1;
  var bgColor = Companion_getInstance_1().r4g(borderColor, Colors_getInstance().h40_1, _Ratio___init__impl__9mwvn2(0.6));
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.za4(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.setupUI.<anonymous>' call
  position(this_1, statsFrameX, statsFrameY);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = SolidRect.cbl(Size2D.f2i(statsFrameWidth, statsFrameHeight), bgColor);
  // Inline function 'kotlin.apply' call
  addTo(this_2, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_3 = SolidRect.cbl(Size2D.f2i(statsFrameWidth, 3.0), borderColor);
  // Inline function 'kotlin.apply' call
  var this_4 = addTo(this_3, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_4, 0.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_5 = SolidRect.cbl(Size2D.f2i(statsFrameWidth, 3.0), borderColor);
  // Inline function 'kotlin.apply' call
  var this_6 = addTo(this_5, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_6, 0.0, statsFrameHeight - 3);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_7 = SolidRect.cbl(Size2D.f2i(3.0, statsFrameHeight), borderColor);
  // Inline function 'kotlin.apply' call
  var this_8 = addTo(this_7, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_8, 0.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_9 = SolidRect.cbl(Size2D.f2i(3.0, statsFrameHeight), borderColor);
  // Inline function 'kotlin.apply' call
  var this_10 = addTo(this_9, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_10, statsFrameWidth - 3, 0.0);
  var tmp = $this;
  // Inline function 'korlibs.korge.view.text' call
  var text = Localization_getInstance().hi('fps') + ' 0';
  var textSize = Companion_instance.gbp_1;
  var color = Colors_getInstance().g40_1;
  var font = get_DefaultTtfFontAsBitmap();
  var alignment = Companion_getInstance_2().l4o_1;
  var renderer = get_DefaultStringTextRenderer();
  var autoScaling = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_11 = Text.lbp(text, numberToDouble(textSize), color, font, alignment, renderer, autoScaling, null, null);
  // Inline function 'kotlin.apply' call
  var this_12 = addTo(this_11, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.setupUI.<anonymous>.<anonymous>' call
  this_12.kbp(get_gameFont());
  position(this_12, 20.0, 10.0);
  this_12.dbl(Colors_getInstance().w45_1);
  this_12.obp(32.0);
  tmp.gcc_1 = this_12;
  var tmp_0 = $this;
  // Inline function 'korlibs.korge.view.text' call
  var text_0 = Localization_getInstance().hi('population') + ' ' + $this.rcb_1 + '\n' + Localization_getInstance().hi('collisions') + ' ' + $this.pcb_1 + ' (' + Localization_getInstance().hi('total') + ': ' + get_totalCollisionCount() + ')\n' + Localization_getInstance().hi('score') + ' ' + numberToInt($this.qcb_1);
  var textSize_0 = Companion_instance.gbp_1;
  var color_0 = Colors_getInstance().g40_1;
  var font_0 = get_DefaultTtfFontAsBitmap();
  var alignment_0 = Companion_getInstance_2().l4o_1;
  var renderer_0 = get_DefaultStringTextRenderer();
  var autoScaling_0 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_13 = Text.lbp(text_0, numberToDouble(textSize_0), color_0, font_0, alignment_0, renderer_0, autoScaling_0, null, null);
  // Inline function 'kotlin.apply' call
  var this_14 = addTo(this_13, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.setupUI.<anonymous>.<anonymous>' call
  this_14.kbp(get_gameFont());
  position(this_14, 20.0, 50.0);
  this_14.dbl(Colors_getInstance().g40_1);
  this_14.obp(32.0);
  tmp_0.ecc_1 = this_14;
  currentY = currentY + uiSpacing * 3.0;
  var barWidth = $this.wcc_1 - 60.0;
  var tmp_1 = $this;
  // Inline function 'korlibs.korge.view.solidRect' call
  var color_1 = $this.hcd_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_15 = SolidRect.cbl(Size2D.f2i(0.0, 20.0), color_1);
  // Inline function 'kotlin.apply' call
  var this_16 = addTo(this_15, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.setupUI.<anonymous>' call
  position(this_16, uiX, currentY);
  tmp_1.hcc_1 = this_16;
  var tmp_2 = $this;
  // Inline function 'korlibs.korge.view.solidRect' call
  var color_2 = $this.icd_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_17 = SolidRect.cbl(Size2D.f2i(0.0, 20.0), color_2);
  // Inline function 'kotlin.apply' call
  var this_18 = addTo(this_17, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.setupUI.<anonymous>' call
  position(this_18, uiX, currentY);
  tmp_2.icc_1 = this_18;
  currentY = currentY + uiSpacing;
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_19 = Container.za4(false);
  // Inline function 'kotlin.apply' call
  var this_20 = addTo(this_19, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.setupUI.<anonymous>' call
  var btnWidth = 340.0;
  var btnHeight = 48.0;
  var borderColor_0 = Colors_getInstance().j44_1;
  var bgColor_0 = Companion_getInstance_1().r4g(borderColor_0, Colors_getInstance().h40_1, _Ratio___init__impl__9mwvn2(0.6));
  var bgHoverColor = Companion_getInstance_1().r4g(borderColor_0, Colors_getInstance().h40_1, _Ratio___init__impl__9mwvn2(0.75));
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_21 = SolidRect.cbl(Size2D.f2i(btnWidth, btnHeight), bgColor_0);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  var bg = addTo(this_21, this_20);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_22 = SolidRect.cbl(Size2D.f2i(btnWidth, 3.0), borderColor_0);
  // Inline function 'kotlin.apply' call
  var this_23 = addTo(this_22, this_20);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_23, 0.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_24 = SolidRect.cbl(Size2D.f2i(btnWidth, 3.0), borderColor_0);
  // Inline function 'kotlin.apply' call
  var this_25 = addTo(this_24, this_20);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_25, 0.0, btnHeight - 3);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_26 = SolidRect.cbl(Size2D.f2i(3.0, btnHeight), borderColor_0);
  // Inline function 'kotlin.apply' call
  var this_27 = addTo(this_26, this_20);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_27, 0.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_28 = SolidRect.cbl(Size2D.f2i(3.0, btnHeight), borderColor_0);
  // Inline function 'kotlin.apply' call
  var this_29 = addTo(this_28, this_20);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_29, btnWidth - 3, 0.0);
  // Inline function 'korlibs.korge.view.text' call
  var text_1 = Localization_getInstance().hi('finish_round');
  var textSize_1 = Companion_instance.gbp_1;
  var color_3 = Colors_getInstance().g40_1;
  var font_1 = get_DefaultTtfFontAsBitmap();
  var alignment_1 = Companion_getInstance_2().l4o_1;
  var renderer_1 = get_DefaultStringTextRenderer();
  var autoScaling_1 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_30 = Text.lbp(text_1, numberToDouble(textSize_1), color_3, font_1, alignment_1, renderer_1, autoScaling_1, null, null);
  // Inline function 'kotlin.apply' call
  var this_31 = addTo(this_30, this_20);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.setupUI.<anonymous>.<anonymous>' call
  this_31.kbp(get_gameFont());
  this_31.obp(32.0);
  this_31.dbl(borderColor_0);
  this_31.qbp(Companion_getInstance_2().y4o_1);
  position(this_31, btnWidth / 2, btnHeight / 2.5);
  var btnText = this_31;
  position(this_20, uiX, currentY);
  // Inline function 'korlibs.korge.input.onClick' call
  var handler = GameScene$setupUI$lambda($this, _this__u8e3s4);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop = click$factory_10();
  var tmp1_safe_receiver = this_20 == null ? null : this_20.gai();
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < tmp1_safe_receiver.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var tmp0_safe_receiver = tmp1_safe_receiver.e1(_unary__edvuaz);
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_3 = prop.get(tmp1_safe_receiver_0);
        tmp_3.q20(GameScene$setupUI$lambda_0(handler));
      }
    }
  }
  // Inline function 'korlibs.korge.input.onOver' call
  var handler_0 = GameScene$setupUI$lambda_1(bg, bgHoverColor);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_0 = over$factory_4();
  var tmp1_safe_receiver_1 = this_20 == null ? null : this_20.gai();
  if (tmp1_safe_receiver_1 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_0 = 0;
    while (n_0 < tmp1_safe_receiver_1.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var tmp0_safe_receiver_0 = tmp1_safe_receiver_1.e1(_unary__edvuaz_0);
      var tmp1_safe_receiver_2 = tmp0_safe_receiver_0 == null ? null : get_mouse(tmp0_safe_receiver_0);
      if (tmp1_safe_receiver_2 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_4 = prop_0.get(tmp1_safe_receiver_2);
        tmp_4.q20(GameScene$setupUI$lambda_2(handler_0));
      }
    }
  }
  // Inline function 'korlibs.korge.input.onOut' call
  var handler_1 = GameScene$setupUI$lambda_3(bg, bgColor_0);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_1 = out$factory_4();
  var tmp1_safe_receiver_3 = this_20 == null ? null : this_20.gai();
  if (tmp1_safe_receiver_3 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_1 = 0;
    while (n_1 < tmp1_safe_receiver_3.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_1 = n_1;
      n_1 = _unary__edvuaz_1 + 1 | 0;
      var tmp0_safe_receiver_1 = tmp1_safe_receiver_3.e1(_unary__edvuaz_1);
      var tmp1_safe_receiver_4 = tmp0_safe_receiver_1 == null ? null : get_mouse(tmp0_safe_receiver_1);
      if (tmp1_safe_receiver_4 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_5 = prop_1.get(tmp1_safe_receiver_4);
        tmp_5.q20(GameScene$setupUI$lambda_4(handler_1));
      }
    }
  }
  currentY = currentY + uiSpacing;
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_32 = Container.za4(false);
  // Inline function 'kotlin.apply' call
  var this_33 = addTo(this_32, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.setupUI.<anonymous>' call
  var btnWidth_0 = 340.0;
  var btnHeight_0 = 48.0;
  var borderColor_1 = Colors_getInstance().j40_1;
  var bgColor_1 = Companion_getInstance_1().r4g(borderColor_1, Colors_getInstance().h40_1, _Ratio___init__impl__9mwvn2(0.6));
  var bgHoverColor_0 = Companion_getInstance_1().r4g(borderColor_1, Colors_getInstance().h40_1, _Ratio___init__impl__9mwvn2(0.75));
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_34 = SolidRect.cbl(Size2D.f2i(btnWidth_0, btnHeight_0), bgColor_1);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  var bg_0 = addTo(this_34, this_33);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_35 = SolidRect.cbl(Size2D.f2i(btnWidth_0, 3.0), borderColor_1);
  // Inline function 'kotlin.apply' call
  var this_36 = addTo(this_35, this_33);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_36, 0.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_37 = SolidRect.cbl(Size2D.f2i(btnWidth_0, 3.0), borderColor_1);
  // Inline function 'kotlin.apply' call
  var this_38 = addTo(this_37, this_33);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_38, 0.0, btnHeight_0 - 3);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_39 = SolidRect.cbl(Size2D.f2i(3.0, btnHeight_0), borderColor_1);
  // Inline function 'kotlin.apply' call
  var this_40 = addTo(this_39, this_33);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_40, 0.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_41 = SolidRect.cbl(Size2D.f2i(3.0, btnHeight_0), borderColor_1);
  // Inline function 'kotlin.apply' call
  var this_42 = addTo(this_41, this_33);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_42, btnWidth_0 - 3, 0.0);
  // Inline function 'korlibs.korge.view.text' call
  var text_2 = Localization_getInstance().hi('achievements');
  var textSize_2 = Companion_instance.gbp_1;
  var color_4 = Colors_getInstance().g40_1;
  var font_2 = get_DefaultTtfFontAsBitmap();
  var alignment_2 = Companion_getInstance_2().l4o_1;
  var renderer_2 = get_DefaultStringTextRenderer();
  var autoScaling_2 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_43 = Text.lbp(text_2, numberToDouble(textSize_2), color_4, font_2, alignment_2, renderer_2, autoScaling_2, null, null);
  // Inline function 'kotlin.apply' call
  var this_44 = addTo(this_43, this_33);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.setupUI.<anonymous>.<anonymous>' call
  this_44.kbp(get_gameFont());
  this_44.obp(32.0);
  this_44.dbl(borderColor_1);
  this_44.qbp(Companion_getInstance_2().y4o_1);
  position(this_44, btnWidth_0 / 2, btnHeight_0 / 2.5);
  var btnText_0 = this_44;
  position(this_33, uiX, currentY);
  // Inline function 'korlibs.korge.input.onClick' call
  var handler_2 = GameScene$setupUI$lambda_5($this, _this__u8e3s4);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_2 = click$factory_11();
  var tmp1_safe_receiver_5 = this_33 == null ? null : this_33.gai();
  if (tmp1_safe_receiver_5 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_2 = 0;
    while (n_2 < tmp1_safe_receiver_5.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_2 = n_2;
      n_2 = _unary__edvuaz_2 + 1 | 0;
      var tmp0_safe_receiver_2 = tmp1_safe_receiver_5.e1(_unary__edvuaz_2);
      var tmp1_safe_receiver_6 = tmp0_safe_receiver_2 == null ? null : get_mouse(tmp0_safe_receiver_2);
      if (tmp1_safe_receiver_6 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_6 = prop_2.get(tmp1_safe_receiver_6);
        tmp_6.q20(GameScene$setupUI$lambda_6(handler_2));
      }
    }
  }
  // Inline function 'korlibs.korge.input.onOver' call
  var handler_3 = GameScene$setupUI$lambda_7(bg_0, bgHoverColor_0);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_3 = over$factory_5();
  var tmp1_safe_receiver_7 = this_33 == null ? null : this_33.gai();
  if (tmp1_safe_receiver_7 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_3 = 0;
    while (n_3 < tmp1_safe_receiver_7.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_3 = n_3;
      n_3 = _unary__edvuaz_3 + 1 | 0;
      var tmp0_safe_receiver_3 = tmp1_safe_receiver_7.e1(_unary__edvuaz_3);
      var tmp1_safe_receiver_8 = tmp0_safe_receiver_3 == null ? null : get_mouse(tmp0_safe_receiver_3);
      if (tmp1_safe_receiver_8 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_7 = prop_3.get(tmp1_safe_receiver_8);
        tmp_7.q20(GameScene$setupUI$lambda_8(handler_3));
      }
    }
  }
  // Inline function 'korlibs.korge.input.onOut' call
  var handler_4 = GameScene$setupUI$lambda_9(bg_0, bgColor_1);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_4 = out$factory_5();
  var tmp1_safe_receiver_9 = this_33 == null ? null : this_33.gai();
  if (tmp1_safe_receiver_9 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_4 = 0;
    while (n_4 < tmp1_safe_receiver_9.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_4 = n_4;
      n_4 = _unary__edvuaz_4 + 1 | 0;
      var tmp0_safe_receiver_4 = tmp1_safe_receiver_9.e1(_unary__edvuaz_4);
      var tmp1_safe_receiver_10 = tmp0_safe_receiver_4 == null ? null : get_mouse(tmp0_safe_receiver_4);
      if (tmp1_safe_receiver_10 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_8 = prop_4.get(tmp1_safe_receiver_10);
        tmp_8.q20(GameScene$setupUI$lambda_10(handler_4));
      }
    }
  }
  currentY = currentY + uiSpacing;
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_45 = Container.za4(false);
  // Inline function 'kotlin.apply' call
  var this_46 = addTo(this_45, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.setupUI.<anonymous>' call
  var btnWidth_1 = 340.0;
  var btnHeight_1 = 48.0;
  var borderColor_2 = Colors_getInstance().c43_1;
  var bgColor_2 = Companion_getInstance_1().r4g(borderColor_2, Colors_getInstance().h40_1, _Ratio___init__impl__9mwvn2(0.6));
  var bgHoverColor_1 = Companion_getInstance_1().r4g(borderColor_2, Colors_getInstance().h40_1, _Ratio___init__impl__9mwvn2(0.75));
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_47 = SolidRect.cbl(Size2D.f2i(btnWidth_1, btnHeight_1), bgColor_2);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  var bg_1 = addTo(this_47, this_46);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_48 = SolidRect.cbl(Size2D.f2i(btnWidth_1, 3.0), borderColor_2);
  // Inline function 'kotlin.apply' call
  var this_49 = addTo(this_48, this_46);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_49, 0.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_50 = SolidRect.cbl(Size2D.f2i(btnWidth_1, 3.0), borderColor_2);
  // Inline function 'kotlin.apply' call
  var this_51 = addTo(this_50, this_46);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_51, 0.0, btnHeight_1 - 3);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_52 = SolidRect.cbl(Size2D.f2i(3.0, btnHeight_1), borderColor_2);
  // Inline function 'kotlin.apply' call
  var this_53 = addTo(this_52, this_46);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_53, 0.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_54 = SolidRect.cbl(Size2D.f2i(3.0, btnHeight_1), borderColor_2);
  // Inline function 'kotlin.apply' call
  var this_55 = addTo(this_54, this_46);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_55, btnWidth_1 - 3, 0.0);
  // Inline function 'korlibs.korge.view.text' call
  var text_3 = Localization_getInstance().hi('settings');
  var textSize_3 = Companion_instance.gbp_1;
  var color_5 = Colors_getInstance().g40_1;
  var font_3 = get_DefaultTtfFontAsBitmap();
  var alignment_3 = Companion_getInstance_2().l4o_1;
  var renderer_3 = get_DefaultStringTextRenderer();
  var autoScaling_3 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_56 = Text.lbp(text_3, numberToDouble(textSize_3), color_5, font_3, alignment_3, renderer_3, autoScaling_3, null, null);
  // Inline function 'kotlin.apply' call
  var this_57 = addTo(this_56, this_46);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.setupUI.<anonymous>.<anonymous>' call
  this_57.kbp(get_gameFont());
  this_57.obp(32.0);
  this_57.dbl(borderColor_2);
  this_57.qbp(Companion_getInstance_2().y4o_1);
  position(this_57, btnWidth_1 / 2, btnHeight_1 / 2.5);
  var btnText_1 = this_57;
  position(this_46, uiX, currentY);
  // Inline function 'korlibs.korge.input.onClick' call
  var handler_5 = GameScene$setupUI$lambda_11($this, _this__u8e3s4);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_5 = click$factory_12();
  var tmp1_safe_receiver_11 = this_46 == null ? null : this_46.gai();
  if (tmp1_safe_receiver_11 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_5 = 0;
    while (n_5 < tmp1_safe_receiver_11.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_5 = n_5;
      n_5 = _unary__edvuaz_5 + 1 | 0;
      var tmp0_safe_receiver_5 = tmp1_safe_receiver_11.e1(_unary__edvuaz_5);
      var tmp1_safe_receiver_12 = tmp0_safe_receiver_5 == null ? null : get_mouse(tmp0_safe_receiver_5);
      if (tmp1_safe_receiver_12 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_9 = prop_5.get(tmp1_safe_receiver_12);
        tmp_9.q20(GameScene$setupUI$lambda_12(handler_5));
      }
    }
  }
  // Inline function 'korlibs.korge.input.onOver' call
  var handler_6 = GameScene$setupUI$lambda_13(bg_1, bgHoverColor_1);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_6 = over$factory_6();
  var tmp1_safe_receiver_13 = this_46 == null ? null : this_46.gai();
  if (tmp1_safe_receiver_13 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_6 = 0;
    while (n_6 < tmp1_safe_receiver_13.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_6 = n_6;
      n_6 = _unary__edvuaz_6 + 1 | 0;
      var tmp0_safe_receiver_6 = tmp1_safe_receiver_13.e1(_unary__edvuaz_6);
      var tmp1_safe_receiver_14 = tmp0_safe_receiver_6 == null ? null : get_mouse(tmp0_safe_receiver_6);
      if (tmp1_safe_receiver_14 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_10 = prop_6.get(tmp1_safe_receiver_14);
        tmp_10.q20(GameScene$setupUI$lambda_14(handler_6));
      }
    }
  }
  // Inline function 'korlibs.korge.input.onOut' call
  var handler_7 = GameScene$setupUI$lambda_15(bg_1, bgColor_2);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_7 = out$factory_6();
  var tmp1_safe_receiver_15 = this_46 == null ? null : this_46.gai();
  if (tmp1_safe_receiver_15 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_7 = 0;
    while (n_7 < tmp1_safe_receiver_15.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_7 = n_7;
      n_7 = _unary__edvuaz_7 + 1 | 0;
      var tmp0_safe_receiver_7 = tmp1_safe_receiver_15.e1(_unary__edvuaz_7);
      var tmp1_safe_receiver_16 = tmp0_safe_receiver_7 == null ? null : get_mouse(tmp0_safe_receiver_7);
      if (tmp1_safe_receiver_16 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_11 = prop_7.get(tmp1_safe_receiver_16);
        tmp_11.q20(GameScene$setupUI$lambda_16(handler_7));
      }
    }
  }
  currentY = currentY + uiSpacing;
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_58 = Container.za4(false);
  // Inline function 'kotlin.apply' call
  var this_59 = addTo(this_58, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.setupUI.<anonymous>' call
  var btnWidth_2 = 340.0;
  var btnHeight_2 = 48.0;
  var borderColor_3 = Colors_getInstance().s45_1;
  var bgColor_3 = Companion_getInstance_1().r4g(borderColor_3, Colors_getInstance().h40_1, _Ratio___init__impl__9mwvn2(0.6));
  var bgHoverColor_2 = Companion_getInstance_1().r4g(borderColor_3, Colors_getInstance().h40_1, _Ratio___init__impl__9mwvn2(0.75));
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_60 = SolidRect.cbl(Size2D.f2i(btnWidth_2, btnHeight_2), bgColor_3);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  var bg_2 = addTo(this_60, this_59);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_61 = SolidRect.cbl(Size2D.f2i(btnWidth_2, 3.0), borderColor_3);
  // Inline function 'kotlin.apply' call
  var this_62 = addTo(this_61, this_59);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_62, 0.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_63 = SolidRect.cbl(Size2D.f2i(btnWidth_2, 3.0), borderColor_3);
  // Inline function 'kotlin.apply' call
  var this_64 = addTo(this_63, this_59);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_64, 0.0, btnHeight_2 - 3);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_65 = SolidRect.cbl(Size2D.f2i(3.0, btnHeight_2), borderColor_3);
  // Inline function 'kotlin.apply' call
  var this_66 = addTo(this_65, this_59);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_66, 0.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_67 = SolidRect.cbl(Size2D.f2i(3.0, btnHeight_2), borderColor_3);
  // Inline function 'kotlin.apply' call
  var this_68 = addTo(this_67, this_59);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_68, btnWidth_2 - 3, 0.0);
  // Inline function 'korlibs.korge.view.text' call
  var text_4 = Localization_getInstance().hi('return_to_main_menu');
  var textSize_4 = Companion_instance.gbp_1;
  var color_6 = Colors_getInstance().g40_1;
  var font_4 = get_DefaultTtfFontAsBitmap();
  var alignment_4 = Companion_getInstance_2().l4o_1;
  var renderer_4 = get_DefaultStringTextRenderer();
  var autoScaling_4 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_69 = Text.lbp(text_4, numberToDouble(textSize_4), color_6, font_4, alignment_4, renderer_4, autoScaling_4, null, null);
  // Inline function 'kotlin.apply' call
  var this_70 = addTo(this_69, this_59);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.setupUI.<anonymous>.<anonymous>' call
  this_70.kbp(get_gameFont());
  this_70.obp(32.0);
  this_70.dbl(borderColor_3);
  this_70.qbp(Companion_getInstance_2().y4o_1);
  position(this_70, btnWidth_2 / 2, btnHeight_2 / 2.5);
  var btnText_2 = this_70;
  position(this_59, uiX, currentY);
  // Inline function 'korlibs.korge.input.onClick' call
  var handler_8 = GameScene$setupUI$lambda_17($this);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_8 = click$factory_13();
  var tmp1_safe_receiver_17 = this_59 == null ? null : this_59.gai();
  if (tmp1_safe_receiver_17 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_8 = 0;
    while (n_8 < tmp1_safe_receiver_17.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_8 = n_8;
      n_8 = _unary__edvuaz_8 + 1 | 0;
      var tmp0_safe_receiver_8 = tmp1_safe_receiver_17.e1(_unary__edvuaz_8);
      var tmp1_safe_receiver_18 = tmp0_safe_receiver_8 == null ? null : get_mouse(tmp0_safe_receiver_8);
      if (tmp1_safe_receiver_18 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_12 = prop_8.get(tmp1_safe_receiver_18);
        tmp_12.q20(GameScene$setupUI$lambda_18(handler_8));
      }
    }
  }
  // Inline function 'korlibs.korge.input.onOver' call
  var handler_9 = GameScene$setupUI$lambda_19(bg_2, bgHoverColor_2);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_9 = over$factory_7();
  var tmp1_safe_receiver_19 = this_59 == null ? null : this_59.gai();
  if (tmp1_safe_receiver_19 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_9 = 0;
    while (n_9 < tmp1_safe_receiver_19.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_9 = n_9;
      n_9 = _unary__edvuaz_9 + 1 | 0;
      var tmp0_safe_receiver_9 = tmp1_safe_receiver_19.e1(_unary__edvuaz_9);
      var tmp1_safe_receiver_20 = tmp0_safe_receiver_9 == null ? null : get_mouse(tmp0_safe_receiver_9);
      if (tmp1_safe_receiver_20 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_13 = prop_9.get(tmp1_safe_receiver_20);
        tmp_13.q20(GameScene$setupUI$lambda_20(handler_9));
      }
    }
  }
  // Inline function 'korlibs.korge.input.onOut' call
  var handler_10 = GameScene$setupUI$lambda_21(bg_2, bgColor_3);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_10 = out$factory_7();
  var tmp1_safe_receiver_21 = this_59 == null ? null : this_59.gai();
  if (tmp1_safe_receiver_21 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_10 = 0;
    while (n_10 < tmp1_safe_receiver_21.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_10 = n_10;
      n_10 = _unary__edvuaz_10 + 1 | 0;
      var tmp0_safe_receiver_10 = tmp1_safe_receiver_21.e1(_unary__edvuaz_10);
      var tmp1_safe_receiver_22 = tmp0_safe_receiver_10 == null ? null : get_mouse(tmp0_safe_receiver_10);
      if (tmp1_safe_receiver_22 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_14 = prop_10.get(tmp1_safe_receiver_22);
        tmp_14.q20(GameScene$setupUI$lambda_22(handler_10));
      }
    }
  }
}
function openAchievementPanel(_this__u8e3s4, $this) {
  $this.dcc_1 = true;
  var tmp = _this__u8e3s4.e28();
  var tmp0_elvis_lhs = tmp instanceof Container ? tmp : null;
  var rootContainer = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  new AchievementPanel(rootContainer, $this.bcc_1, GameScene$openAchievementPanel$lambda($this));
}
function openSettingsPanel_0(_this__u8e3s4, $this) {
  $this.ncc_1 = true;
  var tmp = _this__u8e3s4.e28();
  var tmp0_elvis_lhs = tmp instanceof SContainer ? tmp : null;
  var rootContainer = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  var tmp_0 = GameScene$openSettingsPanel$lambda($this);
  createSettingsPanel(rootContainer, $this.acc_1, tmp_0, GameScene$openSettingsPanel$lambda_0($this));
}
function showAchievementNotification($this, achievement) {
  var tmp = $this.oa2();
  launch(tmp, VOID, VOID, GameScene$showAchievementNotification$slambda_0($this, achievement));
}
function openUpgradeTree(_this__u8e3s4, $this) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = $this.ccc_1.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'GameScene.openUpgradeTree.<anonymous>' call
    element.r6();
  }
  $this.ccc_1.k3();
  set_globalScore($this.qcb_1);
  set_currentRunTime(0.0);
  var tmp = $this.ka1();
  launch(tmp, VOID, VOID, GameScene$openUpgradeTree$slambda_0($this));
}
function showGameOverScreen(_this__u8e3s4, $this, $completion) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = $this.ccc_1.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'GameScene.showGameOverScreen.<anonymous>' call
    element.r6();
  }
  $this.ccc_1.k3();
  var parentContainer = _this__u8e3s4;
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.za4(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.showGameOverScreen.<anonymous>' call
  // Inline function 'korlibs.korge.view.solidRect' call
  var width = $this.ka1().p9r_1;
  var height = $this.ka1().q9r_1;
  var color = RGBA__withAd_impl_cralao(Colors_getInstance().h40_1, 0.8);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = SolidRect.cbl(Size2D.f2i(width, height), color);
  // Inline function 'kotlin.apply' call
  addTo(this_2, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  var panelWidth = 500.0;
  var panelHeight = 300.0;
  var panelX = ($this.ka1().p9r_1 - panelWidth) / 2;
  var panelY = ($this.ka1().q9r_1 - panelHeight) / 2;
  // Inline function 'korlibs.korge.view.solidRect' call
  var color_0 = Colors_getInstance().w41_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_3 = SolidRect.cbl(Size2D.f2i(panelWidth, panelHeight), color_0);
  // Inline function 'kotlin.apply' call
  var this_4 = addTo(this_3, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.showGameOverScreen.<anonymous>.<anonymous>' call
  position(this_4, panelX, panelY);
  // Inline function 'korlibs.korge.view.text' call
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var text = Localization_getInstance().hi('no_people_left').toUpperCase();
  var textSize = Companion_instance.gbp_1;
  var color_1 = Colors_getInstance().g40_1;
  var font = get_DefaultTtfFontAsBitmap();
  var alignment = Companion_getInstance_2().l4o_1;
  var renderer = get_DefaultStringTextRenderer();
  var autoScaling = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_5 = Text.lbp(text, numberToDouble(textSize), color_1, font, alignment, renderer, autoScaling, null, null);
  // Inline function 'kotlin.apply' call
  var this_6 = addTo(this_5, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.showGameOverScreen.<anonymous>.<anonymous>' call
  this_6.kbp(get_gameFont());
  position(this_6, panelX + panelWidth / 2 - 150, panelY + 20);
  this_6.dbl(Colors_getInstance().i40_1);
  this_6.obp(60.0);
  // Inline function 'korlibs.korge.view.text' call
  var text_0 = Localization_getInstance().hi('game_over_message');
  var textSize_0 = Companion_instance.gbp_1;
  var color_2 = Colors_getInstance().g40_1;
  var font_0 = get_DefaultTtfFontAsBitmap();
  var alignment_0 = Companion_getInstance_2().l4o_1;
  var renderer_0 = get_DefaultStringTextRenderer();
  var autoScaling_0 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_7 = Text.lbp(text_0, numberToDouble(textSize_0), color_2, font_0, alignment_0, renderer_0, autoScaling_0, null, null);
  // Inline function 'kotlin.apply' call
  var this_8 = addTo(this_7, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.showGameOverScreen.<anonymous>.<anonymous>' call
  this_8.kbp(get_gameFont());
  position(this_8, panelX + panelWidth / 2 - 150, panelY + 100);
  this_8.dbl(Colors_getInstance().g40_1);
  this_8.obp(32.0);
  var panel = this_1;
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_9 = Container.za4(false);
  // Inline function 'kotlin.apply' call
  var this_10 = addTo(this_9, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.showGameOverScreen.<anonymous>.<anonymous>' call
  var btnWidth = 340.0;
  var btnHeight = 48.0;
  var borderColor = Colors_getInstance().l42_1;
  var bgColor = Companion_getInstance_1().r4g(borderColor, Colors_getInstance().h40_1, _Ratio___init__impl__9mwvn2(0.6));
  var bgHoverColor = Companion_getInstance_1().r4g(borderColor, Colors_getInstance().h40_1, _Ratio___init__impl__9mwvn2(0.75));
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_11 = SolidRect.cbl(Size2D.f2i(btnWidth, btnHeight), bgColor);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  var bg = addTo(this_11, this_10);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_12 = SolidRect.cbl(Size2D.f2i(btnWidth, 3.0), borderColor);
  // Inline function 'kotlin.apply' call
  var this_13 = addTo(this_12, this_10);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_13, 0.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_14 = SolidRect.cbl(Size2D.f2i(btnWidth, 3.0), borderColor);
  // Inline function 'kotlin.apply' call
  var this_15 = addTo(this_14, this_10);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_15, 0.0, btnHeight - 3);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_16 = SolidRect.cbl(Size2D.f2i(3.0, btnHeight), borderColor);
  // Inline function 'kotlin.apply' call
  var this_17 = addTo(this_16, this_10);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_17, 0.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_18 = SolidRect.cbl(Size2D.f2i(3.0, btnHeight), borderColor);
  // Inline function 'kotlin.apply' call
  var this_19 = addTo(this_18, this_10);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  position(this_19, btnWidth - 3, 0.0);
  // Inline function 'korlibs.korge.view.text' call
  var text_1 = '\uD83D\uDCCA ' + Localization_getInstance().hi('open_upgrades');
  var textSize_1 = Companion_instance.gbp_1;
  var color_3 = Colors_getInstance().g40_1;
  var font_1 = get_DefaultTtfFontAsBitmap();
  var alignment_1 = Companion_getInstance_2().l4o_1;
  var renderer_1 = get_DefaultStringTextRenderer();
  var autoScaling_1 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_20 = Text.lbp(text_1, numberToDouble(textSize_1), color_3, font_1, alignment_1, renderer_1, autoScaling_1, null, null);
  // Inline function 'kotlin.apply' call
  var this_21 = addTo(this_20, this_10);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.showGameOverScreen.<anonymous>.<anonymous>.<anonymous>' call
  this_21.kbp(get_gameFont());
  this_21.obp(32.0);
  this_21.dbl(borderColor);
  this_21.qbp(Companion_getInstance_2().y4o_1);
  position(this_21, btnWidth / 2, btnHeight / 2 - 2);
  var btnText = this_21;
  position(this_10, panelX + panelWidth / 2 - btnWidth / 2, panelY + panelHeight - 80);
  // Inline function 'korlibs.korge.input.onClick' call
  var handler = GameScene$showGameOverScreen$lambda(panel, $this, parentContainer);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop = click$factory_14();
  var tmp1_safe_receiver = this_10 == null ? null : this_10.gai();
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < tmp1_safe_receiver.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var tmp0_safe_receiver = tmp1_safe_receiver.e1(_unary__edvuaz);
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp = prop.get(tmp1_safe_receiver_0);
        tmp.q20(GameScene$showGameOverScreen$lambda_0(handler));
      }
    }
  }
  // Inline function 'korlibs.korge.input.onOver' call
  var handler_0 = GameScene$showGameOverScreen$lambda_1(bg, bgHoverColor);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_0 = over$factory_8();
  var tmp1_safe_receiver_1 = this_10 == null ? null : this_10.gai();
  if (tmp1_safe_receiver_1 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_0 = 0;
    while (n_0 < tmp1_safe_receiver_1.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var tmp0_safe_receiver_0 = tmp1_safe_receiver_1.e1(_unary__edvuaz_0);
      var tmp1_safe_receiver_2 = tmp0_safe_receiver_0 == null ? null : get_mouse(tmp0_safe_receiver_0);
      if (tmp1_safe_receiver_2 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0 = prop_0.get(tmp1_safe_receiver_2);
        tmp_0.q20(GameScene$showGameOverScreen$lambda_2(handler_0));
      }
    }
  }
  // Inline function 'korlibs.korge.input.onOut' call
  var handler_1 = GameScene$showGameOverScreen$lambda_3(bg, bgColor);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_1 = out$factory_8();
  var tmp1_safe_receiver_3 = this_10 == null ? null : this_10.gai();
  if (tmp1_safe_receiver_3 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_1 = 0;
    while (n_1 < tmp1_safe_receiver_3.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_1 = n_1;
      n_1 = _unary__edvuaz_1 + 1 | 0;
      var tmp0_safe_receiver_1 = tmp1_safe_receiver_3.e1(_unary__edvuaz_1);
      var tmp1_safe_receiver_4 = tmp0_safe_receiver_1 == null ? null : get_mouse(tmp0_safe_receiver_1);
      if (tmp1_safe_receiver_4 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_1 = prop_1.get(tmp1_safe_receiver_4);
        tmp_1.q20(GameScene$showGameOverScreen$lambda_4(handler_1));
      }
    }
  }
}
function showVictoryScreen(_this__u8e3s4, $this, $completion) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = $this.ccc_1.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'GameScene.showVictoryScreen.<anonymous>' call
    element.r6();
  }
  $this.ccc_1.k3();
  var parentContainer = _this__u8e3s4;
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.za4(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.showVictoryScreen.<anonymous>' call
  // Inline function 'korlibs.korge.view.solidRect' call
  var width = $this.ka1().p9r_1;
  var height = $this.ka1().q9r_1;
  var color = RGBA__withAd_impl_cralao(Colors_getInstance().h40_1, 0.85);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = SolidRect.cbl(Size2D.f2i(width, height), color);
  // Inline function 'kotlin.apply' call
  addTo(this_2, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  var panelWidth = 650.0;
  var panelHeight = 550.0;
  var panelX = ($this.ka1().p9r_1 - panelWidth) / 2;
  var panelY = ($this.ka1().q9r_1 - panelHeight) / 2;
  // Inline function 'korlibs.korge.view.solidRect' call
  var color_0 = Colors_getInstance().k41_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_3 = SolidRect.cbl(Size2D.f2i(panelWidth, panelHeight), color_0);
  // Inline function 'kotlin.apply' call
  var this_4 = addTo(this_3, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.showVictoryScreen.<anonymous>.<anonymous>' call
  position(this_4, panelX, panelY);
  // Inline function 'korlibs.korge.view.graphics' call
  var renderer = GraphicsRenderer_SYSTEM_getInstance();
  // Inline function 'kotlin.also' call
  var this_5 = addTo(Graphics.pbf(EmptyShape_instance, renderer), this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.graphics.<anonymous>' call
  // Inline function 'korlibs.korge.view.Graphics.updateShape' call
  var result;
  // Inline function 'korlibs.image.vector.buildShape' call
  // Inline function 'kotlin.apply' call
  var this_6 = new ShapeBuilder(null, null);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
  // Inline function 'GameScene.showVictoryScreen.<anonymous>.<anonymous>' call
  // Inline function 'korlibs.image.vector.Context2d.stroke' call
  var paint = new RGBA(Colors_getInstance().l42_1);
  var lineCap = this_6.t4q();
  var lineJoin = this_6.u4q();
  var miterLimit = this_6.v4q();
  var lineDash = this_6.w4q();
  var lineDashOffset = this_6.x4q();
  if (true) {
    this_6.f4p();
  }
  // Inline function 'GameScene.showVictoryScreen.<anonymous>.<anonymous>.<anonymous>' call
  this_6.z3q(panelX, panelY, panelWidth, panelHeight);
  // Inline function 'korlibs.image.vector.Context2d.keep' call
  this_6.y4q();
  try {
    // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
    this_6.z4q(numberToDouble(4.0));
    this_6.a4r(lineCap);
    this_6.b4r(lineJoin);
    this_6.c4r(numberToDouble(miterLimit));
    this_6.d4r(lineDash);
    this_6.e4r(numberToDouble(lineDashOffset));
    this_6.f4r(paint);
  }finally {
    this_6.g4r();
  }
  result = Unit_instance;
  var tmp$ret$8 = this_6.n4n();
  this_5.nbf(tmp$ret$8);
  this_5.tbf();
  // Inline function 'korlibs.korge.view.text' call
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var text = '\uD83C\uDF89 ' + Localization_getInstance().hi('congratulations').toUpperCase() + '! \uD83C\uDF89';
  var textSize = Companion_instance.gbp_1;
  var color_1 = Colors_getInstance().g40_1;
  var font = get_DefaultTtfFontAsBitmap();
  var alignment = Companion_getInstance_2().l4o_1;
  var renderer_0 = get_DefaultStringTextRenderer();
  var autoScaling = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_7 = Text.lbp(text, numberToDouble(textSize), color_1, font, alignment, renderer_0, autoScaling, null, null);
  // Inline function 'kotlin.apply' call
  var this_8 = addTo(this_7, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.showVictoryScreen.<anonymous>.<anonymous>' call
  position(this_8, panelX + panelWidth / 2 - 220, panelY + 50);
  this_8.dbl(Colors_getInstance().l42_1);
  this_8.obp(58.0);
  // Inline function 'korlibs.korge.view.text' call
  var text_0 = Localization_getInstance().hi('victory_message');
  var textSize_0 = Companion_instance.gbp_1;
  var color_2 = Colors_getInstance().g40_1;
  var font_0 = get_DefaultTtfFontAsBitmap();
  var alignment_0 = Companion_getInstance_2().l4o_1;
  var renderer_1 = get_DefaultStringTextRenderer();
  var autoScaling_0 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_9 = Text.lbp(text_0, numberToDouble(textSize_0), color_2, font_0, alignment_0, renderer_1, autoScaling_0, null, null);
  // Inline function 'kotlin.apply' call
  var this_10 = addTo(this_9, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.showVictoryScreen.<anonymous>.<anonymous>' call
  this_10.kbp(get_gameFont());
  position(this_10, panelX + panelWidth / 2 - 150, panelY + 130);
  this_10.dbl(Colors_getInstance().g40_1);
  this_10.obp(28.0);
  // Inline function 'korlibs.korge.view.text' call
  var text_1 = Localization_getInstance().hi('session_time') + ' ' + showVictoryScreen$_anonymous_$formatTime_e5459a(get_currentRunTime());
  var textSize_1 = Companion_instance.gbp_1;
  var color_3 = Colors_getInstance().g40_1;
  var font_1 = get_DefaultTtfFontAsBitmap();
  var alignment_1 = Companion_getInstance_2().l4o_1;
  var renderer_2 = get_DefaultStringTextRenderer();
  var autoScaling_1 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_11 = Text.lbp(text_1, numberToDouble(textSize_1), color_3, font_1, alignment_1, renderer_2, autoScaling_1, null, null);
  // Inline function 'kotlin.apply' call
  var this_12 = addTo(this_11, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.showVictoryScreen.<anonymous>.<anonymous>' call
  this_12.kbp(get_gameFont());
  position(this_12, panelX + panelWidth / 2 - 100, panelY + 190);
  this_12.dbl(Colors_getInstance().d43_1);
  this_12.obp(30.0);
  // Inline function 'korlibs.korge.view.text' call
  var text_2 = Localization_getInstance().hi('total_time_played') + ' ' + showVictoryScreen$_anonymous_$formatTime_e5459a(get_totalGameTime());
  var textSize_2 = Companion_instance.gbp_1;
  var color_4 = Colors_getInstance().g40_1;
  var font_2 = get_DefaultTtfFontAsBitmap();
  var alignment_2 = Companion_getInstance_2().l4o_1;
  var renderer_3 = get_DefaultStringTextRenderer();
  var autoScaling_2 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_13 = Text.lbp(text_2, numberToDouble(textSize_2), color_4, font_2, alignment_2, renderer_3, autoScaling_2, null, null);
  // Inline function 'kotlin.apply' call
  var this_14 = addTo(this_13, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.showVictoryScreen.<anonymous>.<anonymous>' call
  this_14.kbp(get_gameFont());
  position(this_14, panelX + panelWidth / 2 - 110, panelY + 230);
  this_14.dbl(Colors_getInstance().y42_1);
  this_14.obp(30.0);
  // Inline function 'korlibs.korge.view.text' call
  var text_3 = Localization_getInstance().hi('thank_you');
  var textSize_3 = Companion_instance.gbp_1;
  var color_5 = Colors_getInstance().g40_1;
  var font_3 = get_DefaultTtfFontAsBitmap();
  var alignment_3 = Companion_getInstance_2().l4o_1;
  var renderer_4 = get_DefaultStringTextRenderer();
  var autoScaling_3 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_15 = Text.lbp(text_3, numberToDouble(textSize_3), color_5, font_3, alignment_3, renderer_4, autoScaling_3, null, null);
  // Inline function 'kotlin.apply' call
  var this_16 = addTo(this_15, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.showVictoryScreen.<anonymous>.<anonymous>' call
  this_16.kbp(get_gameFont());
  position(this_16, panelX + panelWidth / 2 - 160, panelY + 290);
  this_16.dbl(Colors_getInstance().c43_1);
  this_16.obp(38.0);
  // Inline function 'korlibs.korge.view.text' call
  var text_4 = Localization_getInstance().hi('created_by');
  var textSize_4 = Companion_instance.gbp_1;
  var color_6 = Colors_getInstance().g40_1;
  var font_4 = get_DefaultTtfFontAsBitmap();
  var alignment_4 = Companion_getInstance_2().l4o_1;
  var renderer_5 = get_DefaultStringTextRenderer();
  var autoScaling_4 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_17 = Text.lbp(text_4, numberToDouble(textSize_4), color_6, font_4, alignment_4, renderer_5, autoScaling_4, null, null);
  // Inline function 'kotlin.apply' call
  var this_18 = addTo(this_17, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.showVictoryScreen.<anonymous>.<anonymous>' call
  this_18.kbp(get_gameFont());
  position(this_18, panelX + panelWidth / 2 - 170, panelY + 340);
  this_18.dbl(Colors_getInstance().f45_1);
  this_18.obp(30.0);
  var panel = this_1;
  // Inline function 'korlibs.korge.view.text' call
  var text_5 = '\uD83C\uDFAE ' + Localization_getInstance().hi('continue_playing');
  var textSize_5 = Companion_instance.gbp_1;
  var color_7 = Colors_getInstance().g40_1;
  var font_5 = get_DefaultTtfFontAsBitmap();
  var alignment_5 = Companion_getInstance_2().l4o_1;
  var renderer_6 = get_DefaultStringTextRenderer();
  var autoScaling_5 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_19 = Text.lbp(text_5, numberToDouble(textSize_5), color_7, font_5, alignment_5, renderer_6, autoScaling_5, null, null);
  // Inline function 'kotlin.apply' call
  var this_20 = addTo(this_19, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.showVictoryScreen.<anonymous>.<anonymous>' call
  position(this_20, panelX + panelWidth / 2 - 150, panelY + panelHeight - 130);
  this_20.dbl(Colors_getInstance().y42_1);
  this_20.obp(40.0);
  // Inline function 'korlibs.korge.input.onClick' call
  var handler = GameScene$showVictoryScreen$lambda(panel, $this);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop = click$factory_15();
  var tmp1_safe_receiver = this_20 == null ? null : this_20.gai();
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < tmp1_safe_receiver.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var tmp0_safe_receiver = tmp1_safe_receiver.e1(_unary__edvuaz);
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp = prop.get(tmp1_safe_receiver_0);
        tmp.q20(GameScene$showVictoryScreen$lambda_0(handler));
      }
    }
  }
  // Inline function 'korlibs.korge.view.text' call
  var text_6 = '\uD83D\uDCCA ' + Localization_getInstance().hi('open_upgrades');
  var textSize_6 = Companion_instance.gbp_1;
  var color_8 = Colors_getInstance().g40_1;
  var font_6 = get_DefaultTtfFontAsBitmap();
  var alignment_6 = Companion_getInstance_2().l4o_1;
  var renderer_7 = get_DefaultStringTextRenderer();
  var autoScaling_6 = Companion_instance.hbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_21 = Text.lbp(text_6, numberToDouble(textSize_6), color_8, font_6, alignment_6, renderer_7, autoScaling_6, null, null);
  // Inline function 'kotlin.apply' call
  var this_22 = addTo(this_21, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.showVictoryScreen.<anonymous>.<anonymous>' call
  position(this_22, panelX + panelWidth / 2 - 130, panelY + panelHeight - 70);
  this_22.dbl(Colors_getInstance().l42_1);
  this_22.obp(28.0);
  // Inline function 'korlibs.korge.input.onClick' call
  var handler_0 = GameScene$showVictoryScreen$lambda_1(panel, $this, parentContainer);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_0 = click$factory_16();
  var tmp1_safe_receiver_1 = this_22 == null ? null : this_22.gai();
  if (tmp1_safe_receiver_1 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_0 = 0;
    while (n_0 < tmp1_safe_receiver_1.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var tmp0_safe_receiver_0 = tmp1_safe_receiver_1.e1(_unary__edvuaz_0);
      var tmp1_safe_receiver_2 = tmp0_safe_receiver_0 == null ? null : get_mouse(tmp0_safe_receiver_0);
      if (tmp1_safe_receiver_2 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0 = prop_0.get(tmp1_safe_receiver_2);
        tmp_0.q20(GameScene$showVictoryScreen$lambda_2(handler_0));
      }
    }
  }
}
function setupContainer(_this__u8e3s4, $this) {
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.za4(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.setupContainer.<anonymous>' call
  position(this_1, $this.dcd_1, $this.ecd_1);
  // Inline function 'korlibs.korge.view.graphics' call
  var renderer = GraphicsRenderer_SYSTEM_getInstance();
  // Inline function 'kotlin.also' call
  var this_2 = addTo(Graphics.pbf(EmptyShape_instance, renderer), this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.graphics.<anonymous>' call
  // Inline function 'korlibs.korge.view.Graphics.updateShape' call
  var result;
  // Inline function 'korlibs.image.vector.buildShape' call
  // Inline function 'kotlin.apply' call
  var this_3 = new ShapeBuilder(null, null);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
  // Inline function 'GameScene.setupContainer.<anonymous>.<anonymous>' call
  // Inline function 'korlibs.image.vector.Context2d.stroke' call
  var paint = new RGBA(Colors_getInstance().g40_1);
  var lineCap = this_3.t4q();
  var lineJoin = this_3.u4q();
  var miterLimit = this_3.v4q();
  var lineDash = this_3.w4q();
  var lineDashOffset = this_3.x4q();
  if (true) {
    this_3.f4p();
  }
  // Inline function 'GameScene.setupContainer.<anonymous>.<anonymous>.<anonymous>' call
  this_3.z3q(0.0, 0.0, $this.xcc_1, $this.ycc_1);
  // Inline function 'korlibs.image.vector.Context2d.keep' call
  this_3.y4q();
  try {
    // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
    this_3.z4q(numberToDouble(3.0));
    this_3.a4r(lineCap);
    this_3.b4r(lineJoin);
    this_3.c4r(numberToDouble(miterLimit));
    this_3.d4r(lineDash);
    this_3.e4r(numberToDouble(lineDashOffset));
    this_3.f4r(paint);
  }finally {
    this_3.g4r();
  }
  result = Unit_instance;
  var tmp$ret$1 = this_3.n4n();
  this_2.nbf(tmp$ret$1);
  this_2.tbf();
  // Inline function 'korlibs.korge.view.graphics' call
  var renderer_0 = GraphicsRenderer_SYSTEM_getInstance();
  // Inline function 'kotlin.also' call
  var this_4 = addTo(Graphics.pbf(EmptyShape_instance, renderer_0), this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.graphics.<anonymous>' call
  // Inline function 'korlibs.korge.view.Graphics.updateShape' call
  var result_0;
  // Inline function 'korlibs.image.vector.buildShape' call
  // Inline function 'kotlin.apply' call
  var this_5 = new ShapeBuilder(null, null);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
  // Inline function 'GameScene.setupContainer.<anonymous>.<anonymous>' call
  // Inline function 'korlibs.image.vector.Context2d.stroke' call
  var paint_0 = new RGBA(Colors_getInstance().j41_1);
  var lineCap_0 = this_5.t4q();
  var lineJoin_0 = this_5.u4q();
  var miterLimit_0 = this_5.v4q();
  var lineDash_0 = this_5.w4q();
  var lineDashOffset_0 = this_5.x4q();
  if (true) {
    this_5.f4p();
  }
  // Inline function 'GameScene.setupContainer.<anonymous>.<anonymous>.<anonymous>' call
  this_5.z3q(-3.0, -3.0, $this.xcc_1 + 6.0, $this.ycc_1 + 6.0);
  // Inline function 'korlibs.image.vector.Context2d.keep' call
  this_5.y4q();
  try {
    // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
    this_5.z4q(numberToDouble(6.0));
    this_5.a4r(lineCap_0);
    this_5.b4r(lineJoin_0);
    this_5.c4r(numberToDouble(miterLimit_0));
    this_5.d4r(lineDash_0);
    this_5.e4r(numberToDouble(lineDashOffset_0));
    this_5.f4r(paint_0);
  }finally {
    this_5.g4r();
  }
  result_0 = Unit_instance;
  var tmp$ret$6 = this_5.n4n();
  this_4.nbf(tmp$ret$6);
  this_4.tbf();
  // Inline function 'korlibs.korge.view.graphics' call
  var renderer_1 = GraphicsRenderer_SYSTEM_getInstance();
  // Inline function 'kotlin.also' call
  var this_6 = addTo(Graphics.pbf(EmptyShape_instance, renderer_1), this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.graphics.<anonymous>' call
  // Inline function 'korlibs.korge.view.Graphics.updateShape' call
  var result_1;
  // Inline function 'korlibs.image.vector.buildShape' call
  // Inline function 'kotlin.apply' call
  var this_7 = new ShapeBuilder(null, null);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
  // Inline function 'GameScene.setupContainer.<anonymous>.<anonymous>' call
  // Inline function 'korlibs.image.vector.Context2d.stroke' call
  var paint_1 = new RGBA(Colors_getInstance().c43_1);
  var lineCap_1 = this_7.t4q();
  var lineJoin_1 = this_7.u4q();
  var miterLimit_1 = this_7.v4q();
  var lineDash_1 = this_7.w4q();
  var lineDashOffset_1 = this_7.x4q();
  if (true) {
    this_7.f4p();
  }
  // Inline function 'GameScene.setupContainer.<anonymous>.<anonymous>.<anonymous>' call
  this_7.z3q(-1.5, -1.5, $this.xcc_1 + 3.0, $this.ycc_1 + 3.0);
  // Inline function 'korlibs.image.vector.Context2d.keep' call
  this_7.y4q();
  try {
    // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
    this_7.z4q(numberToDouble(1.0));
    this_7.a4r(lineCap_1);
    this_7.b4r(lineJoin_1);
    this_7.c4r(numberToDouble(miterLimit_1));
    this_7.d4r(lineDash_1);
    this_7.e4r(numberToDouble(lineDashOffset_1));
    this_7.f4r(paint_1);
  }finally {
    this_7.g4r();
  }
  result_1 = Unit_instance;
  var tmp$ret$11 = this_7.n4n();
  this_6.nbf(tmp$ret$11);
  this_6.tbf();
}
function setupClickStar(_this__u8e3s4, $this) {
  spawnStar(_this__u8e3s4, $this);
}
function spawnStar(_this__u8e3s4, $this) {
  if ($this.occ_1)
    return Unit_instance;
  var tmp0_safe_receiver = $this.qcc_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.kak();
  }
  var randomX = $this.dcd_1 + Default_getInstance().xo(40.0, $this.xcc_1 - 40.0);
  var randomY = $this.ecd_1 + Default_getInstance().xo(40.0, $this.ycc_1 - 40.0);
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.za4(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.spawnStar.<anonymous>' call
  position(this_1, randomX, randomY);
  var starColor = Colors_getInstance().w45_1;
  var outlineColor = Colors_getInstance().j44_1;
  var outerRadius = 20.0;
  var innerRadius = 8.0;
  var centerX = 0.0;
  var centerY = 0.0;
  // Inline function 'kotlin.collections.mutableListOf' call
  var points = ArrayList.j1();
  var inductionVariable = 0;
  if (inductionVariable < 10)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var angle = (i * 36.0 - 90.0) * 3.141592653589793 / 180.0;
      var radius = (i % 2 | 0) === 0 ? outerRadius : innerRadius;
      // Inline function 'kotlin.math.cos' call
      var x = centerX + radius * Math.cos(angle);
      // Inline function 'kotlin.math.sin' call
      var y = centerY + radius * Math.sin(angle);
      points.h(new Pair(x, y));
    }
     while (inductionVariable < 10);
  // Inline function 'kotlin.collections.minOf' call
  var iterator = points.b1();
  if (!iterator.c1())
    throw NoSuchElementException.v6();
  // Inline function 'GameScene.spawnStar.<anonymous>.<anonymous>' call
  var minValue = iterator.d1().ll_1;
  while (iterator.c1()) {
    // Inline function 'GameScene.spawnStar.<anonymous>.<anonymous>' call
    var v = iterator.d1().ll_1;
    // Inline function 'kotlin.comparisons.minOf' call
    var a = minValue;
    minValue = Math.min(a, v);
  }
  var tmp$ret$6 = minValue;
  var minX = numberToInt(tmp$ret$6) - 1 | 0;
  // Inline function 'kotlin.collections.maxOf' call
  var iterator_0 = points.b1();
  if (!iterator_0.c1())
    throw NoSuchElementException.v6();
  // Inline function 'GameScene.spawnStar.<anonymous>.<anonymous>' call
  var maxValue = iterator_0.d1().ll_1;
  while (iterator_0.c1()) {
    // Inline function 'GameScene.spawnStar.<anonymous>.<anonymous>' call
    var v_0 = iterator_0.d1().ll_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_0 = maxValue;
    maxValue = Math.max(a_0, v_0);
  }
  var tmp$ret$10 = maxValue;
  var maxX = numberToInt(tmp$ret$10) + 1 | 0;
  // Inline function 'kotlin.collections.minOf' call
  var iterator_1 = points.b1();
  if (!iterator_1.c1())
    throw NoSuchElementException.v6();
  // Inline function 'GameScene.spawnStar.<anonymous>.<anonymous>' call
  var minValue_0 = iterator_1.d1().ml_1;
  while (iterator_1.c1()) {
    // Inline function 'GameScene.spawnStar.<anonymous>.<anonymous>' call
    var v_1 = iterator_1.d1().ml_1;
    // Inline function 'kotlin.comparisons.minOf' call
    var a_1 = minValue_0;
    minValue_0 = Math.min(a_1, v_1);
  }
  var tmp$ret$14 = minValue_0;
  var minY = numberToInt(tmp$ret$14) - 1 | 0;
  // Inline function 'kotlin.collections.maxOf' call
  var iterator_2 = points.b1();
  if (!iterator_2.c1())
    throw NoSuchElementException.v6();
  // Inline function 'GameScene.spawnStar.<anonymous>.<anonymous>' call
  var maxValue_0 = iterator_2.d1().ml_1;
  while (iterator_2.c1()) {
    // Inline function 'GameScene.spawnStar.<anonymous>.<anonymous>' call
    var v_2 = iterator_2.d1().ml_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_2 = maxValue_0;
    maxValue_0 = Math.max(a_2, v_2);
  }
  var tmp$ret$18 = maxValue_0;
  var maxY = numberToInt(tmp$ret$18) + 1 | 0;
  var inductionVariable_0 = minY;
  if (inductionVariable_0 <= maxY)
    do {
      var py = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var inductionVariable_1 = minX;
      if (inductionVariable_1 <= maxX)
        do {
          var px = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          if (isPointInPolygon($this, px, py, points)) {
            // Inline function 'korlibs.korge.view.solidRect' call
            // Inline function 'korlibs.korge.view.addTo' call
            var this_2 = SolidRect.cbl(Size2D.f2i(2.0, 2.0), starColor);
            // Inline function 'kotlin.apply' call
            var this_3 = addTo(this_2, this_1);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'GameScene.spawnStar.<anonymous>.<anonymous>' call
            position(this_3, px, py);
          }
        }
         while (!(px === maxX));
    }
     while (!(py === maxY));
  var inductionVariable_2 = 0;
  var last = points.f1() - 1 | 0;
  if (inductionVariable_2 <= last)
    do {
      var i_0 = inductionVariable_2;
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      var p1 = points.e1(i_0);
      var p2 = points.e1((i_0 + 1 | 0) % points.f1() | 0);
      drawLine(this_1, $this, p1.ll_1, p1.ml_1, p2.ll_1, p2.ml_1, outlineColor);
    }
     while (inductionVariable_2 <= last);
  var starContainer = this_1;
  // Inline function 'korlibs.korge.input.onClick' call
  var handler = GameScene$spawnStar$lambda($this, starContainer, _this__u8e3s4);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop = click$factory_17();
  var tmp1_safe_receiver = starContainer == null ? null : starContainer.gai();
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < tmp1_safe_receiver.f1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var tmp0_safe_receiver_0 = tmp1_safe_receiver.e1(_unary__edvuaz);
      var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : get_mouse(tmp0_safe_receiver_0);
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp = prop.get(tmp1_safe_receiver_0);
        tmp.q20(GameScene$spawnStar$lambda_0(handler));
      }
    }
  }
  $this.qcc_1 = starContainer;
}
function spawnInitialSquares(_this__u8e3s4, $this) {
  var totalToSpawn = $this.ocb_1.hbz_1;
  var males = totalToSpawn / 2 | 0;
  var females = totalToSpawn / 2 | 0;
  var remaining = totalToSpawn % 2 | 0;
  var inductionVariable = 0;
  if (inductionVariable < males)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var x = $this.dcd_1 + Default_getInstance().xo(50.0, $this.xcc_1 - 50.0);
      var y = $this.ecd_1 + Default_getInstance().xo(50.0, $this.ycc_1 - 50.0);
      var velocityX = Default_getInstance().xo(-80.0, 80.0);
      var velocityY = Default_getInstance().xo(-80.0, 80.0);
      createSquare(_this__u8e3s4, $this, x, y, Vector2D.k2c(velocityX, velocityY), Gender_MALE_getInstance());
    }
     while (inductionVariable < males);
  var inductionVariable_0 = 0;
  if (inductionVariable_0 < females)
    do {
      var i_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var x_0 = $this.dcd_1 + Default_getInstance().xo(50.0, $this.xcc_1 - 50.0);
      var y_0 = $this.ecd_1 + Default_getInstance().xo(50.0, $this.ycc_1 - 50.0);
      var velocityX_0 = Default_getInstance().xo(-80.0, 80.0);
      var velocityY_0 = Default_getInstance().xo(-80.0, 80.0);
      createSquare(_this__u8e3s4, $this, x_0, y_0, Vector2D.k2c(velocityX_0, velocityY_0), Gender_FEMALE_getInstance());
    }
     while (inductionVariable_0 < females);
  if (remaining > 0) {
    var x_1 = $this.dcd_1 + Default_getInstance().xo(50.0, $this.xcc_1 - 50.0);
    var y_1 = $this.ecd_1 + Default_getInstance().xo(50.0, $this.ycc_1 - 50.0);
    var velocityX_1 = Default_getInstance().xo(-80.0, 80.0);
    var velocityY_1 = Default_getInstance().xo(-80.0, 80.0);
    var randomGender = Default_getInstance().wo() > 0.5 ? Gender_MALE_getInstance() : Gender_FEMALE_getInstance();
    createSquare(_this__u8e3s4, $this, x_1, y_1, Vector2D.k2c(velocityX_1, velocityY_1), randomGender);
  }
  $this.rcb_1 = $this.scc_1.f1();
  updateGenderRatio($this);
  updateStats($this);
}
function setupGameLoop(_this__u8e3s4, $this) {
  var accumulator = {_v: 0.0};
  var fixedDeltaTime = 1.0 / 60.0;
  var autoSaveTimer = {_v: 0.0};
  var autoSaveInterval = 30.0;
  var autoSpawnTimer = {_v: 0.0};
  addUpdater(_this__u8e3s4, GameScene$setupGameLoop$lambda(accumulator, $this, autoSaveTimer, autoSaveInterval, fixedDeltaTime, autoSpawnTimer));
}
function updateFPS($this, deltaTime) {
  $this.xcb_1 = $this.xcb_1 + 1 | 0;
  $this.ycb_1 = $this.ycb_1 + deltaTime;
  if ($this.ycb_1 >= 1.0) {
    $this.zcb_1 = $this.xcb_1;
    _get_fpsText__d9bdut($this).mbp(Localization_getInstance().hi('fps') + ' ' + $this.zcb_1);
    $this.xcb_1 = 0;
    $this.ycb_1 = 0.0;
  }
}
function updateNameTooltip($this) {
  var mousePos = ensureNotNull($this.ba5()).q8b();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var tmp0_iterator = $this.scc_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'GameScene.updateNameTooltip.<anonymous>' call
      var bounds = element.dc4_1;
      var globalBounds = bounds.rak();
      if (mousePos.a2a_1 >= globalBounds.r2a() && mousePos.a2a_1 <= globalBounds.s2a() && mousePos.b2a_1 >= globalBounds.t2a() && mousePos.b2a_1 <= globalBounds.u2a()) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var hoveredPerson = tmp$ret$1;
  if (!(hoveredPerson == null)) {
    if ($this.ncb_1 == null) {
      var tmp = $this;
      // Inline function 'korlibs.korge.view.text' call
      var this_0 = $this.ca5();
      var text = hoveredPerson.oc4_1;
      var textSize = Companion_instance.gbp_1;
      var color = Colors_getInstance().g40_1;
      var font = get_DefaultTtfFontAsBitmap();
      var alignment = Companion_getInstance_2().l4o_1;
      var renderer = get_DefaultStringTextRenderer();
      var autoScaling = Companion_instance.hbp_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_1 = Text.lbp(text, numberToDouble(textSize), color, font, alignment, renderer, autoScaling, null, null);
      // Inline function 'kotlin.apply' call
      var this_2 = addTo(this_1, this_0);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'GameScene.updateNameTooltip.<anonymous>' call
      this_2.kbp(get_gameFont());
      this_2.dbl(Colors_getInstance().g40_1);
      this_2.obp(26.0);
      tmp.ncb_1 = this_2;
    } else {
      var tmp_0 = $this.ncb_1;
      var tmp0_safe_receiver = tmp_0 instanceof Text ? tmp_0 : null;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.mbp(hoveredPerson.oc4_1);
      }
    }
    var tmp_1 = $this.ncb_1;
    var tooltip = tmp_1 instanceof Text ? tmp_1 : null;
    if (!(tooltip == null)) {
      var textWidth = tooltip.rbp().m2a_1;
      position(tooltip, hoveredPerson.m2i() - textWidth / 2, hoveredPerson.n2i() - 40.0);
    }
  } else {
    var tmp1_safe_receiver = $this.ncb_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.kak();
    }
    $this.ncb_1 = null;
  }
}
function updateSquares(_this__u8e3s4, $this, deltaTime) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = $this.scc_1.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'GameScene.updateSquares.<anonymous>' call
    element.oc5(deltaTime);
  }
  checkForDeaths(_this__u8e3s4, $this);
}
function checkForDeaths(_this__u8e3s4, $this) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var squaresToRemove = ArrayList.j1();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = $this.scc_1.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'GameScene.checkForDeaths.<anonymous>' call
    if (!element.kc4_1 && element.gc4_1 >= $this.ocb_1.qby_1) {
      element.sc5();
    }
    if (element.nc5()) {
      squaresToRemove.h(element);
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_0 = squaresToRemove.b1();
  while (tmp0_iterator_0.c1()) {
    var element_0 = tmp0_iterator_0.d1();
    // Inline function 'GameScene.checkForDeaths.<anonymous>' call
    var gravestoneX = element_0.m2i() - element_0.dc4_1.d2m() / 2;
    var gravestoneY = element_0.n2i() - element_0.dc4_1.e2m() / 2;
    var gravestoneW = element_0.dc4_1.d2m();
    var gravestoneH = element_0.dc4_1.e2m();
    var gravestoneSize = coerceAtLeast_0(numberToInt(coerceAtLeast(gravestoneW, gravestoneH)), 24);
    var gravestoneBitmap = GravestoneSpriteCache_getInstance().vc5(gravestoneSize);
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.za4(false);
    // Inline function 'kotlin.apply' call
    var this_1 = addTo(this_0, _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'GameScene.checkForDeaths.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.korge.view.text' call
    var text = element_0.oc4_1;
    var textSize = Companion_instance.gbp_1;
    var color = Colors_getInstance().g40_1;
    var font = get_DefaultTtfFontAsBitmap();
    var alignment = Companion_getInstance_2().l4o_1;
    var renderer = get_DefaultStringTextRenderer();
    var autoScaling = Companion_instance.hbp_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = Text.lbp(text, numberToDouble(textSize), color, font, alignment, renderer, autoScaling, null, null);
    // Inline function 'kotlin.apply' call
    var this_3 = addTo(this_2, this_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'GameScene.checkForDeaths.<anonymous>.<anonymous>.<anonymous>' call
    this_3.kbp(get_gameFont());
    this_3.dbl(Colors_getInstance().c43_1);
    this_3.obp(28.0);
    var textWidth = this_3.rbp().m2a_1;
    position(this_3, gravestoneX + gravestoneW / 2 - textWidth / 2, gravestoneY - 24.0);
    // Inline function 'korlibs.korge.view.image' call
    var anchor = Companion_getInstance_4().b29_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_4 = Image.kbi(gravestoneBitmap, anchor);
    // Inline function 'kotlin.apply' call
    var this_5 = addTo(this_4, this_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'GameScene.checkForDeaths.<anonymous>.<anonymous>.<anonymous>' call
    position(this_5, gravestoneX, gravestoneY);
    this_5.yai(gravestoneW / gravestoneSize);
    this_5.aaj(gravestoneH / gravestoneSize);
    this_5.maj(0.85);
    var gravestoneContainer = this_1;
    launch($this, VOID, VOID, GameScene$checkForDeaths$slambda_0(gravestoneContainer));
    element_0.r6();
    $this.scc_1.m3(element_0);
    $this.rcb_1 = $this.rcb_1 - 1 | 0;
  }
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!squaresToRemove.h1()) {
    updateStats($this);
  }
}
function updateCollisionEvents(_this__u8e3s4, $this, deltaTime) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var eventsToRemove = ArrayList.j1();
  var _iterator__ex2g4s = $this.tcc_1.b1();
  while (_iterator__ex2g4s.c1()) {
    var event = _iterator__ex2g4s.d1();
    event.tbw_1 = event.tbw_1 - deltaTime;
    var frame = (numberToInt(event.tbw_1 * 5) % 2 | 0) === 0 ? 0 : 1;
    animateDustCloud($this, event.sbw_1, frame);
    if (event.tbw_1 <= 0) {
      event.sbw_1.kak();
      spawnSquareFromCollision(_this__u8e3s4, $this, event);
      eventsToRemove.h(event);
    }
  }
  $this.tcc_1.n3(eventsToRemove);
}
function animateDustCloud($this, dustCloud, frame) {
  var scale = frame === 0 ? 1.0 : 1.2;
  dustCloud.wai(scale);
}
function moveSquares($this, deltaTime) {
  var _iterator__ex2g4s = $this.scc_1.b1();
  while (_iterator__ex2g4s.c1()) {
    var square = _iterator__ex2g4s.d1();
    square.pc5(deltaTime);
    square.qc5($this.dcd_1, $this.ecd_1, $this.xcc_1, $this.ycc_1);
  }
}
function updateCollisionPairCooldowns($this, deltaTime) {
  // Inline function 'kotlin.collections.iterator' call
  var iterator = $this.vcc_1.q1().b1();
  while (iterator.c1()) {
    var entry = iterator.d1();
    var newCooldown = entry.s1() - deltaTime;
    if (newCooldown <= 0) {
      iterator.r6();
    } else {
      // Inline function 'kotlin.collections.set' call
      var this_0 = $this.vcc_1;
      var key = entry.r1();
      this_0.h3(key, newCooldown);
    }
  }
}
function checkCollisions(_this__u8e3s4, $this) {
  $this.ucc_1.k3();
  $this.ccd_1.k3();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = $this.scc_1.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'GameScene.checkCollisions.<anonymous>' call
    $this.ccd_1.nc7(element);
  }
  var inductionVariable = 0;
  var last = $this.scc_1.f1();
  if (inductionVariable < last)
    $l$loop: do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var square1 = $this.scc_1.e1(i);
      if (!square1.tc4())
        continue $l$loop;
      var nearbySquares = $this.ccd_1.oc7(square1);
      var _iterator__ex2g4s = nearbySquares.b1();
      $l$loop_5: while (_iterator__ex2g4s.c1()) {
        var square2 = _iterator__ex2g4s.d1();
        if (square1 === square2)
          continue $l$loop_5;
        if (!square2.tc4())
          continue $l$loop_5;
        var idx1 = i;
        var idx2 = $this.scc_1.z2(square2);
        if (idx2 === -1)
          continue $l$loop_5;
        var pair1 = new Pair(idx1, idx2);
        var pair2 = new Pair(idx2, idx1);
        if ($this.ucc_1.x2(pair1) || $this.ucc_1.x2(pair2))
          continue $l$loop_5;
        if (!canInteract($this, square1, square2))
          continue $l$loop_5;
        var squarePair1 = new Pair(square1, square2);
        var squarePair2 = new Pair(square2, square1);
        // Inline function 'kotlin.comparisons.maxOf' call
        var tmp0_elvis_lhs = $this.vcc_1.f3(squarePair1);
        var a = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
        var tmp1_elvis_lhs = $this.vcc_1.f3(squarePair2);
        var b = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
        var pairCooldown = Math.max(a, b);
        if (pairCooldown > 0)
          continue $l$loop_5;
        var dx = square2.m2i() - square1.m2i();
        var dy = square2.n2i() - square1.n2i();
        // Inline function 'kotlin.math.sqrt' call
        var x = dx * dx + dy * dy;
        var distance = Math.sqrt(x);
        var radiusSum = $this.ocb_1.rby_1 * 2;
        var tmp;
        if ($this.ocb_1.gbz_1) {
          tmp = radiusSum * 1.2;
        } else {
          tmp = radiusSum;
        }
        var effectiveRange = tmp;
        if (distance < effectiveRange) {
          var newCooldown = 1.0;
          var squarePair1_0 = new Pair(square1, square2);
          var squarePair2_0 = new Pair(square2, square1);
          // Inline function 'kotlin.collections.set' call
          var this_0 = $this.vcc_1;
          // Inline function 'kotlin.comparisons.maxOf' call
          var tmp2_elvis_lhs = $this.vcc_1.f3(squarePair1_0);
          var b_0 = tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
          var value = Math.max(newCooldown, b_0);
          this_0.h3(squarePair1_0, value);
          // Inline function 'kotlin.collections.set' call
          var this_1 = $this.vcc_1;
          // Inline function 'kotlin.comparisons.maxOf' call
          var tmp3_elvis_lhs = $this.vcc_1.f3(squarePair2_0);
          var b_1 = tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs;
          var value_0 = Math.max(newCooldown, b_1);
          this_1.h3(squarePair2_0, value_0);
          $this.ucc_1.h(pair1);
          handleCollision(_this__u8e3s4, $this, square1, square2);
        }
      }
    }
     while (inductionVariable < last);
}
function canInteract($this, square1, square2) {
  if (square1.yc3_1.equals(Gender_FEMALE_getInstance()) && square2.yc3_1.equals(Gender_FEMALE_getInstance())) {
    return false;
  }
  return true;
}
function determineCollisionType($this, square1, square2) {
  var tmp;
  if (square1.yc3_1.equals(Gender_MALE_getInstance()) && square2.yc3_1.equals(Gender_FEMALE_getInstance()) || (square1.yc3_1.equals(Gender_FEMALE_getInstance()) && square2.yc3_1.equals(Gender_MALE_getInstance()))) {
    tmp = CollisionType_REPRODUCTION_getInstance();
  } else {
    tmp = CollisionType_BOUNCE_ONLY_getInstance();
  }
  return tmp;
}
function handleCollision(_this__u8e3s4, $this, square1, square2) {
  $this.pcb_1 = $this.pcb_1 + 1 | 0;
  var _unary__edvuaz = get_totalCollisionCount();
  set_totalCollisionCount(_unary__edvuaz + 1 | 0);
  var collisionType = determineCollisionType($this, square1, square2);
  switch (collisionType.r3_1) {
    case 0:
      var baseScore = 1.0;
      var bonusScore = baseScore * $this.ocb_1.mby_1 * $this.ocb_1.vby_1 * $this.ocb_1.ebz_1;
      $this.qcb_1 = $this.qcb_1 + bonusScore;
      set_globalScore($this.qcb_1);
      $this.acc_1.fc7();
      handleReproduction(_this__u8e3s4, $this, square1, square2);
      break;
    case 1:
      $this.acc_1.ec7();
      handleBounce($this, square1, square2);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  updateStats($this);
}
function handleReproduction(_this__u8e3s4, $this, square1, square2) {
  if (Default_getInstance().wo() > $this.ocb_1.oby_1) {
    square1.rc5();
    square2.rc5();
    handleBounce($this, square1, square2);
    return Unit_instance;
  }
  square1.rc5();
  square2.rc5();
  var midX = (square1.m2i() + square2.m2i()) / 2;
  var midY = (square1.n2i() + square2.n2i()) / 2;
  var dustCloud = createDustCloud(_this__u8e3s4, $this, midX, midY);
  var sumVelocity = Vector2D.k2c(-(square1.fc4_1.a2a_1 + square2.fc4_1.a2a_1), -(square1.fc4_1.b2a_1 + square2.fc4_1.b2a_1));
  $this.tcc_1.h(new CollisionEvent(dustCloud, $this.gcd_1, midX - $this.bcd_1 / 2, midY - $this.bcd_1 / 2, sumVelocity));
}
function createDustCloud(_this__u8e3s4, $this, x, y) {
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.za4(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>' call
  var pixelSize = 2.0;
  var dustColor1 = RGBA__withAd_impl_cralao(Colors_getInstance().c43_1, 0.7);
  var dustColor2 = RGBA__withAd_impl_cralao(Companion_getInstance_1().x4f(169, 169, 169), 0.5);
  var dustColor3 = RGBA__withAd_impl_cralao(Colors_getInstance().j41_1, 0.3);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor1);
  // Inline function 'kotlin.apply' call
  var this_3 = addTo(this_2, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_3, -10.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_4 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor1);
  // Inline function 'kotlin.apply' call
  var this_5 = addTo(this_4, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_5, 10.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_6 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor1);
  // Inline function 'kotlin.apply' call
  var this_7 = addTo(this_6, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_7, 0.0, -10.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_8 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor1);
  // Inline function 'kotlin.apply' call
  var this_9 = addTo(this_8, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_9, 0.0, 10.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_10 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor1);
  // Inline function 'kotlin.apply' call
  var this_11 = addTo(this_10, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_11, -7.0, -7.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_12 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor1);
  // Inline function 'kotlin.apply' call
  var this_13 = addTo(this_12, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_13, 7.0, -7.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_14 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor1);
  // Inline function 'kotlin.apply' call
  var this_15 = addTo(this_14, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_15, -7.0, 7.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_16 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor1);
  // Inline function 'kotlin.apply' call
  var this_17 = addTo(this_16, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_17, 7.0, 7.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_18 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor2);
  // Inline function 'kotlin.apply' call
  var this_19 = addTo(this_18, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_19, -6.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_20 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor2);
  // Inline function 'kotlin.apply' call
  var this_21 = addTo(this_20, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_21, 6.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_22 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor2);
  // Inline function 'kotlin.apply' call
  var this_23 = addTo(this_22, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_23, 0.0, -6.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_24 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor2);
  // Inline function 'kotlin.apply' call
  var this_25 = addTo(this_24, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_25, 0.0, 6.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_26 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor2);
  // Inline function 'kotlin.apply' call
  var this_27 = addTo(this_26, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_27, -4.0, -4.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_28 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor2);
  // Inline function 'kotlin.apply' call
  var this_29 = addTo(this_28, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_29, 4.0, -4.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_30 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor2);
  // Inline function 'kotlin.apply' call
  var this_31 = addTo(this_30, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_31, -4.0, 4.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_32 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor2);
  // Inline function 'kotlin.apply' call
  var this_33 = addTo(this_32, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_33, 4.0, 4.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_34 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor3);
  // Inline function 'kotlin.apply' call
  var this_35 = addTo(this_34, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_35, -3.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_36 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor3);
  // Inline function 'kotlin.apply' call
  var this_37 = addTo(this_36, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_37, 3.0, 0.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_38 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor3);
  // Inline function 'kotlin.apply' call
  var this_39 = addTo(this_38, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_39, 0.0, -3.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_40 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor3);
  // Inline function 'kotlin.apply' call
  var this_41 = addTo(this_40, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_41, 0.0, 3.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_42 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor3);
  // Inline function 'kotlin.apply' call
  var this_43 = addTo(this_42, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_43, -1.0, -1.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_44 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor3);
  // Inline function 'kotlin.apply' call
  var this_45 = addTo(this_44, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_45, 1.0, -1.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_46 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor3);
  // Inline function 'kotlin.apply' call
  var this_47 = addTo(this_46, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_47, -1.0, 1.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_48 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor3);
  // Inline function 'kotlin.apply' call
  var this_49 = addTo(this_48, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_49, 1.0, 1.0);
  // Inline function 'korlibs.korge.view.solidRect' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_50 = SolidRect.cbl(Size2D.f2i(pixelSize, pixelSize), dustColor3);
  // Inline function 'kotlin.apply' call
  var this_51 = addTo(this_50, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.createDustCloud.<anonymous>.<anonymous>' call
  position(this_51, 0.0, 0.0);
  var cloud = this_1;
  position(cloud, x, y);
  return cloud;
}
function handleBounce($this, square1, square2) {
  var dx = square2.m2i() - square1.m2i();
  var dy = square2.n2i() - square1.n2i();
  // Inline function 'kotlin.math.sqrt' call
  var x = dx * dx + dy * dy;
  var distance = Math.sqrt(x);
  if (distance > 0) {
    var normalX = dx / distance;
    var normalY = dy / distance;
    // Inline function 'kotlin.math.sqrt' call
    var x_0 = square1.ec4_1.a2a_1 * square1.ec4_1.a2a_1 + square1.ec4_1.b2a_1 * square1.ec4_1.b2a_1;
    var speed1 = Math.sqrt(x_0);
    // Inline function 'kotlin.math.sqrt' call
    var x_1 = square2.ec4_1.a2a_1 * square2.ec4_1.a2a_1 + square2.ec4_1.b2a_1 * square2.ec4_1.b2a_1;
    var speed2 = Math.sqrt(x_1);
    var avgSpeed = (speed1 + speed2) / 2.0;
    square1.ec4_1 = Vector2D.k2c(-normalX * avgSpeed, -normalY * avgSpeed);
    square2.ec4_1 = Vector2D.k2c(normalX * avgSpeed, normalY * avgSpeed);
    square1.fc4_1 = square1.ec4_1;
    square2.fc4_1 = square2.ec4_1;
    var collisionRadius = $this.bcd_1 / 2;
    var targetDistance = collisionRadius * 2 + 2.0;
    var overlap = targetDistance - distance;
    if (overlap > 0) {
      var separationPerSquare = overlap / 2.0;
      var _receiver__tnumb7 = square1.dc4_1;
      _receiver__tnumb7.tai(_receiver__tnumb7.b6j() - normalX * separationPerSquare);
      var _receiver__tnumb7_0 = square1.dc4_1;
      _receiver__tnumb7_0.uai(_receiver__tnumb7_0.c6j() - normalY * separationPerSquare);
      var _receiver__tnumb7_1 = square2.dc4_1;
      _receiver__tnumb7_1.tai(_receiver__tnumb7_1.b6j() + normalX * separationPerSquare);
      var _receiver__tnumb7_2 = square2.dc4_1;
      _receiver__tnumb7_2.uai(_receiver__tnumb7_2.c6j() + normalY * separationPerSquare);
    }
    square1.jc4_1 = 0.5;
    square2.jc4_1 = 0.5;
  }
}
function spawnRandomSquare(_this__u8e3s4, $this) {
  var randomX = $this.dcd_1 + Default_getInstance().wo() * ($this.xcc_1 - $this.bcd_1);
  var randomY = $this.ecd_1 + Default_getInstance().wo() * ($this.ycc_1 - $this.bcd_1);
  var randomVelX = calculateSpeedWithEfficiency($this) * (Default_getInstance().wo() > 0.5 ? 1 : -1);
  var randomVelY = calculateSpeedWithEfficiency($this) * (Default_getInstance().wo() > 0.5 ? 1 : -1);
  var randomGender = Default_getInstance().wo() < $this.ocb_1.pby_1 ? Gender_MALE_getInstance() : Gender_FEMALE_getInstance();
  createSquare(_this__u8e3s4, $this, randomX, randomY, Vector2D.k2c(randomVelX, randomVelY), randomGender);
}
function calculateSpeedWithEfficiency($this) {
  var tmp;
  if ($this.ocb_1.nby_1 > 1.0) {
    var mid = ($this.ocb_1.lby_1 + $this.ocb_1.kby_1) / 2;
    var range = ($this.ocb_1.kby_1 - $this.ocb_1.lby_1) / $this.ocb_1.nby_1;
    tmp = mid + Default_getInstance().xo(-range / 2, range / 2);
  } else {
    tmp = $this.ocb_1.lby_1 + Default_getInstance().wo() * ($this.ocb_1.kby_1 - $this.ocb_1.lby_1);
  }
  return tmp;
}
function spawnSquareFromCollision(_this__u8e3s4, $this, event) {
  if ($this.rcb_1 >= $this.ocb_1.jby_1) {
    return Unit_instance;
  }
  var tmp;
  if ($this.ocb_1.xby_1 && Default_getInstance().wo() < 0.4) {
    tmp = 2;
  } else {
    tmp = 1;
  }
  var birthCount = tmp;
  // Inline function 'kotlin.repeat' call
  // Inline function 'kotlin.contracts.contract' call
  var inductionVariable = 0;
  if (inductionVariable < birthCount)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      $l$block: {
        // Inline function 'GameScene.spawnSquareFromCollision.<anonymous>' call
        if ($this.rcb_1 >= $this.ocb_1.jby_1) {
          break $l$block;
        }
        var randomGender = Default_getInstance().wo() < $this.ocb_1.pby_1 ? Gender_MALE_getInstance() : Gender_FEMALE_getInstance();
        var offsetX = birthCount > 1 ? Default_getInstance().xo(-20.0, 20.0) : 0.0;
        var offsetY = birthCount > 1 ? Default_getInstance().xo(-20.0, 20.0) : 0.0;
        createSquare(_this__u8e3s4, $this, event.ubw_1 + offsetX, event.vbw_1 + offsetY, event.wbw_1, randomGender);
        $this.rcb_1 = $this.rcb_1 + 1 | 0;
      }
    }
     while (inductionVariable < birthCount);
  updateStats($this);
}
function createSquare(_this__u8e3s4, $this, x, y, velocity, gender) {
  var tmp;
  switch (gender.r3_1) {
    case 0:
      tmp = $this.hcd_1;
      break;
    case 1:
      tmp = $this.icd_1;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var color = tmp;
  var baseCooldown = $this.ocb_1.hby_1 * $this.ocb_1.yby_1;
  var tmp_0;
  if ($this.ocb_1.gbz_1) {
    tmp_0 = baseCooldown * 0.6;
  } else {
    tmp_0 = baseCooldown;
  }
  var effectiveCooldown = tmp_0;
  var effectiveAdultAge = $this.ocb_1.abz_1 ? 0.0 : $this.ocb_1.iby_1;
  var square = new GameSquare(_this__u8e3s4, x, y, color, velocity, $this.bcd_1, effectiveAdultAge, gender, VOID, VOID, effectiveCooldown, $this.acc_1, $this.ocb_1);
  square.tc5($this.ocb_1.qby_1);
  if ($this.ocb_1.abz_1) {
    square.gc4_1 = effectiveAdultAge;
  }
  $this.scc_1.h(square);
}
function updateStats($this) {
  _get_statsText__ixs61n($this).mbp(Localization_getInstance().hi('population') + ' ' + $this.rcb_1 + ' / ' + $this.ocb_1.jby_1 + '\n' + Localization_getInstance().hi('collisions') + ' ' + $this.pcb_1 + '\n' + Localization_getInstance().hi('score') + ' ' + numberToInt($this.qcb_1));
  updateGenderRatio($this);
}
function refreshUILanguage($this) {
  _get_resetButton__lir900($this).mbp(Localization_getInstance().hi('upgrades'));
  _get_achievementButton__awzb9s($this).mbp(Localization_getInstance().hi('achievements'));
  _get_settingsButton__qak9sa($this).mbp(Localization_getInstance().hi('settings'));
  _get_soundButton__fse1kg($this).mbp(Localization_getInstance().hi('sound') + ' ' + ($this.acc_1.ic7() ? Localization_getInstance().hi('on') : Localization_getInstance().hi('off')));
  _get_stressTestButton__i3tbir($this).mbp(Localization_getInstance().hi('stress_test') + ' ' + ($this.ucb_1 ? Localization_getInstance().hi('on') : Localization_getInstance().hi('off')));
  _get_fpsText__d9bdut($this).mbp(Localization_getInstance().hi('fps') + ' ' + $this.zcb_1);
  updateStats($this);
}
function updateGenderRatio($this) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.count' call
    var this_0 = $this.scc_1;
    var tmp;
    if (isInterface(this_0, Collection)) {
      tmp = this_0.h1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = 0;
      break $l$block;
    }
    var count = 0;
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'GameScene.updateGenderRatio.<anonymous>' call
      if (element.yc3_1.equals(Gender_MALE_getInstance())) {
        count = count + 1 | 0;
        checkCountOverflow(count);
      }
    }
    tmp$ret$0 = count;
  }
  var maleCount = tmp$ret$0;
  var tmp$ret$2;
  $l$block_0: {
    // Inline function 'kotlin.collections.count' call
    var this_1 = $this.scc_1;
    var tmp_0;
    if (isInterface(this_1, Collection)) {
      tmp_0 = this_1.h1();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp$ret$2 = 0;
      break $l$block_0;
    }
    var count_0 = 0;
    var tmp0_iterator_0 = this_1.b1();
    while (tmp0_iterator_0.c1()) {
      var element_0 = tmp0_iterator_0.d1();
      // Inline function 'GameScene.updateGenderRatio.<anonymous>' call
      if (element_0.yc3_1.equals(Gender_FEMALE_getInstance())) {
        count_0 = count_0 + 1 | 0;
        checkCountOverflow(count_0);
      }
    }
    tmp$ret$2 = count_0;
  }
  var femaleCount = tmp$ret$2;
  var total = $this.scc_1.f1();
  var barWidth = $this.wcc_1 - 60.0;
  if (total > 0) {
    var maleWidth = barWidth * (maleCount / total);
    var femaleWidth = barWidth * (femaleCount / total);
    _get_maleBar__yqi039($this).ubi(maleWidth);
    _get_femaleBar__wmo3jq($this).ubi(femaleWidth);
    _get_femaleBar__wmo3jq($this).tai(_get_maleBar__yqi039($this).b6j() + maleWidth);
  } else {
    _get_maleBar__yqi039($this).ubi(0.0);
    _get_femaleBar__wmo3jq($this).ubi(0.0);
  }
}
function isPointInPolygon($this, x, y, points) {
  var inside = false;
  var j = points.f1() - 1 | 0;
  var inductionVariable = 0;
  var last = points.f1() - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var xi = points.e1(i).ll_1;
      var yi = points.e1(i).ml_1;
      var xj = points.e1(j).ll_1;
      var yj = points.e1(j).ml_1;
      var intersect = !(yi > y === yj > y) && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
      if (intersect)
        inside = !inside;
      j = i;
    }
     while (inductionVariable <= last);
  return inside;
}
function drawLine(_this__u8e3s4, $this, x0, y0, x1, y1, color) {
  var x = numberToInt(x0);
  var y = numberToInt(y0);
  var x2 = numberToInt(x1);
  var y2 = numberToInt(y1);
  var dx = abs(x2 - x | 0);
  var dy = abs(y2 - y | 0);
  var sx = x < x2 ? 1 : -1;
  var sy = y < y2 ? 1 : -1;
  var err = dx - dy | 0;
  $l$loop: while (true) {
    // Inline function 'korlibs.korge.view.solidRect' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = SolidRect.cbl(Size2D.f2i(2.0, 2.0), color);
    // Inline function 'kotlin.apply' call
    var this_1 = addTo(this_0, _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'GameScene.drawLine.<anonymous>' call
    position(this_1, x, y);
    if (x === x2 && y === y2)
      break $l$loop;
    var e2 = imul(2, err);
    if (e2 > (-dy | 0)) {
      err = err - dy | 0;
      x = x + sx | 0;
    }
    if (e2 < dx) {
      err = err + dx | 0;
      y = y + sy | 0;
    }
  }
}
function showVictoryScreen$_anonymous_$formatTime_e5459a(seconds) {
  var hours = numberToInt(seconds / 3600);
  var minutes = numberToInt(seconds % 3600 / 60);
  var secs = numberToInt(seconds % 60);
  var tmp;
  if (hours > 0) {
    tmp = '' + hours + 'h ' + minutes + 'm ' + secs + 's';
  } else if (minutes > 0) {
    tmp = '' + minutes + 'm ' + secs + 's';
  } else {
    tmp = '' + secs + 's';
  }
  return tmp;
}
function GameScene$setupAchievements$lambda$slambda_0(this$0, $achievement) {
  var i = new GameScene$setupAchievements$lambda$slambda(this$0, $achievement);
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameScene$setupAchievements$lambda(this$0) {
  return function (achievement) {
    var tmp = this$0.oa2();
    launch(tmp, VOID, VOID, GameScene$setupAchievements$lambda$slambda_0(this$0, achievement));
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda(this$0, $this_setupUI) {
  return function (it) {
    openUpgradeTree($this_setupUI, this$0);
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda_1($bg, $bgHoverColor) {
  return function (it) {
    $bg.dbl($bgHoverColor);
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda_2($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda_3($bg, $bgColor) {
  return function (it) {
    $bg.dbl($bgColor);
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda_4($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda_5(this$0, $this_setupUI) {
  return function (it) {
    var tmp;
    if (!this$0.dcc_1) {
      openAchievementPanel($this_setupUI, this$0);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda_6($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda_7($bg, $bgHoverColor) {
  return function (it) {
    $bg.dbl($bgHoverColor);
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda_8($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda_9($bg, $bgColor) {
  return function (it) {
    $bg.dbl($bgColor);
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda_10($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda_11(this$0, $this_setupUI) {
  return function (it) {
    var tmp;
    if (!this$0.ncc_1) {
      openSettingsPanel_0($this_setupUI, this$0);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda_12($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda_13($bg, $bgHoverColor) {
  return function (it) {
    $bg.dbl($bgHoverColor);
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda_14($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda_15($bg, $bgColor) {
  return function (it) {
    $bg.dbl($bgColor);
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda_16($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda$slambda_0(this$0) {
  var i = new GameScene$setupUI$lambda$slambda(this$0);
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameScene$setupUI$lambda_17(this$0) {
  return function (it) {
    var tmp = this$0.ka1();
    launch(tmp, VOID, VOID, GameScene$setupUI$lambda$slambda_0(this$0));
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda_18($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda_19($bg, $bgHoverColor) {
  return function (it) {
    $bg.dbl($bgHoverColor);
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda_20($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda_21($bg, $bgColor) {
  return function (it) {
    $bg.dbl($bgColor);
    return Unit_instance;
  };
}
function GameScene$setupUI$lambda_22($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$openAchievementPanel$lambda(this$0) {
  return function () {
    this$0.dcc_1 = false;
    return Unit_instance;
  };
}
function GameScene$openSettingsPanel$lambda(this$0) {
  return function () {
    refreshUILanguage(this$0);
    return Unit_instance;
  };
}
function GameScene$openSettingsPanel$lambda_0(this$0) {
  return function () {
    this$0.ncc_1 = false;
    return Unit_instance;
  };
}
function GameScene$showAchievementNotification$slambda_0(this$0, $achievement) {
  var i = new GameScene$showAchievementNotification$slambda(this$0, $achievement);
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameScene$openUpgradeTree$slambda_0(this$0) {
  var i = new GameScene$openUpgradeTree$slambda(this$0);
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameScene$showGameOverScreen$lambda($panel, this$0, $parentContainer) {
  return function (it) {
    $panel.kak();
    openUpgradeTree($parentContainer, this$0);
    return Unit_instance;
  };
}
function GameScene$showGameOverScreen$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$showGameOverScreen$lambda_1($bg, $bgHoverColor) {
  return function (it) {
    $bg.dbl($bgHoverColor);
    return Unit_instance;
  };
}
function GameScene$showGameOverScreen$lambda_2($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$showGameOverScreen$lambda_3($bg, $bgColor) {
  return function (it) {
    $bg.dbl($bgColor);
    return Unit_instance;
  };
}
function GameScene$showGameOverScreen$lambda_4($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$showVictoryScreen$lambda($panel, this$0) {
  return function (it) {
    $panel.kak();
    this$0.pcc_1 = false;
    return Unit_instance;
  };
}
function GameScene$showVictoryScreen$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$showVictoryScreen$lambda_1($panel, this$0, $parentContainer) {
  return function (it) {
    $panel.kak();
    openUpgradeTree($parentContainer, this$0);
    return Unit_instance;
  };
}
function GameScene$showVictoryScreen$lambda_2($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$spawnStar$lambda$slambda_0(this$0, $this_spawnStar) {
  var i = new GameScene$spawnStar$lambda$slambda(this$0, $this_spawnStar);
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameScene$spawnStar$lambda(this$0, $starContainer, $this_spawnStar) {
  return function (it) {
    this$0.qcb_1 = this$0.qcb_1 + this$0.ocb_1.jbz_1;
    set_globalScore(this$0.qcb_1);
    updateStats(this$0);
    this$0.acc_1.hc7();
    $starContainer.i8q(false);
    var tmp0_safe_receiver = this$0.rcc_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.j18();
    }
    var tmp = this$0;
    tmp.rcc_1 = launch(this$0, VOID, VOID, GameScene$spawnStar$lambda$slambda_0(this$0, $this_spawnStar));
    return Unit_instance;
  };
}
function GameScene$spawnStar$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$setupGameLoop$lambda$slambda_2() {
  var i = new GameScene$setupGameLoop$lambda$slambda();
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameScene$setupGameLoop$lambda$slambda_3(this$0, $this_addUpdater) {
  var i = new GameScene$setupGameLoop$lambda$slambda_0(this$0, $this_addUpdater);
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameScene$setupGameLoop$lambda$slambda_4(this$0, $this_addUpdater) {
  var i = new GameScene$setupGameLoop$lambda$slambda_1(this$0, $this_addUpdater);
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameScene$setupGameLoop$lambda($accumulator, this$0, $autoSaveTimer, $autoSaveInterval, $fixedDeltaTime, $autoSpawnTimer) {
  return function ($this$addUpdater, dt) {
    var deltaTime = coerceAtMost_0(get_seconds(dt.qj_1), 0.1);
    $accumulator._v = $accumulator._v + deltaTime * this$0.ocb_1.wby_1;
    $autoSaveTimer._v = $autoSaveTimer._v + deltaTime;
    var tmp;
    if ($autoSaveTimer._v >= $autoSaveInterval) {
      $autoSaveTimer._v = 0.0;
      var tmp_0 = this$0.ka1();
      launch(tmp_0, VOID, VOID, GameScene$setupGameLoop$lambda$slambda_2());
      tmp = Unit_instance;
    }
    while ($accumulator._v >= $fixedDeltaTime) {
      if (!this$0.pcc_1) {
        updateSquares($this$addUpdater, this$0, $fixedDeltaTime);
        updateCollisionEvents($this$addUpdater, this$0, $fixedDeltaTime);
        checkCollisions($this$addUpdater, this$0);
        updateCollisionPairCooldowns(this$0, $fixedDeltaTime);
        if (this$0.ocb_1.tby_1) {
          $autoSpawnTimer._v = $autoSpawnTimer._v + $fixedDeltaTime;
          if ($autoSpawnTimer._v >= this$0.ocb_1.uby_1) {
            $autoSpawnTimer._v = 0.0;
            if (this$0.rcb_1 < this$0.ocb_1.jby_1) {
              spawnRandomSquare($this$addUpdater, this$0);
              var _unary__edvuaz = this$0.rcb_1;
              this$0.rcb_1 = _unary__edvuaz + 1 | 0;
              updateStats(this$0);
            }
          }
        }
        if (this$0.ucb_1) {
          this$0.vcb_1 = this$0.vcb_1 + $fixedDeltaTime;
          if (this$0.vcb_1 >= this$0.wcb_1) {
            this$0.vcb_1 = 0.0;
            spawnRandomSquare($this$addUpdater, this$0);
            var _unary__edvuaz_0 = this$0.rcb_1;
            this$0.rcb_1 = _unary__edvuaz_0 + 1 | 0;
            updateStats(this$0);
          }
        }
        this$0.scb_1 = this$0.scb_1 + $fixedDeltaTime;
        set_currentRunTime(get_currentRunTime() + $fixedDeltaTime);
        set_totalGameTime(get_totalGameTime() + $fixedDeltaTime);
        var scoreReward = this$0.bcc_1.pbv(this$0.rcb_1, this$0.pcb_1, this$0.qcb_1, this$0.scb_1);
        if (scoreReward > 0) {
          this$0.qcb_1 = this$0.qcb_1 + scoreReward;
          set_globalScore(this$0.qcb_1);
          updateStats(this$0);
        }
        if (!get_hasWon() && this$0.scc_1.f1() >= numberToInt(500.0)) {
          set_hasWon(true);
          this$0.pcc_1 = true;
          var tmp0_safe_receiver = this$0.qcc_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.kak();
          }
          var tmp1_safe_receiver = this$0.rcc_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            tmp1_safe_receiver.j18();
          }
          var tmp_1 = this$0.ka1();
          launch(tmp_1, VOID, VOID, GameScene$setupGameLoop$lambda$slambda_3(this$0, $this$addUpdater));
        }
      }
      $accumulator._v = $accumulator._v - $fixedDeltaTime;
    }
    var tmp_2;
    if (!this$0.pcc_1 && this$0.scc_1.h1() && !this$0.occ_1 && !get_hasWon()) {
      this$0.occ_1 = true;
      this$0.pcc_1 = true;
      var tmp2_safe_receiver = this$0.qcc_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.kak();
      }
      var tmp3_safe_receiver = this$0.rcc_1;
      if (tmp3_safe_receiver == null)
        null;
      else {
        tmp3_safe_receiver.j18();
      }
      var tmp_3 = this$0.ka1();
      launch(tmp_3, VOID, VOID, GameScene$setupGameLoop$lambda$slambda_4(this$0, $this$addUpdater));
      tmp_2 = Unit_instance;
    }
    var tmp_4;
    if (!this$0.pcc_1) {
      moveSquares(this$0, deltaTime);
      tmp_4 = Unit_instance;
    }
    updateFPS(this$0, deltaTime);
    updateNameTooltip(this$0);
    return Unit_instance;
  };
}
function GameScene$checkForDeaths$slambda_0($gravestoneContainer) {
  var i = new GameScene$checkForDeaths$slambda($gravestoneContainer);
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_saveGameState__xwc0y6($completion) {
  try {
    var tmp = to('totalCollisionCount', get_totalCollisionCount());
    var tmp_0 = to('score', get_globalScore());
    var tmp_1 = to('totalGameTime', get_totalGameTime());
    var tmp_2 = to('language', Localization_getInstance().mbv_1);
    var tmp_3 = to('startLevel', get_globalConfig().gby_1);
    var tmp_4 = to('collisionCooldownLevel', get_globalConfig().uc0_1);
    var tmp_5 = to('adultAgeLevel', get_globalConfig().vc0_1);
    var tmp_6 = to('maxPopulationLevel', get_globalConfig().wc0_1);
    var tmp_7 = to('maxSpeedLevel', get_globalConfig().xc0_1);
    var tmp_8 = to('birthBonusLevel', get_globalConfig().yc0_1);
    var tmp_9 = to('movementEfficiencyLevel', get_globalConfig().zc0_1);
    var tmp_10 = to('fertilityRateLevel', get_globalConfig().ac1_1);
    var tmp_11 = to('genderBalanceLevel', get_globalConfig().bc1_1);
    var tmp_12 = to('lifespanLevel', get_globalConfig().cc1_1);
    var tmp_13 = to('collisionRangeLevel', get_globalConfig().dc1_1);
    var tmp_14 = to('fertilityAgeLevel', get_globalConfig().ec1_1);
    var tmp_15 = to('autoSpawnLevel', get_globalConfig().fc1_1);
    var tmp_16 = to('autoSpawnRateLevel', get_globalConfig().gc1_1);
    var tmp_17 = to('scoreMultiplierLevel', get_globalConfig().hc1_1);
    var tmp_18 = to('timeAccelerationLevel', get_globalConfig().ic1_1);
    var tmp_19 = to('massReproductionLevel', get_globalConfig().jc1_1);
    var tmp_20 = to('evolutionBonusLevel', get_globalConfig().kc1_1);
    var tmp_21 = to('ultraSpeedLevel', get_globalConfig().lc1_1);
    var tmp_22 = to('instantMaturityLevel', get_globalConfig().mc1_1);
    var tmp_23 = to('megaPopulationLevel', get_globalConfig().nc1_1);
    var tmp_24 = to('fertilityExplosionLevel', get_globalConfig().oc1_1);
    var tmp_25 = to('scoreAscensionLevel', get_globalConfig().pc1_1);
    var tmp_26 = to('timeDilationLevel', get_globalConfig().qc1_1);
    var tmp_27 = to('reproductionFrenzyLevel', get_globalConfig().rc1_1);
    var tmp_28 = to('cosmicConvergenceLevel', get_globalConfig().tc1_1);
    var tmp_29 = to('transcendenceLevel', get_globalConfig().uc1_1);
    var tmp_30 = to('infinitePopulationLevel', get_globalConfig().sc1_1);
    var tmp_31 = to('startingPopulationLevel', get_globalConfig().vc1_1);
    var tmp_32 = to('startingPopulationBoostLevel', get_globalConfig().wc1_1);
    var tmp_33 = to('startingPopulationMegaLevel', get_globalConfig().xc1_1);
    var tmp_34 = to('clickPowerLevel', get_globalConfig().yc1_1);
    var tmp_35 = to('clickPowerBoostLevel', get_globalConfig().zc1_1);
    var tmp_36 = to('clickPowerMegaLevel', get_globalConfig().ac2_1);
    var tmp_37 = to('starSpeedLevel', get_globalConfig().bc2_1);
    var tmp_38 = to('starSpeedBoostLevel', get_globalConfig().cc2_1);
    var tmp_39 = to('starSpeedMegaLevel', get_globalConfig().dc2_1);
    var tmp_40 = to('treeViewX', get_treeViewX());
    var tmp_41 = to('treeViewY', get_treeViewY());
    var tmp_42 = to('treeViewScale', get_treeViewScale());
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = get_globalAchievementManager().rbv();
    var destination = ArrayList.j1();
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'saveGameState.<anonymous>' call
      if (element.abv_1) {
        destination.h(element);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator_0 = destination.b1();
    while (tmp0_iterator_0.c1()) {
      var item = tmp0_iterator_0.d1();
      // Inline function 'saveGameState.<anonymous>' call
      var tmp$ret$3 = item.vbu_1;
      destination_0.h(tmp$ret$3);
    }
    var saveData = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, tmp_28, tmp_29, tmp_30, tmp_31, tmp_32, tmp_33, tmp_34, tmp_35, tmp_36, tmp_37, tmp_38, tmp_39, tmp_40, tmp_41, tmp_42, to('unlockedAchievements', destination_0)]);
    var jsonString = Companion_getInstance_8().h11(saveData);
    var tmp_43 = SaveStorage_instance.wcd(jsonString, $completion);
    if (tmp_43 === get_COROUTINE_SUSPENDED())
      tmp_43 = yield tmp_43;
    println('Game state saved successfully');
  } catch ($p) {
    if ($p instanceof Exception) {
      var e = $p;
      println('Failed to save game state: ' + e.message);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function saveGameState($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_saveGameState__xwc0y6.bind(VOID), $completion);
}
function *_generator_loadGameState__cm4j8b($completion) {
  try {
    var tmp = SaveStorage_instance.xcd($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp0_elvis_lhs = tmp;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var jsonString = tmp_0;
    var tmp_1 = Companion_getInstance_8().e11(jsonString);
    var tmp1_elvis_lhs = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap) : false) ? tmp_1 : null;
    var tmp_2;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_2 = tmp1_elvis_lhs;
    }
    var saveData = tmp_2;
    // Inline function 'kotlin.collections.get' call
    var tmp_3 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3('score');
    var tmp2_safe_receiver = isNumber(tmp_3) ? tmp_3 : null;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : numberToDouble(tmp2_safe_receiver);
    set_globalScore(tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs);
    // Inline function 'kotlin.collections.get' call
    var key = 'totalGameTime';
    var tmp_4 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key);
    var tmp4_safe_receiver = isNumber(tmp_4) ? tmp_4 : null;
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : numberToDouble(tmp4_safe_receiver);
    set_totalGameTime(tmp5_elvis_lhs == null ? 0.0 : tmp5_elvis_lhs);
    // Inline function 'kotlin.collections.get' call
    var key_0 = 'totalCollisionCount';
    var tmp_5 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_0);
    var tmp6_safe_receiver = isNumber(tmp_5) ? tmp_5 : null;
    var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : numberToInt(tmp6_safe_receiver);
    set_totalCollisionCount(tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs);
    // Inline function 'kotlin.collections.get' call
    var key_1 = 'language';
    var tmp_6 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_1);
    var savedLanguage = (!(tmp_6 == null) ? typeof tmp_6 === 'string' : false) ? tmp_6 : null;
    if (!(savedLanguage == null) && listOf(['en', 'de', 'ru', 'cs', 'fr']).x2(savedLanguage)) {
      Localization_getInstance().mbv_1 = savedLanguage;
    }
    var tmp_7 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_2 = 'startLevel';
    var tmp_8 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_2);
    var tmp8_safe_receiver = isNumber(tmp_8) ? tmp_8 : null;
    var tmp9_elvis_lhs = tmp8_safe_receiver == null ? null : numberToInt(tmp8_safe_receiver);
    tmp_7.gby_1 = tmp9_elvis_lhs == null ? 0 : tmp9_elvis_lhs;
    var tmp_9 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_3 = 'collisionCooldownLevel';
    var tmp_10 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_3);
    var tmp10_safe_receiver = isNumber(tmp_10) ? tmp_10 : null;
    var tmp11_elvis_lhs = tmp10_safe_receiver == null ? null : numberToInt(tmp10_safe_receiver);
    tmp_9.uc0_1 = tmp11_elvis_lhs == null ? 0 : tmp11_elvis_lhs;
    var tmp_11 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_4 = 'adultAgeLevel';
    var tmp_12 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_4);
    var tmp12_safe_receiver = isNumber(tmp_12) ? tmp_12 : null;
    var tmp13_elvis_lhs = tmp12_safe_receiver == null ? null : numberToInt(tmp12_safe_receiver);
    tmp_11.vc0_1 = tmp13_elvis_lhs == null ? 0 : tmp13_elvis_lhs;
    var tmp_13 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_5 = 'maxPopulationLevel';
    var tmp_14 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_5);
    var tmp14_safe_receiver = isNumber(tmp_14) ? tmp_14 : null;
    var tmp15_elvis_lhs = tmp14_safe_receiver == null ? null : numberToInt(tmp14_safe_receiver);
    tmp_13.wc0_1 = tmp15_elvis_lhs == null ? 0 : tmp15_elvis_lhs;
    var tmp_15 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_6 = 'maxSpeedLevel';
    var tmp_16 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_6);
    var tmp16_safe_receiver = isNumber(tmp_16) ? tmp_16 : null;
    var tmp17_elvis_lhs = tmp16_safe_receiver == null ? null : numberToInt(tmp16_safe_receiver);
    tmp_15.xc0_1 = tmp17_elvis_lhs == null ? 0 : tmp17_elvis_lhs;
    var tmp_17 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_7 = 'birthBonusLevel';
    var tmp_18 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_7);
    var tmp18_safe_receiver = isNumber(tmp_18) ? tmp_18 : null;
    var tmp19_elvis_lhs = tmp18_safe_receiver == null ? null : numberToInt(tmp18_safe_receiver);
    tmp_17.yc0_1 = tmp19_elvis_lhs == null ? 0 : tmp19_elvis_lhs;
    var tmp_19 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_8 = 'movementEfficiencyLevel';
    var tmp_20 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_8);
    var tmp20_safe_receiver = isNumber(tmp_20) ? tmp_20 : null;
    var tmp21_elvis_lhs = tmp20_safe_receiver == null ? null : numberToInt(tmp20_safe_receiver);
    tmp_19.zc0_1 = tmp21_elvis_lhs == null ? 0 : tmp21_elvis_lhs;
    var tmp_21 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_9 = 'fertilityRateLevel';
    var tmp_22 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_9);
    var tmp22_safe_receiver = isNumber(tmp_22) ? tmp_22 : null;
    var tmp23_elvis_lhs = tmp22_safe_receiver == null ? null : numberToInt(tmp22_safe_receiver);
    tmp_21.ac1_1 = tmp23_elvis_lhs == null ? 0 : tmp23_elvis_lhs;
    var tmp_23 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_10 = 'genderBalanceLevel';
    var tmp_24 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_10);
    var tmp24_safe_receiver = isNumber(tmp_24) ? tmp_24 : null;
    var tmp25_elvis_lhs = tmp24_safe_receiver == null ? null : numberToInt(tmp24_safe_receiver);
    tmp_23.bc1_1 = tmp25_elvis_lhs == null ? 0 : tmp25_elvis_lhs;
    var tmp_25 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_11 = 'lifespanLevel';
    var tmp_26 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_11);
    var tmp26_safe_receiver = isNumber(tmp_26) ? tmp_26 : null;
    var tmp27_elvis_lhs = tmp26_safe_receiver == null ? null : numberToInt(tmp26_safe_receiver);
    tmp_25.cc1_1 = tmp27_elvis_lhs == null ? 0 : tmp27_elvis_lhs;
    var tmp_27 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_12 = 'collisionRangeLevel';
    var tmp_28 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_12);
    var tmp28_safe_receiver = isNumber(tmp_28) ? tmp_28 : null;
    var tmp29_elvis_lhs = tmp28_safe_receiver == null ? null : numberToInt(tmp28_safe_receiver);
    tmp_27.dc1_1 = tmp29_elvis_lhs == null ? 0 : tmp29_elvis_lhs;
    var tmp_29 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_13 = 'fertilityAgeLevel';
    var tmp_30 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_13);
    var tmp30_safe_receiver = isNumber(tmp_30) ? tmp_30 : null;
    var tmp31_elvis_lhs = tmp30_safe_receiver == null ? null : numberToInt(tmp30_safe_receiver);
    tmp_29.ec1_1 = tmp31_elvis_lhs == null ? 0 : tmp31_elvis_lhs;
    var tmp_31 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_14 = 'autoSpawnLevel';
    var tmp_32 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_14);
    var tmp32_safe_receiver = isNumber(tmp_32) ? tmp_32 : null;
    var tmp33_elvis_lhs = tmp32_safe_receiver == null ? null : numberToInt(tmp32_safe_receiver);
    tmp_31.fc1_1 = tmp33_elvis_lhs == null ? 0 : tmp33_elvis_lhs;
    var tmp_33 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_15 = 'autoSpawnRateLevel';
    var tmp_34 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_15);
    var tmp34_safe_receiver = isNumber(tmp_34) ? tmp_34 : null;
    var tmp35_elvis_lhs = tmp34_safe_receiver == null ? null : numberToInt(tmp34_safe_receiver);
    tmp_33.gc1_1 = tmp35_elvis_lhs == null ? 0 : tmp35_elvis_lhs;
    var tmp_35 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_16 = 'scoreMultiplierLevel';
    var tmp_36 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_16);
    var tmp36_safe_receiver = isNumber(tmp_36) ? tmp_36 : null;
    var tmp37_elvis_lhs = tmp36_safe_receiver == null ? null : numberToInt(tmp36_safe_receiver);
    tmp_35.hc1_1 = tmp37_elvis_lhs == null ? 0 : tmp37_elvis_lhs;
    var tmp_37 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_17 = 'timeAccelerationLevel';
    var tmp_38 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_17);
    var tmp38_safe_receiver = isNumber(tmp_38) ? tmp_38 : null;
    var tmp39_elvis_lhs = tmp38_safe_receiver == null ? null : numberToInt(tmp38_safe_receiver);
    tmp_37.ic1_1 = tmp39_elvis_lhs == null ? 0 : tmp39_elvis_lhs;
    var tmp_39 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_18 = 'massReproductionLevel';
    var tmp_40 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_18);
    var tmp40_safe_receiver = isNumber(tmp_40) ? tmp_40 : null;
    var tmp41_elvis_lhs = tmp40_safe_receiver == null ? null : numberToInt(tmp40_safe_receiver);
    tmp_39.jc1_1 = tmp41_elvis_lhs == null ? 0 : tmp41_elvis_lhs;
    var tmp_41 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_19 = 'evolutionBonusLevel';
    var tmp_42 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_19);
    var tmp42_safe_receiver = isNumber(tmp_42) ? tmp_42 : null;
    var tmp43_elvis_lhs = tmp42_safe_receiver == null ? null : numberToInt(tmp42_safe_receiver);
    tmp_41.kc1_1 = tmp43_elvis_lhs == null ? 0 : tmp43_elvis_lhs;
    var tmp_43 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_20 = 'ultraSpeedLevel';
    var tmp_44 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_20);
    var tmp44_safe_receiver = isNumber(tmp_44) ? tmp_44 : null;
    var tmp45_elvis_lhs = tmp44_safe_receiver == null ? null : numberToInt(tmp44_safe_receiver);
    tmp_43.lc1_1 = tmp45_elvis_lhs == null ? 0 : tmp45_elvis_lhs;
    var tmp_45 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_21 = 'instantMaturityLevel';
    var tmp_46 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_21);
    var tmp46_safe_receiver = isNumber(tmp_46) ? tmp_46 : null;
    var tmp47_elvis_lhs = tmp46_safe_receiver == null ? null : numberToInt(tmp46_safe_receiver);
    tmp_45.mc1_1 = tmp47_elvis_lhs == null ? 0 : tmp47_elvis_lhs;
    var tmp_47 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_22 = 'megaPopulationLevel';
    var tmp_48 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_22);
    var tmp48_safe_receiver = isNumber(tmp_48) ? tmp_48 : null;
    var tmp49_elvis_lhs = tmp48_safe_receiver == null ? null : numberToInt(tmp48_safe_receiver);
    tmp_47.nc1_1 = tmp49_elvis_lhs == null ? 0 : tmp49_elvis_lhs;
    var tmp_49 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_23 = 'fertilityExplosionLevel';
    var tmp_50 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_23);
    var tmp50_safe_receiver = isNumber(tmp_50) ? tmp_50 : null;
    var tmp51_elvis_lhs = tmp50_safe_receiver == null ? null : numberToInt(tmp50_safe_receiver);
    tmp_49.oc1_1 = tmp51_elvis_lhs == null ? 0 : tmp51_elvis_lhs;
    var tmp_51 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_24 = 'scoreAscensionLevel';
    var tmp_52 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_24);
    var tmp52_safe_receiver = isNumber(tmp_52) ? tmp_52 : null;
    var tmp53_elvis_lhs = tmp52_safe_receiver == null ? null : numberToInt(tmp52_safe_receiver);
    tmp_51.pc1_1 = tmp53_elvis_lhs == null ? 0 : tmp53_elvis_lhs;
    var tmp_53 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_25 = 'timeDilationLevel';
    var tmp_54 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_25);
    var tmp54_safe_receiver = isNumber(tmp_54) ? tmp_54 : null;
    var tmp55_elvis_lhs = tmp54_safe_receiver == null ? null : numberToInt(tmp54_safe_receiver);
    tmp_53.qc1_1 = tmp55_elvis_lhs == null ? 0 : tmp55_elvis_lhs;
    var tmp_55 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_26 = 'reproductionFrenzyLevel';
    var tmp_56 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_26);
    var tmp56_safe_receiver = isNumber(tmp_56) ? tmp_56 : null;
    var tmp57_elvis_lhs = tmp56_safe_receiver == null ? null : numberToInt(tmp56_safe_receiver);
    tmp_55.rc1_1 = tmp57_elvis_lhs == null ? 0 : tmp57_elvis_lhs;
    var tmp_57 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_27 = 'cosmicConvergenceLevel';
    var tmp_58 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_27);
    var tmp58_safe_receiver = isNumber(tmp_58) ? tmp_58 : null;
    var tmp59_elvis_lhs = tmp58_safe_receiver == null ? null : numberToInt(tmp58_safe_receiver);
    tmp_57.tc1_1 = tmp59_elvis_lhs == null ? 0 : tmp59_elvis_lhs;
    var tmp_59 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_28 = 'transcendenceLevel';
    var tmp_60 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_28);
    var tmp60_safe_receiver = isNumber(tmp_60) ? tmp_60 : null;
    var tmp61_elvis_lhs = tmp60_safe_receiver == null ? null : numberToInt(tmp60_safe_receiver);
    tmp_59.uc1_1 = tmp61_elvis_lhs == null ? 0 : tmp61_elvis_lhs;
    var tmp_61 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_29 = 'infinitePopulationLevel';
    var tmp_62 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_29);
    var tmp62_safe_receiver = isNumber(tmp_62) ? tmp_62 : null;
    var tmp63_elvis_lhs = tmp62_safe_receiver == null ? null : numberToInt(tmp62_safe_receiver);
    tmp_61.sc1_1 = tmp63_elvis_lhs == null ? 0 : tmp63_elvis_lhs;
    var tmp_63 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_30 = 'startingPopulationLevel';
    var tmp_64 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_30);
    var tmp64_safe_receiver = isNumber(tmp_64) ? tmp_64 : null;
    var tmp65_elvis_lhs = tmp64_safe_receiver == null ? null : numberToInt(tmp64_safe_receiver);
    tmp_63.vc1_1 = tmp65_elvis_lhs == null ? 0 : tmp65_elvis_lhs;
    var tmp_65 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_31 = 'startingPopulationBoostLevel';
    var tmp_66 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_31);
    var tmp66_safe_receiver = isNumber(tmp_66) ? tmp_66 : null;
    var tmp67_elvis_lhs = tmp66_safe_receiver == null ? null : numberToInt(tmp66_safe_receiver);
    tmp_65.wc1_1 = tmp67_elvis_lhs == null ? 0 : tmp67_elvis_lhs;
    var tmp_67 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_32 = 'startingPopulationMegaLevel';
    var tmp_68 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_32);
    var tmp68_safe_receiver = isNumber(tmp_68) ? tmp_68 : null;
    var tmp69_elvis_lhs = tmp68_safe_receiver == null ? null : numberToInt(tmp68_safe_receiver);
    tmp_67.xc1_1 = tmp69_elvis_lhs == null ? 0 : tmp69_elvis_lhs;
    var tmp_69 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_33 = 'clickPowerLevel';
    var tmp_70 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_33);
    var tmp70_safe_receiver = isNumber(tmp_70) ? tmp_70 : null;
    var tmp71_elvis_lhs = tmp70_safe_receiver == null ? null : numberToInt(tmp70_safe_receiver);
    tmp_69.yc1_1 = tmp71_elvis_lhs == null ? 0 : tmp71_elvis_lhs;
    var tmp_71 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_34 = 'clickPowerBoostLevel';
    var tmp_72 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_34);
    var tmp72_safe_receiver = isNumber(tmp_72) ? tmp_72 : null;
    var tmp73_elvis_lhs = tmp72_safe_receiver == null ? null : numberToInt(tmp72_safe_receiver);
    tmp_71.zc1_1 = tmp73_elvis_lhs == null ? 0 : tmp73_elvis_lhs;
    var tmp_73 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_35 = 'clickPowerMegaLevel';
    var tmp_74 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_35);
    var tmp74_safe_receiver = isNumber(tmp_74) ? tmp_74 : null;
    var tmp75_elvis_lhs = tmp74_safe_receiver == null ? null : numberToInt(tmp74_safe_receiver);
    tmp_73.ac2_1 = tmp75_elvis_lhs == null ? 0 : tmp75_elvis_lhs;
    var tmp_75 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_36 = 'starSpeedLevel';
    var tmp_76 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_36);
    var tmp76_safe_receiver = isNumber(tmp_76) ? tmp_76 : null;
    var tmp77_elvis_lhs = tmp76_safe_receiver == null ? null : numberToInt(tmp76_safe_receiver);
    tmp_75.bc2_1 = tmp77_elvis_lhs == null ? 0 : tmp77_elvis_lhs;
    var tmp_77 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_37 = 'starSpeedBoostLevel';
    var tmp_78 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_37);
    var tmp78_safe_receiver = isNumber(tmp_78) ? tmp_78 : null;
    var tmp79_elvis_lhs = tmp78_safe_receiver == null ? null : numberToInt(tmp78_safe_receiver);
    tmp_77.cc2_1 = tmp79_elvis_lhs == null ? 0 : tmp79_elvis_lhs;
    var tmp_79 = get_globalConfig();
    // Inline function 'kotlin.collections.get' call
    var key_38 = 'starSpeedMegaLevel';
    var tmp_80 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_38);
    var tmp80_safe_receiver = isNumber(tmp_80) ? tmp_80 : null;
    var tmp81_elvis_lhs = tmp80_safe_receiver == null ? null : numberToInt(tmp80_safe_receiver);
    tmp_79.dc2_1 = tmp81_elvis_lhs == null ? 0 : tmp81_elvis_lhs;
    // Inline function 'kotlin.collections.get' call
    var key_39 = 'treeViewX';
    var tmp_81 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_39);
    var tmp82_safe_receiver = isNumber(tmp_81) ? tmp_81 : null;
    set_treeViewX(tmp82_safe_receiver == null ? null : numberToDouble(tmp82_safe_receiver));
    // Inline function 'kotlin.collections.get' call
    var key_40 = 'treeViewY';
    var tmp_82 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_40);
    var tmp83_safe_receiver = isNumber(tmp_82) ? tmp_82 : null;
    set_treeViewY(tmp83_safe_receiver == null ? null : numberToDouble(tmp83_safe_receiver));
    // Inline function 'kotlin.collections.get' call
    var key_41 = 'treeViewScale';
    var tmp_83 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_41);
    var tmp84_safe_receiver = isNumber(tmp_83) ? tmp_83 : null;
    set_treeViewScale(tmp84_safe_receiver == null ? null : numberToDouble(tmp84_safe_receiver));
    // Inline function 'kotlin.collections.get' call
    var key_42 = 'unlockedAchievements';
    var tmp_84 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3(key_42);
    var tmp85_safe_receiver = (!(tmp_84 == null) ? isInterface(tmp_84, KtList) : false) ? tmp_84 : null;
    var tmp_85;
    if (tmp85_safe_receiver == null) {
      tmp_85 = null;
    } else {
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList.j1();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = tmp85_safe_receiver.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'loadGameState.<anonymous>' call
        var tmp0_safe_receiver = (!(element == null) ? typeof element === 'string' : false) ? element : null;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.h(tmp0_safe_receiver);
        }
      }
      tmp_85 = destination;
    }
    var tmp86_elvis_lhs = tmp_85;
    var unlockedAchievements = tmp86_elvis_lhs == null ? emptyList() : tmp86_elvis_lhs;
    println('Loading ' + unlockedAchievements.f1() + ' unlocked achievements: ' + toString(unlockedAchievements));
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = get_globalAchievementManager().rbv().b1();
    while (tmp0_iterator_0.c1()) {
      var element_0 = tmp0_iterator_0.d1();
      // Inline function 'loadGameState.<anonymous>' call
      if (unlockedAchievements.x2(element_0.vbu_1)) {
        element_0.abv_1 = true;
        element_0.dbv_1 = true;
        println('Restored achievement: ' + element_0.vbu_1 + ' - ' + element_0.wbu_1);
      }
    }
    println('Total unlocked count after load: ' + get_globalAchievementManager().sbv());
    // Inline function 'kotlin.collections.get' call
    var tmp_86 = (isInterface(saveData, KtMap) ? saveData : THROW_CCE()).f3('score');
    var tmp87_safe_receiver = isNumber(tmp_86) ? tmp_86 : null;
    var tmp88_elvis_lhs = tmp87_safe_receiver == null ? null : numberToDouble(tmp87_safe_receiver);
    set_globalScore(tmp88_elvis_lhs == null ? 0.0 : tmp88_elvis_lhs);
    get_globalConfig().pc3();
    println('Game state loaded successfully');
  } catch ($p) {
    if ($p instanceof Exception) {
      var e = $p;
      println('Failed to load game state: ' + e.message);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function loadGameState($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_loadGameState__cm4j8b.bind(VOID), $completion);
}
function *_generator_hasSaveGame__k1fbsl($completion) {
  var tmp;
  try {
    var tmp_0 = SaveStorage_instance.ycd($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof Exception) {
      var e = $p;
      tmp_1 = false;
    } else {
      throw $p;
    }
    tmp = tmp_1;
  }
  return tmp;
}
function hasSaveGame($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_hasSaveGame__k1fbsl.bind(VOID), $completion);
}
function *_generator_invoke__zhh2q8_28($this, $this$Korge, $completion) {
  try {
    var tmp = readTtfFont(get_resourcesVfs().hi('fonts/Normal font.ttf'), VOID, VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    set_mainMenuNormalFont(tmp);
    var tmp_0 = readTtfFont(get_resourcesVfs().hi('fonts/Game name.otf'), VOID, VOID, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    set_mainMenuTitleFont(tmp_0);
    set_gameFont(get_mainMenuNormalFont());
    println('\u2713 Game and menu fonts loaded successfully');
  } catch ($p) {
    if ($p instanceof Exception) {
      var e = $p;
      println('\u26A0 Failed to load game/menu fonts, falling back to DefaultTtfFont: ' + e.message);
      set_gameFont(get_DefaultTtfFont());
      set_mainMenuNormalFont(get_DefaultTtfFont());
      set_mainMenuTitleFont(get_DefaultTtfFont());
    } else {
      throw $p;
    }
  }
  Localization_getInstance().mbv_1 = Localization_getInstance().wc5();
  var tmp_1 = loadGameState($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  get_globalAchievementManager().ubv();
  get_globalConfig().pc3();
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_6()));
  var name = 'sceneContainer';
  var size = Companion_getInstance_5().f2k_1;
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var tmp_2 = views($completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var views_0 = tmp_2;
  var width = size.nl();
  var height = size.ol();
  var rwidth = width;
  var rheight = height;
  if (width === 0.0 && height === 0.0) {
    var tmp_3 = findFirstAscendant($this$Korge, main$slambda$lambda);
    var base = (tmp_3 == null ? true : tmp_3 instanceof FixedSizeContainer) ? tmp_3 : null;
    var tmp1_elvis_lhs = base == null ? null : base.d2m();
    rwidth = tmp1_elvis_lhs == null ? views_0.v9r_1.d2m() : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = base == null ? null : base.e2m();
    rheight = tmp3_elvis_lhs == null ? views_0.v9r_1.e2m() : tmp3_elvis_lhs;
  }
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SceneContainer.w9x(views_0, defaultTransition, name, Size2D.f2i(rwidth, rheight));
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
  var sceneContainer = addTo(this_0, $this$Korge);
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var injects = [];
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var time = toDuration(0, DurationUnit_SECONDS_getInstance());
  var transition = sceneContainer.r9x_1;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(MainMenuScene);
  var injects_0 = injects.slice();
  var sceneInjector = sceneContainer.q9x_1.l9q_1.e6c().c6c(getKClass(SceneContainer), sceneContainer).c6c(getKClass(Resources), new Resources(sceneContainer.b17(), sceneContainer.q9x_1.s9y().t37_1, sceneContainer.q9x_1.s9y()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp_4 = getKClassFromExpression(inject);
    sceneInjector.c6c(isInterface(tmp_4, KClass) ? tmp_4 : THROW_CCE(), inject);
  }
  // Inline function 'main.<anonymous>.<anonymous>' call
  var newScene = new MainMenuScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_3().ra8_1;
  var level = Level_INFO_getInstance();
  var tmp_5;
  if (this_1.x2x(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$8 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_1.y2x(level, tmp$ret$8);
    tmp_5 = Unit_instance;
  }
  if (true) {
    newScene.n6c(sceneInjector);
    var tmp_6 = getKClassFromExpression(newScene);
    var tmp_7 = isInterface(tmp_6, KClass) ? tmp_6 : THROW_CCE();
    sceneContainer.q9x_1.l9q_1.g6c(tmp_7, main$slambda$lambda_0(sceneInjector));
  }
  var tmp_8 = sceneContainer.ta8(newScene, time, transition, $completion);
  if (tmp_8 === get_COROUTINE_SUSPENDED())
    tmp_8 = yield tmp_8;
  return Unit_instance;
}
function main$slambda$lambda(it) {
  return it instanceof FixedSizeContainer;
}
function main$slambda$lambda_0($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'main.<anonymous>.<anonymous>' call
    return new MainMenuScene();
  };
}
function main$slambda_0() {
  var i = new main$slambda();
  var l = function ($this$Korge, $completion) {
    return i.e9n($this$Korge, $completion);
  };
  l.$arity = 1;
  return l;
}
function CollisionType_REPRODUCTION_getInstance() {
  CollisionType_initEntries();
  return CollisionType_REPRODUCTION_instance;
}
function CollisionType_BOUNCE_ONLY_getInstance() {
  CollisionType_initEntries();
  return CollisionType_BOUNCE_ONLY_instance;
}
function click$factory_10() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.t9z_1;
  }, null);
}
function over$factory_4() {
  return getPropertyCallableRef('over', 1, KProperty1, function (receiver) {
    return receiver.u9z_1;
  }, null);
}
function out$factory_4() {
  return getPropertyCallableRef('out', 1, KProperty1, function (receiver) {
    return receiver.v9z_1;
  }, null);
}
function click$factory_11() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.t9z_1;
  }, null);
}
function over$factory_5() {
  return getPropertyCallableRef('over', 1, KProperty1, function (receiver) {
    return receiver.u9z_1;
  }, null);
}
function out$factory_5() {
  return getPropertyCallableRef('out', 1, KProperty1, function (receiver) {
    return receiver.v9z_1;
  }, null);
}
function click$factory_12() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.t9z_1;
  }, null);
}
function over$factory_6() {
  return getPropertyCallableRef('over', 1, KProperty1, function (receiver) {
    return receiver.u9z_1;
  }, null);
}
function out$factory_6() {
  return getPropertyCallableRef('out', 1, KProperty1, function (receiver) {
    return receiver.v9z_1;
  }, null);
}
function click$factory_13() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.t9z_1;
  }, null);
}
function over$factory_7() {
  return getPropertyCallableRef('over', 1, KProperty1, function (receiver) {
    return receiver.u9z_1;
  }, null);
}
function out$factory_7() {
  return getPropertyCallableRef('out', 1, KProperty1, function (receiver) {
    return receiver.v9z_1;
  }, null);
}
function click$factory_14() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.t9z_1;
  }, null);
}
function over$factory_8() {
  return getPropertyCallableRef('over', 1, KProperty1, function (receiver) {
    return receiver.u9z_1;
  }, null);
}
function out$factory_8() {
  return getPropertyCallableRef('out', 1, KProperty1, function (receiver) {
    return receiver.v9z_1;
  }, null);
}
function click$factory_15() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.t9z_1;
  }, null);
}
function click$factory_16() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.t9z_1;
  }, null);
}
function click$factory_17() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.t9z_1;
  }, null);
}
var properties_initialized_main_kt_ask6ij;
function _init_properties_main_kt__ykjpl3() {
  if (!properties_initialized_main_kt_ask6ij) {
    properties_initialized_main_kt_ask6ij = true;
    globalConfig = new GameConfig();
    globalAchievementManager = new AchievementManager();
    globalScore = 0.0;
    hasWon = false;
    totalGameTime = 0.0;
    currentRunTime = 0.0;
    totalCollisionCount = 0;
    treeViewX = null;
    treeViewY = null;
    treeViewScale = null;
    globalSavedScore = 0.0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    globalSavedConfig = LinkedHashMap.oc();
  }
}
function mainWrapper() {
  startCoroutineUninterceptedOrReturnGeneratorVersion(main, get_EmptyContinuation());
}
var SaveStorage_instance;
function SaveStorage_getInstance() {
  return SaveStorage_instance;
}
//region block: post-declaration
initMetadataForClass(Achievement, 'Achievement');
initMetadataForClass(AchievementReward, 'AchievementReward', AchievementReward);
initMetadataForClass(AchievementCondition, 'AchievementCondition');
initMetadataForClass(Population, 'Population');
initMetadataForClass(Collisions, 'Collisions');
initMetadataForClass(Score, 'Score');
initMetadataForClass(TimeAlive, 'TimeAlive');
initMetadataForClass(ReproductionStreak, 'ReproductionStreak');
initMetadataForClass(AchievementManager, 'AchievementManager', AchievementManager);
initMetadataForClass(AchievementNotification, 'AchievementNotification');
initMetadataForClass(AchievementPanel, 'AchievementPanel');
initMetadataForClass(CollisionEvent, 'CollisionEvent');
initMetadataForCompanion(Companion);
initMetadataForClass(GameConfig, 'GameConfig', GameConfig);
initMetadataForClass(Gender, 'Gender');
initMetadataForClass(HairStyle, 'HairStyle');
initMetadataForClass(OutfitStyle, 'OutfitStyle');
initMetadataForClass(Appearance, 'Appearance');
initMetadataForClass(GameSquare, 'GameSquare');
initMetadataForObject(GravestoneSpriteCache, 'GravestoneSpriteCache');
initMetadataForObject(HumanSpriteCache, 'HumanSpriteCache');
initMetadataForObject(Localization, 'Localization');
initMetadataForLambda(MainMenuScene$sceneMain$lambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(MainMenuScene$sceneMain$lambda$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(MainMenuScene$sceneMain$lambda$slambda_1, VOID, VOID, [1]);
initMetadataForClass(MainMenuScene, 'MainMenuScene', MainMenuScene, VOID, VOID, [0]);
initMetadataForObject(NameGenerator, 'NameGenerator');
initMetadataForLambda(createSettingsPanel$lambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(SoundManager$slambda, VOID, VOID, [1]);
initMetadataForLambda(SoundManager$playBounceSound$slambda, VOID, VOID, [1]);
initMetadataForLambda(SoundManager$playReproductionSound$slambda, VOID, VOID, [1]);
initMetadataForLambda(SoundManager$playAchievementSound$slambda, VOID, VOID, [1]);
initMetadataForLambda(SoundManager$playFootstepSound$slambda, VOID, VOID, [1]);
initMetadataForLambda(SoundManager$playStarCollectSound$slambda, VOID, VOID, [1]);
initMetadataForClass(SoundManager, 'SoundManager', SoundManager);
initMetadataForClass(SpatialGrid, 'SpatialGrid');
initMetadataForClass(UpgradeState, 'UpgradeState');
initMetadataForClass(UpgradeDefinition, 'UpgradeDefinition');
initMetadataForLambda(UpgradeTreeScene$refreshUpgradeTree$slambda, VOID, VOID, [1]);
initMetadataForLambda(UpgradeTreeScene$setupScreen$slambda, VOID, VOID, [1]);
initMetadataForLambda(UpgradeTreeScene$setupScreen$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(UpgradeTreeScene$setupScreen$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(UpgradeTreeScene$setupScreen$lambda$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(UpgradeTreeScene$setupScreen$slambda_1, VOID, VOID, [1]);
initMetadataForLambda(UpgradeTreeScene$setupScreen$lambda$slambda_1, VOID, VOID, [0]);
initMetadataForLambda(UpgradeTreeScene$setupScreen$slambda_2, VOID, VOID, [1]);
initMetadataForLambda(UpgradeTreeScene$setupScreen$lambda$slambda_2, VOID, VOID, [0]);
initMetadataForLambda(UpgradeTreeScene$setupUpgrades$slambda, VOID, VOID, [1]);
initMetadataForLambda(UpgradeTreeScene$createUpgradeCard$lambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(UpgradeTreeScene$createUpgradeCard$slambda, VOID, VOID, [1]);
initMetadataForLambda(UpgradeTreeScene$createUpgradeCard$lambda$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(UpgradeTreeScene$createUpgradeCard$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(UpgradeTreeScene$createUpgradeCard$lambda$slambda_1, VOID, VOID, [0]);
initMetadataForLambda(UpgradeTreeScene$createUpgradeCard$slambda_1, VOID, VOID, [1]);
initMetadataForLambda(UpgradeTreeScene$createUpgradeCard$lambda$slambda_2, VOID, VOID, [0]);
initMetadataForLambda(UpgradeTreeScene$createUpgradeCard$slambda_2, VOID, VOID, [1]);
initMetadataForClass(UpgradeTreeScene, 'UpgradeTreeScene', VOID, VOID, VOID, [0, 4]);
initMetadataForClass(CollisionType, 'CollisionType');
initMetadataForLambda(GameScene$openUpgradeTree$slambda$lambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(GameScene$setupAchievements$lambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(GameScene$setupUI$lambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(GameScene$showAchievementNotification$slambda, VOID, VOID, [1]);
initMetadataForLambda(GameScene$openUpgradeTree$slambda, VOID, VOID, [1]);
initMetadataForLambda(GameScene$spawnStar$lambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(GameScene$setupGameLoop$lambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(GameScene$setupGameLoop$lambda$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(GameScene$setupGameLoop$lambda$slambda_1, VOID, VOID, [1]);
initMetadataForLambda(GameScene$checkForDeaths$slambda, VOID, VOID, [1]);
initMetadataForClass(GameScene, 'GameScene', GameScene, VOID, VOID, [0]);
initMetadataForLambda(main$slambda, VOID, VOID, [1]);
initMetadataForObject(SaveStorage, 'SaveStorage', VOID, VOID, VOID, [1, 0]);
//endregion
//region block: init
Companion_instance_0 = new Companion();
SaveStorage_instance = new SaveStorage();
//endregion
mainWrapper();
